var __defProp = Object.defineProperty;
var __returnValue = (v) => v;
function __exportSetter(name, newValue) {
  this[name] = __returnValue.bind(null, newValue);
}
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, {
      get: all[name],
      enumerable: true,
      configurable: true,
      set: __exportSetter.bind(all, name)
    });
};

// src/timeline-position-state.ts
var exports_timeline_position_state = {};
__export(exports_timeline_position_state, {
  clampFrameToCompositionRange: () => clampFrameToCompositionRange,
  getFrameForComposition: () => getFrameForComposition,
  getInitialFrameState: () => getInitialFrameState,
  persistCurrentFrame: () => persistCurrentFrame,
  useAbsoluteTimelinePosition: () => useAbsoluteTimelinePosition,
  useBuffering: () => useBuffering,
  useIsInsideFreeze: () => useIsInsideFreeze,
  usePlaybackRate: () => usePlaybackRate,
  usePlaying: () => usePlaying,
  useTimelineContext: () => useTimelineContext,
  useTimelinePosition: () => useTimelinePosition,
  useTimelinePositionWithOptionalSubscription: () => useTimelinePositionWithOptionalSubscription,
  useTimelineSeekFrame: () => useTimelineSeekFrame,
  useTimelineSetFrameWithoutSeek: () => useTimelineSetFrameWithoutSeek
});

// src/default-css.ts
var exports_default_css = {};
__export(exports_default_css, {
  OBJECTFIT_CONTAIN_CLASS_NAME: () => OBJECTFIT_CONTAIN_CLASS_NAME,
  injectCSS: () => injectCSS,
  makeDefaultPreviewCSS: () => makeDefaultPreviewCSS
});

// src/_check-rsc.ts
import { createContext } from "react";
if (typeof createContext !== "function") {
  const err = [
    'Remotion requires React.createContext, but it is "undefined".',
    'If you are in a React Server Component, turn it into a client component by adding "use client" at the top of the file.',
    "",
    "Before:",
    '  import {useCurrentFrame} from "remotion";',
    "",
    "After:",
    '  "use client";',
    '  import {useCurrentFrame} from "remotion";'
  ];
  throw new Error(err.join(`
`));
}

// src/Clipper.tsx
var Clipper = () => {
  throw new Error("<Clipper> has been removed as of Remotion v4.0.228. The native clipping APIs were experimental and subject to removal at any time. We removed them because they were sparingly used and made rendering often slower rather than faster.");
};

// src/Composition.tsx
import { Suspense, useContext as useContext10, useEffect as useEffect4, useMemo as useMemo8 } from "react";
import { createPortal } from "react-dom";

// src/CanUseRemotionHooks.tsx
import { createContext as createContext2 } from "react";
import { jsx } from "react/jsx-runtime";
var CanUseRemotionHooks = createContext2(false);
var CanUseRemotionHooksProvider = ({ children }) => {
  return /* @__PURE__ */ jsx(CanUseRemotionHooks.Provider, {
    value: true,
    children
  });
};

// src/committed-metadata.ts
import { createContext as createContext3 } from "react";
var COMMITTED_METADATA_PROP = "_remotionCommitMetadata";
var COMMIT_ORDER_EVENT = "remotion:commit-order";
var COMMIT_REGISTRATION_ERROR_EVENT = "remotion:commit-registration-error";
var COMMIT_OBSERVER_INSTALLATION_MARKER = Symbol.for("remotion.commit-order-observer-installed");
var COMMIT_OBSERVER_FAILURE_MARKER = Symbol.for("remotion.commit-registration-observer-failed");
var isCommitRegistrationObserverInstalled = () => {
  if (typeof window === "undefined") {
    return false;
  }
  const hook = Reflect.get(window, "__REACT_DEVTOOLS_GLOBAL_HOOK__");
  return typeof hook === "object" && hook !== null && Reflect.get(hook, "isDisabled") !== true && Reflect.get(hook, COMMIT_OBSERVER_INSTALLATION_MARKER) === true && Reflect.get(hook, COMMIT_OBSERVER_FAILURE_MARKER) !== true;
};
var getCompositionAndFolderOrderKey = (item) => `${item.type}:${item.id}`;
var getFolderOrderId = ({
  name,
  parent
}) => [parent, name].filter(Boolean).join("/");
var withCommittedMetadata = (provider) => provider;
var CommittedMetadataProvider = withCommittedMetadata(createContext3(null).Provider);
var CommittedMetadataInternals = {
  metadataProp: COMMITTED_METADATA_PROP,
  eventName: COMMIT_ORDER_EVENT,
  installationMarker: COMMIT_OBSERVER_INSTALLATION_MARKER,
  failureMarker: COMMIT_OBSERVER_FAILURE_MARKER,
  registrationErrorEventName: COMMIT_REGISTRATION_ERROR_EVENT
};

// src/component-identity.ts
import React4 from "react";

// src/series/is-inside-series.tsx
import React3, { createContext as createContext4 } from "react";
import { jsx as jsx2 } from "react/jsx-runtime";
var IsInsideSeriesContext = createContext4(false);
var IsInsideSeriesContainer = ({ children }) => {
  return /* @__PURE__ */ jsx2(IsInsideSeriesContext.Provider, {
    value: true,
    children
  });
};
var IsNotInsideSeriesProvider = ({ children }) => {
  return /* @__PURE__ */ jsx2(IsInsideSeriesContext.Provider, {
    value: false,
    children
  });
};
var useRequireToBeInsideSeries = () => {
  const isInsideSeries = React3.useContext(IsInsideSeriesContext);
  if (!isInsideSeries) {
    throw new Error("This component must be inside a <Series /> component.");
  }
};

// src/component-identity.ts
var componentIdentityResolver = null;
var setComponentIdentityResolver = (resolver) => {
  componentIdentityResolver = resolver;
};
var resolveComponentIdentity = (component) => {
  return componentIdentityResolver?.(component) ?? component;
};
var getSingleChildElement = (children) => {
  const mountedChildren = React4.Children.toArray(children);
  if (mountedChildren.length !== 1) {
    return null;
  }
  const child = mountedChildren[0];
  if (!React4.isValidElement(child)) {
    return null;
  }
  if (child.type === IsNotInsideSeriesProvider) {
    return getSingleChildElement(child.props.children);
  }
  if (typeof child.type !== "function" && typeof child.type !== "object") {
    return null;
  }
  return child;
};
var getSingleChildComponent = (children) => {
  const child = getSingleChildElement(children);
  return child === null ? null : resolveComponentIdentity(child.type);
};
var getSingleChildProps = (children) => {
  return getSingleChildElement(children)?.props ?? null;
};

// src/composition-registry-fallback.ts
import {
  createContext as createContext5,
  useContext,
  useEffect,
  useLayoutEffect,
  useRef
} from "react";
var CompositionRegistryFallbackContext = createContext5(null);
var useIsomorphicLayoutEffect = typeof window === "undefined" ? useEffect : useLayoutEffect;
var createEntryCleanup = (registry, identity) => {
  if (registry === null) {
    return;
  }
  return () => {
    registry.entries.delete(identity);
    registry.notifyCommit();
  };
};
var useCommittedCompositionEntry = (entry) => {
  const registry = useContext(CompositionRegistryFallbackContext);
  const key = useRef({});
  useIsomorphicLayoutEffect(() => {
    if (registry === null) {
      return;
    }
    if (entry === null) {
      registry.entries.delete(key.current);
    } else {
      registry.entries.set(key.current, entry);
    }
    registry.notifyCommit();
  }, [entry, registry]);
  useIsomorphicLayoutEffect(createEntryCleanup.bind(null, registry, key.current), [registry]);
};

// src/composition-render-error-context.ts
import { createContext as createContext6 } from "react";
var CompositionRenderErrorContext = createContext6({
  setError: () => {},
  clearError: () => {}
});

// src/CompositionErrorBoundary.tsx
import React5 from "react";
var getHot = () => {
  try {
    if (typeof __webpack_module__ === "undefined") {
      return null;
    }
    return __webpack_module__.hot ?? null;
  } catch {
    return null;
  }
};

class CompositionErrorBoundary extends React5.Component {
  state = { hasError: false };
  hmrStatusHandler = null;
  static getDerivedStateFromError() {
    return { hasError: true };
  }
  componentDidCatch(error) {
    this.props.onError(error);
    this.subscribeToHmrReset();
  }
  componentDidMount() {
    if (!this.state.hasError) {
      this.props.onClear();
    }
  }
  componentDidUpdate(_prevProps, prevState) {
    if (prevState.hasError && !this.state.hasError) {
      this.props.onClear();
    }
  }
  componentWillUnmount() {
    this.unsubscribeFromHmrReset();
  }
  subscribeToHmrReset() {
    if (this.hmrStatusHandler) {
      return;
    }
    const hot = getHot();
    if (!hot) {
      return;
    }
    const handler = (status) => {
      if (status !== "idle") {
        return;
      }
      this.unsubscribeFromHmrReset();
      this.setState({ hasError: false });
    };
    this.hmrStatusHandler = handler;
    hot.addStatusHandler(handler);
  }
  unsubscribeFromHmrReset() {
    const handler = this.hmrStatusHandler;
    if (!handler) {
      return;
    }
    this.hmrStatusHandler = null;
    const hot = getHot();
    if (!hot) {
      return;
    }
    hot.removeStatusHandler(handler);
  }
  render() {
    if (this.state.hasError) {
      return null;
    }
    return this.props.children;
  }
}

// src/CompositionManagerContext.tsx
import { createContext as createContext7 } from "react";
var getAssetPreviewCompositionId = (asset) => `asset:${asset}`;
var defaultCompositionManagerContext = {
  compositions: [],
  folders: [],
  currentCompositionMetadata: null,
  currentAssetMetadata: null,
  canvasContent: null
};
var CompositionManager = createContext7(defaultCompositionManagerContext);
var CompositionManagerRefContext = createContext7({ current: defaultCompositionManagerContext });
var CompositionSetters = createContext7({
  setCanvasContent: () => {
    return;
  },
  setCurrentAssetMetadata: () => {
    return;
  },
  onlyRenderComposition: null
});

// src/Folder.tsx
import { createContext as createContext8, useContext as useContext2, useMemo } from "react";

// src/truthy.ts
function truthy(value) {
  return Boolean(value);
}

// src/validation/validate-folder-name.ts
var getRegex = () => /^([a-zA-Z0-9-\u4E00-\u9FFF])+$/g;
var isFolderNameValid = (name) => name.match(getRegex());
var validateFolderName = (name) => {
  if (name === undefined || name === null) {
    throw new TypeError("You must pass a name to a <Folder />.");
  }
  if (typeof name !== "string") {
    throw new TypeError(`The "name" you pass into <Folder /> must be a string. Got: ${typeof name}`);
  }
  if (!isFolderNameValid(name)) {
    throw new Error(`Folder name can only contain a-z, A-Z, 0-9 and -. You passed ${name}`);
  }
};
var invalidFolderNameErrorMessage = `Folder name must match ${String(getRegex())}`;

// src/Folder.tsx
import { jsx as jsx3 } from "react/jsx-runtime";
var FolderContext = createContext8({
  folderName: null,
  parentName: null
});
var FolderContextProvider = withCommittedMetadata(FolderContext.Provider);
var Folder = (props) => {
  const { name, children } = props;
  const parent = useContext2(FolderContext);
  const stack = props._remotionInternalStack ?? null;
  validateFolderName(name);
  const parentNameArr = [parent.parentName, parent.folderName].filter(truthy);
  const parentName = parentNameArr.length === 0 ? null : parentNameArr.join("/");
  const value = useMemo(() => {
    return {
      folderName: name,
      parentName
    };
  }, [name, parentName]);
  const registration = useMemo(() => ({ name, parent: parentName, order: null, stack }), [name, parentName, stack]);
  const metadata = useMemo(() => ({
    type: "folder",
    id: getFolderOrderId({ name, parent: parentName }),
    value: registration
  }), [name, parentName, registration]);
  useCommittedCompositionEntry(metadata);
  return /* @__PURE__ */ jsx3(FolderContextProvider, {
    value,
    _remotionCommitMetadata: metadata,
    children
  });
};

// src/get-remotion-environment.ts
function getNodeEnvString() {
  return ["NOD", "E_EN", "V"].join("");
}
var getEnvString = () => {
  return ["e", "nv"].join("");
};
var getRemotionEnvironment = () => {
  const isPlayer = typeof window !== "undefined" && window.remotion_isPlayer;
  const isRendering = typeof window !== "undefined" && typeof window.process !== "undefined" && typeof window.process.env !== "undefined" && (window.process[getEnvString()][getNodeEnvString()] === "test" || window.process[getEnvString()][getNodeEnvString()] === "production" && typeof window !== "undefined" && typeof window.remotion_puppeteerTimeout !== "undefined");
  const isStudio = typeof window !== "undefined" && window.remotion_isStudio;
  const isReadOnlyStudio = typeof window !== "undefined" && window.remotion_isReadOnlyStudio;
  return {
    isStudio,
    isRendering,
    isPlayer,
    isReadOnlyStudio,
    isClientSideRendering: false
  };
};

// src/input-props-serialization.ts
var DATE_TOKEN = "remotion-date:";
var FILE_TOKEN = "remotion-file:";
var serializeJSONWithSpecialTypes = ({
  data,
  indent,
  staticBase
}) => {
  let customDateUsed = false;
  let customFileUsed = false;
  let mapUsed = false;
  let setUsed = false;
  try {
    const serializedString = JSON.stringify(data, function(key, value) {
      const item = this[key];
      if (item instanceof Date) {
        customDateUsed = true;
        return `${DATE_TOKEN}${item.toISOString()}`;
      }
      if (item instanceof Map) {
        mapUsed = true;
        return value;
      }
      if (item instanceof Set) {
        setUsed = true;
        return value;
      }
      if (typeof item === "string" && staticBase !== null && staticBase !== "" && item.startsWith(staticBase)) {
        customFileUsed = true;
        return `${FILE_TOKEN}${item.replace(staticBase + "/", "")}`;
      }
      return value;
    }, indent);
    return { serializedString, customDateUsed, customFileUsed, mapUsed, setUsed };
  } catch (err) {
    throw new Error("Could not serialize the passed input props to JSON: " + err.message);
  }
};
var resolveFileTokenToUrl = (value) => {
  const encodedName = value.replace(FILE_TOKEN, "");
  let name = encodedName;
  try {
    name = encodedName.split("/").map(decodeURIComponent).join("/");
  } catch {}
  const matchingStaticFile = window.remotion_staticFiles?.find((file) => file.name === name);
  if (matchingStaticFile) {
    return matchingStaticFile.src;
  }
  return `${window.remotion_staticBase}/${encodedName}`;
};
var deserializeJSONWithSpecialTypes = (data) => {
  return JSON.parse(data, (_, value) => {
    if (typeof value === "string" && value.startsWith(DATE_TOKEN)) {
      return new Date(value.replace(DATE_TOKEN, ""));
    }
    if (typeof value === "string" && value.startsWith(FILE_TOKEN)) {
      return resolveFileTokenToUrl(value);
    }
    return value;
  });
};
var serializeThenDeserialize = (props) => {
  return deserializeJSONWithSpecialTypes(serializeJSONWithSpecialTypes({
    data: props,
    indent: 2,
    staticBase: window.remotion_staticBase
  }).serializedString);
};
var serializeThenDeserializeInStudio = (props) => {
  if (getRemotionEnvironment().isStudio) {
    return serializeThenDeserialize(props);
  }
  return props;
};

// src/is-player.tsx
import { createContext as createContext9, useContext as useContext3 } from "react";
import { jsx as jsx4 } from "react/jsx-runtime";
var IsPlayerContext = createContext9(false);
var IsPlayerContextProvider = ({
  children
}) => {
  return /* @__PURE__ */ jsx4(IsPlayerContext.Provider, {
    value: true,
    children
  });
};
var useIsPlayer = () => {
  return useContext3(IsPlayerContext);
};

// src/AbsoluteFillElement.tsx
import React6, { forwardRef, useMemo as useMemo2 } from "react";
import { jsx as jsx5 } from "react/jsx-runtime";
var hasTailwindClassName = ({
  className,
  classPrefix,
  type
}) => {
  if (!className) {
    return false;
  }
  if (type === "exact") {
    const split = className.split(" ");
    return classPrefix.some((token) => {
      return split.some((part) => {
        return part.trim() === token || part.trim().endsWith(`:${token}`) || part.trim().endsWith(`!${token}`);
      });
    });
  }
  return classPrefix.some((prefix) => {
    return className.startsWith(prefix) || className.includes(` ${prefix}`) || className.includes(`!${prefix}`) || className.includes(`:${prefix}`);
  });
};
var AbsoluteFillElementRefForwarding = (props, ref) => {
  const { style, ...other } = props;
  const defaultStyle = useMemo2(() => {
    return {
      position: "absolute",
      top: hasTailwindClassName({
        className: other.className,
        classPrefix: ["top-", "inset-"],
        type: "prefix"
      }) ? undefined : 0,
      left: hasTailwindClassName({
        className: other.className,
        classPrefix: ["left-", "inset-"],
        type: "prefix"
      }) ? undefined : 0,
      right: hasTailwindClassName({
        className: other.className,
        classPrefix: ["right-", "inset-"],
        type: "prefix"
      }) ? undefined : 0,
      bottom: hasTailwindClassName({
        className: other.className,
        classPrefix: ["bottom-", "inset-"],
        type: "prefix"
      }) ? undefined : 0,
      width: hasTailwindClassName({
        className: other.className,
        classPrefix: ["w-"],
        type: "prefix"
      }) ? undefined : "100%",
      height: hasTailwindClassName({
        className: other.className,
        classPrefix: ["h-"],
        type: "prefix"
      }) ? undefined : "100%",
      display: hasTailwindClassName({
        className: other.className,
        classPrefix: [
          "block",
          "inline-block",
          "inline",
          "flex",
          "inline-flex",
          "flow-root",
          "grid",
          "inline-grid",
          "contents",
          "list-item",
          "hidden"
        ],
        type: "exact"
      }) ? undefined : "flex",
      flexDirection: hasTailwindClassName({
        className: other.className,
        classPrefix: [
          "flex-row",
          "flex-col",
          "flex-row-reverse",
          "flex-col-reverse"
        ],
        type: "exact"
      }) ? undefined : "column"
    };
  }, [other.className]);
  const actualStyle = useMemo2(() => {
    return {
      ...defaultStyle,
      ...style
    };
  }, [defaultStyle, style]);
  return /* @__PURE__ */ jsx5("div", {
    ref,
    style: actualStyle,
    ...other
  });
};
var AbsoluteFillElement = React6.memo(forwardRef(AbsoluteFillElementRefForwarding));

// src/use-current-scale.ts
import React10, { createContext as createContext14 } from "react";

// src/portal-node.ts
var _portalNode = null;
var portalNodeCurrentScale = 1;
var portalNodeCurrentScaleListeners = [];
var getPortalNodeCurrentScale = () => portalNodeCurrentScale;
var subscribeToPortalNodeCurrentScale = (listener) => {
  portalNodeCurrentScaleListeners.push(listener);
  return () => {
    portalNodeCurrentScaleListeners = portalNodeCurrentScaleListeners.filter((currentListener) => currentListener !== listener);
  };
};
var setPortalNodeCurrentScale = (scale) => {
  if (portalNodeCurrentScale === scale) {
    return;
  }
  portalNodeCurrentScale = scale;
  for (const listener of portalNodeCurrentScaleListeners) {
    listener();
  }
};
var portalNode = () => {
  if (!_portalNode) {
    if (typeof document === "undefined") {
      throw new Error("Tried to call an API that only works in the browser from outside the browser");
    }
    _portalNode = document.createElement("div");
    _portalNode.style.position = "absolute";
    _portalNode.style.top = "0px";
    _portalNode.style.left = "0px";
    _portalNode.style.right = "0px";
    _portalNode.style.bottom = "0px";
    _portalNode.style.width = "100%";
    _portalNode.style.height = "100%";
    _portalNode.style.display = "flex";
    _portalNode.style.flexDirection = "column";
    const containerNode = document.createElement("div");
    containerNode.style.position = "fixed";
    containerNode.style.top = -999999 + "px";
    containerNode.appendChild(_portalNode);
    document.body.appendChild(containerNode);
  }
  return _portalNode;
};

// src/use-remotion-environment.ts
import { useContext as useContext4, useState } from "react";

// src/remotion-environment-context.ts
import React7 from "react";
var RemotionEnvironmentContext = React7.createContext(null);

// src/use-remotion-environment.ts
var useRemotionEnvironment = () => {
  const context = useContext4(RemotionEnvironmentContext);
  const [env] = useState(() => getRemotionEnvironment());
  return context ?? env;
};

// src/use-unsafe-video-config.ts
import { useContext as useContext7, useMemo as useMemo6 } from "react";

// src/SequenceContext.tsx
import { createContext as createContext10 } from "react";
var SequenceContext = createContext10(null);

// src/use-video.tsx
import { createContext as createContext13, useContext as useContext6, useMemo as useMemo5 } from "react";

// src/ResolveCompositionConfig.tsx
import { createContext as createContext12, createRef, useContext as useContext5, useMemo as useMemo4 } from "react";

// src/input-props-override.ts
var getKey = () => {
  return `remotion_inputPropsOverride` + window.location.origin;
};
var getInputPropsOverride = () => {
  if (typeof localStorage === "undefined")
    return null;
  const override = localStorage.getItem(getKey());
  if (!override)
    return null;
  return JSON.parse(override);
};
var setInputPropsOverride = (override) => {
  if (typeof localStorage === "undefined")
    return;
  if (override === null) {
    localStorage.removeItem(getKey());
    return;
  }
  localStorage.setItem(getKey(), JSON.stringify(override));
};

// src/config/input-props.ts
var didWarnSSRImport = false;
var warnOnceSSRImport = () => {
  if (didWarnSSRImport) {
    return;
  }
  didWarnSSRImport = true;
  console.warn("Called `getInputProps()` on the server. This function is not available server-side and has returned an empty object.");
  console.warn("To hide this warning, don't call this function on the server:");
  console.warn("  typeof window === 'undefined' ? {} : getInputProps()");
};
var getInputProps = () => {
  if (typeof window === "undefined") {
    warnOnceSSRImport();
    return {};
  }
  if (getRemotionEnvironment().isPlayer) {
    throw new Error("You cannot call `getInputProps()` from a <Player>. Instead, the props are available as React props from component that you passed as `component` prop.");
  }
  const override = getInputPropsOverride();
  if (override) {
    return override;
  }
  if (typeof window === "undefined" || typeof window.remotion_inputProps === "undefined") {
    throw new Error("Cannot call `getInputProps()` - window.remotion_inputProps is not set. This API is only available if you are in the Studio, or while you are rendering server-side.");
  }
  const param = window.remotion_inputProps;
  if (!param) {
    return {};
  }
  const parsed = deserializeJSONWithSpecialTypes(param);
  return parsed;
};

// src/EditorProps.tsx
import React8, { createContext as createContext11, useCallback, useMemo as useMemo3 } from "react";
import { jsx as jsx6 } from "react/jsx-runtime";
var EditorPropsContext = createContext11({
  props: {},
  updateProps: () => {
    throw new Error("Not implemented");
  }
});
var timeValueRef = React8.createRef();
var EditorPropsProvider = ({ children }) => {
  const [props, setProps] = React8.useState({});
  const updateProps = useCallback(({
    defaultProps,
    id,
    newProps
  }) => {
    setProps((prev) => {
      return {
        ...prev,
        [id]: typeof newProps === "function" ? newProps(prev[id] ?? defaultProps) : newProps
      };
    });
  }, []);
  const ctx = useMemo3(() => {
    return { props, updateProps };
  }, [props, updateProps]);
  return /* @__PURE__ */ jsx6(EditorPropsContext.Provider, {
    value: ctx,
    children
  });
};

// src/validation/validate-dimensions.ts
function validateDimension(amount, nameOfProp, location) {
  if (typeof amount !== "number") {
    throw new Error(`The "${nameOfProp}" prop ${location} must be a number, but you passed a value of type ${typeof amount}`);
  }
  if (isNaN(amount)) {
    throw new TypeError(`The "${nameOfProp}" prop ${location} must not be NaN, but is NaN.`);
  }
  if (!Number.isFinite(amount)) {
    throw new TypeError(`The "${nameOfProp}" prop ${location} must be finite, but is ${amount}.`);
  }
  if (amount % 1 !== 0) {
    throw new TypeError(`The "${nameOfProp}" prop ${location} must be an integer, but is ${amount}.`);
  }
  if (amount <= 0) {
    throw new TypeError(`The "${nameOfProp}" prop ${location} must be positive, but got ${amount}.`);
  }
}

// src/validation/validate-duration-in-frames.ts
function validateDurationInFrames(durationInFrames, options) {
  const { allowFloats, component } = options;
  if (typeof durationInFrames === "undefined") {
    throw new Error(`The "durationInFrames" prop ${component} is missing.`);
  }
  if (typeof durationInFrames !== "number") {
    throw new Error(`The "durationInFrames" prop ${component} must be a number, but you passed a value of type ${typeof durationInFrames}`);
  }
  if (durationInFrames <= 0) {
    throw new TypeError(`The "durationInFrames" prop ${component} must be positive, but got ${durationInFrames}.`);
  }
  if (!Number.isFinite(durationInFrames)) {
    throw new TypeError(`The "durationInFrames" prop ${component} must be finite, but got ${durationInFrames}.`);
  }
  if (!allowFloats && durationInFrames % 1 !== 0) {
    throw new TypeError(`The "durationInFrames" prop ${component} must be an integer, but got ${durationInFrames}.`);
  }
}

// src/validation/validate-fps.ts
function validateFps(fps, location, isGif) {
  if (typeof fps !== "number") {
    throw new Error(`"fps" must be a number, but you passed a value of type ${typeof fps} ${location}`);
  }
  if (!Number.isFinite(fps)) {
    throw new Error(`"fps" must be a finite, but you passed ${fps} ${location}`);
  }
  if (isNaN(fps)) {
    throw new Error(`"fps" must not be NaN, but got ${fps} ${location}`);
  }
  if (fps <= 0) {
    throw new TypeError(`"fps" must be positive, but got ${fps} ${location}`);
  }
  if (isGif && fps > 50) {
    throw new TypeError(`The FPS for a GIF cannot be higher than 50. Use the --every-nth-frame option to lower the FPS: https://remotion.dev/docs/render-as-gif`);
  }
}

// src/ResolveCompositionConfig.tsx
var ResolveCompositionContext = createContext12(null);
var resolveCompositionsRef = createRef();
var needsResolution = (composition) => {
  return Boolean(composition.calculateMetadata);
};
var useResolvedVideoConfig = (preferredCompositionId) => {
  const context = useContext5(ResolveCompositionContext);
  const { props: allEditorProps } = useContext5(EditorPropsContext);
  const {
    compositions,
    canvasContent,
    currentCompositionMetadata,
    currentAssetMetadata
  } = useContext5(CompositionManager);
  const currentComposition = canvasContent?.type === "composition" ? canvasContent.compositionId : null;
  const compositionId = preferredCompositionId ?? currentComposition;
  const composition = compositions.find((c) => c.id === compositionId);
  const selectedEditorProps = useMemo4(() => {
    return composition ? allEditorProps[composition.id] ?? {} : {};
  }, [allEditorProps, composition]);
  const env = useRemotionEnvironment();
  return useMemo4(() => {
    if (preferredCompositionId === null && canvasContent?.type === "asset" && currentAssetMetadata?.asset === canvasContent.asset) {
      return {
        type: "success",
        metadataSource: null,
        result: {
          ...currentAssetMetadata,
          id: getAssetPreviewCompositionId(canvasContent.asset),
          defaultProps: {}
        }
      };
    }
    if (!composition) {
      return null;
    }
    if (currentCompositionMetadata) {
      return {
        type: "success",
        metadataSource: null,
        result: {
          ...currentCompositionMetadata,
          id: composition.id,
          defaultProps: composition.defaultProps ?? {}
        }
      };
    }
    if (!needsResolution(composition)) {
      validateDurationInFrames(composition.durationInFrames, {
        allowFloats: false,
        component: `in <Composition id="${composition.id}">`
      });
      validateFps(composition.fps, `in <Composition id="${composition.id}">`, false);
      validateDimension(composition.width, "width", `in <Composition id="${composition.id}">`);
      validateDimension(composition.height, "height", `in <Composition id="${composition.id}">`);
      return {
        type: "success",
        metadataSource: null,
        result: {
          width: composition.width,
          height: composition.height,
          fps: composition.fps,
          id: composition.id,
          durationInFrames: composition.durationInFrames,
          defaultProps: composition.defaultProps ?? {},
          props: {
            ...composition.defaultProps ?? {},
            ...selectedEditorProps ?? {},
            ...typeof window === "undefined" || env.isPlayer || !window.remotion_inputProps ? {} : getInputProps() ?? {}
          },
          defaultCodec: null,
          defaultOutName: null,
          defaultVideoImageFormat: null,
          defaultPixelFormat: null,
          defaultProResProfile: null,
          defaultSampleRate: null
        }
      };
    }
    if (!context) {
      return null;
    }
    if (!context[composition.id]) {
      return null;
    }
    return context[composition.id];
  }, [
    composition,
    canvasContent,
    context,
    currentAssetMetadata,
    currentCompositionMetadata,
    preferredCompositionId,
    selectedEditorProps,
    env.isPlayer
  ]);
};

// src/use-video.tsx
import { jsx as jsx7 } from "react/jsx-runtime";
var AssetPreviewComposition = () => null;
var VideoContext = createContext13(null);
var VideoProvider = ({ children }) => {
  const {
    canvasContent,
    compositions,
    currentCompositionMetadata,
    currentAssetMetadata
  } = useContext6(CompositionManager);
  const selected = compositions.find((c) => {
    return canvasContent?.type === "composition" && c.id === canvasContent.compositionId;
  });
  const resolved = useResolvedVideoConfig(selected?.id ?? null);
  const video = useMemo5(() => {
    if (canvasContent?.type === "asset" && currentAssetMetadata?.asset === canvasContent.asset) {
      return {
        ...currentAssetMetadata,
        id: getAssetPreviewCompositionId(canvasContent.asset),
        defaultProps: {},
        component: AssetPreviewComposition
      };
    }
    if (!resolved) {
      return null;
    }
    if (resolved.type === "error") {
      return null;
    }
    if (resolved.type === "loading") {
      return null;
    }
    if (!selected) {
      return null;
    }
    return {
      ...resolved.result,
      defaultProps: selected.defaultProps ?? {},
      id: selected.id,
      ...currentCompositionMetadata ?? {},
      component: selected.component
    };
  }, [
    canvasContent,
    currentAssetMetadata,
    currentCompositionMetadata,
    resolved,
    selected
  ]);
  return /* @__PURE__ */ jsx7(VideoContext.Provider, {
    value: video,
    children
  });
};
var useVideo = () => {
  return useContext6(VideoContext);
};

// src/use-unsafe-video-config.ts
var useUnsafeVideoConfig = () => {
  const context = useContext7(SequenceContext);
  const ctxWidth = context?.width ?? null;
  const ctxHeight = context?.height ?? null;
  const ctxDuration = context?.durationInFrames ?? null;
  const video = useVideo();
  return useMemo6(() => {
    if (!video) {
      return null;
    }
    const {
      id,
      durationInFrames,
      fps,
      height,
      width,
      defaultProps,
      props,
      defaultCodec,
      defaultOutName,
      defaultVideoImageFormat,
      defaultPixelFormat,
      defaultProResProfile,
      defaultSampleRate
    } = video;
    return {
      id,
      width: ctxWidth ?? width,
      height: ctxHeight ?? height,
      fps,
      durationInFrames: ctxDuration ?? durationInFrames,
      defaultProps,
      props,
      defaultCodec,
      defaultOutName,
      defaultVideoImageFormat,
      defaultPixelFormat,
      defaultProResProfile,
      defaultSampleRate
    };
  }, [ctxDuration, ctxHeight, ctxWidth, video]);
};

// src/use-current-scale.ts
var CurrentScaleContext = React10.createContext(null);
var PreviewSizeContext = createContext14({
  setSize: () => {
    return;
  },
  size: { size: "auto", translation: { x: 0, y: 0 } }
});
var calculateScale = ({
  canvasSize,
  compositionHeight,
  compositionWidth,
  previewSize
}) => {
  const heightRatio = canvasSize.height / compositionHeight;
  const widthRatio = canvasSize.width / compositionWidth;
  const ratio = Math.min(heightRatio, widthRatio);
  if (previewSize === "auto") {
    if (ratio === 0) {
      return 1;
    }
    return ratio;
  }
  return Number(previewSize);
};
var useCurrentScale = (options) => {
  const hasContext = React10.useContext(CurrentScaleContext);
  const zoomContext = React10.useContext(PreviewSizeContext);
  const config = useUnsafeVideoConfig();
  const env = useRemotionEnvironment();
  const [portalScale, setPortalScale] = React10.useState(getPortalNodeCurrentScale);
  React10.useEffect(() => {
    const update = () => setPortalScale(getPortalNodeCurrentScale());
    update();
    return subscribeToPortalNodeCurrentScale(update);
  }, []);
  if (hasContext === null || config === null || zoomContext === null) {
    if (options?.dontThrowIfOutsideOfRemotion) {
      return 1;
    }
    if (env.isRendering) {
      return 1;
    }
    throw new Error([
      "useCurrentScale() was called outside of a Remotion context.",
      "This hook can only be called in a component that is being rendered by Remotion.",
      "If you want to this hook to return 1 outside of Remotion, pass {dontThrowIfOutsideOfRemotion: true} as an option.",
      "If you think you called this hook in a Remotion component, make sure all versions of Remotion are aligned."
    ].join(`
`));
  }
  if (hasContext.type === "scale") {
    return hasContext.scale;
  }
  return portalScale;
};

// src/loading-indicator.tsx
import { jsx as jsx8, jsxs } from "react/jsx-runtime";
var rotate = {
  transform: `rotate(90deg)`
};
var ICON_SIZE = 40;
var LABEL_SIZE = 14;
var label = {
  color: "rgba(255, 255, 255, 0.8)",
  fontFamily: "sans-serif"
};
var container = {
  justifyContent: "center",
  alignItems: "center",
  backgroundColor: "#1f2428"
};
var content = {
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  animation: "anim 2s",
  animationFillMode: "forwards"
};
var Loading = () => {
  const scale = useCurrentScale({ dontThrowIfOutsideOfRemotion: true });
  return /* @__PURE__ */ jsxs(AbsoluteFillElement, {
    style: container,
    id: "remotion-comp-loading",
    children: [
      /* @__PURE__ */ jsx8("style", {
        type: "text/css",
        children: `
				@keyframes anim {
					from {
						opacity: 0
					}
					to {
						opacity: 1
					}
				}
			`
      }),
      /* @__PURE__ */ jsxs("div", {
        id: "remotion-comp-loading-content",
        style: content,
        children: [
          /* @__PURE__ */ jsx8("svg", {
            width: ICON_SIZE / scale,
            height: ICON_SIZE / scale,
            viewBox: "-100 -100 400 400",
            style: rotate,
            children: /* @__PURE__ */ jsx8("path", {
              fill: "#555",
              stroke: "#555",
              strokeWidth: "100",
              strokeLinejoin: "round",
              d: "M 2 172 a 196 100 0 0 0 195 5 A 196 240 0 0 0 100 2.259 A 196 240 0 0 0 2 172 z"
            })
          }),
          /* @__PURE__ */ jsxs("p", {
            style: { ...label, fontSize: LABEL_SIZE / scale },
            children: [
              "Resolving ",
              "<Suspense>",
              "..."
            ]
          })
        ]
      })
    ]
  });
};

// src/use-delay-render.tsx
import { createContext as createContext16, useCallback as useCallback2, useContext as useContext9 } from "react";

// src/cancel-render.ts
var getErrorStackWithMessage = (error) => {
  const stack = error.stack ?? "";
  return stack.startsWith("Error:") ? stack : `${error.message}
${stack}`;
};
var isErrorLike = (err) => {
  if (err instanceof Error) {
    return true;
  }
  if (err === null) {
    return false;
  }
  if (typeof err !== "object") {
    return false;
  }
  if (!("stack" in err)) {
    return false;
  }
  if (typeof err.stack !== "string") {
    return false;
  }
  if (!("message" in err)) {
    return false;
  }
  if (typeof err.message !== "string") {
    return false;
  }
  return true;
};
function cancelRenderInternal(scope, err) {
  let error;
  if (isErrorLike(err)) {
    error = err;
    if (!error.stack) {
      error.stack = new Error(error.message).stack;
    }
  } else if (typeof err === "string") {
    error = Error(err);
  } else {
    error = Error("Rendering was cancelled");
  }
  if (scope) {
    scope.remotion_cancelledErrorObject = error;
    scope.remotion_cancelledError = getErrorStackWithMessage(error);
  }
  throw error;
}
function cancelRender(err) {
  return cancelRenderInternal(typeof window !== "undefined" ? window : undefined, err);
}

// src/delay-render-constants.ts
var DELAY_RENDER_CALLSTACK_TOKEN = "The delayRender was called:";
var DELAY_RENDER_RETRIES_LEFT = "Retries left: ";
var DELAY_RENDER_RETRY_TOKEN = "- Rendering the frame will be retried.";
var DELAY_RENDER_CLEAR_TOKEN = "handle was cleared after";

// src/log.ts
var logLevels = ["trace", "verbose", "info", "warn", "error"];
var getNumberForLogLevel = (level) => {
  return logLevels.indexOf(level);
};
var isEqualOrBelowLogLevel = (currentLevel, level) => {
  return getNumberForLogLevel(currentLevel) <= getNumberForLogLevel(level);
};
var transformArgs = ({
  args,
  logLevel,
  tag
}) => {
  const arr = [...args];
  if (getRemotionEnvironment().isRendering && !getRemotionEnvironment().isClientSideRendering) {
    arr.unshift(Symbol.for(`__remotion_level_${logLevel}`));
  }
  if (tag && getRemotionEnvironment().isRendering && !getRemotionEnvironment().isClientSideRendering) {
    arr.unshift(Symbol.for(`__remotion_tag_${tag}`));
  }
  return arr;
};
var verbose = (options, ...args) => {
  if (isEqualOrBelowLogLevel(options.logLevel, "verbose")) {
    return console.debug(...transformArgs({ args, logLevel: "verbose", tag: options.tag }));
  }
};
var trace = (options, ...args) => {
  if (isEqualOrBelowLogLevel(options.logLevel, "trace")) {
    return console.debug(...transformArgs({ args, logLevel: "trace", tag: options.tag }));
  }
};
var info = (options, ...args) => {
  if (isEqualOrBelowLogLevel(options.logLevel, "info")) {
    return console.log(...transformArgs({ args, logLevel: "info", tag: options.tag }));
  }
};
var warn = (options, ...args) => {
  if (isEqualOrBelowLogLevel(options.logLevel, "warn")) {
    return console.warn(...transformArgs({ args, logLevel: "warn", tag: options.tag }));
  }
};
var error = (options, ...args) => {
  return console.error(...transformArgs({ args, logLevel: "error", tag: options.tag }));
};
var Log = {
  trace,
  verbose,
  info,
  warn,
  error
};

// src/delay-render.ts
if (typeof window !== "undefined") {
  window.remotion_renderReady = false;
  if (!window.remotion_delayRenderTimeouts) {
    window.remotion_delayRenderTimeouts = {};
  }
  window.remotion_delayRenderHandles = [];
}
var defaultTimeout = 30000;
var delayRenderInternal = ({
  scope,
  environment,
  label,
  options
}) => {
  if (typeof label !== "string" && label !== null) {
    throw new Error("The label parameter of delayRender() must be a string or undefined, got: " + JSON.stringify(label));
  }
  const handle = Math.random();
  scope.remotion_delayRenderHandles.push(handle);
  const called = Error().stack?.replace(/^Error/g, "") ?? "";
  if (environment.isRendering) {
    const timeoutToUse = Math.max(0, (options?.timeoutInMilliseconds ?? scope.remotion_puppeteerTimeout ?? defaultTimeout) - 2000);
    const retriesLeft = (options?.retries ?? 0) - (scope.remotion_attempt - 1);
    scope.remotion_delayRenderTimeouts[handle] = {
      label: label ?? null,
      startTime: Date.now(),
      timeout: setTimeout(() => {
        const message = [
          `A delayRender()`,
          label ? `"${label}"` : null,
          `was called but not cleared after ${timeoutToUse}ms. See https://remotion.dev/docs/timeout for help.`,
          retriesLeft > 0 ? DELAY_RENDER_RETRIES_LEFT + retriesLeft : null,
          retriesLeft > 0 ? DELAY_RENDER_RETRY_TOKEN : null,
          DELAY_RENDER_CALLSTACK_TOKEN,
          called
        ].filter(truthy).join(" ");
        if (environment.isClientSideRendering) {
          const error = Error(message);
          scope.remotion_cancelledErrorObject = error;
          scope.remotion_cancelledError = getErrorStackWithMessage(error);
        } else {
          cancelRenderInternal(scope, Error(message));
        }
      }, timeoutToUse)
    };
  }
  scope.remotion_renderReady = false;
  return handle;
};
var delayRender = (label, options) => {
  if (typeof window === "undefined") {
    return Math.random();
  }
  return delayRenderInternal({
    scope: window,
    environment: getRemotionEnvironment(),
    label: label ?? null,
    options: options ?? {}
  });
};
var continueRenderInternal = ({
  scope,
  handle,
  environment,
  logLevel
}) => {
  if (typeof handle === "undefined") {
    throw new TypeError("The continueRender() method must be called with a parameter that is the return value of delayRender(). No value was passed.");
  }
  if (typeof handle !== "number") {
    throw new TypeError("The parameter passed into continueRender() must be the return value of delayRender() which is a number. Got: " + JSON.stringify(handle));
  }
  const handleExists = scope.remotion_delayRenderHandles.includes(handle);
  const timeoutEntry = scope.remotion_delayRenderTimeouts[handle];
  if (handleExists && environment.isRendering && timeoutEntry) {
    const { label, startTime, timeout } = timeoutEntry;
    clearTimeout(timeout);
    const message = [
      label ? `"${label}"` : "A handle",
      DELAY_RENDER_CLEAR_TOKEN,
      `${Date.now() - startTime}ms`
    ].filter(truthy).join(" ");
    Log.verbose({ logLevel, tag: "delayRender()" }, message);
    delete scope.remotion_delayRenderTimeouts[handle];
  }
  scope.remotion_delayRenderHandles = scope.remotion_delayRenderHandles.filter((h) => h !== handle);
  if (scope.remotion_delayRenderHandles.length === 0) {
    scope.remotion_renderReady = true;
  }
};
var continueRender = (handle) => {
  if (typeof window === "undefined") {
    return;
  }
  continueRenderInternal({
    scope: window,
    handle,
    environment: getRemotionEnvironment(),
    logLevel: window.remotion_logLevel ?? "info"
  });
};

// src/log-level-context.tsx
import { createContext as createContext15 } from "react";
import * as React11 from "react";
var LogLevelContext = createContext15({
  logLevel: "info",
  mountTime: 0
});
var useLogLevel = () => {
  const { logLevel } = React11.useContext(LogLevelContext);
  if (logLevel === null) {
    throw new Error("useLogLevel must be used within a LogLevelProvider");
  }
  return logLevel;
};
var useMountTime = () => {
  const { mountTime } = React11.useContext(LogLevelContext);
  if (mountTime === null) {
    throw new Error("useMountTime must be used within a LogLevelProvider");
  }
  return mountTime;
};

// src/use-delay-render.tsx
var DelayRenderContextType = createContext16(null);
var useDelayRender = () => {
  const environment = useRemotionEnvironment();
  const scope = useContext9(DelayRenderContextType) ?? (typeof window !== "undefined" ? window : undefined);
  const logLevel = useLogLevel();
  const delayRender = useCallback2((label, options) => {
    if (!scope) {
      return Math.random();
    }
    return delayRenderInternal({
      scope,
      environment,
      label: label ?? null,
      options: options ?? {}
    });
  }, [environment, scope]);
  const continueRender = useCallback2((handle) => {
    if (!scope) {
      return;
    }
    continueRenderInternal({
      scope,
      handle,
      environment,
      logLevel
    });
  }, [environment, logLevel, scope]);
  const cancelRender = useCallback2((err) => {
    return cancelRenderInternal(scope ?? (typeof window !== "undefined" ? window : undefined), err);
  }, [scope]);
  return { delayRender, continueRender, cancelRender };
};

// src/use-lazy-component.ts
import React13, { useEffect as useEffect3, useLayoutEffect as useLayoutEffect3, useMemo as useMemo7 } from "react";

// src/registry-store.ts
var areRegistryEntriesEqual = (previous, next) => {
  const keys = Object.keys(previous);
  return keys.length === Object.keys(next).length && keys.every((key) => Object.prototype.hasOwnProperty.call(next, key) && Object.is(Reflect.get(previous, key), Reflect.get(next, key)));
};
var reconcileRegistryEntries = ({
  current,
  entries,
  previousDescriptors,
  previousKeys,
  nextKeys,
  getKey,
  order,
  orderProperty
}) => {
  const previousByKey = new Map(current.map((entry) => [getKey(entry), entry]));
  const next = entries.map((entry) => {
    const key = getKey(entry);
    const previous = previousByKey.get(key);
    const nextOrder = order.get(key) ?? null;
    if (previous && previousDescriptors.get(key) === entry && previous[orderProperty] === nextOrder) {
      return previous;
    }
    const registered = { ...entry, [orderProperty]: nextOrder };
    return previous && areRegistryEntriesEqual(previous, registered) ? previous : registered;
  });
  for (const entry of current) {
    const key = getKey(entry);
    if (!previousKeys.has(key) && !nextKeys.has(key)) {
      const nextOrder = order.get(key) ?? entry[orderProperty];
      next.push(entry[orderProperty] === nextOrder ? entry : { ...entry, [orderProperty]: nextOrder });
    }
  }
  return next.length === current.length && next.every((entry, index) => entry === current[index]) ? current : next;
};
var createRegistryStore = (initialSnapshot) => {
  let snapshot = initialSnapshot;
  const listeners = new Set;
  return {
    getSnapshot: () => snapshot,
    subscribe: (listener) => {
      listeners.add(listener);
      return () => {
        listeners.delete(listener);
      };
    },
    setSnapshot: (update) => {
      const next = update(snapshot);
      if (next === snapshot) {
        return;
      }
      snapshot = next;
      for (const listener of [...listeners]) {
        listener();
      }
    }
  };
};

// src/use-sync-external-store.ts
import * as React12 from "react";
var objectIs = typeof Object.is === "function" ? Object.is : (first, second) => first === second && (first !== 0 || 1 / first === 1 / second) || Number.isNaN(first) && Number.isNaN(second);
var checkIfSnapshotChanged = (instance) => {
  try {
    return !objectIs(instance.value, instance.getSnapshot());
  } catch {
    return true;
  }
};
var useSyncExternalStoreShimClient = (subscribe, getSnapshot) => {
  const value = getSnapshot();
  if (false) {}
  const [{ instance }, forceUpdate] = React12.useState({
    instance: { value, getSnapshot }
  });
  React12.useLayoutEffect(() => {
    instance.value = value;
    instance.getSnapshot = getSnapshot;
    if (checkIfSnapshotChanged(instance)) {
      forceUpdate({ instance });
    }
  }, [getSnapshot, instance, subscribe, value]);
  React12.useEffect(() => {
    if (checkIfSnapshotChanged(instance)) {
      forceUpdate({ instance });
    }
    return subscribe(() => {
      if (checkIfSnapshotChanged(instance)) {
        forceUpdate({ instance });
      }
    });
  }, [instance, subscribe]);
  React12.useDebugValue(value);
  return value;
};
var useSyncExternalStoreShimServer = (_subscribe, getSnapshot) => getSnapshot();
var shim = typeof window === "undefined" || typeof window.document === "undefined" || typeof window.document.createElement === "undefined" ? useSyncExternalStoreShimServer : useSyncExternalStoreShimClient;
var useSyncExternalStore2 = React12.useSyncExternalStore ?? shim;

// src/use-lazy-component.ts
var useIsomorphicLayoutEffect2 = typeof window === "undefined" ? useEffect3 : useLayoutEffect3;
var createComponentWrapper = (componentStore) => {
  const Wrapper = (props) => {
    const Comp = useSyncExternalStore2(componentStore.subscribe, componentStore.getSnapshot, componentStore.getSnapshot);
    return React13.createElement(Comp, props);
  };
  return Wrapper;
};
var useLazyComponent = ({
  compProps,
  componentName,
  noSuspense
}) => {
  const componentFromProps = "component" in compProps ? compProps.component : null;
  if (componentFromProps === undefined && typeof document !== "undefined" && !noSuspense) {
    throw new Error(`A value of \`undefined\` was passed to the \`component\` prop. Check the value you are passing to the <${componentName}/> component.`);
  }
  const lazyComponentFromProps = "lazyComponent" in compProps ? compProps.lazyComponent : null;
  const componentStore = useMemo7(() => createRegistryStore(componentFromProps ?? null), [lazyComponentFromProps]);
  useIsomorphicLayoutEffect2(() => {
    if (componentFromProps !== null && componentFromProps !== undefined) {
      componentStore.setSnapshot(() => componentFromProps);
    }
  }, [componentFromProps, componentStore]);
  const createWrapper = createComponentWrapper;
  const Wrapper = useMemo7(createWrapper.bind(null, componentStore), [
    componentStore
  ]);
  const lazy = useMemo7(() => {
    if ("component" in compProps) {
      return Wrapper;
    }
    if ("lazyComponent" in compProps && typeof compProps.lazyComponent !== "undefined") {
      if (typeof compProps.lazyComponent === "undefined") {
        throw new Error(`A value of \`undefined\` was passed to the \`lazyComponent\` prop. Check the value you are passing to the <${componentName}/> component.`);
      }
      return React13.lazy(compProps.lazyComponent);
    }
    throw new Error("You must pass either 'component' or 'lazyComponent'");
  }, [lazyComponentFromProps, componentStore, Wrapper]);
  if ("component" in compProps && (typeof document === "undefined" || noSuspense)) {
    return compProps.component;
  }
  return lazy;
};

// src/validation/validate-composition-id.ts
var getRegex2 = () => /^([a-zA-Z0-9-\u4E00-\u9FFF])+$/g;
var isCompositionIdValid = (id) => id.match(getRegex2());
var validateCompositionId = (id) => {
  if (!isCompositionIdValid(id)) {
    throw new Error(`Composition id can only contain a-z, A-Z, 0-9, CJK characters and -. You passed ${id}`);
  }
};
var invalidCompositionErrorMessage = `Composition ID must match ${String(getRegex2())}`;

// src/validation/validate-default-props.ts
var validateDefaultAndInputProps = (defaultProps, name, compositionId) => {
  if (!defaultProps) {
    return;
  }
  if (typeof defaultProps !== "object") {
    throw new Error(`"${name}" must be an object, but you passed a value of type ${typeof defaultProps}`);
  }
  if (Array.isArray(defaultProps)) {
    throw new Error(`"${name}" must be an object, an array was passed ${compositionId ? `for composition "${compositionId}"` : ""}`);
  }
};

// src/Composition.tsx
import { jsx as jsx9 } from "react/jsx-runtime";
var Fallback = () => {
  const { continueRender, delayRender } = useDelayRender();
  useEffect4(() => {
    const fallback = delayRender("Waiting for Root component to unsuspend");
    return () => continueRender(fallback);
  }, [continueRender, delayRender]);
  return null;
};
var InnerComposition = ({
  width,
  height,
  fps,
  durationInFrames,
  id,
  defaultProps,
  schema,
  ...compProps
}) => {
  const video = useVideo();
  const lazy = useLazyComponent({
    compProps,
    componentName: "Composition",
    noSuspense: false
  });
  const isPlayer = useIsPlayer();
  const environment = useRemotionEnvironment();
  const canUseComposition = useContext10(CanUseRemotionHooks);
  if (typeof window !== "undefined") {
    window.remotion_seenCompositionIds = Array.from(new Set([...window.remotion_seenCompositionIds ?? [], id]));
  }
  if (canUseComposition) {
    if (isPlayer) {
      throw new Error("<Composition> was mounted inside the `component` that was passed to the <Player>. See https://remotion.dev/docs/wrong-composition-mount for help.");
    }
    throw new Error("<Composition> mounted inside another composition. See https://remotion.dev/docs/wrong-composition-mount for help.");
  }
  const { folderName, parentName } = useContext10(FolderContext);
  const stack = compProps._remotionInternalStack ?? null;
  const componentFromProps = "component" in compProps ? resolveComponentIdentity(compProps.component) : null;
  const registration = useMemo8(() => {
    if (!id) {
      throw new Error("No id for composition passed.");
    }
    validateCompositionId(id);
    validateDefaultAndInputProps(defaultProps, "defaultProps", id);
    return {
      durationInFrames: durationInFrames ?? undefined,
      fps: fps ?? undefined,
      height: height ?? undefined,
      width: width ?? undefined,
      id,
      folderName,
      component: lazy,
      defaultProps: serializeThenDeserializeInStudio(defaultProps ?? {}),
      order: null,
      parentFolderName: parentName,
      componentFromProps,
      schema: schema ?? null,
      calculateMetadata: compProps.calculateMetadata ?? null,
      stack
    };
  }, [
    durationInFrames,
    fps,
    height,
    lazy,
    id,
    folderName,
    defaultProps,
    width,
    parentName,
    componentFromProps,
    schema,
    compProps.calculateMetadata,
    stack
  ]);
  const metadata = useMemo8(() => ({ type: "composition", id, value: registration }), [id, registration]);
  useCommittedCompositionEntry(metadata);
  const resolved = useResolvedVideoConfig(id);
  const { setError: onError, clearError: onClear } = useContext10(CompositionRenderErrorContext);
  const wrapRegistration = (content) => /* @__PURE__ */ jsx9(CommittedMetadataProvider, {
    value: null,
    _remotionCommitMetadata: metadata,
    children: content
  });
  if (environment.isStudio && video && video.component === lazy && video.id === id) {
    const Comp = lazy;
    if (resolved === null || resolved.type !== "success" && resolved.type !== "success-and-refreshing") {
      return wrapRegistration(null);
    }
    return wrapRegistration(createPortal(/* @__PURE__ */ jsx9(CanUseRemotionHooksProvider, {
      children: /* @__PURE__ */ jsx9(CompositionErrorBoundary, {
        onError,
        onClear,
        children: /* @__PURE__ */ jsx9(Suspense, {
          fallback: /* @__PURE__ */ jsx9(Loading, {}),
          children: /* @__PURE__ */ jsx9(Comp, {
            ...resolved.result.props ?? {}
          })
        })
      })
    }), portalNode()));
  }
  if (environment.isRendering && video && video.component === lazy && video.id === id) {
    const Comp = lazy;
    if (resolved === null || resolved.type !== "success" && resolved.type !== "success-and-refreshing") {
      return wrapRegistration(null);
    }
    return wrapRegistration(createPortal(/* @__PURE__ */ jsx9(CanUseRemotionHooksProvider, {
      children: /* @__PURE__ */ jsx9(Suspense, {
        fallback: /* @__PURE__ */ jsx9(Fallback, {}),
        children: /* @__PURE__ */ jsx9(Comp, {
          ...resolved.result.props ?? {}
        })
      })
    }), portalNode()));
  }
  return wrapRegistration(null);
};
var Composition = (props) => {
  const { onlyRenderComposition } = useContext10(CompositionSetters);
  if (onlyRenderComposition && onlyRenderComposition !== props.id) {
    return null;
  }
  return /* @__PURE__ */ jsx9(InnerComposition, {
    ...props
  });
};

// src/enable-sequence-stack-traces.ts
var componentsToAddStacksTo = [];
var sequenceComponent = null;
var setSequenceComponent = (component) => {
  sequenceComponent = component;
};
var getSequenceComponent = () => sequenceComponent;
var stacksByControls = new WeakMap;
var REMOTION_INTERNAL_STACK_PROP = "_remotionInternalStack";
var ORIGINAL_SOURCE_STACK_PREFIX = "studio-original://";
var originalSourceStackPattern = /\(studio-original:\/\/([^\r\n]+):(\d+):(\d+)\)/;
var makeOriginalSourceStack = ({
  fileName,
  lineNumber,
  columnNumber
}, compiledSourceHash = null) => {
  const location = `Error
    at remotionOriginalSource (${ORIGINAL_SOURCE_STACK_PREFIX}${encodeURIComponent(fileName)}:${lineNumber}:${columnNumber})`;
  return compiledSourceHash === null ? location : `${location}
    at remotionCompiledSource (remotion-source-sha256:${compiledSourceHash})`;
};
var parseOriginalSourceStack = (stack) => {
  if (!stack) {
    return null;
  }
  const match = stack.match(originalSourceStackPattern);
  if (!match) {
    return null;
  }
  return {
    fileName: decodeURIComponent(match[1]),
    line: Number(match[2]),
    column: Number(match[3])
  };
};
var getComponentsToAddStacksTo = () => componentsToAddStacksTo;
var addSequenceStackTraces = (component) => {
  componentsToAddStacksTo.push(component);
};
var setStackForControls = (controls, stack) => {
  if (stack === undefined) {
    stacksByControls.delete(controls);
    return;
  }
  stacksByControls.set(controls, stack);
};
var getStackForControls = (controls) => {
  return stacksByControls.get(controls) ?? null;
};

// src/version.ts
var VERSION = "4.0.540";

// src/multiple-versions-warning.ts
var checkMultipleRemotionVersions = () => {
  if (typeof globalThis === "undefined") {
    return;
  }
  const set = () => {
    globalThis.remotion_imported = VERSION;
    if (typeof window !== "undefined") {
      window.remotion_imported = VERSION;
    }
  };
  const alreadyImported = globalThis.remotion_imported || typeof window !== "undefined" && window.remotion_imported;
  if (alreadyImported) {
    if (alreadyImported === VERSION) {
      return;
    }
    if (typeof alreadyImported === "string" && alreadyImported.includes("webcodecs")) {
      set();
      return;
    }
    throw new TypeError(`\uD83D\uDEA8 Multiple versions of Remotion detected: ${[
      VERSION,
      typeof alreadyImported === "string" ? alreadyImported : "an older version"
    ].filter(truthy).join(" and ")}. This will cause things to break in an unexpected way.
Check that all your Remotion packages are on the same version. If your dependencies depend on Remotion, make them peer dependencies. You can also run \`npx remotion versions\` from your terminal to see which versions are mismatching.`);
  }
  set();
};

// src/Null.tsx
var Null = () => {
  throw new Error("<Null> has been removed as of Remotion v4.0.228. The native clipping APIs were experimental and subject to removal at any time. We removed them because they were sparingly used and made rendering often slower rather than faster.");
};

// src/Sequence.tsx
import React27, {
  createContext as createContext28,
  forwardRef as forwardRef3,
  useContext as useContext28,
  useLayoutEffect as useLayoutEffect9,
  useMemo as useMemo22,
  useRef as useRef8,
  useState as useState10
} from "react";

// src/DefaultPremountContext.ts
import { createContext as createContext17 } from "react";

// src/v5-flag.ts
var ENABLE_V5_BREAKING_CHANGES = false;
var resolveV5Default = (value) => {
  return value ?? ENABLE_V5_BREAKING_CHANGES;
};

// src/default-premount-in-seconds.ts
var DEFAULT_PREMOUNT_IN_SECONDS = ENABLE_V5_BREAKING_CHANGES ? 2 : 0;

// src/DefaultPremountContext.ts
var DefaultPremountContext = createContext17(DEFAULT_PREMOUNT_IN_SECONDS);

// src/freeze.tsx
import { createContext as createContext21, useContext as useContext17, useMemo as useMemo11 } from "react";

// src/sequence-activity-context.ts
import { createContext as createContext18, useContext as useContext11 } from "react";

// src/sequence-activity-defaults.ts
var DEFAULT_SEQUENCE_ACTIVITY_LIMIT = Infinity;

// src/sequence-activity-context.ts
var SequenceActivityContext = createContext18(false);
var SequenceActivityDormantContext = createContext18(false);
var SequenceActivitySuspensionContext = createContext18(false);
var SequenceActivitySettingsContext = createContext18(null);
var SequenceActivityTimelineContext = createContext18(null);
var SequenceActivityAbsoluteTimeContext = createContext18(null);
var SequenceContent = ({ children }) => {
  return useContext11(SequenceActivityDormantContext) ? null : children;
};

// src/timeline-position-state.ts
import { createContext as createContext20, useContext as useContext14 } from "react";

// src/TimelineContext.tsx
import {
  createContext as createContext19,
  useCallback as useCallback3,
  useLayoutEffect as useLayoutEffect4,
  useMemo as useMemo10,
  useRef as useRef3,
  useState as useState3
} from "react";

// src/runtime-value-store.ts
var createRuntimeValueStore = (initialSnapshot) => {
  let snapshot = initialSnapshot;
  const listeners = new Set;
  const store = {
    getSnapshot: () => snapshot,
    subscribe: (listener) => {
      listeners.add(listener);
      return () => {
        listeners.delete(listener);
      };
    }
  };
  return {
    store,
    setSnapshot: (newSnapshot) => {
      if (snapshot === newSnapshot) {
        return;
      }
      snapshot = newSnapshot;
      for (const listener of listeners) {
        listener(snapshot);
      }
    }
  };
};

// src/use-timeline-seek.ts
import { useMemo as useMemo9, useRef as useRef2 } from "react";
var useTimelineSeek = (setFrame) => {
  const revision = useRef2(0);
  const listeners = useRef2(new Set);
  return useMemo9(() => ({
    revision,
    seekFrame: (frame) => {
      revision.current++;
      for (const listener of listeners.current) {
        listener();
      }
      setFrame(frame);
    },
    subscribe: (listener) => {
      listeners.current.add(listener);
      return () => {
        listeners.current.delete(listener);
      };
    }
  }), [setFrame]);
};

// src/TimelineContext.tsx
import { jsx as jsx10 } from "react/jsx-runtime";
var missingSetTimelineContext = () => {
  throw new Error("SetTimelineContext is missing. This is likely caused by a Remotion version mismatch.");
};
var SetTimelineContext = createContext19({
  seek: null,
  setFrameWithoutSeek: missingSetTimelineContext,
  setPlaying: missingSetTimelineContext,
  setBuffering: missingSetTimelineContext,
  subscribePlaying: () => () => {
    return;
  },
  subscribeBuffering: () => () => {
    return;
  },
  isPlaying: () => false,
  isBuffering: missingSetTimelineContext,
  frameRef: { current: {} },
  audioAndVideoTags: { current: [] }
});
var TimelineContext = createContext19(null);
var PlaybackRateContext = createContext19(null);
var AbsoluteTimeContext = createContext19(null);
var TimelineContextProvider = ({ children, frameState }) => {
  const playingStore = useMemo10(() => createRuntimeValueStore({ playing: false }), []);
  const bufferingStore = useMemo10(() => createRuntimeValueStore({ buffering: false }), []);
  const [playbackRate, setPlaybackRate] = useState3(1);
  const audioAndVideoTags = useRef3([]);
  const [_frame, setFrame] = useState3(() => getInitialFrameState());
  const timelineSeek = useTimelineSeek(setFrame);
  const { isStudio } = useRemotionEnvironment();
  const seek = isStudio ? timelineSeek : null;
  const frame = frameState ?? _frame;
  const frameRef = useRef3(frame);
  frameRef.current = frame;
  const readIsPlaying = useCallback3(() => playingStore.store.getSnapshot().playing, [playingStore]);
  const readIsBuffering = useCallback3(() => bufferingStore.store.getSnapshot().buffering, [bufferingStore]);
  const { delayRender, continueRender } = useDelayRender();
  if (typeof window !== "undefined") {
    useLayoutEffect4(() => {
      window.remotion_setFrame = (f, composition, attempt) => {
        window.remotion_attempt = attempt;
        const id = delayRender(`Setting the current frame to ${f}`);
        let asyncUpdate = true;
        setFrame((s) => {
          const currentFrame = s[composition] ?? window.remotion_initialFrame;
          if (currentFrame === f) {
            asyncUpdate = false;
            return s;
          }
          return {
            ...s,
            [composition]: f
          };
        });
        if (asyncUpdate) {
          requestAnimationFrame(() => continueRender(id));
        } else {
          continueRender(id);
        }
      };
      window.remotion_isPlayer = false;
    }, [continueRender, delayRender]);
  }
  const timelineContextValue = useMemo10(() => {
    return {
      frame,
      isPlaying: readIsPlaying,
      isInsideFreeze: false,
      audioAndVideoTags
    };
  }, [frame, readIsPlaying]);
  const playbackRateContextValue = useMemo10(() => {
    return {
      playbackRate,
      setPlaybackRate
    };
  }, [playbackRate]);
  const setTimelineContextValue = useMemo10(() => {
    return {
      setFrameWithoutSeek: setFrame,
      seek,
      setPlaying: (updater) => {
        const current = playingStore.store.getSnapshot().playing;
        const next = typeof updater === "function" ? updater(current) : updater;
        if (current !== next) {
          playingStore.setSnapshot({ playing: next });
        }
      },
      setBuffering: (buffering) => {
        if (readIsBuffering() !== buffering) {
          bufferingStore.setSnapshot({ buffering });
        }
      },
      subscribePlaying: playingStore.store.subscribe,
      subscribeBuffering: bufferingStore.store.subscribe,
      isPlaying: readIsPlaying,
      isBuffering: readIsBuffering,
      frameRef,
      audioAndVideoTags
    };
  }, [bufferingStore, playingStore, readIsBuffering, readIsPlaying, seek]);
  return /* @__PURE__ */ jsx10(AbsoluteTimeContext.Provider, {
    value: timelineContextValue,
    children: /* @__PURE__ */ jsx10(PlaybackRateContext.Provider, {
      value: playbackRateContextValue,
      children: /* @__PURE__ */ jsx10(TimelineContext.Provider, {
        value: timelineContextValue,
        children: /* @__PURE__ */ jsx10(SetTimelineContext.Provider, {
          value: setTimelineContextValue,
          children
        })
      })
    })
  });
};

// src/use-playing.ts
import { useContext as useContext12 } from "react";
var usePlaying = () => {
  const { isPlaying } = useTimelineContext();
  const { subscribePlaying } = useContext12(SetTimelineContext);
  return useSyncExternalStore2(subscribePlaying, isPlaying, isPlaying);
};
// src/use-buffering.ts
import { useContext as useContext13 } from "react";
var useBuffering = () => {
  const { isBuffering, subscribeBuffering } = useContext13(SetTimelineContext);
  return useSyncExternalStore2(subscribeBuffering, isBuffering, isBuffering);
};

// src/timeline-position-state.ts
var UnsubscribedTimelineContext = createContext20(null);
var makeKey = () => {
  return `remotion.time-all`;
};
var persistCurrentFrame = (time) => {
  localStorage.setItem(makeKey(), JSON.stringify(time));
};
var getInitialFrameState = () => {
  const item = localStorage.getItem(makeKey()) ?? "{}";
  const obj = JSON.parse(item);
  return obj;
};
var getFrameForComposition = (composition) => {
  const item = localStorage.getItem(makeKey()) ?? "{}";
  const obj = JSON.parse(item);
  if (obj[composition] !== undefined) {
    return Number(obj[composition]);
  }
  if (typeof window === "undefined") {
    return 0;
  }
  return window.remotion_initialFrame ?? 0;
};
var clampFrameToCompositionRange = (frame, durationInFrames) => {
  return Math.max(0, Math.min(Math.max(0, durationInFrames - 1), frame));
};
var useTimelinePositionFromContext = (state) => {
  const videoConfig = useVideo();
  const env = useRemotionEnvironment();
  const dormant = useContext14(SequenceActivityDormantContext);
  if (state === null) {
    return 0;
  }
  if (!videoConfig) {
    return typeof window === "undefined" ? 0 : window.remotion_initialFrame ?? 0;
  }
  const unclamped = state.frame[videoConfig.id] ?? (env.isPlayer ? 0 : getFrameForComposition(videoConfig.id));
  return dormant ? unclamped : clampFrameToCompositionRange(unclamped, videoConfig.durationInFrames);
};
var useTimelineContext = () => {
  const dormant = useContext14(SequenceActivityDormantContext);
  const state = useContext14(dormant ? SequenceActivityTimelineContext : TimelineContext);
  if (state === null) {
    throw new Error("TimelineContext is not available. This hook must be used inside a <Player> or the Remotion Studio.");
  }
  return state;
};
var usePlaybackRate = () => {
  const state = useContext14(PlaybackRateContext);
  if (state === null) {
    throw new Error("PlaybackRateContext is not available. This hook must be used inside a <Player> or the Remotion Studio.");
  }
  return state;
};
var useTimelinePosition = () => {
  const state = useTimelineContext();
  return useTimelinePositionFromContext(state);
};
var useTimelinePositionWithOptionalSubscription = (subscribe) => {
  const dormant = useContext14(SequenceActivityDormantContext);
  const state = useContext14(subscribe ? dormant ? SequenceActivityTimelineContext : TimelineContext : UnsubscribedTimelineContext);
  const frame = useTimelinePositionFromContext(state);
  if (subscribe && state === null) {
    throw new Error("TimelineContext is not available. This hook must be used inside a <Player> or the Remotion Studio.");
  }
  return frame;
};
var useIsInsideFreeze = () => {
  return useTimelineContext().isInsideFreeze;
};
var useAbsoluteTimelinePosition = () => {
  const dormant = useContext14(SequenceActivityDormantContext);
  const state = useContext14(dormant ? SequenceActivityAbsoluteTimeContext : AbsoluteTimeContext);
  if (state === null) {
    throw new Error("AbsoluteTimeContext is not available. This hook must be used inside a <Player> or the Remotion Studio.");
  }
  return useTimelinePositionFromContext(state);
};
var useTimelineSetFrameWithoutSeek = () => {
  const { setFrameWithoutSeek } = useContext14(SetTimelineContext);
  return setFrameWithoutSeek;
};
var useTimelineSeekFrame = () => {
  const { seek, setFrameWithoutSeek } = useContext14(SetTimelineContext);
  return seek?.seekFrame ?? setFrameWithoutSeek;
};

// src/use-current-frame.ts
import { useContext as useContext15 } from "react";
var useCurrentFrameWithOptionalSubscription = (subscribe) => {
  const canUseRemotionHooks = useContext15(CanUseRemotionHooks);
  const env = useRemotionEnvironment();
  if (!canUseRemotionHooks) {
    if (env.isPlayer) {
      throw new Error(`useCurrentFrame can only be called inside a component that was passed to <Player>. See: https://www.remotion.dev/docs/player/examples`);
    }
    throw new Error(`useCurrentFrame() can only be called inside a component that was registered as a composition. See https://www.remotion.dev/docs/the-fundamentals#defining-compositions`);
  }
  const frame = useTimelinePositionWithOptionalSubscription(subscribe);
  const context = useContext15(SequenceContext);
  if (!subscribe) {
    return 0;
  }
  const contextOffset = context ? context.cumulatedFrom + context.relativeFrom : 0;
  return (frame - contextOffset) * (context?.playbackRate ?? 1);
};
var useCurrentFrame = () => {
  return useCurrentFrameWithOptionalSubscription(true);
};

// src/use-video-config.ts
import { useContext as useContext16 } from "react";
var useVideoConfig = () => {
  const videoConfig = useUnsafeVideoConfig();
  const context = useContext16(CanUseRemotionHooks);
  const isPlayer = useIsPlayer();
  if (!videoConfig) {
    if (typeof window !== "undefined" && window.remotion_isPlayer || isPlayer) {
      throw new Error([
        "No video config found. Likely reasons:",
        "- You are probably calling useVideoConfig() from outside the component passed to <Player />. See https://www.remotion.dev/docs/player/examples for how to set up the Player correctly.",
        "- You have multiple versions of Remotion installed which causes the React context to get lost."
      ].join("-"));
    }
    throw new Error("No video config found. You are probably calling useVideoConfig() from a component which has not been registered as a <Composition />. See https://www.remotion.dev/docs/the-fundamentals#defining-compositions for more information.");
  }
  if (!context) {
    throw new Error("Called useVideoConfig() outside a Remotion composition.");
  }
  return videoConfig;
};

// src/freeze.tsx
import { jsx as jsx11 } from "react/jsx-runtime";
var NonPremountFreezeContext = createContext21(false);
var useIsInsideNonPremountFreeze = () => useContext17(NonPremountFreezeContext);
var Freeze = ({
  frame: frameToFreeze,
  children,
  active = true,
  _remotionInternalIsPremounting = false
}) => {
  const frame = useCurrentFrame();
  const videoConfig = useVideoConfig();
  if (typeof frameToFreeze === "undefined") {
    throw new Error(`The <Freeze /> component requires a 'frame' prop, but none was passed.`);
  }
  if (typeof frameToFreeze !== "number") {
    throw new Error(`The 'frame' prop of <Freeze /> must be a number, but is of type ${typeof frameToFreeze}`);
  }
  if (Number.isNaN(frameToFreeze)) {
    throw new Error(`The 'frame' prop of <Freeze /> must be a real number, but it is NaN.`);
  }
  if (!Number.isFinite(frameToFreeze)) {
    throw new Error(`The 'frame' prop of <Freeze /> must be a finite number, but it is ${frameToFreeze}.`);
  }
  const isActive = useMemo11(() => {
    if (typeof active === "boolean") {
      return active;
    }
    if (typeof active === "function") {
      return active(frame);
    }
  }, [active, frame]);
  const timelineContext = useTimelineContext();
  const activityDormant = useContext17(SequenceActivityDormantContext);
  const sequenceContext = useContext17(SequenceContext);
  const isInsideNonPremountFreeze = useIsInsideNonPremountFreeze();
  const relativeFrom = sequenceContext?.relativeFrom ?? 0;
  const playbackRate = sequenceContext?.playbackRate ?? 1;
  const { audioAndVideoTags } = timelineContext;
  const frozenTimelineValue = useMemo11(() => {
    return {
      audioAndVideoTags,
      isPlaying: () => false,
      isInsideFreeze: true,
      frame: {
        [videoConfig.id]: frameToFreeze / playbackRate + relativeFrom
      }
    };
  }, [
    audioAndVideoTags,
    videoConfig.id,
    frameToFreeze,
    relativeFrom,
    playbackRate
  ]);
  const newSequenceContext = useMemo11(() => {
    if (!sequenceContext) {
      return null;
    }
    if (!isActive) {
      return sequenceContext;
    }
    return {
      ...sequenceContext,
      cumulatedFrom: 0
    };
  }, [sequenceContext, isActive]);
  const providedTimeline = isActive ? frozenTimelineValue : timelineContext;
  return /* @__PURE__ */ jsx11(NonPremountFreezeContext.Provider, {
    value: isInsideNonPremountFreeze || Boolean(isActive) && !_remotionInternalIsPremounting,
    children: /* @__PURE__ */ jsx11(TimelineContext.Provider, {
      value: providedTimeline,
      children: /* @__PURE__ */ jsx11(SequenceActivityTimelineContext.Provider, {
        value: activityDormant ? providedTimeline : null,
        children: /* @__PURE__ */ jsx11(SequenceContext.Provider, {
          value: newSequenceContext,
          children
        })
      })
    })
  });
};

// src/get-sequence-boundary-tolerance.ts
var getSequenceBoundaryTolerance = ({
  absoluteFrame,
  cumulatedFrom,
  from,
  parentPlaybackRate,
  durationInFrames
}) => {
  return Math.min(durationInFrames / 2, Number.EPSILON * Math.max(Math.abs(absoluteFrame * parentPlaybackRate), Math.abs(cumulatedFrom * parentPlaybackRate), Math.abs(from)) * 4);
};

// src/interactivity-schema.ts
var captionsSchema = {
  captions: {
    type: "remotion-captions",
    default: undefined,
    description: "Captions",
    keyframable: false
  }
};
var transformSchema = {
  "style.transformOrigin": {
    type: "transform-origin",
    step: 1,
    default: "50% 50%",
    description: "Transform origin"
  },
  "style.translate": {
    type: "translate",
    step: 1,
    default: "0px 0px",
    description: "Offset"
  },
  "style.scale": {
    type: "scale",
    max: 100,
    step: 0.01,
    default: 1,
    description: "Scale",
    defaultKeyframeOutput: "perceptual-scale"
  },
  "style.rotate": {
    type: "rotation-css",
    step: 1,
    default: "0deg",
    description: "Rotation"
  },
  "style.opacity": {
    type: "number",
    min: 0,
    max: 1,
    step: 0.01,
    default: 1,
    description: "Opacity",
    hiddenFromList: false
  }
};
var sequenceVisualStyleSchema = transformSchema;
var textSchema = {
  "style.color": {
    type: "color",
    default: undefined,
    description: "Color"
  },
  "style.fontFamily": {
    type: "font-family",
    default: undefined,
    description: "Font family",
    keyframable: false
  },
  "style.fontSize": {
    type: "number",
    default: undefined,
    min: 0,
    step: 1,
    description: "Font size",
    hiddenFromList: false
  },
  "style.lineHeight": {
    type: "number",
    default: undefined,
    min: 0,
    step: 0.05,
    description: "Line height",
    hiddenFromList: false
  },
  "style.fontWeight": {
    type: "font-weight",
    default: 400,
    description: "Font weight"
  },
  "style.fontStyle": {
    type: "enum",
    default: "normal",
    description: "Font style",
    variants: {
      normal: {},
      italic: {},
      oblique: {}
    }
  },
  "style.textAlign": {
    type: "enum",
    default: "left",
    description: "Text align",
    variants: {
      left: {},
      center: {},
      right: {},
      justify: {},
      start: {},
      end: {}
    }
  },
  "style.letterSpacing": {
    type: "number",
    default: undefined,
    step: 0.1,
    description: "Letter spacing",
    hiddenFromList: false
  }
};
var borderSchema = {
  "style.borderWidth": {
    type: "number",
    default: undefined,
    min: 0,
    step: 1,
    description: "Border width",
    hiddenFromList: false
  },
  "style.borderStyle": {
    type: "enum",
    default: "none",
    description: "Border style",
    variants: {
      none: {},
      hidden: {},
      solid: {},
      dashed: {},
      dotted: {},
      double: {},
      groove: {},
      ridge: {},
      inset: {},
      outset: {}
    }
  },
  "style.borderColor": {
    type: "color",
    default: undefined,
    description: "Border color"
  }
};
var borderRadiusSchema = {
  "style.borderRadius": {
    type: "number",
    default: 0,
    min: 0,
    step: 1,
    description: "Border radius",
    hiddenFromList: false,
    keyframable: true
  },
  "style.borderTopLeftRadius": {
    type: "number",
    default: 0,
    min: 0,
    step: 1,
    description: "Top left radius",
    hiddenFromList: false
  },
  "style.borderTopRightRadius": {
    type: "number",
    default: 0,
    min: 0,
    step: 1,
    description: "Top right radius",
    hiddenFromList: false
  },
  "style.borderBottomRightRadius": {
    type: "number",
    default: 0,
    min: 0,
    step: 1,
    description: "Bottom right radius",
    hiddenFromList: false
  },
  "style.borderBottomLeftRadius": {
    type: "number",
    default: 0,
    min: 0,
    step: 1,
    description: "Bottom left radius",
    hiddenFromList: false
  }
};
var backgroundSchema = {
  "style.backgroundColor": {
    type: "color",
    default: "transparent",
    description: "Color"
  }
};
var svgColorSchema = {
  color: {
    type: "color",
    default: undefined,
    description: "Current color"
  }
};
var svgStrokeSchema = {
  ...svgColorSchema,
  stroke: {
    type: "color",
    default: "none",
    description: "Stroke"
  },
  strokeWidth: {
    type: "number",
    default: 1,
    description: "Stroke width",
    min: 0,
    step: 1,
    hiddenFromList: false
  }
};
var svgPaintSchema = {
  fill: {
    type: "color",
    default: undefined,
    description: "Fill"
  },
  ...svgStrokeSchema
};
var childrenSchema = {
  children: {
    type: "string",
    default: "",
    description: "Text",
    keyframable: false
  }
};
var premountSchema = {
  premountFor: {
    type: "number",
    default: undefined,
    description: "Premount For",
    min: 0,
    step: 1,
    hiddenFromList: false,
    keyframable: false
  },
  postmountFor: {
    type: "number",
    default: 0,
    min: 0,
    step: 1,
    hiddenFromList: true,
    keyframable: false
  }
};
var sequencePremountSchema = {
  ...premountSchema
};
var cropSchema = {
  cropLeft: {
    type: "number",
    default: 0,
    description: "Crop left",
    min: 0,
    max: 1,
    step: 0.01,
    hiddenFromList: false,
    keyframable: true
  },
  cropRight: {
    type: "number",
    default: 0,
    description: "Crop right",
    min: 0,
    max: 1,
    step: 0.01,
    hiddenFromList: false,
    keyframable: true
  },
  cropTop: {
    type: "number",
    default: 0,
    description: "Crop top",
    min: 0,
    max: 1,
    step: 0.01,
    hiddenFromList: false,
    keyframable: true
  },
  cropBottom: {
    type: "number",
    default: 0,
    description: "Crop bottom",
    min: 0,
    max: 1,
    step: 0.01,
    hiddenFromList: false,
    keyframable: true
  }
};
var sequenceCropSchema = cropSchema;
var sequenceStyleSchema = {
  ...sequenceCropSchema,
  ...transformSchema,
  ...backgroundSchema,
  ...borderSchema,
  ...borderRadiusSchema,
  ...sequencePremountSchema
};
var hiddenField = {
  type: "boolean",
  default: false,
  description: "Hidden"
};
var showInTimelineField = {
  type: "hidden"
};
var sequenceNameField = {
  type: "hidden"
};
var extendSchemaWithSequenceName = (schema) => {
  return {
    name: sequenceNameField,
    ...schema
  };
};
var durationInFramesField = {
  type: "number",
  default: undefined,
  min: 1,
  step: 1,
  hiddenFromList: true
};
var fromField = {
  type: "number",
  default: 0,
  step: 1,
  hiddenFromList: true
};
var trimBeforeField = {
  type: "number",
  default: 0,
  min: 0,
  step: 1,
  hiddenFromList: true
};
var sequenceTimingSchema = {
  from: {
    ...fromField,
    description: "From",
    hiddenFromList: false,
    keyframable: false
  },
  durationInFrames: {
    ...durationInFramesField,
    description: "Duration",
    hiddenFromList: false,
    keyframable: false
  },
  trimBefore: {
    ...trimBeforeField,
    description: "Trim before",
    hiddenFromList: false,
    keyframable: false
  }
};
var trimAfterField = {
  type: "number",
  default: undefined,
  min: 1,
  step: 1,
  hiddenFromList: true
};
var loopField = {
  type: "boolean",
  default: false,
  description: "Loop",
  keyframable: false
};
var freezeField = {
  type: "number",
  default: null,
  step: 1,
  hiddenFromList: true
};
var playbackRateField = {
  type: "number",
  default: 1,
  min: 0.01,
  step: 0.1,
  description: "Playback rate",
  hiddenFromList: false,
  keyframable: false
};
var baseSchema = {
  durationInFrames: durationInFramesField,
  from: fromField,
  trimBefore: trimBeforeField,
  playbackRate: playbackRateField,
  freeze: freezeField,
  hidden: hiddenField,
  name: sequenceNameField,
  showInTimeline: showInTimelineField
};
var baseSchemaWithoutPlaybackRate = {
  durationInFrames: durationInFramesField,
  from: fromField,
  trimBefore: trimBeforeField,
  freeze: freezeField,
  hidden: hiddenField,
  name: sequenceNameField,
  showInTimeline: showInTimelineField
};
var sequenceSchema = {
  ...baseSchema,
  layout: {
    type: "enum",
    default: "absolute-fill",
    description: "Layout",
    variants: {
      "absolute-fill": sequenceStyleSchema,
      none: {}
    }
  }
};
var baseSchemaWithoutFrom = {
  durationInFrames: durationInFramesField,
  trimBefore: trimBeforeField,
  playbackRate: playbackRateField,
  freeze: freezeField,
  hidden: hiddenField,
  name: sequenceNameField,
  showInTimeline: showInTimelineField
};
var sequenceSchemaWithoutFrom = {
  ...baseSchemaWithoutFrom,
  layout: sequenceSchema.layout
};
var sequenceSchemaDefaultLayoutNone = {
  ...sequenceSchema,
  layout: {
    ...sequenceSchema.layout,
    default: "none"
  }
};

// src/loop/loop-context.ts
import { createContext as createContext22 } from "react";
var LoopContext = createContext22(null);

// src/resolve-sequence-duration.ts
var resolveSequenceContentDuration = ({
  durationInFrames
}) => {
  return durationInFrames ?? Infinity;
};
var resolveSequenceDuration = ({
  durationInFrames,
  playbackRate,
  loop
}) => {
  if (loop) {
    return Infinity;
  }
  return resolveSequenceContentDuration({
    durationInFrames
  }) / (playbackRate ?? 1);
};

// src/sequence-crop.ts
var clampCrop = (value) => {
  return Math.min(1, Math.max(0, value ?? 0));
};
var resolveAxis = (start, end) => {
  const resolvedStart = clampCrop(start);
  const resolvedEnd = clampCrop(end);
  if (resolvedStart + resolvedEnd > 1) {
    return [0.5, 0.5];
  }
  return [resolvedStart, resolvedEnd];
};
var resolveSequenceCrop = ({
  cropLeft,
  cropRight,
  cropTop,
  cropBottom
}) => {
  const [left, right] = resolveAxis(cropLeft, cropRight);
  const [top, bottom] = resolveAxis(cropTop, cropBottom);
  return { left, right, top, bottom };
};
var getSequenceCropClipPath = ({
  left,
  right,
  top,
  bottom,
  style
}) => {
  if (left === 0 && right === 0 && top === 0 && bottom === 0) {
    return null;
  }
  const serializeRadius = (radius) => typeof radius === "number" ? `${radius}px` : radius;
  const shorthand = serializeRadius(style?.borderRadius);
  const longhands = [
    style?.borderTopLeftRadius,
    style?.borderTopRightRadius,
    style?.borderBottomRightRadius,
    style?.borderBottomLeftRadius
  ];
  const serializedBorderRadius = shorthand || (longhands.some((radius) => radius !== undefined) ? longhands.map((radius) => serializeRadius(radius) ?? "0px").join(" ") : undefined);
  const rounded = serializedBorderRadius ? ` round ${serializedBorderRadius}` : "";
  return `inset(${top * 100}% ${right * 100}% ${bottom * 100}% ${left * 100}%${rounded})`;
};
var validateSequenceCrop = (crop, componentName = "<Sequence />") => {
  for (const [name, value] of Object.entries(crop)) {
    if (value === undefined) {
      continue;
    }
    if (typeof value !== "number" || !Number.isFinite(value)) {
      throw new TypeError(`The "${name}" prop of ${componentName} must be a finite number, but got ${String(value)}.`);
    }
    if (value > 100) {
      throw new RangeError(`The "${name}" prop of ${componentName} must be between 0 and 1, but got ${value}. The crop range is 0 to 1, not 0 to 100.`);
    }
  }
};

// src/sequence-outline.ts
import React17 from "react";
var SequenceOutlineContext = React17.createContext(false);
var nodesByRef = new WeakMap;
var SequenceOutlineInternals = {
  createRef: () => {
    const ref = { current: null };
    nodesByRef.set(ref, []);
    return ref;
  },
  getNodes: (ref) => {
    return nodesByRef.get(ref) ?? null;
  },
  setNodes: (ref, nodes) => {
    const previous = nodesByRef.get(ref);
    if (previous?.length === nodes.length && previous.every((node, index) => node === nodes[index])) {
      return;
    }
    ref.current = nodes.length === 1 && nodes[0].nodeType === 1 ? nodes[0] : null;
    nodesByRef.set(ref, nodes);
  }
};

// src/SequenceActivityBoundary.tsx
import React18, { useContext as useContext18, useMemo as useMemo12 } from "react";
import { jsx as jsx12 } from "react/jsx-runtime";
var suspendedActivity = { then: () => {
  return;
} };
var SuspendSequenceActivity = ({ children, dormant }) => {
  const suspended = useContext18(SequenceActivitySuspensionContext);
  if (dormant && suspended) {
    throw suspendedActivity;
  }
  return children;
};
var areActivityChildrenEqual = (previous, next) => {
  if (Object.is(previous, next)) {
    return true;
  }
  if (Array.isArray(previous) && Array.isArray(next)) {
    return previous.length === next.length && previous.every((child, index) => areActivityChildrenEqual(child, next[index]));
  }
  if (!React18.isValidElement(previous) || !React18.isValidElement(next) || previous.type !== next.type || previous.key !== next.key) {
    return false;
  }
  const keys = Object.keys(previous.props);
  return keys.length === Object.keys(next.props).length && keys.every((key) => Object.prototype.hasOwnProperty.call(next.props, key) && (key === "children" ? areActivityChildrenEqual(previous.props.children, next.props.children) : Object.is(previous.props[key], next.props[key])));
};
var SequenceActivityContent = React18.memo(({ children }) => children, (previous, next) => previous.dormant && next.dormant && areActivityChildrenEqual(previous.children, next.children));
var SequenceActivityBoundary = ({ children, dormant, frame }) => {
  const parentDormant = useContext18(SequenceActivityDormantContext);
  const timeline = useContext18(parentDormant ? SequenceActivityTimelineContext : TimelineContext);
  const absoluteTime = useContext18(parentDormant ? SequenceActivityAbsoluteTimeContext : AbsoluteTimeContext);
  const { id } = useVideoConfig();
  if (timeline === null) {
    throw new Error("TimelineContext is missing");
  }
  const { audioAndVideoTags } = timeline;
  const dormantTimeline = useMemo12(() => ({
    frame: { [id]: frame },
    isPlaying: () => false,
    isInsideFreeze: true,
    audioAndVideoTags
  }), [audioAndVideoTags, frame, id]);
  return /* @__PURE__ */ jsx12(SequenceActivityDormantContext.Provider, {
    value: dormant,
    children: /* @__PURE__ */ jsx12(SequenceActivityTimelineContext.Provider, {
      value: dormant ? dormantTimeline : null,
      children: /* @__PURE__ */ jsx12(SequenceActivityAbsoluteTimeContext.Provider, {
        value: dormant ? dormantTimeline : null,
        children: /* @__PURE__ */ jsx12(TimelineContext.Provider, {
          value: dormant ? dormantTimeline : timeline,
          children: /* @__PURE__ */ jsx12(AbsoluteTimeContext.Provider, {
            value: dormant ? dormantTimeline : absoluteTime,
            children: /* @__PURE__ */ jsx12(React18.Activity, {
              mode: dormant && !parentDormant ? "hidden" : "visible",
              children: /* @__PURE__ */ jsx12(SuspendSequenceActivity, {
                dormant,
                children
              })
            })
          })
        })
      })
    })
  });
};

// src/SequenceActivityBudget.tsx
import React19, { createContext as createContext23, useContext as useContext19, useMemo as useMemo13, useState as useState4 } from "react";
import { jsx as jsx13 } from "react/jsx-runtime";
var useCommitEffect = React19.useInsertionEffect ?? React19.useLayoutEffect;
var createActivityBudget = () => {
  const registry = createRegistryStore(new Set);
  const candidates = new Map;
  let frame = {};
  let limit = DEFAULT_SEQUENCE_ACTIVITY_LIMIT;
  let scheduled = false;
  let suspended = false;
  const schedule = () => {
    if (scheduled || suspended) {
      return;
    }
    scheduled = true;
    queueMicrotask(() => {
      scheduled = false;
      if (suspended) {
        return;
      }
      const ranked = [...candidates.values()].filter((candidate) => candidate.end > candidate.from).map((candidate) => {
        const currentFrame = frame[candidate.compositionId] ?? 0;
        return {
          candidate,
          distance: Math.max(0, candidate.from - currentFrame, currentFrame - candidate.end)
        };
      }).sort((a, b) => a.distance - b.distance);
      const selected = new Set;
      for (const { candidate } of ranked) {
        const ancestors = [];
        let ancestor = candidate;
        while (ancestor && !selected.has(ancestor.id)) {
          ancestors.push(ancestor.id);
          if (selected.size + ancestors.length > limit) {
            break;
          }
          ancestor = ancestor.parent === null ? undefined : candidates.get(ancestor.parent);
        }
        if (selected.size + ancestors.length > limit) {
          continue;
        }
        for (const id of ancestors) {
          selected.add(id);
        }
        if (selected.size === limit) {
          break;
        }
      }
      registry.setSnapshot((previous) => previous.size === selected.size && [...previous].every((id) => selected.has(id)) ? previous : selected);
    });
  };
  return {
    ...registry,
    setSuspended: (next) => {
      if (suspended !== next) {
        suspended = next;
        schedule();
      }
    },
    setLimit: (next) => {
      if (limit !== next) {
        limit = next;
        schedule();
      }
    },
    setFrame: (next) => {
      frame = next;
      schedule();
    },
    register: (candidate) => {
      candidates.set(candidate.id, candidate);
      schedule();
      return () => {
        candidates.delete(candidate.id);
        schedule();
      };
    }
  };
};
var ActivityBudgetContext = createContext23(null);
var InactiveTimelineContext = createContext23(null);
var emptySelection = new Set;
var ActivitySelectionContext = createContext23(emptySelection);
var SequenceActivityBudgetProvider = ({ children }) => {
  const enabled = useContext19(SequenceActivityContext);
  const settings = useContext19(SequenceActivitySettingsContext);
  const suspended = useContext19(SequenceActivitySuspensionContext);
  const limit = settings?.limit ?? DEFAULT_SEQUENCE_ACTIVITY_LIMIT;
  const admitting = enabled && limit > 0 && limit !== Infinity;
  const [budget] = useState4(createActivityBudget);
  const timeline = useContext19(admitting && !suspended ? TimelineContext : InactiveTimelineContext);
  const selected = useSyncExternalStore2(budget.subscribe, budget.getSnapshot, budget.getSnapshot);
  const admitted = useMemo13(() => !admitting ? emptySelection : selected.size > limit ? new Set([...selected].slice(0, limit)) : selected, [admitting, limit, selected]);
  useCommitEffect(() => {
    budget.setSuspended(suspended);
    budget.setLimit(admitting ? limit : 0);
    if (admitting && timeline !== null) {
      budget.setFrame(timeline.frame);
    }
  }, [admitting, budget, limit, suspended, timeline]);
  return /* @__PURE__ */ jsx13(ActivityBudgetContext.Provider, {
    value: admitting ? budget : null,
    children: /* @__PURE__ */ jsx13(ActivitySelectionContext.Provider, {
      value: admitted,
      children
    })
  });
};
var useSequenceActivityAdmission = (candidate) => {
  const budget = useContext19(ActivityBudgetContext);
  const enabled = useContext19(SequenceActivityContext);
  const settings = useContext19(SequenceActivitySettingsContext);
  const unlimited = enabled && (settings?.limit ?? DEFAULT_SEQUENCE_ACTIVITY_LIMIT) === Infinity;
  const selected = useContext19(ActivitySelectionContext);
  const id = candidate?.id ?? null;
  const parent = candidate?.parent ?? null;
  const compositionId = candidate?.compositionId ?? null;
  const from = candidate?.from ?? null;
  const end = candidate?.end ?? null;
  const committedCandidate = useMemo13(() => id !== null && compositionId !== null && from !== null && end !== null ? { id, parent, compositionId, from, end } : null, [id, parent, compositionId, from, end]);
  useCommitEffect(() => {
    if (budget !== null && committedCandidate !== null) {
      return budget.register(committedCandidate);
    }
  }, [budget, committedCandidate]);
  return id !== null && (unlimited || selected.has(id));
};

// src/SequenceManager.tsx
import React23, { useCallback as useCallback5, useContext as useContext23, useMemo as useMemo15, useRef as useRef5, useState as useState7 } from "react";

// src/sequence-registry-context.tsx
import React20, { useContext as useContext20 } from "react";
var defaultSequenceManagerActions = {
  registerSequence: () => {
    throw new Error("SequenceManagerActionsContext not initialized");
  },
  updateSequence: () => {
    throw new Error("SequenceManagerActionsContext not initialized");
  },
  unregisterSequence: () => {
    throw new Error("SequenceManagerActionsContext not initialized");
  }
};
var SequenceManagerActionsContext = React20.createContext(defaultSequenceManagerActions);
var SequenceRegistryContext = React20.createContext(null);
var subscribeToNoRegistry = () => () => {
  return;
};
var emptySequences = [];
var getEmptySequences = () => emptySequences;
var SequenceCommitRegistrationContext = React20.createContext(false);
var SequenceRegistryScopeContext = React20.createContext(null);
var useSequenceManagerSequences = () => {
  const registry = useContext20(SequenceRegistryContext);
  return useSyncExternalStore2(registry?.subscribe ?? subscribeToNoRegistry, registry?.getSnapshot ?? getEmptySequences, registry?.getSnapshot ?? getEmptySequences);
};
var SequenceManagerRefContext = React20.createContext({
  current: []
});
var SequenceRegistrationContext = React20.createContext(false);
var DisableSequenceRegistrationContext = React20.createContext(false);
var DisableSequenceRegistrationProvider = ({ children }) => {
  return React20.createElement(DisableSequenceRegistrationContext.Provider, { value: true }, children);
};
// src/SequenceActivitySuspensionProvider.tsx
import { useContext as useContext21, useEffect as useEffect5, useState as useState5 } from "react";
import { jsx as jsx14 } from "react/jsx-runtime";
var SequenceActivitySuspensionProvider = ({ children }) => {
  const enabled = useContext21(SequenceActivityContext);
  const { isPlaying, subscribePlaying, seek } = useContext21(SetTimelineContext);
  const [suspended, setSuspended] = useState5(false);
  useEffect5(() => {
    if (!enabled) {
      setSuspended(false);
      return;
    }
    let timeout = null;
    const update = () => {
      setSuspended(isPlaying() || timeout !== null);
    };
    const unsubscribePlaying = subscribePlaying(update);
    const unsubscribeSeek = seek?.subscribe(() => {
      setSuspended(true);
      if (timeout !== null) {
        clearTimeout(timeout);
      }
      timeout = setTimeout(() => {
        timeout = null;
        update();
      }, 150);
    });
    update();
    return () => {
      unsubscribePlaying();
      unsubscribeSeek?.();
      if (timeout !== null) {
        clearTimeout(timeout);
      }
    };
  }, [enabled, isPlaying, seek, subscribePlaying]);
  return /* @__PURE__ */ jsx14(SequenceActivitySuspensionContext.Provider, {
    value: suspended,
    children
  });
};

// src/SequenceRegistryProvider.tsx
import React22, { useCallback as useCallback4, useContext as useContext22, useMemo as useMemo14, useRef as useRef4, useState as useState6 } from "react";
import { jsx as jsx15 } from "react/jsx-runtime";
var useIsomorphicLayoutEffect3 = typeof window === "undefined" ? React22.useEffect : React22.useLayoutEffect;
var SequenceManagerRefProvider = withCommittedMetadata(SequenceManagerRefContext.Provider);
var SequenceRegistryProvider = ({ children }) => {
  const { isStudio } = useRemotionEnvironment();
  const logLevel = useLogLevel();
  const sequenceRegistrationEnabled = useContext22(SequenceRegistrationContext);
  const shouldObserveCommits = isStudio || sequenceRegistrationEnabled;
  const [sequenceManagerId] = useState6(() => String(Math.random()));
  const [commitRegistrationEnabled, setCommitRegistrationEnabled] = useState6(() => shouldObserveCommits && isCommitRegistrationObserverInstalled());
  const observedCommitRef = useRef4(false);
  const rootObservationFailedRef = useRef4(false);
  const committedRegistrationIdsRef = useRef4(new Set);
  const committedDescriptorsRef = useRef4(new Map);
  const pendingCommittedSequencesRef = useRef4(new Map);
  const committedScopesRef = useRef4(new Map([
    [sequenceManagerId, { sequences: [], sequenceIds: [] }]
  ]));
  const registrationObserverFailedRef = useRef4(false);
  const registrationUnmountedRef = useRef4(false);
  const committedOrderRef = useRef4(null);
  const committedOrderIdsRef = useRef4(null);
  const [registry] = useState6(() => createRegistryStore([]));
  const setSequences = registry.setSnapshot;
  const sequencesRef = useMemo14(() => ({
    get current() {
      return registry.getSnapshot();
    }
  }), [registry]);
  const onCommitSequences = useCallback4((scopeId, snapshot, sequenceIds) => {
    if (registrationObserverFailedRef.current || registrationUnmountedRef.current) {
      return;
    }
    const previousSnapshot = pendingCommittedSequencesRef.current.get(scopeId) ?? committedScopesRef.current.get(scopeId);
    if (previousSnapshot?.sequences === snapshot && previousSnapshot.sequenceIds === sequenceIds) {
      return;
    }
    const alreadyPending = pendingCommittedSequencesRef.current.size > 0;
    pendingCommittedSequencesRef.current.set(scopeId, {
      sequences: snapshot,
      sequenceIds
    });
    if (alreadyPending) {
      return;
    }
    queueMicrotask(() => {
      const pending = pendingCommittedSequencesRef.current;
      pendingCommittedSequencesRef.current = new Map;
      if (pending.size === 0 || registrationObserverFailedRef.current || registrationUnmountedRef.current) {
        return;
      }
      const previousIds = committedRegistrationIdsRef.current;
      const previousDescriptors = committedDescriptorsRef.current;
      for (const [id, scope] of pending) {
        if (id !== sequenceManagerId && scope.sequenceIds.length === 0) {
          committedScopesRef.current.delete(id);
        } else {
          committedScopesRef.current.set(id, scope);
        }
      }
      const scopes = [...committedScopesRef.current.values()];
      const sequences = scopes.flatMap((scope) => scope.sequences);
      const ids = scopes.flatMap((scope) => scope.sequenceIds);
      committedDescriptorsRef.current = new Map(sequences.map((sequence) => [sequence.id, sequence]));
      const nextIds = new Set(sequences.map((sequence) => sequence.id));
      const order = new Map(ids.map((id, index) => [id, index]));
      committedOrderIdsRef.current = ids;
      committedOrderRef.current = order;
      committedRegistrationIdsRef.current = nextIds;
      if (isStudio && logLevel === "trace") {
        for (const sequence of sequences) {
          if (!previousIds.has(sequence.id)) {
            Log.trace({ logLevel, tag: null }, `[Sequence registration] Registered "${sequence.displayName}" (${sequence.id}) after commit`, sequence);
          }
        }
      }
      setSequences((current) => reconcileRegistryEntries({
        current,
        entries: sequences,
        previousDescriptors,
        previousKeys: previousIds,
        nextKeys: nextIds,
        getKey: (sequence) => sequence.id,
        order,
        orderProperty: "timelineOrder"
      }));
    });
  }, [isStudio, logLevel, sequenceManagerId, setSequences]);
  const onCommitRootSequences = useCallback4((sequences, sequenceIds) => {
    if (!rootObservationFailedRef.current) {
      observedCommitRef.current = true;
      onCommitSequences(sequenceManagerId, sequences, sequenceIds);
    }
  }, [onCommitSequences, sequenceManagerId]);
  const registryScope = useMemo14(() => ({
    onCommitSequences,
    commitRegistrationRequested: shouldObserveCommits
  }), [onCommitSequences, shouldObserveCommits]);
  useIsomorphicLayoutEffect3(() => {
    if (!shouldObserveCommits) {
      return;
    }
    let unmounted = false;
    registrationUnmountedRef.current = false;
    const onRegistrationError = () => {
      if (registrationObserverFailedRef.current) {
        return;
      }
      registrationObserverFailedRef.current = true;
      pendingCommittedSequencesRef.current.clear();
      queueMicrotask(() => {
        if (registrationUnmountedRef.current) {
          return;
        }
        const previousIds = committedRegistrationIdsRef.current;
        committedRegistrationIdsRef.current = new Set;
        committedScopesRef.current.clear();
        setSequences((current) => current.filter((sequence) => !previousIds.has(sequence.id)));
        setCommitRegistrationEnabled(false);
      });
    };
    const onCommitOrder = (event) => {
      const { detail } = event;
      const managerOrder = detail.sequenceManagers.find((item) => item.managerId === sequenceManagerId);
      if (!managerOrder) {
        return;
      }
      if (commitRegistrationEnabled) {
        return;
      }
      const previousOrder = committedOrderIdsRef.current;
      if (previousOrder === managerOrder.sequenceIds || previousOrder !== null && previousOrder.length === managerOrder.sequenceIds.length && previousOrder.every((sequenceId, index) => sequenceId === managerOrder.sequenceIds[index])) {
        return;
      }
      const order = new Map(managerOrder.sequenceIds.map((sequenceId, index) => [
        sequenceId,
        index
      ]));
      committedOrderIdsRef.current = managerOrder.sequenceIds;
      committedOrderRef.current = order;
      queueMicrotask(() => {
        if (unmounted) {
          return;
        }
        setSequences((currentSequences) => {
          let changed = false;
          const nextSequences = currentSequences.map((sequence) => {
            const timelineOrder = order.get(sequence.id) ?? null;
            if (sequence.timelineOrder === timelineOrder) {
              return sequence;
            }
            changed = true;
            return { ...sequence, timelineOrder };
          });
          return changed ? nextSequences : currentSequences;
        });
      });
    };
    window.addEventListener(COMMIT_ORDER_EVENT, onCommitOrder);
    window.addEventListener(COMMIT_REGISTRATION_ERROR_EVENT, onRegistrationError);
    if (commitRegistrationEnabled) {
      queueMicrotask(() => {
        if (unmounted || observedCommitRef.current || registrationObserverFailedRef.current) {
          return;
        }
        rootObservationFailedRef.current = true;
        onCommitSequences(sequenceManagerId, [], []);
        setCommitRegistrationEnabled(false);
      });
    }
    return () => {
      unmounted = true;
      registrationUnmountedRef.current = true;
      window.removeEventListener(COMMIT_ORDER_EVENT, onCommitOrder);
      window.removeEventListener(COMMIT_REGISTRATION_ERROR_EVENT, onRegistrationError);
    };
  }, [
    shouldObserveCommits,
    sequenceManagerId,
    setSequences,
    commitRegistrationEnabled,
    onCommitSequences
  ]);
  const registerSequence = useCallback4((seq) => {
    if (isStudio) {
      Log.trace({ logLevel, tag: null }, `[Sequence registration] Registered "${seq.displayName}" (${seq.id}) after commit`, seq);
    }
    setSequences((seqs) => {
      return [
        ...seqs,
        {
          ...seq,
          timelineOrder: committedOrderRef.current?.get(seq.id) ?? null
        }
      ];
    });
  }, [isStudio, logLevel, setSequences]);
  const updateSequence = useCallback4((seq) => {
    setSequences((seqs) => {
      const index = seqs.findIndex((item) => item.id === seq.id);
      if (index === -1) {
        return seqs;
      }
      const updatedSequence = {
        ...seq,
        timelineOrder: committedOrderRef.current?.get(seq.id) ?? null
      };
      if (areRegistryEntriesEqual(seqs[index], updatedSequence)) {
        return seqs;
      }
      const next = [...seqs];
      next[index] = updatedSequence;
      return next;
    });
  }, [setSequences]);
  const unregisterSequence = useCallback4((seq) => {
    setSequences((seqs) => seqs.filter((s) => s.id !== seq));
  }, [setSequences]);
  const actions = useMemo14(() => {
    return {
      registerSequence,
      updateSequence,
      unregisterSequence
    };
  }, [registerSequence, unregisterSequence, updateSequence]);
  const metadata = useMemo14(() => shouldObserveCommits ? {
    type: "sequence-manager",
    id: sequenceManagerId,
    onCommit: commitRegistrationEnabled ? onCommitRootSequences : null
  } : null, [
    commitRegistrationEnabled,
    onCommitRootSequences,
    sequenceManagerId,
    shouldObserveCommits
  ]);
  return /* @__PURE__ */ jsx15(SequenceManagerRefProvider, {
    value: sequencesRef,
    _remotionCommitMetadata: metadata,
    children: /* @__PURE__ */ jsx15(SequenceRegistryScopeContext.Provider, {
      value: registryScope,
      children: /* @__PURE__ */ jsx15(SequenceManagerActionsContext.Provider, {
        value: actions,
        children: /* @__PURE__ */ jsx15(SequenceRegistryContext.Provider, {
          value: registry,
          children: /* @__PURE__ */ jsx15(SequenceCommitRegistrationContext.Provider, {
            value: commitRegistrationEnabled,
            children
          })
        })
      })
    })
  });
};

// src/SequenceManager.tsx
import { jsx as jsx16 } from "react/jsx-runtime";
var useIsomorphicLayoutEffect4 = typeof window === "undefined" ? React23.useEffect : React23.useLayoutEffect;
var useCommitEffect2 = React23.useInsertionEffect ?? useIsomorphicLayoutEffect4;
var VisualModeDragOverridesSubscriptionContext = React23.createContext(null);
var ActiveFromDragOverrideKeysContext = React23.createContext(null);
var SequenceManagerScopeProviders = ({ children, dragOverridesSubscription, fromKeys }) => {
  const { isStudio } = useRemotionEnvironment();
  const activitySettings = useContext23(SequenceActivitySettingsContext);
  const commitRegistrationEnabled = useContext23(SequenceCommitRegistrationContext);
  const manager = useContext23(SequenceManagerActionsContext);
  const scopedDragOverridesSubscription = useMemo15(() => ({ ...dragOverridesSubscription, manager }), [dragOverridesSubscription, manager]);
  const activeFromDragOverrideKeys = useMemo15(() => ({ manager, keys: fromKeys }), [fromKeys, manager]);
  return /* @__PURE__ */ jsx16(ActiveFromDragOverrideKeysContext.Provider, {
    value: activeFromDragOverrideKeys,
    children: /* @__PURE__ */ jsx16(VisualModeDragOverridesSubscriptionContext.Provider, {
      value: scopedDragOverridesSubscription,
      children: /* @__PURE__ */ jsx16(SequenceActivityContext.Provider, {
        value: (activitySettings?.limit ?? DEFAULT_SEQUENCE_ACTIVITY_LIMIT) > 0 && isStudio && commitRegistrationEnabled && typeof React23.Activity !== "undefined",
        children: /* @__PURE__ */ jsx16(SequenceActivitySuspensionProvider, {
          children: /* @__PURE__ */ jsx16(SequenceActivityBudgetProvider, {
            children
          })
        })
      })
    })
  });
};
var emptyDragOverrides = {};
var emptyFromOverrideKeys = new Set;
var emptyEffectDragOverrides = {};
var makeSequencePropsSubscriptionKey = (key) => {
  return `${key.absolutePath}\x00${key.nodePath.join(".")}\x00${key.sequenceKeys.join(".")}\x00${key.effectKeys.map((keys) => keys.join(".")).join(".")}`;
};
var VisualModePropStatusesContext = React23.createContext({
  propStatuses: {}
});
var VisualModePropStatusesRefContext = React23.createContext({
  current: {}
});
var VisualModePropStatusesSubscriptionContext = React23.createContext({
  subscribe: () => () => {
    return;
  },
  getSnapshot: () => null
});
var defaultVisualModeDragOverrides = {
  getDragOverrides: () => {
    throw new Error("VisualModeDragOverridesContext not initialized");
  },
  getEffectDragOverrides: () => {
    throw new Error("VisualModeDragOverridesContext not initialized");
  }
};
var VisualModeDragOverridesContext = React23.createContext(defaultVisualModeDragOverrides);
var VisualModeDragOverridesRefContext = React23.createContext({ current: defaultVisualModeDragOverrides });
var useVisualModeSnapshot = (subscribe, getSnapshot) => {
  const dormant = useContext23(SequenceActivityDormantContext);
  const [, forceUpdate] = useState7(0);
  const snapshot = useSyncExternalStore2(subscribe, getSnapshot, getSnapshot);
  useCommitEffect2(() => {
    if (!dormant) {
      return;
    }
    return subscribe(() => forceUpdate((current) => current + 1));
  }, [dormant, subscribe]);
  return snapshot;
};
var useDragOverridesForNodePath = (nodePath) => {
  const subscription = useContext23(VisualModeDragOverridesSubscriptionContext);
  const manager = useContext23(SequenceManagerActionsContext);
  const scopedSubscription = subscription?.manager === manager ? subscription : null;
  const key = nodePath === null ? null : makeSequencePropsSubscriptionKey(nodePath);
  const subscribe = useCallback5((listener) => scopedSubscription?.subscribe(key, listener) ?? (() => {
    return;
  }), [key, scopedSubscription]);
  const getSnapshot = useCallback5(() => scopedSubscription?.getSnapshot(key) ?? emptyDragOverrides, [key, scopedSubscription]);
  return useVisualModeSnapshot(subscribe, getSnapshot);
};
var usePropStatusForNodePath = (nodePath) => {
  const subscription = useContext23(VisualModePropStatusesSubscriptionContext);
  const key = nodePath === null ? null : makeSequencePropsSubscriptionKey(nodePath);
  const subscribe = useCallback5((listener) => subscription.subscribe(key, listener), [key, subscription]);
  const getSnapshot = useCallback5(() => subscription.getSnapshot(key), [key, subscription]);
  return useVisualModeSnapshot(subscribe, getSnapshot);
};
var useActiveFromDragOverrideKeys = () => {
  const snapshot = useContext23(ActiveFromDragOverrideKeysContext);
  const manager = useContext23(SequenceManagerActionsContext);
  return snapshot?.manager === manager ? snapshot.keys : emptyFromOverrideKeys;
};
var useEffectDragOverridesForNodePath = (nodePath) => {
  const subscription = useContext23(VisualModeDragOverridesSubscriptionContext);
  const manager = useContext23(SequenceManagerActionsContext);
  const scopedSubscription = subscription?.manager === manager ? subscription : null;
  const key = nodePath === null ? null : makeSequencePropsSubscriptionKey(nodePath);
  const subscribe = useCallback5((listener) => scopedSubscription?.subscribeEffects(key, listener) ?? (() => {
    return;
  }), [key, scopedSubscription]);
  const getSnapshot = useCallback5(() => scopedSubscription?.getEffectSnapshot(key) ?? emptyEffectDragOverrides, [key, scopedSubscription]);
  return useVisualModeSnapshot(subscribe, getSnapshot);
};
var VisualModeSettersContext = React23.createContext({
  setDragOverrides: () => {
    throw new Error("VisualModeSettersContext not initialized");
  },
  updateDragOverrides: () => {
    throw new Error("VisualModeSettersContext not initialized");
  },
  updateDragOverridesBatch: () => {
    throw new Error("VisualModeSettersContext not initialized");
  },
  remapDragOverrideFields: () => {
    throw new Error("VisualModeSettersContext not initialized");
  },
  clearDragOverrides: () => {
    throw new Error("VisualModeSettersContext not initialized");
  },
  setEffectDragOverrides: () => {
    throw new Error("VisualModeSettersContext not initialized");
  },
  updateEffectDragOverridesBatch: () => {
    throw new Error("VisualModeSettersContext not initialized");
  },
  remapEffectDragOverrideFields: () => {
    throw new Error("VisualModeSettersContext not initialized");
  },
  clearEffectDragOverrides: () => {
    throw new Error("VisualModeSettersContext not initialized");
  },
  setPropStatuses: () => {
    throw new Error("VisualModeSettersContext not initialized");
  },
  setPropStatusesBatch: () => {
    throw new Error("VisualModeSettersContext not initialized");
  },
  remapPropStatuses: () => {
    throw new Error("VisualModeSettersContext not initialized");
  }
});
var VisualModeBatchSettersContext = React23.createContext(null);
var effectDragOverridesKey = (nodePath, effectIndex) => `${makeSequencePropsSubscriptionKey(nodePath)}.effects.${effectIndex}`;
var SequenceManagerProvider = ({ children }) => {
  const [dragOverrideState, setDragOverrideState] = useState7(() => ({
    overrides: {},
    fromKeys: new Set
  }));
  const dragOverrides = dragOverrideState.overrides;
  const dragOverridesStore = useRef5({
    snapshot: dragOverrides,
    listeners: new Map
  });
  const [effectDragOverridesState, setEffectDragOverridesState] = useState7({});
  const effectDragOverridesStore = useRef5({
    snapshot: effectDragOverridesState,
    byNode: new Map,
    listeners: new Map
  });
  const [propStatuses, setPropStatusesMapState] = useState7({});
  const propStatusesRef = useRef5(propStatuses);
  const requestedPropStatusesRef = useRef5(propStatuses);
  const propStatusListeners = useRef5(new Map);
  useIsomorphicLayoutEffect4(() => {
    const previous = propStatusesRef.current;
    propStatusesRef.current = propStatuses;
    for (const [key, listeners] of propStatusListeners.current) {
      if (previous[key] !== propStatuses[key]) {
        for (const listener of listeners) {
          listener();
        }
      }
    }
  }, [propStatuses]);
  const setDragOverridesBatch = useCallback5((overrides) => {
    setDragOverrideState((prevState) => {
      const prev = prevState.overrides;
      let next = null;
      let nextFromKeys = prevState.fromKeys;
      for (const { nodePath, key, value } of overrides) {
        const mapKey = makeSequencePropsSubscriptionKey(nodePath);
        const existing = (next ?? prev)[mapKey]?.[key];
        if (existing === value || existing?.type === "static" && value.type === "static" && Object.is(existing.value, value.value)) {
          continue;
        }
        if (next === null) {
          next = { ...prev };
        }
        if (next[mapKey] === prev[mapKey]) {
          next[mapKey] = { ...prev[mapKey] };
        }
        next[mapKey][key] = value;
        if (key === "from" && !nextFromKeys.has(mapKey)) {
          nextFromKeys = new Set(nextFromKeys);
          nextFromKeys.add(mapKey);
        }
      }
      return next === null ? prevState : { overrides: next, fromKeys: nextFromKeys };
    });
  }, []);
  const setDragOverrides = useCallback5((nodePath, key, value) => setDragOverridesBatch([{ nodePath, key, value }]), [setDragOverridesBatch]);
  const updateDragOverridesBatch = useCallback5((updates) => {
    if (updates.length === 0)
      return;
    setDragOverrideState((previous) => {
      let { overrides, fromKeys } = previous;
      for (const { nodePath, update } of updates) {
        const key = makeSequencePropsSubscriptionKey(nodePath);
        const current = overrides[key] ?? emptyDragOverrides;
        const updated = update(current);
        if (updated === current)
          continue;
        const hasOverrides = Object.keys(updated).length > 0;
        if (!hasOverrides && overrides[key] === undefined)
          continue;
        if (overrides === previous.overrides)
          overrides = { ...overrides };
        if (hasOverrides) {
          overrides[key] = updated;
        } else {
          delete overrides[key];
        }
        const hasFrom = updated.from !== undefined;
        if (fromKeys.has(key) !== hasFrom) {
          if (fromKeys === previous.fromKeys)
            fromKeys = new Set(fromKeys);
          if (hasFrom) {
            fromKeys.add(key);
          } else {
            fromKeys.delete(key);
          }
        }
      }
      return overrides === previous.overrides ? previous : { overrides, fromKeys };
    });
  }, []);
  const updateDragOverrides = useCallback5((nodePath, update) => updateDragOverridesBatch([{ nodePath, update }]), [updateDragOverridesBatch]);
  const remapDragOverrideFields = useCallback5((remappings) => {
    setDragOverrideState((previous) => {
      const moves = remappings.flatMap((remapping) => {
        const previousKey = makeSequencePropsSubscriptionKey(remapping.previousNodePath);
        const key = remapping.nodePath ? makeSequencePropsSubscriptionKey(remapping.nodePath) : null;
        if (previousKey === key) {
          return [];
        }
        const fields = Object.entries(remapping.fields).filter(([field, expected]) => previous.overrides[previousKey]?.[field] === expected);
        return fields.length > 0 ? [{ previousKey, key, fields }] : [];
      });
      if (moves.length === 0) {
        return previous;
      }
      const overrides = { ...previous.overrides };
      const changedKeys = new Set;
      const getMutableFields = (key) => {
        if (!changedKeys.has(key)) {
          changedKeys.add(key);
          overrides[key] = { ...overrides[key] };
        }
        return overrides[key];
      };
      for (const { previousKey, fields } of moves) {
        const source = getMutableFields(previousKey);
        for (const [field] of fields) {
          delete source[field];
        }
      }
      for (const { key, fields } of moves) {
        if (key === null) {
          continue;
        }
        for (const [field, value] of fields) {
          if (overrides[key]?.[field] !== undefined) {
            continue;
          }
          getMutableFields(key)[field] = value;
        }
      }
      let { fromKeys } = previous;
      for (const key of changedKeys) {
        const hasFrom = overrides[key].from !== undefined;
        if (Object.keys(overrides[key]).length === 0) {
          delete overrides[key];
        }
        if (fromKeys.has(key) === hasFrom) {
          continue;
        }
        if (fromKeys === previous.fromKeys) {
          fromKeys = new Set(fromKeys);
        }
        if (hasFrom) {
          fromKeys.add(key);
        } else {
          fromKeys.delete(key);
        }
      }
      return { overrides, fromKeys };
    });
  }, []);
  const subscribeDragOverrides = useCallback5((key, listener) => {
    if (key === null) {
      return () => {
        return;
      };
    }
    let listeners = dragOverridesStore.current.listeners.get(key);
    if (!listeners) {
      listeners = new Set;
      dragOverridesStore.current.listeners.set(key, listeners);
    }
    listeners.add(listener);
    return () => {
      listeners.delete(listener);
      if (listeners.size === 0) {
        dragOverridesStore.current.listeners.delete(key);
      }
    };
  }, []);
  const getDragOverridesSnapshot = useCallback5((key) => {
    return key === null ? emptyDragOverrides : dragOverridesStore.current.snapshot[key] ?? emptyDragOverrides;
  }, []);
  useIsomorphicLayoutEffect4(() => {
    const previous = dragOverridesStore.current.snapshot;
    dragOverridesStore.current.snapshot = dragOverrides;
    for (const key of new Set([
      ...Object.keys(previous),
      ...Object.keys(dragOverrides)
    ])) {
      if (previous[key] !== dragOverrides[key]) {
        for (const listener of dragOverridesStore.current.listeners.get(key) ?? []) {
          listener();
        }
      }
    }
  }, [dragOverrides]);
  const subscribeEffectDragOverrides = useCallback5((key, listener) => {
    if (key === null) {
      return () => {
        return;
      };
    }
    let listeners = effectDragOverridesStore.current.listeners.get(key);
    if (!listeners) {
      listeners = new Set;
      effectDragOverridesStore.current.listeners.set(key, listeners);
    }
    listeners.add(listener);
    return () => {
      listeners.delete(listener);
      if (listeners.size === 0) {
        effectDragOverridesStore.current.listeners.delete(key);
      }
    };
  }, []);
  const getEffectDragOverridesSnapshot = useCallback5((key) => {
    return key === null ? emptyEffectDragOverrides : effectDragOverridesStore.current.byNode.get(key) ?? emptyEffectDragOverrides;
  }, []);
  useIsomorphicLayoutEffect4(() => {
    const previous = effectDragOverridesStore.current.snapshot;
    const byNode = new Map(effectDragOverridesStore.current.byNode);
    const changedNodes = new Set;
    for (const flatKey of new Set([
      ...Object.keys(previous),
      ...Object.keys(effectDragOverridesState)
    ])) {
      if (previous[flatKey] === effectDragOverridesState[flatKey]) {
        continue;
      }
      const separator = flatKey.lastIndexOf(".effects.");
      if (separator === -1) {
        throw new Error("Invalid effect drag override key");
      }
      const nodeKey = flatKey.slice(0, separator);
      const effectIndex = flatKey.slice(separator + ".effects.".length);
      if (!changedNodes.has(nodeKey)) {
        byNode.set(nodeKey, { ...byNode.get(nodeKey) });
        changedNodes.add(nodeKey);
      }
      const next = byNode.get(nodeKey);
      if (effectDragOverridesState[flatKey] === undefined) {
        delete next[effectIndex];
      } else {
        next[effectIndex] = effectDragOverridesState[flatKey];
      }
    }
    for (const nodeKey of changedNodes) {
      if (Object.keys(byNode.get(nodeKey)).length === 0) {
        byNode.delete(nodeKey);
      }
    }
    effectDragOverridesStore.current.snapshot = effectDragOverridesState;
    effectDragOverridesStore.current.byNode = byNode;
    for (const nodeKey of changedNodes) {
      for (const listener of effectDragOverridesStore.current.listeners.get(nodeKey) ?? []) {
        listener();
      }
    }
  }, [effectDragOverridesState]);
  const clearDragOverrides = useCallback5((nodePath) => {
    setDragOverrideState((prevState) => {
      const prev = prevState.overrides;
      const key = makeSequencePropsSubscriptionKey(nodePath);
      if (!prev[key]) {
        return prevState;
      }
      const next = { ...prev };
      delete next[key];
      const nextFromKeys = prevState.fromKeys.has(key) ? new Set(prevState.fromKeys) : prevState.fromKeys;
      nextFromKeys.delete(key);
      return { overrides: next, fromKeys: nextFromKeys };
    });
  }, []);
  const setEffectDragOverridesBatch = useCallback5((overrides) => {
    setEffectDragOverridesState((prev) => {
      let next = null;
      for (const { nodePath, effectIndex, key, value } of overrides) {
        const mapKey = effectDragOverridesKey(nodePath, effectIndex);
        const existing = (next ?? prev)[mapKey]?.[key];
        if (existing === value || existing?.type === "static" && value.type === "static" && Object.is(existing.value, value.value)) {
          continue;
        }
        if (next === null) {
          next = { ...prev };
        }
        if (next[mapKey] === prev[mapKey]) {
          next[mapKey] = { ...prev[mapKey] };
        }
        next[mapKey][key] = value;
      }
      return next ?? prev;
    });
  }, []);
  const setEffectDragOverrides = useCallback5((nodePath, effectIndex, key, value) => setEffectDragOverridesBatch([{ nodePath, effectIndex, key, value }]), [setEffectDragOverridesBatch]);
  const updateEffectDragOverridesBatch = useCallback5((updates) => {
    if (updates.length === 0)
      return;
    setEffectDragOverridesState((previous) => {
      let next = previous;
      for (const { nodePath, effectIndex, update } of updates) {
        const key = effectDragOverridesKey(nodePath, effectIndex);
        const current = next[key] ?? emptyDragOverrides;
        const updated = update(current);
        if (updated === current)
          continue;
        const hasOverrides = Object.keys(updated).length > 0;
        if (!hasOverrides && next[key] === undefined)
          continue;
        if (next === previous)
          next = { ...previous };
        if (hasOverrides)
          next[key] = updated;
        else
          delete next[key];
      }
      return next;
    });
  }, []);
  const remapEffectDragOverrideFields = useCallback5((remappings) => {
    setEffectDragOverridesState((previous) => {
      const moves = remappings.flatMap((remapping) => {
        const previousKey = effectDragOverridesKey(remapping.previousNodePath, remapping.effectIndex);
        const key = remapping.nodePath ? effectDragOverridesKey(remapping.nodePath, remapping.effectIndex) : null;
        if (previousKey === key)
          return [];
        const fields = Object.entries(remapping.fields).filter(([field, expected]) => previous[previousKey]?.[field] === expected);
        return fields.length > 0 ? [{ previousKey, key, fields }] : [];
      });
      if (moves.length === 0)
        return previous;
      const next = { ...previous };
      const changedKeys = new Set;
      const getMutableFields = (key) => {
        if (!changedKeys.has(key)) {
          changedKeys.add(key);
          next[key] = { ...next[key] };
        }
        return next[key];
      };
      for (const { previousKey, fields } of moves) {
        const source = getMutableFields(previousKey);
        for (const [field] of fields)
          delete source[field];
      }
      for (const { key, fields } of moves) {
        if (key === null)
          continue;
        for (const [field, value] of fields) {
          if (next[key]?.[field] !== undefined)
            continue;
          getMutableFields(key)[field] = value;
        }
      }
      for (const key of changedKeys) {
        if (Object.keys(next[key]).length === 0)
          delete next[key];
      }
      return next;
    });
  }, []);
  const clearEffectDragOverrides = useCallback5((nodePath, effectIndex) => {
    setEffectDragOverridesState((prev) => {
      const mapKey = effectDragOverridesKey(nodePath, effectIndex);
      if (!prev[mapKey]) {
        return prev;
      }
      const next = { ...prev };
      delete next[mapKey];
      return next;
    });
  }, []);
  const updatePropStatuses = useCallback5((update) => {
    const previous = requestedPropStatusesRef.current;
    const next = update(previous);
    if (next === previous) {
      return;
    }
    requestedPropStatusesRef.current = next;
    setPropStatusesMapState(next);
  }, []);
  const setPropStatusesBatch = useCallback5((updates) => {
    if (updates.length === 0)
      return;
    updatePropStatuses((previous) => {
      let next = previous;
      for (const { nodePath, update } of updates) {
        const key = makeSequencePropsSubscriptionKey(nodePath);
        const current = next[key];
        const updated = update(current);
        if (updated === current)
          continue;
        if (next === previous)
          next = { ...previous };
        next[key] = updated;
      }
      return next;
    });
  }, [updatePropStatuses]);
  const setPropStatuses = useCallback5((nodePath, update) => setPropStatusesBatch([{ nodePath, update }]), [setPropStatusesBatch]);
  const remapPropStatuses = useCallback5((remappings) => {
    updatePropStatuses((prev) => {
      const next = { ...prev };
      for (const remapping of remappings) {
        delete next[makeSequencePropsSubscriptionKey(remapping.previousNodePath)];
      }
      for (const remapping of remappings) {
        if (remapping.nodePath !== null && remapping.result !== null) {
          next[makeSequencePropsSubscriptionKey(remapping.nodePath)] = remapping.result;
        }
      }
      return next;
    });
  }, [updatePropStatuses]);
  const dragOverridesSubscription = useMemo15(() => ({
    subscribe: subscribeDragOverrides,
    getSnapshot: getDragOverridesSnapshot,
    subscribeEffects: subscribeEffectDragOverrides,
    getEffectSnapshot: getEffectDragOverridesSnapshot
  }), [
    getDragOverridesSnapshot,
    getEffectDragOverridesSnapshot,
    subscribeDragOverrides,
    subscribeEffectDragOverrides
  ]);
  const getDragOverrides = useCallback5((nodePath) => {
    return dragOverrides[makeSequencePropsSubscriptionKey(nodePath)] ?? {};
  }, [dragOverrides]);
  const getEffectDragOverrides = useCallback5((nodePath, effectIndex) => {
    return effectDragOverridesState[effectDragOverridesKey(nodePath, effectIndex)] ?? {};
  }, [effectDragOverridesState]);
  const propStatusesContext = useMemo15(() => {
    return {
      propStatuses
    };
  }, [propStatuses]);
  const propStatusesSubscription = useMemo15(() => ({
    subscribe: (key, listener) => {
      if (key === null) {
        return () => {
          return;
        };
      }
      let listeners = propStatusListeners.current.get(key);
      if (!listeners) {
        listeners = new Set;
        propStatusListeners.current.set(key, listeners);
      }
      listeners.add(listener);
      return () => {
        listeners.delete(listener);
        if (listeners.size === 0) {
          propStatusListeners.current.delete(key);
        }
      };
    },
    getSnapshot: (key) => key === null ? null : requestedPropStatusesRef.current[key] ?? null
  }), []);
  const dragOverridesContext = useMemo15(() => {
    return {
      getDragOverrides,
      getEffectDragOverrides
    };
  }, [getDragOverrides, getEffectDragOverrides]);
  const dragOverridesRef = useRef5(dragOverridesContext);
  useIsomorphicLayoutEffect4(() => {
    dragOverridesRef.current = dragOverridesContext;
  }, [dragOverridesContext]);
  const settersContext = useMemo15(() => {
    return {
      setDragOverrides,
      updateDragOverrides,
      updateDragOverridesBatch,
      remapDragOverrideFields,
      clearDragOverrides,
      setEffectDragOverrides,
      updateEffectDragOverridesBatch,
      remapEffectDragOverrideFields,
      clearEffectDragOverrides,
      setPropStatuses,
      setPropStatusesBatch,
      remapPropStatuses
    };
  }, [
    setDragOverrides,
    updateDragOverrides,
    updateDragOverridesBatch,
    remapDragOverrideFields,
    clearDragOverrides,
    setEffectDragOverrides,
    updateEffectDragOverridesBatch,
    remapEffectDragOverrideFields,
    clearEffectDragOverrides,
    setPropStatuses,
    setPropStatusesBatch,
    remapPropStatuses
  ]);
  const batchSettersContext = useMemo15(() => ({ setDragOverridesBatch, setEffectDragOverridesBatch }), [setDragOverridesBatch, setEffectDragOverridesBatch]);
  return /* @__PURE__ */ jsx16(SequenceRegistryProvider, {
    children: /* @__PURE__ */ jsx16(VisualModePropStatusesRefContext.Provider, {
      value: propStatusesRef,
      children: /* @__PURE__ */ jsx16(VisualModePropStatusesSubscriptionContext.Provider, {
        value: propStatusesSubscription,
        children: /* @__PURE__ */ jsx16(VisualModePropStatusesContext.Provider, {
          value: propStatusesContext,
          children: /* @__PURE__ */ jsx16(SequenceManagerScopeProviders, {
            dragOverridesSubscription,
            fromKeys: dragOverrideState.fromKeys,
            children: /* @__PURE__ */ jsx16(VisualModeDragOverridesContext.Provider, {
              value: dragOverridesContext,
              children: /* @__PURE__ */ jsx16(VisualModeDragOverridesRefContext.Provider, {
                value: dragOverridesRef,
                children: /* @__PURE__ */ jsx16(VisualModeSettersContext.Provider, {
                  value: settersContext,
                  children: /* @__PURE__ */ jsx16(VisualModeBatchSettersContext.Provider, {
                    value: batchSettersContext,
                    children
                  })
                })
              })
            })
          })
        })
      })
    })
  });
};

// src/timeline-track-context.ts
import { createContext as createContext24 } from "react";
var TimelineTrackContext = createContext24(null);

// src/use-premounting.ts
import { useContext as useContext24, useMemo as useMemo16 } from "react";

// src/PremountContext.tsx
import { createContext as createContext25 } from "react";
var PremountContext = createContext25({
  premountFramesRemaining: 0
});

// src/use-premounting.ts
var usePremounting = ({
  from,
  durationInFrames,
  premountFor,
  postmountFor,
  style,
  styleWhilePremounted,
  styleWhilePostmounted,
  hideWhilePremounted
}) => {
  const parentPremountContext = useContext24(PremountContext);
  const environment = useRemotionEnvironment();
  const { fps } = useVideoConfig();
  const defaultPremountInSeconds = useContext24(DefaultPremountContext);
  const effectivePremountFor = premountFor ?? Math.round(defaultPremountInSeconds * fps);
  const effectivePostmountFor = postmountFor ?? 0;
  const needsFrame = !environment.isRendering && (effectivePremountFor !== 0 || effectivePostmountFor !== 0);
  const frame = useCurrentFrameWithOptionalSubscription(needsFrame) - parentPremountContext.premountFramesRemaining;
  const endExclusive = from + durationInFrames;
  const sequenceContext = useContext24(SequenceContext);
  const boundaryTolerance = getSequenceBoundaryTolerance({
    absoluteFrame: useTimelinePositionWithOptionalSubscription(needsFrame),
    cumulatedFrom: sequenceContext ? sequenceContext.cumulatedFrom + sequenceContext.relativeFrom : 0,
    from,
    parentPlaybackRate: sequenceContext?.playbackRate ?? 1,
    durationInFrames
  });
  const premountingActive = !environment.isRendering && frame - from < -boundaryTolerance && frame - (from - effectivePremountFor) >= -boundaryTolerance;
  const postmountingActive = !environment.isRendering && frame - endExclusive >= -boundaryTolerance && frame - (endExclusive + effectivePostmountFor) < -boundaryTolerance;
  const isPremountingOrPostmounting = premountingActive || postmountingActive;
  const freezeFrame = premountingActive ? from : postmountingActive ? from + durationInFrames - 1 : 0;
  const premountingStyle = useMemo16(() => {
    if (!isPremountingOrPostmounting) {
      return style;
    }
    return {
      ...style,
      ...hideWhilePremounted === "opacity" ? { opacity: 0 } : { display: "none" },
      pointerEvents: "none",
      ...premountingActive ? styleWhilePremounted : {},
      ...postmountingActive ? styleWhilePostmounted : {}
    };
  }, [
    isPremountingOrPostmounting,
    hideWhilePremounted,
    postmountingActive,
    premountingActive,
    style,
    styleWhilePostmounted,
    styleWhilePremounted
  ]);
  return {
    effectivePremountFor,
    effectivePostmountFor,
    premountingActive,
    postmountingActive,
    isPremountingOrPostmounting,
    freezeFrame,
    premountingStyle
  };
};

// src/use-sequence-registration.ts
import { useContext as useContext25, useEffect as useEffect6, useLayoutEffect as useLayoutEffect5, useMemo as useMemo17, useRef as useRef6 } from "react";
var useIsomorphicLayoutEffect5 = typeof window === "undefined" ? useEffect6 : useLayoutEffect5;
var useSequenceRegistration = ({
  getSequence,
  id
}) => {
  const { registerSequence, unregisterSequence, updateSequence } = useContext25(SequenceManagerActionsContext);
  const registrationDisabled = useContext25(DisableSequenceRegistrationContext);
  const commitRegistrationEnabled = useContext25(SequenceCommitRegistrationContext);
  const getSequenceRef = useRef6(getSequence);
  useIsomorphicLayoutEffect5(() => {
    getSequenceRef.current = getSequence;
  }, [getSequence]);
  const lastRegisteredGetterRef = useRef6(null);
  const registrationEnabled = getSequence !== null && !registrationDisabled && !commitRegistrationEnabled;
  const registration = useMemo17(() => commitRegistrationEnabled && !registrationDisabled && getSequence !== null ? getSequence() : null, [commitRegistrationEnabled, getSequence, registrationDisabled]);
  useEffect6(() => {
    if (!registrationEnabled) {
      return;
    }
    const currentGetter = getSequenceRef.current;
    if (currentGetter === null) {
      throw new Error("Expected a sequence registration getter");
    }
    registerSequence(currentGetter());
    lastRegisteredGetterRef.current = currentGetter;
    return () => {
      lastRegisteredGetterRef.current = null;
      unregisterSequence(id);
    };
  }, [id, registerSequence, registrationEnabled, unregisterSequence]);
  useIsomorphicLayoutEffect5(() => {
    if (commitRegistrationEnabled || registrationDisabled || getSequence === null || lastRegisteredGetterRef.current === null || lastRegisteredGetterRef.current === getSequence) {
      return;
    }
    updateSequence(getSequence());
    lastRegisteredGetterRef.current = getSequence;
  }, [
    commitRegistrationEnabled,
    getSequence,
    registrationDisabled,
    updateSequence
  ]);
  return registration;
};

// src/with-interactivity-schema.ts
import React26, {
  createContext as createContext27,
  forwardRef as forwardRef2,
  useContext as useContext27,
  useLayoutEffect as useLayoutEffect8,
  useMemo as useMemo21,
  useState as useState9
} from "react";

// src/delete-nested-key.ts
var deleteNestedKey = (obj, keysToRemove) => {
  for (const key of keysToRemove) {
    const parts = key.split(".");
    const parents = [obj];
    let current = obj;
    for (let i = 0;i < parts.length - 1; i++) {
      const part = parts[i];
      const next = current[part];
      if (next === undefined || next === null) {
        current = null;
        break;
      }
      current = next;
      parents.push(current);
    }
    if (current === null) {
      continue;
    }
    delete current[parts[parts.length - 1]];
    for (let i = parents.length - 1;i > 0; i--) {
      const parent = parents[i];
      if (Object.keys(parent).length === 0) {
        const parentKey = parts[i - 1];
        delete parents[i - 1][parentKey];
      } else {
        break;
      }
    }
  }
  return obj;
};

// src/effects/use-memoized-effects.ts
import React25, { useContext as useContext26, useLayoutEffect as useLayoutEffect7, useMemo as useMemo20, useRef as useRef7 } from "react";

// src/evaluate-source-expressions.ts
var evaluateSourceNumericValue = (expression, config) => {
  if (typeof expression === "number") {
    return expression;
  }
  if (expression.type === "literal") {
    return expression.value;
  }
  if (expression.type === "binary") {
    const left = evaluateSourceNumericValue(expression.left, config);
    const right = evaluateSourceNumericValue(expression.right, config);
    switch (expression.operator) {
      case "+":
        return left + right;
      case "-":
        return left - right;
      case "*":
        return left * right;
      case "/":
        return left / right;
      default:
        throw new Error("Unknown source expression operator");
    }
  }
  const value = expression.binding.type === "constant" ? expression.binding.value : config?.[expression.binding.field] ?? NaN;
  if (expression.type === "video-config-multiplication") {
    return value * expression.multiplier;
  }
  if (expression.type === "video-config-subtraction") {
    return value - expression.subtrahend;
  }
  return value;
};
var evaluatedProps = new WeakMap;
var evaluateSourcePropStatuses = (props, config) => {
  const configKey = config === null ? "" : `${config.durationInFrames}:${config.fps}:${config.width}:${config.height}`;
  const cached = evaluatedProps.get(props) ?? new Map;
  const existing = cached.get(configKey);
  if (existing)
    return existing;
  const result = Object.fromEntries(Object.entries(props).map(([key, status]) => {
    if (status.status === "computed") {
      return [key, status];
    }
    const adjustment = status.keyframeDisplayOffsetAdjustment === null ? null : evaluateSourceNumericValue(status.keyframeDisplayOffsetAdjustment, config);
    const rate = evaluateSourceNumericValue(status.keyframePlaybackRateAdjustment ?? 1, config);
    if (adjustment !== null && !Number.isFinite(adjustment) || !Number.isFinite(rate) || rate <= 0) {
      return [key, { status: "computed" }];
    }
    const timing = {
      keyframeDisplayOffsetAdjustment: adjustment,
      ...status.keyframePlaybackRateAdjustment === undefined ? {} : { keyframePlaybackRateAdjustment: rate }
    };
    if (status.status === "static") {
      const value = status.numericExpression === undefined ? status.codeValue : evaluateSourceNumericValue(status.numericExpression, config);
      return [
        key,
        status.numericExpression !== undefined && !Number.isFinite(value) ? { status: "computed" } : { ...status, ...timing, codeValue: value }
      ];
    }
    const keyframes = status.keyframes.map((keyframe) => ({
      ...keyframe,
      frame: evaluateSourceNumericValue(keyframe.frame, config)
    }));
    if (keyframes.some((keyframe, index) => !Number.isFinite(keyframe.frame) || index > 0 && keyframe.frame <= keyframes[index - 1].frame)) {
      return [key, { status: "computed" }];
    }
    return [key, { ...status, ...timing, keyframes }];
  }));
  cached.set(configKey, result);
  if (cached.size > 8)
    cached.delete(cached.keys().next().value);
  evaluatedProps.set(props, cached);
  return result;
};

// src/bezier.ts
var NEWTON_ITERATIONS = 4;
var NEWTON_MIN_SLOPE = 0.001;
var SUBDIVISION_PRECISION = 0.0000001;
var SUBDIVISION_MAX_ITERATIONS = 10;
var kSplineTableSize = 11;
var kSampleStepSize = 1 / (kSplineTableSize - 1);
var float32ArraySupported = typeof Float32Array === "function";
function a(aA1, aA2) {
  return 1 - 3 * aA2 + 3 * aA1;
}
function b(aA1, aA2) {
  return 3 * aA2 - 6 * aA1;
}
function c(aA1) {
  return 3 * aA1;
}
function calcBezier(aT, aA1, aA2) {
  return ((a(aA1, aA2) * aT + b(aA1, aA2)) * aT + c(aA1)) * aT;
}
function getSlope(aT, aA1, aA2) {
  return 3 * a(aA1, aA2) * aT * aT + 2 * b(aA1, aA2) * aT + c(aA1);
}
function binarySubdivide({
  aX,
  _aA,
  _aB,
  mX1,
  mX2
}) {
  let currentX;
  let currentT;
  let i = 0;
  let aA = _aA;
  let aB = _aB;
  do {
    currentT = aA + (aB - aA) / 2;
    currentX = calcBezier(currentT, mX1, mX2) - aX;
    if (currentX > 0) {
      aB = currentT;
    } else {
      aA = currentT;
    }
  } while (Math.abs(currentX) > SUBDIVISION_PRECISION && ++i < SUBDIVISION_MAX_ITERATIONS);
  return currentT;
}
function newtonRaphsonIterate(aX, _aGuessT, mX1, mX2) {
  let aGuessT = _aGuessT;
  for (let i = 0;i < NEWTON_ITERATIONS; ++i) {
    const currentSlope = getSlope(aGuessT, mX1, mX2);
    if (currentSlope === 0) {
      return aGuessT;
    }
    const currentX = calcBezier(aGuessT, mX1, mX2) - aX;
    aGuessT -= currentX / currentSlope;
  }
  return aGuessT;
}
function bezier(mX1, mY1, mX2, mY2) {
  if (!(mX1 >= 0 && mX1 <= 1 && mX2 >= 0 && mX2 <= 1)) {
    throw new Error("bezier x values must be in [0, 1] range");
  }
  const sampleValues = float32ArraySupported ? new Float32Array(kSplineTableSize) : new Array(kSplineTableSize);
  if (mX1 !== mY1 || mX2 !== mY2) {
    for (let i = 0;i < kSplineTableSize; ++i) {
      sampleValues[i] = calcBezier(i * kSampleStepSize, mX1, mX2);
    }
  }
  function getTForX(aX) {
    let intervalStart = 0;
    let currentSample = 1;
    const lastSample = kSplineTableSize - 1;
    for (;currentSample !== lastSample && sampleValues[currentSample] <= aX; ++currentSample) {
      intervalStart += kSampleStepSize;
    }
    --currentSample;
    const dist = (aX - sampleValues[currentSample]) / (sampleValues[currentSample + 1] - sampleValues[currentSample]);
    const guessForT = intervalStart + dist * kSampleStepSize;
    const initialSlope = getSlope(guessForT, mX1, mX2);
    if (initialSlope >= NEWTON_MIN_SLOPE) {
      return newtonRaphsonIterate(aX, guessForT, mX1, mX2);
    }
    if (initialSlope === 0) {
      return guessForT;
    }
    return binarySubdivide({
      aX,
      _aA: intervalStart,
      _aB: intervalStart + kSampleStepSize,
      mX1,
      mX2
    });
  }
  return function(x) {
    const clampedX = Math.min(1, Math.max(0, x));
    if (mX1 === mY1 && mX2 === mY2) {
      return clampedX;
    }
    if (clampedX === 0) {
      return 0;
    }
    if (clampedX === 1) {
      return 1;
    }
    return calcBezier(getTForX(clampedX), mY1, mY2);
  };
}

// src/normalize-number.ts
var normalizeNumber = (value) => {
  return Math.round(value * 1e6) / 1e6;
};

// src/interpolate.ts
var angleUnits = new Set(["deg", "rad", "grad", "turn"]);
var lengthUnits = new Set([
  "%",
  "cap",
  "ch",
  "cm",
  "cqb",
  "cqh",
  "cqi",
  "cqmax",
  "cqmin",
  "cqw",
  "dvh",
  "dvw",
  "em",
  "ex",
  "ic",
  "in",
  "lh",
  "lvh",
  "lvw",
  "mm",
  "pc",
  "pt",
  "px",
  "q",
  "rem",
  "rlh",
  "svh",
  "svw",
  "vb",
  "vh",
  "vi",
  "vmax",
  "vmin",
  "vw"
]);
var cssNumberRegex = /^([+-]?(?:\d+\.?\d*|\.\d+))([a-zA-Z%]+)?$/;
var transformOriginKeywords = new Set([
  "left",
  "center",
  "right",
  "top",
  "bottom"
]);
var transformOriginKeywordOptions = (keyword) => {
  if (keyword === "left") {
    return [{ axis: "x", value: { value: 0, unit: "%" } }];
  }
  if (keyword === "right") {
    return [{ axis: "x", value: { value: 100, unit: "%" } }];
  }
  if (keyword === "top") {
    return [{ axis: "y", value: { value: 0, unit: "%" } }];
  }
  if (keyword === "bottom") {
    return [{ axis: "y", value: { value: 100, unit: "%" } }];
  }
  return [
    { axis: "x", value: { value: 50, unit: "%" } },
    { axis: "y", value: { value: 50, unit: "%" } }
  ];
};
var transformOriginCenter = { value: 50, unit: "%" };
var stringifyNumber = (value) => {
  return String(normalizeNumber(value));
};

class UnsupportedStringInterpolationValueError extends TypeError {
}
var parseStringInterpolationComponent = (component, value) => {
  const match = cssNumberRegex.exec(component);
  if (match === null) {
    throw new UnsupportedStringInterpolationValueError(`Cannot interpolate "${value}" because "${component}" is not a supported scale, translate, or rotate value`);
  }
  const unit = match[2] ?? null;
  const numberValue = Number(match[1]);
  if (!Number.isFinite(numberValue)) {
    throw new TypeError(`Cannot interpolate "${value}" because "${component}" is not finite`);
  }
  if (unit === null) {
    return { kind: "scale", value: numberValue, unit: null };
  }
  if (angleUnits.has(unit)) {
    return { kind: "rotate", value: numberValue, unit };
  }
  if (lengthUnits.has(unit)) {
    return { kind: "translate", value: numberValue, unit };
  }
  throw new TypeError(`Cannot interpolate "${value}" because "${unit}" is not a supported translate or rotate unit`);
};
var parseTransformOriginLengthPercentage = ({
  component,
  value,
  allowPercentage
}) => {
  const match = cssNumberRegex.exec(component);
  if (match === null) {
    throw new TypeError(`Cannot interpolate "${value}" because "${component}" is not a supported transform-origin ${allowPercentage ? "length-percentage" : "z length"}`);
  }
  const unit = match[2] ?? null;
  const numberValue = Number(match[1]);
  if (!Number.isFinite(numberValue)) {
    throw new TypeError(`Cannot interpolate "${value}" because "${component}" is not finite`);
  }
  if (unit === null || !lengthUnits.has(unit) || !allowPercentage && unit === "%") {
    throw new TypeError(`Cannot interpolate "${value}" because "${component}" is not a supported transform-origin ${allowPercentage ? "length-percentage" : "z length"}`);
  }
  return { value: numberValue, unit };
};
var parseTransformOriginToken = (component, value) => {
  const lower = component.toLowerCase();
  if (transformOriginKeywords.has(lower)) {
    return { type: "keyword", keyword: lower };
  }
  return {
    type: "length-percentage",
    parsed: parseTransformOriginLengthPercentage({
      component,
      value,
      allowPercentage: true
    })
  };
};
var parseTwoTransformOriginKeywords = (first, second, value) => {
  const candidates = [];
  for (const firstOption of transformOriginKeywordOptions(first)) {
    for (const secondOption of transformOriginKeywordOptions(second)) {
      if (firstOption.axis === secondOption.axis) {
        continue;
      }
      candidates.push(firstOption.axis === "x" ? [firstOption.value, secondOption.value] : [secondOption.value, firstOption.value]);
    }
  }
  if (candidates.length === 0) {
    throw new TypeError(`Cannot interpolate "${value}" because "${first} ${second}" is not a valid transform-origin keyword pair`);
  }
  return candidates[0];
};
var parseTransformOriginXY = (parts, value) => {
  if (parts.length === 1) {
    const token = parseTransformOriginToken(parts[0], value);
    if (token.type === "length-percentage") {
      return [token.parsed, transformOriginCenter];
    }
    if (token.keyword === "top" || token.keyword === "bottom") {
      return [
        transformOriginCenter,
        transformOriginKeywordOptions(token.keyword)[0].value
      ];
    }
    return [
      transformOriginKeywordOptions(token.keyword)[0].value,
      transformOriginCenter
    ];
  }
  const first = parseTransformOriginToken(parts[0], value);
  const second = parseTransformOriginToken(parts[1], value);
  if (first.type === "length-percentage" && second.type === "length-percentage") {
    return [first.parsed, second.parsed];
  }
  if (first.type === "keyword" && second.type === "keyword") {
    return parseTwoTransformOriginKeywords(first.keyword, second.keyword, value);
  }
  const keyword = first.type === "keyword" ? first : second.type === "keyword" ? second : null;
  const length = first.type === "length-percentage" ? first.parsed : second.type === "length-percentage" ? second.parsed : null;
  if (keyword === null || length === null) {
    throw new Error("Expected a keyword and a length-percentage value");
  }
  const keywordIsFirst = first.type === "keyword";
  if (keyword.keyword === "left" || keyword.keyword === "right") {
    if (!keywordIsFirst) {
      throw new TypeError(`Cannot interpolate "${value}" because horizontal transform-origin keywords must come before a length-percentage value`);
    }
    return [transformOriginKeywordOptions(keyword.keyword)[0].value, length];
  }
  if (keyword.keyword === "top" || keyword.keyword === "bottom") {
    return [length, transformOriginKeywordOptions(keyword.keyword)[0].value];
  }
  return keywordIsFirst ? [transformOriginCenter, length] : [length, transformOriginCenter];
};
var parseTransformOriginValue = (output, parts) => {
  const [x, y] = parseTransformOriginXY(parts.slice(0, 2), output);
  const z = parts[2] === undefined ? { value: 0, unit: null } : parseTransformOriginLengthPercentage({
    component: parts[2],
    value: output,
    allowPercentage: false
  });
  return {
    kind: "translate",
    values: [x.value, y.value, z.value, 0],
    units: [x.unit, y.unit, z.unit, null],
    dimensions: parts[2] === undefined ? 2 : 3,
    axisRotation: false
  };
};
var parseAxisRotationValue = (output) => {
  const parts = output.trim().split(/\s+/);
  const keywordAxis = parts.length === 2 ? parts[0].toLowerCase() : null;
  if (keywordAxis === "x" || keywordAxis === "y" || keywordAxis === "z") {
    const keywordAngle = parseStringInterpolationComponent(parts[1], output);
    if (keywordAngle.kind !== "rotate") {
      return null;
    }
    return {
      kind: "rotate",
      values: keywordAxis === "x" ? [1, 0, 0, keywordAngle.value] : keywordAxis === "y" ? [0, 1, 0, keywordAngle.value] : [0, 0, 1, keywordAngle.value],
      units: [null, null, null, keywordAngle.unit],
      dimensions: 4,
      axisRotation: true
    };
  }
  if (parts.length !== 4) {
    return null;
  }
  const axis = parts.slice(0, 3).map(Number);
  if (!axis.every(Number.isFinite)) {
    return null;
  }
  const vectorAngle = parseStringInterpolationComponent(parts[3], output);
  if (vectorAngle.kind !== "rotate") {
    return null;
  }
  return {
    kind: "rotate",
    values: [axis[0], axis[1], axis[2], vectorAngle.value],
    units: [null, null, null, vectorAngle.unit],
    dimensions: 4,
    axisRotation: true
  };
};
var parseStringInterpolationValue = (output, outputType) => {
  if (typeof output === "number") {
    if (!Number.isFinite(output)) {
      throw new Error(`outputRange must contain only finite numbers, but got [${output}]`);
    }
    return {
      kind: "scale",
      values: [output, output, 1, 0],
      units: [null, null, null, null],
      dimensions: 1,
      axisRotation: false
    };
  }
  if (outputType === "transform-origin") {
    const transformOriginParts = output.trim().split(/\s+/);
    if (transformOriginParts.length < 1 || transformOriginParts.length > 3 || transformOriginParts[0] === "") {
      throw new TypeError(`String outputRange values must contain 1 to 3 components, but got "${output}"`);
    }
    return parseTransformOriginValue(output, transformOriginParts);
  }
  const axisRotation = parseAxisRotationValue(output);
  if (axisRotation !== null) {
    if (outputType !== undefined && outputType !== "rotate") {
      throw new TypeError(`Cannot interpolate "${output}" as ${outputType} because it is a rotate value`);
    }
    return axisRotation;
  }
  const parts = output.trim().split(/\s+/);
  if (parts.length < 1 || parts.length > 3 || parts[0] === "") {
    const ErrorType = outputType === undefined && parts.some((part) => !cssNumberRegex.test(part) && !transformOriginKeywords.has(part.toLowerCase())) ? UnsupportedStringInterpolationValueError : TypeError;
    throw new ErrorType(`String outputRange values must contain 1 to 3 components, but got "${output}"`);
  }
  if (parts.some((part) => transformOriginKeywords.has(part.toLowerCase()))) {
    if (outputType !== undefined) {
      throw new TypeError(`Cannot interpolate "${output}" as ${outputType} because it is a transform-origin value`);
    }
    return parseTransformOriginValue(output, parts);
  }
  const parsed = parts.map((part) => parseStringInterpolationComponent(part, output));
  const [{ kind }] = parsed;
  for (const part of parsed) {
    if (part.kind !== kind) {
      throw new TypeError(`Cannot interpolate "${output}" because it mixes ${kind} and ${part.kind} values`);
    }
  }
  if (outputType !== undefined && outputType !== kind) {
    throw new TypeError(`Cannot interpolate "${output}" as ${outputType} because it is a ${kind} value`);
  }
  if (kind === "scale") {
    const x = parsed[0].value;
    const y = parsed[1]?.value ?? x;
    const z = parsed[2]?.value ?? 1;
    return {
      kind,
      values: [x, y, z, 0],
      units: [null, null, null, null],
      dimensions: parsed.length,
      axisRotation: false
    };
  }
  return {
    kind,
    values: [parsed[0].value, parsed[1]?.value ?? 0, parsed[2]?.value ?? 0, 0],
    units: [
      parsed[0].unit,
      parsed[1]?.unit ?? null,
      parsed[2]?.unit ?? null,
      null
    ],
    dimensions: parsed.length,
    axisRotation: false
  };
};
var serializeStringInterpolationValue = ({
  kind,
  values,
  units,
  dimensions,
  axisRotation
}) => {
  if (axisRotation) {
    return `${stringifyNumber(values[0])} ${stringifyNumber(values[1])} ${stringifyNumber(values[2])} ${stringifyNumber(values[3])}${units[3]}`;
  }
  if (kind === "scale") {
    return values.slice(0, dimensions).map((value) => stringifyNumber(value)).join(" ");
  }
  return values.slice(0, dimensions).map((value, index) => `${stringifyNumber(value)}${units[index]}`).join(" ");
};
var toSignedArea = (scale) => {
  if (scale === 0) {
    return 0;
  }
  return Math.sign(scale) * scale * scale;
};
var fromSignedArea = (area) => {
  if (area === 0) {
    return 0;
  }
  return Math.sign(area) * Math.sqrt(Math.abs(area));
};
function interpolateFunction(input, inputRange, outputRange, options) {
  const { extrapolateLeft, extrapolateRight, easing, output } = options;
  let result = input;
  const [inputMin, inputMax] = inputRange;
  const [outputMin, outputMax] = outputRange;
  if (result < inputMin) {
    if (extrapolateLeft === "identity") {
      return result;
    }
    if (extrapolateLeft === "clamp") {
      result = inputMin;
    } else if (extrapolateLeft === "wrap") {
      const range = inputMax - inputMin;
      result = ((result - inputMin) % range + range) % range + inputMin;
    } else if (extrapolateLeft === "extend") {}
  }
  if (result > inputMax) {
    if (extrapolateRight === "identity") {
      return result;
    }
    if (extrapolateRight === "clamp") {
      result = inputMax;
    } else if (extrapolateRight === "wrap") {
      const range = inputMax - inputMin;
      result = ((result - inputMin) % range + range) % range + inputMin;
    } else if (extrapolateRight === "extend") {}
  }
  if (outputMin === outputMax) {
    return outputMin;
  }
  result = (result - inputMin) / (inputMax - inputMin);
  result = easing(result);
  if (output === "perceptual-scale") {
    const signedAreaMin = toSignedArea(outputMin);
    const signedAreaMax = toSignedArea(outputMax);
    result = fromSignedArea(result * (signedAreaMax - signedAreaMin) + signedAreaMin);
  } else {
    result = result * (outputMax - outputMin) + outputMin;
  }
  return result;
}
function findRange(input, inputRange) {
  let i;
  for (i = 1;i < inputRange.length - 1; ++i) {
    if (inputRange[i] >= input) {
      break;
    }
  }
  return i - 1;
}
var defaultEasing = (num) => num;
var resolveOutputOption = (output) => {
  return output ?? "linear";
};
var shouldExtendRightForEasing = (easing) => {
  return easing.remotionShouldExtendRight === true;
};
var resolveEasingForSegment = ({
  easing,
  segmentIndex
}) => {
  if (easing === undefined) {
    return defaultEasing;
  }
  if (typeof easing === "function") {
    return easing;
  }
  return easing[segmentIndex];
};
var interpolateSegment = ({
  input,
  inputRange,
  outputRange,
  easing,
  extrapolateLeft,
  extrapolateRight,
  output
}) => {
  return interpolateFunction(input, inputRange, outputRange, {
    easing,
    extrapolateLeft,
    extrapolateRight: input > inputRange[1] && extrapolateRight === "clamp" && shouldExtendRightForEasing(easing) ? "extend" : extrapolateRight,
    output
  });
};
var getInputForInterpolation = ({
  input,
  inputRange,
  options
}) => {
  const posterizedInput = options?.posterize === undefined ? input : Math.floor(input / options.posterize) * options.posterize;
  const inputMin = inputRange[0];
  const inputMax = inputRange[inputRange.length - 1];
  if (inputRange.length === 1 || !(posterizedInput < inputMin && options?.extrapolateLeft === "wrap" || posterizedInput > inputMax && options?.extrapolateRight === "wrap")) {
    return posterizedInput;
  }
  const range = inputMax - inputMin;
  return ((posterizedInput - inputMin) % range + range) % range + inputMin;
};
var interpolateNumber = ({
  input,
  inputRange,
  outputRange,
  options
}) => {
  const output = resolveOutputOption(options?.output);
  if (inputRange.length === 1) {
    return outputRange[0];
  }
  const easingOption = options?.easing;
  let extrapolateLeft = "extend";
  if (options?.extrapolateLeft !== undefined) {
    extrapolateLeft = options.extrapolateLeft;
  }
  let extrapolateRight = "extend";
  if (options?.extrapolateRight !== undefined) {
    extrapolateRight = options.extrapolateRight;
  }
  const resolvedInput = getInputForInterpolation({
    input,
    inputRange,
    options: options ?? null
  });
  const range = findRange(resolvedInput, inputRange);
  const easing = resolveEasingForSegment({
    easing: easingOption,
    segmentIndex: range
  });
  let result = interpolateSegment({
    input: resolvedInput,
    inputRange: [inputRange[range], inputRange[range + 1]],
    outputRange: [outputRange[range], outputRange[range + 1]],
    easing,
    extrapolateLeft,
    extrapolateRight,
    output
  });
  for (let segmentIndex = 0;segmentIndex < range; segmentIndex++) {
    const previousEasing = resolveEasingForSegment({
      easing: easingOption,
      segmentIndex
    });
    if (!shouldExtendRightForEasing(previousEasing)) {
      continue;
    }
    const previousSegmentEnd = inputRange[segmentIndex + 1];
    if (resolvedInput <= previousSegmentEnd) {
      continue;
    }
    const continuedSegmentValue = interpolateSegment({
      input: resolvedInput,
      inputRange: [inputRange[segmentIndex], previousSegmentEnd],
      outputRange: [outputRange[segmentIndex], outputRange[segmentIndex + 1]],
      easing: previousEasing,
      extrapolateLeft,
      extrapolateRight: "extend",
      output
    });
    result += continuedSegmentValue - outputRange[segmentIndex + 1];
  }
  return result;
};
var interpolateString = ({
  input,
  inputRange,
  outputRange,
  options,
  outputType
}) => {
  const initiallyParsedOutputRange = outputRange.map((output) => parseStringInterpolationValue(output, outputType));
  const hasAxisRotation = initiallyParsedOutputRange.some((parsed) => parsed.axisRotation);
  const resolvedInput = getInputForInterpolation({
    input,
    inputRange,
    options: options ?? null
  });
  const segmentIndex = inputRange.length === 1 ? 0 : findRange(resolvedInput, inputRange);
  const parsedOutputRange = hasAxisRotation ? initiallyParsedOutputRange.map((parsed, index) => {
    if (parsed.kind !== "rotate") {
      return parsed;
    }
    if (parsed.axisRotation) {
      return parsed;
    }
    if (parsed.dimensions !== 1) {
      throw new TypeError("Cannot interpolate a multi-angle rotate value with an axis rotation");
    }
    const adjacentAxisRotation = parsed.values[0] === 0 ? index === 0 ? initiallyParsedOutputRange.find((candidate) => candidate.axisRotation) : index === initiallyParsedOutputRange.length - 1 ? [...initiallyParsedOutputRange].reverse().find((candidate) => candidate.axisRotation) : index === segmentIndex ? initiallyParsedOutputRange[index + 1] : index === segmentIndex + 1 ? initiallyParsedOutputRange[index - 1] : undefined : undefined;
    const axis = adjacentAxisRotation?.axisRotation ? adjacentAxisRotation.values : [0, 0, 1];
    return {
      kind: "rotate",
      values: [axis[0], axis[1], axis[2], parsed.values[0]],
      units: [null, null, null, parsed.units[0]],
      dimensions: 4,
      axisRotation: true
    };
  }) : initiallyParsedOutputRange;
  const kind = parsedOutputRange[0]?.kind;
  if (kind === undefined) {
    throw new Error("outputRange must have at least 1 element");
  }
  for (const parsed of parsedOutputRange) {
    if (parsed.kind !== kind) {
      throw new TypeError(`Cannot interpolate ${kind} values with ${parsed.kind} values`);
    }
  }
  const dimensions = Math.max(...parsedOutputRange.map((parsed) => parsed.dimensions));
  const units = [
    null,
    null,
    null,
    null
  ];
  if (kind !== "scale") {
    for (let axis = 0;axis < dimensions; axis++) {
      if (hasAxisRotation && axis < 3) {
        continue;
      }
      for (const parsed of parsedOutputRange) {
        const unit = parsed.units[axis];
        if (unit === null) {
          continue;
        }
        if (units[axis] === null) {
          units[axis] = unit;
          continue;
        }
        if (units[axis] !== unit) {
          throw new TypeError(`Cannot interpolate ${kind} values with different units on axis ${axis + 1}: ${units[axis]} and ${unit}`);
        }
      }
      if (units[axis] === null) {
        throw new TypeError(`Cannot interpolate ${kind} values because axis ${axis + 1} has no unit`);
      }
    }
  }
  const values = [0, 0, 0, 0];
  for (let axis = 0;axis < dimensions; axis++) {
    values[axis] = interpolateNumber({
      input,
      inputRange,
      outputRange: parsedOutputRange.map((parsed) => parsed.values[axis]),
      options
    });
  }
  return serializeStringInterpolationValue({
    kind,
    values,
    units,
    dimensions,
    axisRotation: hasAxisRotation
  });
};
var interpolateFontWeight = ({
  input,
  inputRange,
  outputRange,
  options
}) => {
  const normalizedOutputRange = outputRange.map((output) => {
    if (typeof output === "string") {
      const lowerCaseOutput = output.toLowerCase();
      if (lowerCaseOutput === "normal") {
        return 400;
      }
      if (lowerCaseOutput === "bold") {
        return 700;
      }
    }
    const match = typeof output === "string" ? cssNumberRegex.exec(output) : null;
    const value = typeof output === "number" ? output : match !== null && match[2] === undefined ? Number(match[1]) : Number.NaN;
    if (!Number.isFinite(value) || value < 1 || value > 1000) {
      throw new TypeError(`Cannot interpolate font weight "${output}". Expected "normal", "bold", or a number between 1 and 1000`);
    }
    return value;
  });
  return interpolateNumber({
    input,
    inputRange,
    outputRange: normalizedOutputRange,
    options
  });
};
var interpolateDiscreteValue = ({
  input,
  inputRange,
  outputRange,
  options
}) => {
  if (inputRange.length === 1) {
    return outputRange[0];
  }
  for (let segmentIndex = 0;segmentIndex < inputRange.length - 1; segmentIndex++) {
    if (resolveEasingForSegment({
      easing: options?.easing,
      segmentIndex
    }) !== Easing.step1) {
      throw new TypeError(typeof outputRange[0] === "boolean" ? "Booleans can only be interpolated using Easing.step1" : "Non-numeric strings can only be interpolated using Easing.step1");
    }
  }
  const resolvedInput = getInputForInterpolation({
    input,
    inputRange,
    options: options ?? null
  });
  const inputMin = inputRange[0];
  const inputMax = inputRange[inputRange.length - 1];
  if (resolvedInput < inputMin) {
    if (options?.extrapolateLeft === "identity") {
      throw new TypeError(typeof outputRange[0] === "boolean" ? 'extrapolateLeft: "identity" is not supported for booleans' : 'extrapolateLeft: "identity" is not supported for non-numeric strings');
    }
    return outputRange[0];
  }
  if (resolvedInput > inputMax) {
    if (options?.extrapolateRight === "identity") {
      throw new TypeError(typeof outputRange[0] === "boolean" ? 'extrapolateRight: "identity" is not supported for booleans' : 'extrapolateRight: "identity" is not supported for non-numeric strings');
    }
    return outputRange[outputRange.length - 1];
  }
  const range = findRange(resolvedInput, inputRange);
  return resolvedInput >= inputRange[range + 1] ? outputRange[range + 1] : outputRange[range];
};
var validateTupleOutputRange = (outputRange) => {
  const dimensions = outputRange[0]?.length;
  if (dimensions === undefined) {
    throw new Error("outputRange must have at least 1 element");
  }
  if (dimensions === 0) {
    throw new TypeError("outputRange tuples must contain at least 1 number");
  }
  for (const output of outputRange) {
    if (output.length !== dimensions) {
      throw new TypeError(`outputRange tuples must all have the same length, but got ${dimensions} and ${output.length}`);
    }
    for (const value of output) {
      if (typeof value !== "number" || !Number.isFinite(value)) {
        throw new TypeError(`outputRange tuples must contain only finite numbers, but got [${output.join(",")}]`);
      }
    }
  }
  return dimensions;
};
var interpolateTuple = ({
  input,
  inputRange,
  outputRange,
  options
}) => {
  const dimensions = validateTupleOutputRange(outputRange);
  return new Array(dimensions).fill(true).map((_, axis) => interpolateNumber({
    input,
    inputRange,
    outputRange: outputRange.map((output) => output[axis]),
    options
  }));
};
function checkValidInputRange(arr) {
  for (let i = 1;i < arr.length; ++i) {
    if (!(arr[i] > arr[i - 1])) {
      throw new Error(`inputRange must be strictly monotonically increasing but got [${arr.join(",")}]`);
    }
  }
}
function checkInfiniteRange(name, arr) {
  if (arr.length < 1) {
    throw new Error(name + " must have at least 1 element");
  }
  for (const element of arr) {
    if (typeof element !== "number") {
      throw new Error(`${name} must contain only numbers`);
    }
    if (!Number.isFinite(element)) {
      throw new Error(`${name} must contain only finite numbers, but got [${arr.join(",")}]`);
    }
  }
}
function assertValidInterpolateEasingOption(easing, inputRangeLength) {
  if (easing === undefined) {
    return;
  }
  if (typeof easing === "function") {
    return;
  }
  const expectedLength = inputRangeLength - 1;
  if (easing.length !== expectedLength) {
    throw new Error(`When easing is an array, it must have one entry per segment between keyframes (length inputRange.length - 1 = ${expectedLength}), but got length ${easing.length}`);
  }
  for (let i = 0;i < easing.length; i++) {
    if (typeof easing[i] !== "function") {
      throw new Error(`easing[${i}] must be a function`);
    }
  }
}
function assertValidInterpolatePosterizeOption(posterize) {
  if (posterize === undefined) {
    return;
  }
  if (typeof posterize !== "number" || !Number.isFinite(posterize) || posterize <= 0) {
    throw new Error(`posterize must be a positive finite number, but got ${posterize}`);
  }
}
function assertValidInterpolateOutputOption(output) {
  if (output === undefined || output === "linear" || output === "perceptual-scale") {
    return;
  }
  throw new Error(`output must be "linear" or "perceptual-scale", but got ${String(output)}`);
}
function assertValidInterpolateOutputType(outputType) {
  if (outputType === undefined || outputType === "font-weight" || outputType === "scale" || outputType === "translate" || outputType === "rotate" || outputType === "transform-origin") {
    return;
  }
  throw new Error(`outputType must be "font-weight", "scale", "translate", "rotate", or "transform-origin", but got ${String(outputType)}`);
}
function interpolate(input, inputRange, outputRange, options) {
  if (typeof input === "undefined") {
    throw new Error("input can not be undefined");
  }
  if (typeof inputRange === "undefined") {
    throw new Error("inputRange can not be undefined");
  }
  if (typeof outputRange === "undefined") {
    throw new Error("outputRange can not be undefined");
  }
  if (inputRange.length !== outputRange.length) {
    throw new Error("inputRange (" + inputRange.length + ") and outputRange (" + outputRange.length + ") must have the same length");
  }
  checkInfiniteRange("inputRange", inputRange);
  checkValidInputRange(inputRange);
  assertValidInterpolateEasingOption(options?.easing, inputRange.length);
  assertValidInterpolatePosterizeOption(options?.posterize);
  assertValidInterpolateOutputOption(options?.output);
  assertValidInterpolateOutputType(options?.outputType);
  if (typeof input !== "number") {
    throw new TypeError("Cannot interpolate an input which is not a number");
  }
  if (!Array.isArray(outputRange)) {
    throw new Error("outputRange must contain only numbers");
  }
  const outputType = options?.outputType;
  if (outputRange.some((output) => typeof output === "boolean")) {
    if (!outputRange.every((output) => typeof output === "boolean")) {
      throw new TypeError("Boolean outputRange must contain only booleans");
    }
    if (outputType !== undefined) {
      throw new TypeError("Boolean outputRange cannot use outputType");
    }
    return interpolateDiscreteValue({
      input,
      inputRange,
      outputRange,
      options
    });
  }
  if (outputType === "font-weight") {
    if (!outputRange.every((output) => typeof output === "number" || typeof output === "string")) {
      throw new TypeError("Font weight outputRange must contain only numbers or strings");
    }
    return interpolateFontWeight({
      input,
      inputRange,
      outputRange,
      options
    });
  }
  const hasStringOutput = outputRange.some((output) => typeof output === "string");
  if (outputType !== undefined && outputType !== "scale" && !hasStringOutput) {
    throw new TypeError(`${outputType} outputRange must contain strings with the appropriate CSS units`);
  }
  if (hasStringOutput) {
    if (!outputRange.every((output) => typeof output === "string" || typeof output === "number")) {
      throw new TypeError("outputRange must contain only numbers, or supported scale, translate, and rotate strings");
    }
    try {
      return interpolateString({
        input,
        inputRange,
        outputRange,
        options,
        outputType
      });
    } catch (error) {
      if (!outputRange.every((output) => typeof output === "string")) {
        throw error;
      }
      const hasNonNumericString = outputRange.some((output) => {
        try {
          parseStringInterpolationValue(output, outputType);
          return false;
        } catch (parseError) {
          return parseError instanceof UnsupportedStringInterpolationValueError;
        }
      });
      if (!hasNonNumericString) {
        throw error;
      }
      return interpolateDiscreteValue({
        input,
        inputRange,
        outputRange,
        options
      });
    }
  }
  if (outputRange.every((output) => Array.isArray(output))) {
    return interpolateTuple({ input, inputRange, outputRange, options });
  }
  if (!outputRange.every((output) => typeof output === "number")) {
    throw new TypeError("outputRange must contain only numbers, numeric tuples, or supported scale, translate, and rotate strings");
  }
  checkInfiniteRange("outputRange", outputRange);
  return interpolateNumber({ input, inputRange, outputRange, options });
}
var prepareNumericInterpolation = ({
  inputRange,
  outputRange,
  options
}) => {
  interpolate(inputRange[0], inputRange, outputRange, options);
  return (input) => interpolateNumber({ input, inputRange, outputRange, options });
};

// src/validate-frame.ts
var validateFrame = ({
  allowFloats,
  durationInFrames,
  frame
}) => {
  if (typeof frame === "undefined") {
    throw new TypeError(`Argument missing for parameter "frame"`);
  }
  if (typeof frame !== "number") {
    throw new TypeError(`Argument passed for "frame" is not a number: ${frame}`);
  }
  if (!Number.isFinite(frame)) {
    throw new RangeError(`Frame ${frame} is not finite`);
  }
  if (frame % 1 !== 0 && !allowFloats) {
    throw new RangeError(`Argument for frame must be an integer, but got ${frame}`);
  }
  if (frame < 0 && frame < -durationInFrames) {
    throw new RangeError(`Cannot use frame ${frame}: Duration of composition is ${durationInFrames}, therefore the lowest frame that can be rendered is ${-durationInFrames}`);
  }
  if (frame > durationInFrames - 1) {
    throw new RangeError(`Cannot use frame ${frame}: Duration of composition is ${durationInFrames}, therefore the highest frame that can be rendered is ${durationInFrames - 1}`);
  }
};

// src/validation/validation-spring-duration.ts
var validateSpringDuration = (dur) => {
  if (typeof dur === "undefined") {
    return;
  }
  if (typeof dur !== "number") {
    throw new TypeError(`A "duration" of a spring must be a "number" but is "${typeof dur}"`);
  }
  if (Number.isNaN(dur)) {
    throw new TypeError('A "duration" of a spring is NaN, which it must not be');
  }
  if (!Number.isFinite(dur)) {
    throw new TypeError('A "duration" of a spring must be finite, but is ' + dur);
  }
  if (dur <= 0) {
    throw new TypeError('A "duration" of a spring must be positive, but is ' + dur);
  }
};

// src/spring/spring-utils.ts
var defaultSpringConfig = {
  damping: 10,
  mass: 1,
  stiffness: 100,
  overshootClamping: false
};
var advanceCache = {};
function advance({
  animation,
  now,
  config
}) {
  const { toValue, lastTimestamp, current, velocity } = animation;
  const deltaTime = Math.min(now - lastTimestamp, 64);
  if (config.damping <= 0) {
    throw new Error("Spring damping must be greater than 0, otherwise the spring() animation will never end, causing an infinite loop.");
  }
  const c = config.damping;
  const m = config.mass;
  const k = config.stiffness;
  const cacheKey = [
    toValue,
    lastTimestamp,
    current,
    velocity,
    c,
    m,
    k,
    now
  ].join("-");
  if (advanceCache[cacheKey]) {
    return advanceCache[cacheKey];
  }
  const v0 = -velocity;
  const x0 = toValue - current;
  const zeta = c / (2 * Math.sqrt(k * m));
  const omega0 = Math.sqrt(k / m);
  const omega1 = omega0 * Math.sqrt(1 - zeta ** 2);
  const t = deltaTime / 1000;
  const sin1 = Math.sin(omega1 * t);
  const cos1 = Math.cos(omega1 * t);
  const underDampedEnvelope = Math.exp(-zeta * omega0 * t);
  const underDampedFrag1 = underDampedEnvelope * (sin1 * ((v0 + zeta * omega0 * x0) / omega1) + x0 * cos1);
  const underDampedPosition = toValue - underDampedFrag1;
  const underDampedVelocity = zeta * omega0 * underDampedFrag1 - underDampedEnvelope * (cos1 * (v0 + zeta * omega0 * x0) - omega1 * x0 * sin1);
  const criticallyDampedEnvelope = Math.exp(-omega0 * t);
  const criticallyDampedPosition = toValue - criticallyDampedEnvelope * (x0 + (v0 + omega0 * x0) * t);
  const criticallyDampedVelocity = criticallyDampedEnvelope * (v0 * (t * omega0 - 1) + t * x0 * omega0 * omega0);
  const animationNode = {
    toValue,
    prevPosition: current,
    lastTimestamp: now,
    current: zeta < 1 ? underDampedPosition : criticallyDampedPosition,
    velocity: zeta < 1 ? underDampedVelocity : criticallyDampedVelocity
  };
  advanceCache[cacheKey] = animationNode;
  return animationNode;
}
var calculationCache = {};
function springCalculation({
  frame,
  fps,
  config = {}
}) {
  const from = 0;
  const to = 1;
  const resolvedConfig = {
    damping: config.damping ?? defaultSpringConfig.damping,
    mass: config.mass ?? defaultSpringConfig.mass,
    stiffness: config.stiffness ?? defaultSpringConfig.stiffness,
    overshootClamping: config.overshootClamping ?? defaultSpringConfig.overshootClamping
  };
  const configKey = [
    fps,
    resolvedConfig.damping,
    resolvedConfig.mass,
    resolvedConfig.overshootClamping,
    resolvedConfig.stiffness
  ].join("-");
  const cacheKey = `${frame}-${configKey}`;
  if (calculationCache[cacheKey]) {
    return calculationCache[cacheKey];
  }
  const frameClamped = Math.max(0, frame);
  const previousFrame = Math.ceil(frameClamped) - 1;
  const previousAnimation = previousFrame >= 0 ? calculationCache[`${previousFrame}-${configKey}`] : undefined;
  let animation = previousAnimation ?? {
    lastTimestamp: 0,
    current: from,
    toValue: to,
    velocity: 0,
    prevPosition: 0
  };
  const unevenRest = frameClamped % 1;
  const startFrame = previousAnimation ? previousFrame + 1 : 0;
  for (let f = startFrame;f <= Math.floor(frameClamped); f++) {
    const time = f / fps * 1000;
    animation = advance({
      animation,
      now: time,
      config: resolvedConfig
    });
  }
  if (unevenRest > 0) {
    animation = advance({
      animation,
      now: frameClamped / fps * 1000,
      config: resolvedConfig
    });
  }
  calculationCache[cacheKey] = animation;
  return animation;
}

// src/spring/measure-spring.ts
var cache = new Map;
function measureSpring({
  fps,
  config = {},
  threshold = 0.005
}) {
  if (typeof threshold !== "number") {
    throw new TypeError(`threshold must be a number, got ${threshold} of type ${typeof threshold}`);
  }
  if (threshold === 0) {
    return Infinity;
  }
  if (threshold === 1) {
    return 0;
  }
  if (isNaN(threshold)) {
    throw new TypeError("Threshold is NaN");
  }
  if (!Number.isFinite(threshold)) {
    throw new TypeError("Threshold is not finite");
  }
  if (threshold < 0) {
    throw new TypeError("Threshold is below 0");
  }
  const cacheKey = [
    fps,
    config.damping,
    config.mass,
    config.overshootClamping,
    config.stiffness,
    threshold
  ].join("-");
  if (cache.has(cacheKey)) {
    return cache.get(cacheKey);
  }
  validateFps(fps, "to the measureSpring() function", false);
  let frame = 0;
  let finishedFrame = 0;
  const calc = () => {
    return springCalculation({
      fps,
      frame,
      config
    });
  };
  let animation = calc();
  const calcDifference = () => {
    return Math.abs(animation.current - animation.toValue);
  };
  let difference = calcDifference();
  while (difference >= threshold) {
    frame++;
    animation = calc();
    difference = calcDifference();
  }
  finishedFrame = frame;
  for (let i = 0;i < 20; i++) {
    frame++;
    animation = calc();
    difference = calcDifference();
    if (difference >= threshold) {
      i = 0;
      finishedFrame = frame + 1;
    }
  }
  cache.set(cacheKey, finishedFrame);
  return finishedFrame;
}

// src/spring/index.ts
function spring({
  frame: passedFrame,
  fps,
  config = {},
  from = 0,
  to = 1,
  durationInFrames: passedDurationInFrames,
  durationRestThreshold,
  delay = 0,
  reverse = false
}) {
  validateSpringDuration(passedDurationInFrames);
  validateFrame({
    frame: passedFrame,
    durationInFrames: Infinity,
    allowFloats: true
  });
  validateFps(fps, "to spring()", false);
  const needsToCalculateNaturalDuration = reverse || typeof passedDurationInFrames !== "undefined";
  const naturalDuration = needsToCalculateNaturalDuration ? measureSpring({
    fps,
    config,
    threshold: durationRestThreshold
  }) : undefined;
  const naturalDurationGetter = needsToCalculateNaturalDuration ? {
    get: () => naturalDuration
  } : {
    get: () => {
      throw new Error("did not calculate natural duration, this is an error with Remotion. Please report");
    }
  };
  const reverseProcessed = reverse ? (passedDurationInFrames ?? naturalDurationGetter.get()) - passedFrame : passedFrame;
  const delayProcessed = reverseProcessed + (reverse ? delay : -delay);
  const durationProcessed = passedDurationInFrames === undefined ? delayProcessed : delayProcessed / (passedDurationInFrames / naturalDurationGetter.get());
  if (passedDurationInFrames && delayProcessed > passedDurationInFrames) {
    return to;
  }
  const spr = springCalculation({
    fps,
    frame: durationProcessed,
    config
  });
  const inner = config.overshootClamping ? Math.min(spr.current, 1) : spr.current;
  const interpolated = from === 0 && to === 1 ? inner : interpolate(inner, [0, 1], [from, to]);
  return interpolated;
}

// src/easing.ts
var clampUnit = (t) => Math.min(1, Math.max(0, t));
var springEasingDurationInFrames = 30;
var easeBezier = null;

class Easing {
  static step0(n) {
    return n > 0 ? 1 : 0;
  }
  static step1(n) {
    return n >= 1 ? 1 : 0;
  }
  static linear(t) {
    return t;
  }
  static ease(t) {
    easeBezier ??= Easing.bezier(0.42, 0, 1, 1);
    return easeBezier(t);
  }
  static quad(t) {
    return t * t;
  }
  static cubic(t) {
    return t * t * t;
  }
  static poly(n) {
    return (t) => t ** n;
  }
  static sin(t) {
    return 1 - Math.cos(t * Math.PI / 2);
  }
  static circle(t) {
    const u = clampUnit(t);
    return 1 - Math.sqrt(1 - u * u);
  }
  static exp(t) {
    return 2 ** (10 * (t - 1));
  }
  static elastic(bounciness = 1) {
    const p = bounciness * Math.PI;
    return (t) => 1 - Math.cos(t * Math.PI / 2) ** 3 * Math.cos(t * p);
  }
  static back(s = 1.70158) {
    return (t) => t * t * ((s + 1) * t - s);
  }
  static spring({
    allowTail = false,
    durationRestThreshold,
    ...config
  } = {}) {
    const easing = (t) => {
      if (t <= 0) {
        return 0;
      }
      if (!allowTail && t >= 1) {
        return 1;
      }
      if (allowTail) {
        return spring({
          fps: springEasingDurationInFrames,
          frame: t * measureSpring({
            fps: springEasingDurationInFrames,
            config,
            threshold: durationRestThreshold
          }),
          config
        });
      }
      return spring({
        fps: springEasingDurationInFrames,
        frame: t * springEasingDurationInFrames,
        config,
        durationInFrames: springEasingDurationInFrames,
        durationRestThreshold
      });
    };
    return Object.assign(easing, {
      remotionShouldExtendRight: allowTail
    });
  }
  static bounce(t) {
    const u = clampUnit(t);
    if (u < 1 / 2.75) {
      return 7.5625 * u * u;
    }
    if (u < 2 / 2.75) {
      const t2_ = u - 1.5 / 2.75;
      return 7.5625 * t2_ * t2_ + 0.75;
    }
    if (u < 2.5 / 2.75) {
      const t2_ = u - 2.25 / 2.75;
      return 7.5625 * t2_ * t2_ + 0.9375;
    }
    const t2 = u - 2.625 / 2.75;
    return 7.5625 * t2 * t2 + 0.984375;
  }
  static bezier(x1, y1, x2, y2) {
    return bezier(x1, y1, x2, y2);
  }
  static in(easing) {
    return easing;
  }
  static out(easing) {
    return (t) => 1 - easing(1 - t);
  }
  static inOut(easing) {
    return (t) => {
      if (t < 0.5) {
        return easing(t * 2) / 2;
      }
      return 1 - easing((1 - t) * 2) / 2;
    };
  }
}

// src/interpolate-colors.ts
var NUMBER = "[-+]?\\d*\\.?\\d+";
var PERCENTAGE = NUMBER + "%";
function call(...args) {
  return "\\(\\s*(" + args.join(")\\s*,\\s*(") + ")\\s*\\)";
}
var MODERN_VALUE = "(?:none|[-+]?\\d*\\.?\\d+(?:%|deg|rad|grad|turn)?)";
function modernColorCall(name) {
  return new RegExp(name + "\\(\\s*(" + MODERN_VALUE + ")\\s+(" + MODERN_VALUE + ")\\s+(" + MODERN_VALUE + ")(?:\\s*\\/\\s*(" + MODERN_VALUE + "))?\\s*\\)");
}
var cachedMatchers = {
  rgb: undefined,
  rgba: undefined,
  hsl: undefined,
  hsla: undefined,
  hex3: undefined,
  hex4: undefined,
  hex5: undefined,
  hex6: undefined,
  hex8: undefined,
  oklch: undefined,
  oklab: undefined,
  lab: undefined,
  lch: undefined,
  hwb: undefined
};
function getMatchers() {
  if (cachedMatchers.rgb === undefined) {
    cachedMatchers.rgb = new RegExp("rgb" + call(NUMBER, NUMBER, NUMBER));
    cachedMatchers.rgba = new RegExp("rgba" + call(NUMBER, NUMBER, NUMBER, NUMBER));
    cachedMatchers.hsl = new RegExp("hsl" + call(NUMBER, PERCENTAGE, PERCENTAGE));
    cachedMatchers.hsla = new RegExp("hsla" + call(NUMBER, PERCENTAGE, PERCENTAGE, NUMBER));
    cachedMatchers.hex3 = /^#([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})$/;
    cachedMatchers.hex4 = /^#([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})$/;
    cachedMatchers.hex6 = /^#([0-9a-fA-F]{6})$/;
    cachedMatchers.hex8 = /^#([0-9a-fA-F]{8})$/;
    cachedMatchers.oklch = modernColorCall("oklch");
    cachedMatchers.oklab = modernColorCall("oklab");
    cachedMatchers.lab = modernColorCall("lab");
    cachedMatchers.lch = modernColorCall("lch");
    cachedMatchers.hwb = modernColorCall("hwb");
  }
  return cachedMatchers;
}
function hue2rgb(p, q, t) {
  if (t < 0) {
    t += 1;
  }
  if (t > 1) {
    t -= 1;
  }
  if (t < 1 / 6) {
    return p + (q - p) * 6 * t;
  }
  if (t < 1 / 2) {
    return q;
  }
  if (t < 2 / 3) {
    return p + (q - p) * (2 / 3 - t) * 6;
  }
  return p;
}
function hslToRgb(h, s, l) {
  const q = l < 0.5 ? l * (1 + s) : l + s - l * s;
  const p = 2 * l - q;
  const r = hue2rgb(p, q, h + 1 / 3);
  const g = hue2rgb(p, q, h);
  const b = hue2rgb(p, q, h - 1 / 3);
  return Math.round(r * 255) << 24 | Math.round(g * 255) << 16 | Math.round(b * 255) << 8;
}
function parse255(str) {
  const int = Math.round(Number.parseFloat(str));
  if (int < 0) {
    return 0;
  }
  if (int > 255) {
    return 255;
  }
  return int;
}
function parse360(str) {
  const int = Number.parseFloat(str);
  return (int % 360 + 360) % 360 / 360;
}
function parse1(str) {
  const num = Number.parseFloat(str);
  if (num < 0) {
    return 0;
  }
  if (num > 1) {
    return 255;
  }
  return Math.round(num * 255);
}
function parsePercentage(str) {
  const int = Number.parseFloat(str);
  if (int < 0) {
    return 0;
  }
  if (int > 100) {
    return 1;
  }
  return int / 100;
}
function parseModernComponent(str, percentScale) {
  if (str === "none")
    return 0;
  if (str.endsWith("%")) {
    return Number.parseFloat(str) / 100 * percentScale;
  }
  return Number.parseFloat(str);
}
function parseHueAngle(str) {
  if (str === "none")
    return 0;
  let degrees = Number.parseFloat(str);
  if (str.endsWith("grad")) {
    degrees *= 0.9;
  } else if (str.endsWith("rad")) {
    degrees = degrees * 180 / Math.PI;
  } else if (str.endsWith("turn")) {
    degrees *= 360;
  }
  const normalized = degrees % 360;
  return normalized < 0 ? (normalized + 360) % 360 : normalized;
}
function parseModernAlpha(str) {
  if (str === undefined || str === "none")
    return 1;
  if (str.endsWith("%")) {
    return Math.max(0, Math.min(1, Number.parseFloat(str) / 100));
  }
  return Math.max(0, Math.min(1, Number.parseFloat(str)));
}
function linearToSrgb(c) {
  if (c <= 0.0031308)
    return 12.92 * c;
  return 1.055 * c ** (1 / 2.4) - 0.055;
}
function clamp01(v) {
  return Math.max(0, Math.min(1, v));
}
function rgbFloatToInt(r, g, b, alpha) {
  const ri = Math.round(clamp01(r) * 255);
  const gi = Math.round(clamp01(g) * 255);
  const bi = Math.round(clamp01(b) * 255);
  const ai = Math.round(clamp01(alpha) * 255);
  return (ri << 24 | gi << 16 | bi << 8 | ai) >>> 0;
}
function oklabToSrgb(L, a, b) {
  const l_ = L + 0.3963377774 * a + 0.2158037573 * b;
  const m_ = L - 0.1055613458 * a - 0.0638541728 * b;
  const s_ = L - 0.0894841775 * a - 1.291485548 * b;
  const l = l_ * l_ * l_;
  const m = m_ * m_ * m_;
  const s = s_ * s_ * s_;
  const rLin = 4.0767416621 * l - 3.3077115913 * m + 0.2309699292 * s;
  const gLin = -1.2684380046 * l + 2.6097574011 * m - 0.3413193965 * s;
  const bLin = -0.0041960863 * l - 0.7034186147 * m + 1.707614701 * s;
  return [linearToSrgb(rLin), linearToSrgb(gLin), linearToSrgb(bLin)];
}
function labToSrgb(L, a, b) {
  const epsilon = 216 / 24389;
  const kappa = 24389 / 27;
  const Xn = 0.95047;
  const Yn = 1;
  const Zn = 1.08883;
  const fy = (L + 16) / 116;
  const fx = a / 500 + fy;
  const fz = fy - b / 200;
  const fx3 = fx * fx * fx;
  const fz3 = fz * fz * fz;
  const xr = fx3 > epsilon ? fx3 : (116 * fx - 16) / kappa;
  const yr = L > kappa * epsilon ? ((L + 16) / 116) ** 3 : L / kappa;
  const zr = fz3 > epsilon ? fz3 : (116 * fz - 16) / kappa;
  const X = xr * Xn;
  const Y = yr * Yn;
  const Z = zr * Zn;
  const rLin = 3.2404542 * X - 1.5371385 * Y - 0.4985314 * Z;
  const gLin = -0.969266 * X + 1.8760108 * Y + 0.041556 * Z;
  const bLin = 0.0556434 * X - 0.2040259 * Y + 1.0572252 * Z;
  return [linearToSrgb(rLin), linearToSrgb(gLin), linearToSrgb(bLin)];
}
function hwbToSrgb(h, w, bk) {
  if (w + bk >= 1) {
    const gray = w / (w + bk);
    return [gray, gray, gray];
  }
  const q = 1;
  const p = 0;
  const r = hue2rgb(p, q, h + 1 / 3);
  const g = hue2rgb(p, q, h);
  const bl = hue2rgb(p, q, h - 1 / 3);
  const factor = 1 - w - bk;
  return [r * factor + w, g * factor + w, bl * factor + w];
}
var colorNames = {
  transparent: 0,
  aliceblue: 4042850303,
  antiquewhite: 4209760255,
  aqua: 16777215,
  aquamarine: 2147472639,
  azure: 4043309055,
  beige: 4126530815,
  bisque: 4293182719,
  black: 255,
  blanchedalmond: 4293643775,
  blue: 65535,
  blueviolet: 2318131967,
  brown: 2771004159,
  burlywood: 3736635391,
  burntsienna: 3934150143,
  cadetblue: 1604231423,
  chartreuse: 2147418367,
  chocolate: 3530104575,
  coral: 4286533887,
  cornflowerblue: 1687547391,
  cornsilk: 4294499583,
  crimson: 3692313855,
  cyan: 16777215,
  darkblue: 35839,
  darkcyan: 9145343,
  darkgoldenrod: 3095792639,
  darkgray: 2846468607,
  darkgreen: 6553855,
  darkgrey: 2846468607,
  darkkhaki: 3182914559,
  darkmagenta: 2332068863,
  darkolivegreen: 1433087999,
  darkorange: 4287365375,
  darkorchid: 2570243327,
  darkred: 2332033279,
  darksalmon: 3918953215,
  darkseagreen: 2411499519,
  darkslateblue: 1211993087,
  darkslategray: 793726975,
  darkslategrey: 793726975,
  darkturquoise: 13554175,
  darkviolet: 2483082239,
  deeppink: 4279538687,
  deepskyblue: 12582911,
  dimgray: 1768516095,
  dimgrey: 1768516095,
  dodgerblue: 512819199,
  firebrick: 2988581631,
  floralwhite: 4294635775,
  forestgreen: 579543807,
  fuchsia: 4278255615,
  gainsboro: 3705462015,
  ghostwhite: 4177068031,
  gold: 4292280575,
  goldenrod: 3668254975,
  gray: 2155905279,
  green: 8388863,
  greenyellow: 2919182335,
  grey: 2155905279,
  honeydew: 4043305215,
  hotpink: 4285117695,
  indianred: 3445382399,
  indigo: 1258324735,
  ivory: 4294963455,
  khaki: 4041641215,
  lavender: 3873897215,
  lavenderblush: 4293981695,
  lawngreen: 2096890111,
  lemonchiffon: 4294626815,
  lightblue: 2916673279,
  lightcoral: 4034953471,
  lightcyan: 3774873599,
  lightgoldenrodyellow: 4210742015,
  lightgray: 3553874943,
  lightgreen: 2431553791,
  lightgrey: 3553874943,
  lightpink: 4290167295,
  lightsalmon: 4288707327,
  lightseagreen: 548580095,
  lightskyblue: 2278488831,
  lightslategray: 2005441023,
  lightslategrey: 2005441023,
  lightsteelblue: 2965692159,
  lightyellow: 4294959359,
  lime: 16711935,
  limegreen: 852308735,
  linen: 4210091775,
  magenta: 4278255615,
  maroon: 2147483903,
  mediumaquamarine: 1724754687,
  mediumblue: 52735,
  mediumorchid: 3126187007,
  mediumpurple: 2473647103,
  mediumseagreen: 1018393087,
  mediumslateblue: 2070474495,
  mediumspringgreen: 16423679,
  mediumturquoise: 1221709055,
  mediumvioletred: 3340076543,
  midnightblue: 421097727,
  mintcream: 4127193855,
  mistyrose: 4293190143,
  moccasin: 4293178879,
  navajowhite: 4292783615,
  navy: 33023,
  oldlace: 4260751103,
  olive: 2155872511,
  olivedrab: 1804477439,
  orange: 4289003775,
  orangered: 4282712319,
  orchid: 3664828159,
  palegoldenrod: 4008225535,
  palegreen: 2566625535,
  paleturquoise: 2951671551,
  palevioletred: 3681588223,
  papayawhip: 4293907967,
  peachpuff: 4292524543,
  peru: 3448061951,
  pink: 4290825215,
  plum: 3718307327,
  powderblue: 2967529215,
  purple: 2147516671,
  rebeccapurple: 1714657791,
  red: 4278190335,
  rosybrown: 3163525119,
  royalblue: 1097458175,
  saddlebrown: 2336560127,
  salmon: 4202722047,
  sandybrown: 4104413439,
  seagreen: 780883967,
  seashell: 4294307583,
  sienna: 2689740287,
  silver: 3233857791,
  skyblue: 2278484991,
  slateblue: 1784335871,
  slategray: 1887473919,
  slategrey: 1887473919,
  snow: 4294638335,
  springgreen: 16744447,
  steelblue: 1182971135,
  tan: 3535047935,
  teal: 8421631,
  thistle: 3636451583,
  tomato: 4284696575,
  turquoise: 1088475391,
  violet: 4001558271,
  wheat: 4125012991,
  white: 4294967295,
  whitesmoke: 4126537215,
  yellow: 4294902015,
  yellowgreen: 2597139199
};
function normalizeColor(color) {
  const matchers = getMatchers();
  let match;
  if (matchers.hex6) {
    if (match = matchers.hex6.exec(color)) {
      return Number.parseInt(match[1] + "ff", 16) >>> 0;
    }
  }
  if (colorNames[color] !== undefined) {
    return colorNames[color];
  }
  if (matchers.rgb) {
    if (match = matchers.rgb.exec(color)) {
      return (parse255(match[1]) << 24 | parse255(match[2]) << 16 | parse255(match[3]) << 8 | 255) >>> 0;
    }
  }
  if (matchers.rgba) {
    if (match = matchers.rgba.exec(color)) {
      return (parse255(match[1]) << 24 | parse255(match[2]) << 16 | parse255(match[3]) << 8 | parse1(match[4])) >>> 0;
    }
  }
  if (matchers.hex3) {
    if (match = matchers.hex3.exec(color)) {
      return Number.parseInt(match[1] + match[1] + match[2] + match[2] + match[3] + match[3] + "ff", 16) >>> 0;
    }
  }
  if (matchers.hex8) {
    if (match = matchers.hex8.exec(color)) {
      return Number.parseInt(match[1], 16) >>> 0;
    }
  }
  if (matchers.hex4) {
    if (match = matchers.hex4.exec(color)) {
      return Number.parseInt(match[1] + match[1] + match[2] + match[2] + match[3] + match[3] + match[4] + match[4], 16) >>> 0;
    }
  }
  if (matchers.hsl) {
    if (match = matchers.hsl.exec(color)) {
      return (hslToRgb(parse360(match[1]), parsePercentage(match[2]), parsePercentage(match[3])) | 255) >>> 0;
    }
  }
  if (matchers.hsla) {
    if (match = matchers.hsla.exec(color)) {
      return (hslToRgb(parse360(match[1]), parsePercentage(match[2]), parsePercentage(match[3])) | parse1(match[4])) >>> 0;
    }
  }
  if (matchers.oklch) {
    if (match = matchers.oklch.exec(color)) {
      const L = parseModernComponent(match[1], 1);
      const C = parseModernComponent(match[2], 0.4);
      const H = parseHueAngle(match[3]);
      const alpha = parseModernAlpha(match[4]);
      const hRad = H * Math.PI / 180;
      const [r, g, b] = oklabToSrgb(L, C * Math.cos(hRad), C * Math.sin(hRad));
      return rgbFloatToInt(r, g, b, alpha);
    }
  }
  if (matchers.oklab) {
    if (match = matchers.oklab.exec(color)) {
      const L = parseModernComponent(match[1], 1);
      const a = parseModernComponent(match[2], 0.4);
      const b = parseModernComponent(match[3], 0.4);
      const alpha = parseModernAlpha(match[4]);
      const [r, g, bl] = oklabToSrgb(L, a, b);
      return rgbFloatToInt(r, g, bl, alpha);
    }
  }
  if (matchers.lab) {
    if (match = matchers.lab.exec(color)) {
      const L = parseModernComponent(match[1], 100);
      const a = parseModernComponent(match[2], 125);
      const b = parseModernComponent(match[3], 125);
      const alpha = parseModernAlpha(match[4]);
      const [r, g, bl] = labToSrgb(L, a, b);
      return rgbFloatToInt(r, g, bl, alpha);
    }
  }
  if (matchers.lch) {
    if (match = matchers.lch.exec(color)) {
      const L = parseModernComponent(match[1], 100);
      const C = parseModernComponent(match[2], 150);
      const H = parseHueAngle(match[3]);
      const alpha = parseModernAlpha(match[4]);
      const hRad = H * Math.PI / 180;
      const [r, g, bl] = labToSrgb(L, C * Math.cos(hRad), C * Math.sin(hRad));
      return rgbFloatToInt(r, g, bl, alpha);
    }
  }
  if (matchers.hwb) {
    if (match = matchers.hwb.exec(color)) {
      const H = parseHueAngle(match[1]);
      const W = parseModernComponent(match[2], 1);
      const B = parseModernComponent(match[3], 1);
      const alpha = parseModernAlpha(match[4]);
      const [r, g, bl] = hwbToSrgb(H / 360, W, B);
      return rgbFloatToInt(r, g, bl, alpha);
    }
  }
  throw new Error(`invalid color string ${color} provided`);
}
var opacity = (c) => {
  return (c >> 24 & 255) / 255;
};
var red = (c) => {
  return c >> 16 & 255;
};
var green = (c) => {
  return c >> 8 & 255;
};
var blue = (c) => {
  return c & 255;
};
var rgbaColor = (r, g, b, alpha) => {
  return `rgba(${r}, ${g}, ${b}, ${alpha})`;
};
function processColor(color) {
  const normalizedColor = normalizeColor(color);
  return (normalizedColor << 24 | normalizedColor >>> 8) >>> 0;
}
var interpolateColorsRGB = (value, inputRange, colors, options) => {
  const [r, g, b, a] = [red, green, blue, opacity].map((f) => {
    const unrounded = interpolate(value, inputRange, colors.map((c) => f(c)), {
      easing: options?.easing,
      extrapolateLeft: "clamp",
      extrapolateRight: "clamp",
      posterize: options?.posterize
    });
    if (f === opacity) {
      return Number(unrounded.toFixed(3));
    }
    return Math.round(unrounded);
  });
  return rgbaColor(r, g, b, a);
};
var interpolateColors = (input, inputRange, outputRange, options) => {
  if (typeof input === "undefined") {
    throw new TypeError("input can not be undefined");
  }
  if (typeof inputRange === "undefined") {
    throw new TypeError("inputRange can not be undefined");
  }
  if (typeof outputRange === "undefined") {
    throw new TypeError("outputRange can not be undefined");
  }
  if (inputRange.length !== outputRange.length) {
    throw new TypeError("inputRange (" + inputRange.length + " values provided) and outputRange (" + outputRange.length + " values provided) must have the same length");
  }
  const processedOutputRange = outputRange.map((c) => processColor(c));
  return interpolateColorsRGB(input, inputRange, processedOutputRange, options);
};

// src/interpolate-keyframed-status.ts
var interpolatePaths = null;
var setInterpolatePaths = (interpolator) => {
  interpolatePaths = interpolator;
};
var easingToFn = ({
  easing,
  forceSpringAllowTail
}) => {
  switch (easing.type) {
    case "linear":
      return Easing.linear;
    case "step1":
      return Easing.step1;
    case "spring":
      return Easing.spring({
        allowTail: forceSpringAllowTail ?? easing.allowTail ?? undefined,
        damping: easing.damping,
        durationRestThreshold: easing.durationRestThreshold ?? undefined,
        mass: easing.mass,
        overshootClamping: easing.overshootClamping,
        stiffness: easing.stiffness
      });
    case "bezier":
      return bezier(easing.x1, easing.y1, easing.x2, easing.y2);
    default:
      throw new TypeError(`Unsupported easing: ${JSON.stringify(easing)}`);
  }
};
var prepareNumericKeyframedStatus = ({
  forceSpringAllowTail,
  status
}) => {
  if (status.interpolationFunction !== "interpolate" || status.keyframes.length === 0) {
    return null;
  }
  const sortedKeyframes = [...status.keyframes].sort((a, b) => a.frame - b.frame);
  const inputRange = sortedKeyframes.map((keyframe) => keyframe.frame);
  const outputRange = sortedKeyframes.map((keyframe) => keyframe.value);
  if (!outputRange.every((value) => typeof value === "number")) {
    return null;
  }
  try {
    const evaluate = prepareNumericInterpolation({
      inputRange,
      outputRange,
      options: {
        easing: status.easing.map((easing) => easingToFn({ easing, forceSpringAllowTail })),
        extrapolateLeft: status.clamping.left,
        extrapolateRight: status.clamping.right,
        output: status.output,
        posterize: status.posterize
      }
    });
    return (frame) => {
      try {
        return evaluate(frame);
      } catch {
        return null;
      }
    };
  } catch {
    return null;
  }
};
var interpolateKeyframedStatus = ({
  frame,
  forceSpringAllowTail,
  status
}) => {
  const { keyframes, easing, clamping, interpolationFunction } = status;
  if (keyframes.length === 0) {
    return null;
  }
  const sortedKeyframes = [...keyframes].sort((a, b) => a.frame - b.frame);
  const inputRange = sortedKeyframes.map((k) => k.frame);
  const outputs = sortedKeyframes.map((k) => k.value);
  if (interpolationFunction === "interpolatePaths") {
    if (!outputs.every((v) => typeof v === "string")) {
      return null;
    }
    if (keyframes.length === 1) {
      return outputs[0];
    }
    if (!interpolatePaths || clamping.left === "identity" || clamping.right === "identity") {
      return null;
    }
    try {
      return interpolatePaths(frame, inputRange, outputs, {
        easing: easing.map((e) => easingToFn({ easing: e, forceSpringAllowTail })),
        extrapolateLeft: clamping.left,
        extrapolateRight: clamping.right,
        posterize: status.posterize
      });
    } catch {
      return null;
    }
  }
  if (interpolationFunction === "interpolateColors") {
    if (!outputs.every((v) => typeof v === "string")) {
      return null;
    }
    if (keyframes.length === 1) {
      return outputs[0];
    }
    try {
      return interpolateColors(frame, inputRange, outputs, {
        easing: easing.map((e) => easingToFn({ easing: e, forceSpringAllowTail })),
        posterize: status.posterize
      });
    } catch {
      return null;
    }
  }
  if (interpolationFunction !== "interpolate") {
    return null;
  }
  try {
    return interpolate(frame, inputRange, outputs, {
      easing: easing.map((e) => easingToFn({ easing: e, forceSpringAllowTail })),
      extrapolateLeft: clamping.left,
      extrapolateRight: clamping.right,
      output: status.output,
      posterize: status.posterize
    });
  } catch {
    return null;
  }
};

// src/get-effective-visual-mode-value.ts
var getFrameInKeyframedStatusClock = ({
  frame,
  status
}) => frame * (status.keyframePlaybackRateAdjustment ?? 1) - (status.keyframeDisplayOffsetAdjustment ?? 0);
var resolveDragOverrideValue = ({
  dragOverrideValue,
  frame
}) => {
  if (dragOverrideValue === undefined) {
    return { type: "none" };
  }
  if (dragOverrideValue.type === "static") {
    return { type: "resolved", value: dragOverrideValue.value };
  }
  if (frame === null) {
    return { type: "none" };
  }
  const interpolated = interpolateKeyframedStatus({
    forceSpringAllowTail: null,
    frame: getFrameInKeyframedStatusClock({
      frame,
      status: dragOverrideValue.status
    }),
    status: dragOverrideValue.status
  });
  if (interpolated === null) {
    return { type: "none" };
  }
  return { type: "resolved", value: interpolated };
};
var getEffectiveVisualModeValue = ({
  propStatus,
  dragOverrideValue,
  defaultValue,
  frame = null,
  shouldResortToDefaultValueIfUndefined = false
}) => {
  const dragOverride = resolveDragOverrideValue({
    dragOverrideValue,
    frame
  });
  if (dragOverride.type === "resolved" && dragOverride.value !== undefined) {
    return dragOverride.value;
  }
  if (propStatus.status === "keyframed") {
    if (frame !== null) {
      return interpolateKeyframedStatus({
        forceSpringAllowTail: null,
        frame: getFrameInKeyframedStatusClock({ frame, status: propStatus }),
        status: propStatus
      });
    }
    return shouldResortToDefaultValueIfUndefined ? defaultValue : undefined;
  }
  if (propStatus.codeValue === undefined && shouldResortToDefaultValueIfUndefined) {
    return defaultValue;
  }
  return propStatus.codeValue;
};

// src/optimistic-effect-deletion.ts
import { useMemo as useMemo18 } from "react";
var entries = new Map;
var acknowledged = new WeakSet;
var listeners = new Set;
var nodeListeners = new Map;
var nodeSnapshots = new Map;
var empty = [];
var snapshot = empty;
var batchDepth = 0;
var batchedKeys = new Set;
var nodeKeys = new WeakMap;
var keyForNode = (node) => {
  const cached = nodeKeys.get(node);
  if (cached !== undefined)
    return cached;
  const key = JSON.stringify([node.absolutePath, node.nodePath]);
  nodeKeys.set(node, key);
  return key;
};
var publish = (keys) => {
  if (batchDepth > 0) {
    for (const key of keys)
      batchedKeys.add(key);
    return;
  }
  const changedKeys = new Set(keys);
  for (const key of changedKeys) {
    const entry = entries.get(key);
    if (entry)
      nodeSnapshots.set(key, { entry: { ...entry } });
    else
      nodeSnapshots.delete(key);
  }
  snapshot = entries.size === 0 ? empty : [...entries.values()];
  for (const key of changedKeys) {
    for (const listener of nodeListeners.get(key) ?? [])
      listener();
  }
  for (const listener of listeners)
    listener();
};
var subscribeToKey = (key, listener) => {
  if (key === null)
    return () => {
      return;
    };
  const current = nodeListeners.get(key) ?? new Set;
  current.add(listener);
  nodeListeners.set(key, current);
  return () => {
    current.delete(listener);
    if (current.size === 0)
      nodeListeners.delete(key);
  };
};
var matches = (entry, definitions) => !entry.sourceChanged && entry.definitions.length === definitions.length && entry.definitions.every((definition, index) => definition === definitions[index]);
var remove = (entry) => {
  const key = keyForNode(entry.nodePath);
  if (entries.get(key) !== entry)
    return;
  entries.delete(key);
  acknowledged.delete(entry);
  publish([key]);
};
var OptimisticEffectDeletion = {
  batch: (run) => {
    batchDepth++;
    try {
      return run();
    } finally {
      batchDepth--;
      if (batchDepth === 0 && batchedKeys.size > 0) {
        const keys = [...batchedKeys];
        batchedKeys.clear();
        publish(keys);
      }
    }
  },
  clear: () => {
    if (entries.size === 0)
      return;
    const keys = [...entries.keys()];
    for (const entry of entries.values())
      acknowledged.delete(entry);
    entries.clear();
    publish(keys);
  },
  begin: ({
    nodePath,
    effectIndices,
    definitions
  }) => {
    const key = keyForNode(nodePath);
    if (entries.has(key) || effectIndices.length === 0 || effectIndices.some((index) => !Number.isInteger(index) || index < 0 || index >= definitions.length))
      return null;
    const entry = {
      nodePath,
      effectIndices: [...new Set(effectIndices)],
      definitions: [...definitions],
      sourceChanged: false
    };
    entries.set(key, entry);
    publish([key]);
    return entry;
  },
  remove,
  acknowledge: (entry) => {
    if (entries.get(keyForNode(entry.nodePath)) !== entry)
      return;
    acknowledged.add(entry);
    if (entry.sourceChanged)
      remove(entry);
  },
  get: (nodePath) => entries.get(keyForNode(nodePath)) ?? null,
  getSnapshot: () => snapshot,
  subscribe: (listener) => {
    listeners.add(listener);
    return () => {
      listeners.delete(listener);
    };
  },
  subscribeToNode: (nodePath, listener) => subscribeToKey(keyForNode(nodePath), listener),
  matches,
  reconcile: (nodePath, definitions) => {
    if (nodePath === null || definitions === null)
      return;
    const key = keyForNode(nodePath);
    const entry = entries.get(key);
    if (!entry || entry.sourceChanged || matches(entry, definitions))
      return;
    entry.sourceChanged = true;
    if (acknowledged.has(entry))
      remove(entry);
    else
      publish([key]);
  },
  remap: (remappings) => {
    const moves = remappings.flatMap(({ entry, nodePath }) => {
      const oldKey = keyForNode(entry.nodePath);
      const newKey = nodePath === null ? null : keyForNode(nodePath);
      return entries.get(oldKey) === entry && oldKey !== newKey ? [{ entry, nodePath, oldKey, newKey }] : [];
    });
    if (moves.length === 0)
      return;
    for (const { oldKey } of moves)
      entries.delete(oldKey);
    for (const { entry, nodePath, newKey } of moves) {
      if (nodePath === null || newKey === null) {
        acknowledged.delete(entry);
        continue;
      }
      entry.nodePath = nodePath;
      entries.set(newKey, entry);
    }
    publish(moves.flatMap(({ oldKey, newKey }) => newKey === null ? [oldKey] : [oldKey, newKey]));
  }
};
var useOptimisticEffectDeletion = (nodePath) => {
  const key = nodePath === null ? null : keyForNode(nodePath);
  const observer = useMemo18(() => ({
    subscribe: (listener) => subscribeToKey(key, listener),
    getSnapshot: () => key === null ? null : nodeSnapshots.get(key) ?? null
  }), [key]);
  return useSyncExternalStore2(observer.subscribe, observer.getSnapshot, () => null)?.entry ?? null;
};

// src/sequence-node-path.tsx
import { createContext as createContext26 } from "react";
var OverrideIdsToNodePathsGettersContext = createContext26({
  overrideIdToNodePathMappings: {}
});
var OverrideIdsToNodePathsSettersContext = createContext26({
  setOverrideIdToNodePath: () => {
    throw new Error("OverrideIdsToNodePathsSettersContext not initialized");
  }
});

// src/effects/effect-source-observer.ts
import React24, { useLayoutEffect as useLayoutEffect6, useMemo as useMemo19, useState as useState8 } from "react";
var observers = new Map;
var redrawListeners = new Map;
var identities = new WeakMap;
var inspectedChains = new WeakMap;
var sourceChainOwners = new Map;
var useIdentityCommitEffect = React24.useInsertionEffect ?? useLayoutEffect6;
var subscribeToEffectSource = ({
  sequenceKey,
  effectIndex,
  onSource
}) => {
  let sequence = observers.get(sequenceKey);
  if (!sequence) {
    sequence = new Map;
    observers.set(sequenceKey, sequence);
  }
  let listeners = sequence.get(effectIndex);
  if (!listeners) {
    listeners = new Set;
    sequence.set(effectIndex, listeners);
  }
  listeners.add(onSource);
  redrawListeners.get(sequenceKey)?.forEach((redraw) => redraw());
  return () => {
    listeners.delete(onSource);
    if (listeners.size === 0) {
      sequence.delete(effectIndex);
    }
    if (sequence.size === 0) {
      observers.delete(sequenceKey);
    }
  };
};
var publishEffectSource = (effect, source, chain) => {
  if (observers.size === 0) {
    return;
  }
  const identity = identities.get(effect);
  if (!identity) {
    return;
  }
  const listeners = observers.get(identity.sequenceKey)?.get(identity.effectIndex);
  if (!listeners || listeners.size === 0) {
    return;
  }
  let inspected = inspectedChains.get(chain);
  if (!inspected) {
    inspected = new Map;
    inspectedChains.set(chain, inspected);
  }
  const key = `${identity.sequenceKey}\x00${identity.effectIndex}`;
  inspected.set(key, identity);
  sourceChainOwners.set(key, chain);
  listeners.forEach((listener) => {
    try {
      listener(source);
    } catch {}
  });
};
var invalidateEffectChainSources = (chain) => {
  const inspected = inspectedChains.get(chain);
  inspectedChains.delete(chain);
  inspected?.forEach((identity, key) => {
    if (sourceChainOwners.get(key) !== chain) {
      return;
    }
    sourceChainOwners.delete(key);
    observers.get(identity.sequenceKey)?.get(identity.effectIndex)?.forEach((listener) => {
      try {
        listener(null);
      } catch {}
    });
  });
};
var useEffectSourceInspection = (effects, sequenceKey) => {
  const [revision, setRevision] = useState8(0);
  useLayoutEffect6(() => {
    if (sequenceKey === null) {
      return;
    }
    let listeners = redrawListeners.get(sequenceKey);
    if (!listeners) {
      listeners = new Set;
      redrawListeners.set(sequenceKey, listeners);
    }
    const redraw = () => setRevision((previous) => previous + 1);
    listeners.add(redraw);
    if (observers.has(sequenceKey)) {
      redraw();
    }
    return () => {
      listeners.delete(redraw);
      if (listeners.size === 0) {
        redrawListeners.delete(sequenceKey);
        observers.get(sequenceKey)?.forEach((sourceListeners) => {
          sourceListeners.forEach((listener) => {
            try {
              listener(null);
            } catch {}
          });
        });
      }
    };
  }, [sequenceKey]);
  useIdentityCommitEffect(() => {
    if (sequenceKey === null) {
      return;
    }
    effects.forEach((effect, effectIndex) => {
      identities.set(effect, { sequenceKey, effectIndex });
    });
    return () => {
      effects.forEach((effect) => identities.delete(effect));
    };
  }, [effects, sequenceKey]);
  return useMemo19(() => {
    return sequenceKey === null || revision === 0 ? effects : effects.slice();
  }, [effects, revision, sequenceKey]);
};

// src/effects/use-memoized-effects.ts
var emptyDragOverrides2 = {};
var useCacheCommitEffect = React25.useInsertionEffect ?? useLayoutEffect7;
var areEffectParamsEqual = (previous, next) => {
  if (Object.is(previous, next)) {
    return true;
  }
  if (previous === null || next === null || typeof previous !== "object" || typeof next !== "object" || Object.getPrototypeOf(previous) !== Object.prototype || Object.getPrototypeOf(next) !== Object.prototype) {
    return false;
  }
  return areRegistryEntriesEqual(previous, next);
};
var mergeOverrides = ({
  descriptor,
  propStatusOverrides,
  dragOverrides,
  frame
}) => {
  if (!propStatusOverrides && !dragOverrides) {
    return { params: descriptor.params, effectKey: descriptor.effectKey };
  }
  const merged = {
    ...descriptor.params
  };
  if (propStatusOverrides) {
    for (const [key, value] of Object.entries(propStatusOverrides)) {
      if (value !== undefined) {
        merged[key] = value;
      }
    }
  }
  if (dragOverrides) {
    for (const [key, value] of Object.entries(dragOverrides)) {
      const resolved = resolveDragOverrideValue({
        dragOverrideValue: value,
        frame
      });
      if (resolved.type === "resolved") {
        merged[key] = resolved.value;
      }
    }
  }
  return {
    params: merged,
    effectKey: descriptor.definition.calculateKey(merged)
  };
};
var resolvePropStatusOverrides = (propStatus, frame) => {
  if (!propStatus) {
    return null;
  }
  const out = {};
  let hasAny = false;
  for (const [key, status] of Object.entries(propStatus)) {
    if (status.status === "static") {
      out[key] = status.codeValue;
      hasAny = true;
      continue;
    }
    if (status.status === "keyframed") {
      const value = interpolateKeyframedStatus({
        forceSpringAllowTail: null,
        frame: getFrameInKeyframedStatusClock({ frame, status }),
        status
      });
      if (value !== null) {
        out[key] = value;
        hasAny = true;
      }
    }
  }
  return hasAny ? out : null;
};
var useMemoizedEffectDefinitions = (effects) => {
  const activityDormant = useContext26(SequenceActivityDormantContext);
  const previousRef = useRef7(null);
  const previous = previousRef.current;
  const isSame = previous !== null && previous.definitions.length === effects.length && previous.definitions.every((definition, i) => definition === effects[i].definition);
  const controllers = isSame ? previous.controllers : effects.map((effect) => createRuntimeValueStore(effect.params));
  const stableDefinitions = isSame ? previous.definitions : Object.assign(effects.map((descriptor) => descriptor.definition), {
    runtimeValues: controllers.map((controller) => controller.store)
  });
  useCacheCommitEffect(() => {
    previousRef.current = { definitions: stableDefinitions, controllers };
    if (!activityDormant || controllers.length === 0) {
      return;
    }
    if (controllers.every((controller, index) => areEffectParamsEqual(controller.store.getSnapshot(), effects[index]?.params))) {
      return;
    }
    let cancelled = false;
    queueMicrotask(() => {
      if (cancelled) {
        return;
      }
      controllers.forEach((controller, index) => {
        const snapshot = effects[index]?.params;
        const currentSnapshot = controller.store.getSnapshot();
        if (areEffectParamsEqual(snapshot, currentSnapshot)) {
          return;
        }
        controller.setSnapshot(snapshot);
      });
    });
    return () => {
      cancelled = true;
    };
  }, [activityDormant, controllers, effects, stableDefinitions]);
  useLayoutEffect7(() => {
    stableDefinitions.forEach((_definition, index) => {
      const snapshot = effects[index]?.params;
      if (!areEffectParamsEqual(controllers[index].store.getSnapshot(), snapshot)) {
        controllers[index].setSnapshot(snapshot);
      }
    });
  }, [controllers, effects, stableDefinitions]);
  return stableDefinitions;
};
var getEffectStatusForSequenceStatus = ({
  status,
  effectIndex,
  videoConfigValues
}) => {
  if (!status) {
    return { type: "cannot-update-sequence", reason: "not-found" };
  }
  if (!status.canUpdate) {
    return { type: "cannot-update-sequence", reason: status.reason };
  }
  const effect = status.effects.find((e) => e.effectIndex === effectIndex);
  if (!effect) {
    return { type: "cannot-update-effect", reason: "not-found" };
  }
  if (!effect.canUpdate) {
    return { type: "cannot-update-effect", reason: effect.reason };
  }
  return {
    type: "can-update-effect",
    props: evaluateSourcePropStatuses(effect.props, videoConfigValues)
  };
};
var getEffectPropStatusesCtx = ({
  propStatuses,
  nodePath,
  effectIndex
}) => {
  return getEffectStatusForSequenceStatus({
    status: propStatuses[makeSequencePropsSubscriptionKey(nodePath)] ?? null,
    effectIndex,
    videoConfigValues: nodePath.videoConfigValues
  });
};
var getPropStatusesForSequenceStatus = (status, videoConfigValues) => {
  if (!status) {
    return;
  }
  if (!status.canUpdate) {
    return;
  }
  return evaluateSourcePropStatuses(status.props, videoConfigValues);
};
var getPropStatusesCtx = (propStatuses, nodePath) => {
  return getPropStatusesForSequenceStatus(propStatuses[makeSequencePropsSubscriptionKey(nodePath)] ?? null, nodePath.videoConfigValues);
};
var useMemoizedEffects = ({
  effects,
  overrideId,
  videoConfigValues
}) => {
  const previousRef = useRef7(null);
  const { isStudio, isRendering } = useRemotionEnvironment();
  const { overrideIdToNodePathMappings } = useContext26(OverrideIdsToNodePathsGettersContext);
  const previous = previousRef.current;
  const nodePath = overrideId ? overrideIdToNodePathMappings[overrideId] ?? null : null;
  const effectDragOverrides = useEffectDragOverridesForNodePath(nodePath);
  const sequenceStatus = usePropStatusForNodePath(nodePath);
  const pendingDeletion = useOptimisticEffectDeletion(isStudio && !isRendering ? nodePath : null);
  const definitions = useMemo20(() => pendingDeletion === null ? null : effects.map((effect) => effect.definition), [effects, pendingDeletion]);
  const deletedIndices = useMemo20(() => new Set(pendingDeletion?.effectIndices ?? []), [pendingDeletion]);
  const matchesPendingDeletion = pendingDeletion !== null && definitions !== null && OptimisticEffectDeletion.matches(pendingDeletion, definitions);
  useLayoutEffect7(() => {
    if (pendingDeletion !== null)
      OptimisticEffectDeletion.reconcile(nodePath, definitions);
  }, [definitions, nodePath, pendingDeletion]);
  const effectPropStatuses = useMemo20(() => Array.from({ length: effects.length }, (_, effectIndex) => {
    if (nodePath === null) {
      return null;
    }
    const status = getEffectStatusForSequenceStatus({
      status: sequenceStatus,
      effectIndex,
      videoConfigValues
    });
    return status.type === "can-update-effect" ? status.props : null;
  }), [effects.length, nodePath, sequenceStatus, videoConfigValues]);
  const animatedEffects = useMemo20(() => effectPropStatuses.map((status, index) => !(matchesPendingDeletion && deletedIndices.has(index)) && (Object.values(status ?? {}).some((prop) => prop.status === "keyframed") || Object.values(effectDragOverrides[index] ?? emptyDragOverrides2).some((override) => override.type === "keyframed"))), [
    deletedIndices,
    effectDragOverrides,
    effectPropStatuses,
    matchesPendingDeletion
  ]);
  const frame = useCurrentFrameWithOptionalSubscription(animatedEffects.some(Boolean));
  const prepared = effects.map((descriptor, index) => {
    const deleted = matchesPendingDeletion && deletedIndices.has(index);
    const propStatus = effectPropStatuses[index];
    const dragOverridesMap = effectDragOverrides[index] ?? emptyDragOverrides2;
    const dragOverrides = Object.keys(dragOverridesMap).length === 0 ? null : dragOverridesMap;
    const effectFrame = animatedEffects[index] ? frame : null;
    const cached = previous?.prepared[index];
    if (cached && cached.deleted === deleted && cached.definition === descriptor.definition && cached.sourceKey === descriptor.effectKey && areEffectParamsEqual(cached.params, descriptor.params) && cached.propStatus === propStatus && cached.dragOverrides === dragOverrides && cached.frame === effectFrame) {
      return cached;
    }
    const propStatusOverrides = resolvePropStatusOverrides(propStatus ?? undefined, frame);
    const merged = mergeOverrides({
      descriptor,
      propStatusOverrides,
      dragOverrides,
      frame
    });
    const params = deleted ? { ...merged.params, disabled: true } : merged.params;
    const effectKey = deleted ? descriptor.definition.calculateKey(params) : merged.effectKey;
    return {
      deleted,
      definition: descriptor.definition,
      sourceKey: descriptor.effectKey,
      params: descriptor.params !== null && typeof descriptor.params === "object" && Object.getPrototypeOf(descriptor.params) === Object.prototype ? { ...descriptor.params } : descriptor.params,
      propStatus,
      dragOverrides,
      frame: effectFrame,
      value: cached?.deleted === deleted && cached.value.definition === descriptor.definition && cached.value.effectKey === effectKey ? cached.value : {
        definition: descriptor.definition,
        effectKey,
        params,
        memoized: true
      }
    };
  });
  const isSame = previous !== null && previous.effects.length === prepared.length && previous.effects.every((effect, i) => effect === prepared[i].value);
  const next = isSame ? previous.effects : prepared.map((effect) => effect.value);
  useCacheCommitEffect(() => {
    previousRef.current = { prepared, effects: next };
  }, [next, prepared]);
  const inspectionKey = useMemo20(() => isStudio && nodePath !== null ? makeSequencePropsSubscriptionKey(nodePath) : null, [isStudio, nodePath]);
  return useEffectSourceInspection(next, inspectionKey);
};

// src/flatten-schema.ts
var flattenActiveSchema = (schema, resolve) => {
  const out = {};
  for (const key of Object.keys(schema)) {
    const field = schema[key];
    if (field.type === "hidden") {
      continue;
    } else if (field.type === "enum") {
      out[key] = field;
      const current = resolve(key) ?? field.default;
      const variant = field.variants[current];
      if (variant) {
        Object.assign(out, flattenActiveSchema(variant, resolve));
      }
    } else {
      out[key] = field;
    }
  }
  return out;
};
var getFlatSchemaWithAllKeys = (schema) => {
  const out = {};
  const addKey = (key, field) => {
    if (key in out) {
      return;
    }
    out[key] = field;
  };
  for (const key of Object.keys(schema)) {
    const field = schema[key];
    addKey(key, field);
    if (field.type === "enum") {
      for (const variant of Object.values(field.variants)) {
        const flatVariant = getFlatSchemaWithAllKeys(variant);
        for (const variantKey of Object.keys(flatVariant)) {
          addKey(variantKey, flatVariant[variantKey]);
        }
      }
    }
  }
  return out;
};

// src/optimistic-sequence-deletion.ts
import { isValidElement } from "react";
var deletions = new Map;
var stackToNode = new Map;
var listeners2 = new Set;
var empty2 = new Set;
var snapshot2 = empty2;
var keyForNode2 = (node) => JSON.stringify([node.absolutePath, node.nodePath]);
var publish2 = (force = false) => {
  const next = new Set([...deletions].filter(([, value]) => value.deleted).map(([key]) => key));
  if (!force && next.size === snapshot2.size && [...next].every((key) => snapshot2.has(key))) {
    return;
  }
  snapshot2 = next.size === 0 ? empty2 : next;
  for (const listener of listeners2) {
    listener();
  }
};
var subscribe = (listener) => {
  listeners2.add(listener);
  return () => {
    listeners2.delete(listener);
  };
};
var usePendingSequenceDeletions = () => {
  const environment = useRemotionEnvironment();
  const value = useSyncExternalStore2(subscribe, () => snapshot2, () => empty2);
  return environment.isStudio && !environment.isRendering ? value : empty2;
};
var OptimisticSequenceDeletion = {
  register: (stack, node) => {
    if (stack === null || node === null) {
      return;
    }
    const key = keyForNode2(node);
    if (stackToNode.get(stack) === key) {
      return;
    }
    stackToNode.set(stack, key);
    if (snapshot2.size > 0) {
      publish2(true);
    }
  },
  isDeleted: (node, pending) => node !== null && pending.has(keyForNode2(node)),
  isElementDeleted: (element, pending) => {
    if (!isValidElement(element)) {
      return false;
    }
    const stack = element.props._remotionInternalStack;
    const key = stack === undefined ? undefined : stackToNode.get(stack);
    return key !== undefined && pending.has(key);
  },
  set: (nodes, revision, deleted) => {
    for (const node of nodes) {
      const key = keyForNode2(node);
      const previous = deletions.get(key);
      if (previous && previous.revision > revision) {
        continue;
      }
      deletions.set(key, { id: revision, revision, deleted });
    }
    publish2();
  },
  rollback: (nodes, revision) => {
    for (const node of nodes) {
      const key = keyForNode2(node);
      if (deletions.get(key)?.revision === revision) {
        deletions.delete(key);
      }
    }
    publish2();
  },
  rollbackRevision: (revision) => {
    for (const [key, deletion] of deletions) {
      if (deletion.revision === revision) {
        deletions.delete(key);
      }
    }
    publish2();
  },
  remap: (remappings) => {
    const moves = remappings.flatMap((remapping) => {
      const oldKey = keyForNode2(remapping.previousNodePath);
      const deletion = deletions.get(oldKey);
      if (deletion?.id !== remapping.revision) {
        return [];
      }
      const newKey = remapping.nodePath === null ? null : keyForNode2(remapping.nodePath);
      return oldKey === newKey ? [] : [{ oldKey, newKey, deletion }];
    });
    if (moves.length === 0) {
      return;
    }
    for (const { oldKey } of moves) {
      deletions.delete(oldKey);
    }
    for (const { newKey, deletion } of moves) {
      if (newKey === null) {
        continue;
      }
      const existing = deletions.get(newKey);
      if (existing && existing.revision > deletion.revision) {
        continue;
      }
      deletions.set(newKey, deletion);
    }
    publish2();
  },
  restore: (nodes, revision, deleted) => {
    for (const node of nodes) {
      const key = keyForNode2(node);
      const previous = deletions.get(key);
      if (previous && previous.revision <= revision) {
        deletions.set(key, { ...previous, revision, deleted });
      }
    }
    publish2();
  },
  prepareRetirement: (nodes, dispatchedRevision) => {
    const keys = nodes.map(keyForNode2);
    return () => {
      let changed = false;
      for (const key of keys) {
        const deletion = deletions.get(key);
        if (deletion !== undefined && deletion.id <= dispatchedRevision) {
          changed = deletions.delete(key) || changed;
        }
      }
      if (changed) {
        publish2();
      }
    };
  }
};

// src/react-refresh-event.ts
var REACT_REFRESH_STARTED_EVENT = "remotion-react-refresh-started";
var REACT_REFRESH_FINISHED_EVENT = "remotion-react-refresh-finished";

// src/find-props-to-delete.ts
var findPropsToDelete = ({
  schema,
  key,
  value
}) => {
  const fieldSchema = schema[key];
  if (!fieldSchema) {
    throw new Error("Key " + JSON.stringify(key) + " not found in schema");
  }
  if (typeof value !== "string") {
    throw new Error("Value must be a string, but is " + JSON.stringify(value));
  }
  if (fieldSchema.type !== "enum") {
    throw new Error("Key " + JSON.stringify(key) + " is not an enum");
  }
  const currentVariant = fieldSchema.variants[value];
  if (!currentVariant) {
    throw new Error("Value for " + JSON.stringify(key) + " must be one of " + Object.keys(fieldSchema.variants).map((v) => JSON.stringify(v)).join(", ") + ", got " + JSON.stringify(value));
  }
  const otherVariants = Object.keys(fieldSchema.variants).filter((v) => v !== value);
  const otherKeys = new Set;
  for (const variant of otherVariants) {
    const otherVariant = fieldSchema.variants[variant];
    const keys = Object.keys(otherVariant);
    for (const k of keys) {
      otherKeys.add(k);
    }
  }
  return [...otherKeys];
};

// src/use-schema.ts
var DEFAULT_LINEAR_EASING = {
  type: "linear"
};
var getEasingIndexToDuplicate = ({
  insertedKeyframeIndex,
  easingLength,
  keyframeCount
}) => {
  const isSplittingExistingSegment = insertedKeyframeIndex > 0 && insertedKeyframeIndex < keyframeCount - 1;
  if (!isSplittingExistingSegment || easingLength === 0) {
    return null;
  }
  return Math.min(insertedKeyframeIndex - 1, easingLength - 1);
};
var makeStaticDragOverride = (value) => {
  return { type: "static", value };
};
var makeKeyframedDragOverride = ({
  status,
  frame,
  value,
  defaultEasing = DEFAULT_LINEAR_EASING
}) => {
  const existingIndex = status.keyframes.findIndex((keyframe) => keyframe.frame === frame);
  const keyframes = existingIndex === -1 ? [...status.keyframes, { frame, value }].sort((first, second) => first.frame - second.frame) : status.keyframes.map((keyframe, index) => index === existingIndex ? { frame, value } : keyframe);
  const easing = [...status.easing];
  if (existingIndex === -1) {
    const insertedKeyframeIndex = keyframes.findIndex((keyframe) => keyframe.frame === frame);
    const easingIndexToDuplicate = getEasingIndexToDuplicate({
      insertedKeyframeIndex,
      easingLength: easing.length,
      keyframeCount: keyframes.length
    });
    const easingToDuplicate = easingIndexToDuplicate === null ? defaultEasing : easing[easingIndexToDuplicate];
    easing.splice(insertedKeyframeIndex, 0, easingToDuplicate);
  }
  while (easing.length < keyframes.length - 1) {
    easing.push(defaultEasing);
  }
  if (easing.length > keyframes.length - 1) {
    easing.length = keyframes.length - 1;
  }
  return {
    type: "keyframed",
    status: {
      ...status,
      keyframes,
      easing
    }
  };
};
var getStaticDragOverrideValue = (dragOverrideValue) => {
  if (dragOverrideValue?.type !== "static") {
    return;
  }
  return dragOverrideValue.value;
};
var isKeyframedStatus = (status) => {
  return status !== null && status.status === "keyframed";
};
var findFieldInSchema = (schema, key) => {
  if (key in schema) {
    return schema[key];
  }
  for (const field of Object.values(schema)) {
    if (field.type !== "enum") {
      continue;
    }
    for (const variant of Object.values(field.variants)) {
      const found = findFieldInSchema(variant, key);
      if (found) {
        return found;
      }
    }
  }
  return;
};
var computeEffectiveSchemaValuesDotNotation = ({
  schema,
  currentValue,
  overrideValues,
  propStatus,
  frame
}) => {
  const merged = {};
  const propsToDelete = new Set;
  for (const key of Object.keys(currentValue)) {
    const status = propStatus?.[key] ?? null;
    const field = findFieldInSchema(schema, key);
    if (field?.type === "hidden") {
      continue;
    }
    let value;
    if (status === null) {
      const dragOverride = resolveDragOverrideValue({
        dragOverrideValue: overrideValues[key],
        frame
      });
      value = dragOverride.type === "resolved" ? dragOverride.value : currentValue[key];
    } else if (isKeyframedStatus(status)) {
      if (field?.type === "array") {
        value = currentValue[key];
      } else {
        const dragOverride = resolveDragOverrideValue({
          dragOverrideValue: overrideValues[key],
          frame
        });
        if (dragOverride.type === "resolved") {
          value = dragOverride.value;
        } else if (frame !== null) {
          const interpolated = interpolateKeyframedStatus({
            forceSpringAllowTail: null,
            frame: getFrameInKeyframedStatusClock({ frame, status }),
            status
          });
          value = interpolated ?? currentValue[key];
        } else {
          value = currentValue[key];
        }
      }
    } else if (status.status === "computed") {
      value = currentValue[key];
    } else {
      value = getEffectiveVisualModeValue({
        propStatus: status,
        dragOverrideValue: overrideValues[key],
        defaultValue: field?.default,
        frame,
        shouldResortToDefaultValueIfUndefined: false
      });
    }
    if (field?.type === "asset" && typeof value === "string" && value.startsWith(FILE_TOKEN)) {
      value = resolveFileTokenToUrl(value);
    }
    if (value === undefined) {
      propsToDelete.add(key);
    }
    merged[key] = value;
  }
  for (const key of Object.keys(overrideValues)) {
    if (schema[key]?.type === "enum") {
      const propsToDeleteForKey = findPropsToDelete({
        schema,
        key,
        value: merged[key]
      });
      for (const propToDelete of propsToDeleteForKey) {
        propsToDelete.add(propToDelete);
      }
    }
  }
  return { merged, propsToDelete };
};

// src/with-interactivity-schema.ts
var sourceRefreshGeneration = 0;
if (typeof window !== "undefined") {
  window.addEventListener(REACT_REFRESH_STARTED_EVENT, () => {
    sourceRefreshGeneration++;
  });
}
var getNestedValue = (obj, key) => {
  const parts = key.split(".");
  let current = obj;
  for (const part of parts) {
    if (current === null || current === undefined || typeof current !== "object")
      return;
    current = current[part];
  }
  return current;
};
var getRuntimeValueForSchemaKey = ({
  flatSchema,
  key,
  props
}) => {
  const value = getNestedValue(props, key);
  if ((flatSchema[key]?.type === "string" || flatSchema[key]?.type === "text-content") && typeof value !== "string") {
    return;
  }
  return value;
};
var readValuesFromProps = (props, keys, flatSchema) => {
  const out = {};
  for (const key of keys) {
    out[key] = flatSchema ? getRuntimeValueForSchemaKey({ flatSchema, key, props }) : getNestedValue(props, key);
  }
  return out;
};
var selectActiveKeys = (schema, values) => {
  return Object.keys(flattenActiveSchema(schema, (key) => values[key]));
};
var mergeValues = ({
  flatSchema,
  props,
  valuesDotNotation,
  schemaKeys,
  propsToDelete
}) => {
  const merged = { ...props };
  for (const key of schemaKeys) {
    const value = valuesDotNotation[key];
    if ((flatSchema[key]?.type === "string" || flatSchema[key]?.type === "text-content") && value === undefined) {
      continue;
    }
    const parts = key.split(".");
    if (parts.length === 1) {
      merged[key] = value;
      continue;
    }
    let current = merged;
    for (let i = 0;i < parts.length - 1; i++) {
      const part = parts[i];
      if (typeof current[part] === "object" && current[part] !== null) {
        current[part] = { ...current[part] };
      } else {
        current[part] = {};
      }
      current = current[part];
    }
    current[parts[parts.length - 1]] = value;
  }
  const propsToDeleteWithoutTextContent = new Set([...propsToDelete].filter((key) => !((flatSchema[key]?.type === "string" || flatSchema[key]?.type === "text-content") && valuesDotNotation[key] === undefined)));
  deleteNestedKey(merged, propsToDeleteWithoutTextContent);
  return merged;
};
var DisableInteractivityContext = createContext27(false);
var DisableInteractivityProvider = ({ children }) => {
  return React26.createElement(DisableInteractivityContext.Provider, { value: true }, children);
};
var EnableInteractivityContext = createContext27(false);
var EnableInteractivityProvider = ({ children }) => {
  return React26.createElement(EnableInteractivityContext.Provider, { value: true }, children);
};
var withInteractivitySchema = ({
  Component,
  componentName,
  componentIdentity = null,
  schema,
  supportsEffects
}) => {
  const schemaWithSequenceName = extendSchemaWithSequenceName(schema);
  const flatSchema = getFlatSchemaWithAllKeys(schemaWithSequenceName);
  const flatKeys = Object.keys(flatSchema);
  let stackToOverrideMap = {};
  let overrideMapGeneration = sourceRefreshGeneration;
  const Wrapped = forwardRef2((props, ref) => {
    const {
      _remotionInternalStack: internalStack,
      ...propsWithoutInternalStack
    } = props;
    const cleanProps = propsWithoutInternalStack;
    const env = useRemotionEnvironment();
    const pendingDeletions = usePendingSequenceDeletions();
    const canUseRemotionHooks = useContext27(CanUseRemotionHooks);
    const disableInteractivity = useContext27(DisableInteractivityContext);
    const enableInteractivity = useContext27(EnableInteractivityContext);
    if (!env.isStudio && !enableInteractivity || env.isRendering || !canUseRemotionHooks || disableInteractivity) {
      return React26.createElement(Component, {
        ...cleanProps,
        controls: null,
        ref
      });
    }
    const nodePathMapping = useContext27(OverrideIdsToNodePathsGettersContext);
    const videoConfig = useUnsafeVideoConfig();
    const durationInFrames = videoConfig?.durationInFrames;
    const fps = videoConfig?.fps;
    const height = videoConfig?.height;
    const width = videoConfig?.width;
    const videoConfigValues = useMemo21(() => durationInFrames === undefined || fps === undefined || height === undefined || width === undefined ? null : {
      durationInFrames,
      fps,
      height,
      width
    }, [durationInFrames, fps, height, width]);
    const passedControls = cleanProps.controls;
    const resolvedPassedControls = useMemo21(() => {
      if (!passedControls || getStackForControls(passedControls) !== null || internalStack === undefined) {
        return passedControls;
      }
      const controlsWithStack = { ...passedControls };
      setStackForControls(controlsWithStack, internalStack);
      return controlsWithStack;
    }, [internalStack, passedControls]);
    if (resolvedPassedControls) {
      return React26.createElement(Component, {
        ...cleanProps,
        controls: resolvedPassedControls,
        ref
      });
    }
    const [overrideId] = useState9(() => {
      if (!internalStack) {
        return String(Math.random());
      }
      if (overrideMapGeneration !== sourceRefreshGeneration) {
        stackToOverrideMap = {};
        overrideMapGeneration = sourceRefreshGeneration;
      }
      const existingOverrideId = stackToOverrideMap[internalStack];
      if (existingOverrideId) {
        return existingOverrideId;
      }
      const newOverrideId = String(Math.random());
      stackToOverrideMap[internalStack] = newOverrideId;
      return newOverrideId;
    });
    const nodePath = env.isReadOnlyStudio ? null : nodePathMapping.overrideIdToNodePathMappings[overrideId] ?? null;
    const dragOverrides = useDragOverridesForNodePath(nodePath);
    const sequenceStatus = usePropStatusForNodePath(nodePath);
    const propStatus = useMemo21(() => getPropStatusesForSequenceStatus(sequenceStatus, videoConfigValues), [sequenceStatus, videoConfigValues]);
    const needsFrame = flatKeys.some((key) => propStatus?.[key]?.status === "keyframed" || dragOverrides[key]?.type === "keyframed");
    const frame = useCurrentFrameWithOptionalSubscription(needsFrame);
    const runtimeValues = flatKeys.map((key) => getRuntimeValueForSchemaKey({
      flatSchema,
      key,
      props: cleanProps
    }));
    const currentRuntimeValueDotNotation = useMemo21(() => readValuesFromProps(cleanProps, flatKeys, flatSchema), runtimeValues);
    const [runtimeValueStore] = useState9(() => createRuntimeValueStore(currentRuntimeValueDotNotation));
    useLayoutEffect8(() => {
      runtimeValueStore.setSnapshot(currentRuntimeValueDotNotation);
    }, [currentRuntimeValueDotNotation, runtimeValueStore]);
    const controls = useMemo21(() => {
      const controlsForRender = {
        schema: schemaWithSequenceName,
        currentRuntimeValueDotNotation,
        runtimeValues: runtimeValueStore.store,
        videoConfigValues,
        overrideId,
        supportsEffects,
        componentIdentity,
        componentName
      };
      setStackForControls(controlsForRender, internalStack);
      return controlsForRender;
    }, [
      currentRuntimeValueDotNotation,
      internalStack,
      overrideId,
      runtimeValueStore.store,
      videoConfigValues
    ]);
    useLayoutEffect8(() => {
      OptimisticSequenceDeletion.register(internalStack ?? null, nodePath);
    }, [internalStack, nodePath]);
    const { merged: valuesDotNotation, propsToDelete } = useMemo21(() => {
      return computeEffectiveSchemaValuesDotNotation({
        schema: schemaWithSequenceName,
        currentValue: currentRuntimeValueDotNotation,
        overrideValues: dragOverrides,
        propStatus,
        frame
      });
    }, [currentRuntimeValueDotNotation, dragOverrides, propStatus, frame]);
    const activeKeys = selectActiveKeys(schemaWithSequenceName, valuesDotNotation);
    const mergedProps = mergeValues({
      flatSchema,
      props: cleanProps,
      valuesDotNotation,
      schemaKeys: activeKeys,
      propsToDelete
    });
    const nameStatus = propStatus?.name;
    if (flatSchema.name?.type === "hidden" && nameStatus?.status === "static") {
      mergedProps.name = typeof nameStatus.codeValue === "string" ? nameStatus.codeValue : undefined;
    }
    if (OptimisticSequenceDeletion.isDeleted(nodePath, pendingDeletions)) {
      return null;
    }
    return React26.createElement(Component, {
      ...mergedProps,
      controls,
      ref
    });
  });
  Wrapped.displayName = `withInteractivitySchema(${Component.displayName || Component.name || "Component"})`;
  return Wrapped;
};

// src/Sequence.tsx
import { jsx as jsx17, jsxs as jsxs2 } from "react/jsx-runtime";
var SeriesContentVisibilityContext = createContext28(true);
var SequenceContextProvider = withCommittedMetadata(SequenceContext.Provider);
var EMPTY_EFFECTS = [];
var getSequenceRegistration = (sequence) => {
  return sequence;
};
var getSequenceStack = (stack) => {
  return stack;
};
var getSequenceCurrentFrame = (ref) => {
  return ref.current;
};
var setSequenceWrapperRef = (ref, wrapperRef, node) => {
  wrapperRef.current = node;
  if (typeof ref === "function") {
    ref(node);
  } else if (ref) {
    ref.current = node;
  }
};
var getSingleChildPropsFromRef = (childrenRef) => getSingleChildProps(childrenRef.current);
var RegularSequenceContentRefForwardingFunction = ({
  timing,
  from = 0,
  trimBefore = 0,
  playbackRate = 1,
  loop = false,
  freeze,
  durationInFrames,
  children,
  name,
  height,
  width,
  showInTimeline = true,
  hidden = false,
  controls,
  _remotionInternalEffects,
  _remotionInternalTimelineTrack: timelineTrackItem,
  _remotionInternalLoopDisplay: loopDisplay,
  _remotionInternalStack: stack,
  _remotionInternalSingleChildComponent: childComponentOverride,
  _remotionInternalSingleChildren: authoredChildrenOverride,
  _remotionInternalDocumentationLink: documentationLink,
  _remotionInternalPremountDisplay: premountDisplay,
  _remotionInternalPostmountDisplay: postmountDisplay,
  _remotionInternalIsMedia: isMedia,
  cropLeft,
  cropRight,
  cropTop,
  cropBottom,
  ...other
}, ref) => {
  const { layout = "absolute-fill" } = other;
  const [id] = useState10(() => String(Math.random()));
  const parentSequence = useContext28(SequenceContext);
  const activityRequested = useContext28(SequenceActivityContext);
  const parentDormant = useContext28(SequenceActivityDormantContext);
  const activitySuspended = useContext28(SequenceActivitySuspensionContext);
  const hadActivity = useRef8(false);
  const env = useRemotionEnvironment();
  const activityEnabled = activityRequested && env.isStudio && !env.isRendering;
  const timelineTrack = useContext28(TimelineTrackContext);
  const timelineTrackRole = timelineTrackItem?.role ?? "clip";
  const seriesOffset = timelineTrackItem?.seriesOffset ?? null;
  const parentPlaybackRate = parentSequence?.playbackRate ?? 1;
  const cumulativePlaybackRate = parentPlaybackRate * playbackRate;
  const cumulatedFrom = parentSequence ? parentSequence.cumulatedFrom + parentSequence.relativeFrom : 0;
  if (layout !== "absolute-fill" && layout !== "none") {
    throw new TypeError(`The layout prop of <Sequence /> expects either "absolute-fill" or "none", but you passed: ${layout}`);
  }
  const cropProps = { cropLeft, cropRight, cropTop, cropBottom };
  const hasCropProp = Object.values(cropProps).some((value) => value !== undefined);
  if (layout === "none" && hasCropProp) {
    throw new TypeError('The cropLeft, cropRight, cropTop and cropBottom props of <Sequence /> are only supported with layout="absolute-fill".');
  }
  validateSequenceCrop(cropProps);
  const {
    left: resolvedCropLeft,
    right: resolvedCropRight,
    top: resolvedCropTop,
    bottom: resolvedCropBottom
  } = resolveSequenceCrop(cropProps);
  if (layout === "none" && typeof other.style !== "undefined") {
    throw new TypeError('If layout="none", you may not pass a style. Passed: ' + JSON.stringify(other.style));
  }
  const {
    contentDurationInFrames,
    effectiveDurationInFrames,
    actualDurationInFrames,
    loopPeriod,
    loopIteration,
    contentVisible,
    inheritedFrozenFrame,
    currentFrameRef
  } = timing;
  if (typeof contentDurationInFrames !== "number") {
    throw new TypeError(`You passed to durationInFrames an argument of type ${typeof contentDurationInFrames}, but it must be a number.`);
  }
  if (contentDurationInFrames <= 0) {
    throw new TypeError(`durationInFrames must be positive, but got ${contentDurationInFrames}`);
  }
  if (typeof from !== "number") {
    throw new TypeError(`You passed to the "from" props of your <Sequence> an argument of type ${typeof from}, but it must be a number.`);
  }
  if (!Number.isFinite(from)) {
    throw new TypeError(`The "from" prop of a sequence must be finite, but got ${from}.`);
  }
  if (typeof trimBefore !== "number") {
    throw new TypeError(`You passed to the "trimBefore" prop of your <Sequence> an argument of type ${typeof trimBefore}, but it must be a number.`);
  }
  if (trimBefore < 0) {
    throw new TypeError(`The "trimBefore" prop of <Sequence /> must be greater than or equal to 0, but got ${trimBefore}.`);
  }
  if (Number.isNaN(trimBefore)) {
    throw new TypeError('The "trimBefore" prop of <Sequence /> must be a real number, but it is NaN.');
  }
  if (!Number.isFinite(trimBefore)) {
    throw new TypeError(`The "trimBefore" prop of <Sequence /> must be finite, but it is ${trimBefore}.`);
  }
  if (typeof loop !== "boolean") {
    throw new TypeError(`The "loop" prop of <Sequence /> must be a boolean, but is of type ${typeof loop}.`);
  }
  if (loop && !Number.isFinite(contentDurationInFrames)) {
    throw new Error('The "loop" prop of <Sequence /> requires a finite "durationInFrames" prop, because a <Sequence /> has no intrinsic duration.');
  }
  if (typeof freeze !== "undefined" && freeze !== null) {
    if (typeof freeze !== "number") {
      throw new TypeError(`The "freeze" prop of <Sequence /> must be a number, but is of type ${typeof freeze}.`);
    }
    if (Number.isNaN(freeze)) {
      throw new TypeError(`The "freeze" prop of <Sequence /> must be a real number, but it is NaN.`);
    }
    if (!Number.isFinite(freeze)) {
      throw new TypeError(`The "freeze" prop of <Sequence /> must be finite, but it is ${freeze}.`);
    }
  }
  const videoConfig = useVideoConfig();
  const loopOffset = loopPeriod === null ? 0 : loopIteration * loopPeriod;
  const clockFrom = from + loopOffset;
  const effectiveRelativeFrom = clockFrom - trimBefore / playbackRate;
  const relativeFrom = effectiveRelativeFrom / parentPlaybackRate;
  const absoluteFrom = (parentSequence?.absoluteFrom ?? 0) + relativeFrom;
  const localClockEnd = loopPeriod === null ? actualDurationInFrames * playbackRate + trimBefore : Math.min(loopPeriod, actualDurationInFrames - loopOffset) * playbackRate + trimBefore;
  const sequenceRegistrationEnabled = useContext28(SequenceRegistrationContext);
  const canvasOutlinesEnabled = useContext28(SequenceOutlineContext);
  const shouldDiscoverOutline = env.isStudio || canvasOutlinesEnabled;
  const automaticOutlineRef = useMemo22(() => shouldDiscoverOutline && layout === "none" ? SequenceOutlineInternals.createRef() : null, [shouldDiscoverOutline, layout]);
  const wrapperRefForOutline = useRef8(null);
  const refForOutline = layout === "none" ? automaticOutlineRef : wrapperRefForOutline;
  const premounting = useMemo22(() => {
    return parentSequence?.premounting || Boolean(other._remotionInternalIsPremounting);
  }, [other._remotionInternalIsPremounting, parentSequence?.premounting]);
  const postmounting = useMemo22(() => {
    return parentSequence?.postmounting || Boolean(other._remotionInternalIsPostmounting);
  }, [other._remotionInternalIsPostmounting, parentSequence?.postmounting]);
  const currentSequenceStart = cumulatedFrom + relativeFrom;
  const parentSequenceStart = parentSequence ? parentSequence.cumulatedFrom + parentSequence.relativeFrom : 0;
  const parentFirstFrame = parentSequence ? parentSequenceStart - parentSequence.cumulatedNegativeFrom / parentPlaybackRate : 0;
  const firstFrame = Math.max(0, parentFirstFrame, cumulatedFrom + clockFrom / parentPlaybackRate);
  const cumulatedNegativeFrom = (currentSequenceStart - firstFrame) * cumulativePlaybackRate;
  const contextValue = useMemo22(() => {
    return {
      playbackRate: cumulativePlaybackRate,
      absoluteFrom,
      cumulatedFrom,
      relativeFrom,
      cumulatedNegativeFrom,
      durationInFrames: localClockEnd,
      parentFrom: parentSequence?.relativeFrom ?? 0,
      id,
      height: height ?? parentSequence?.height ?? null,
      width: width ?? parentSequence?.width ?? null,
      premounting,
      postmounting,
      premountDisplay: premountDisplay ?? null,
      postmountDisplay: postmountDisplay ?? null
    };
  }, [
    cumulatedFrom,
    absoluteFrom,
    relativeFrom,
    cumulativePlaybackRate,
    localClockEnd,
    parentSequence,
    id,
    height,
    width,
    premounting,
    postmounting,
    premountDisplay,
    postmountDisplay,
    cumulatedNegativeFrom
  ]);
  const loopContextValue = useMemo22(() => {
    if (loopPeriod === null) {
      return null;
    }
    return {
      iteration: loopIteration,
      durationInFrames: contentDurationInFrames
    };
  }, [contentDurationInFrames, loopIteration, loopPeriod]);
  const resolvedLoopDisplay = useMemo22(() => {
    if (loopDisplay || loopPeriod === null) {
      return loopDisplay;
    }
    return {
      numberOfTimes: actualDurationInFrames / loopPeriod,
      startOffset: 0,
      durationInFrames: loopPeriod
    };
  }, [actualDurationInFrames, loopDisplay, loopPeriod]);
  const timelineClipName = useMemo22(() => {
    return name ?? "";
  }, [name]);
  const resolvedDocumentationLink = documentationLink ?? "https://www.remotion.dev/docs/sequence";
  const isInsideSeries = useContext28(IsInsideSeriesContext);
  const authoredChildren = authoredChildrenOverride === undefined ? children : authoredChildrenOverride;
  const singleChildComponent = useMemo22(() => childComponentOverride === undefined ? getSingleChildComponent(authoredChildren) : childComponentOverride, [authoredChildren, childComponentOverride]);
  const childrenRef = useRef8(authoredChildren);
  useLayoutEffect9(() => {
    childrenRef.current = authoredChildren;
  }, [authoredChildren]);
  const getRegisteredSingleChildProps = useMemo22(() => childComponentOverride === undefined ? getSingleChildPropsFromRef.bind(null, childrenRef) : null, [childComponentOverride]);
  const registrationStack = controls ? getStackForControls(controls) ?? stack ?? null : stack ?? null;
  const getStack = useMemo22(() => getSequenceStack.bind(null, registrationStack), [registrationStack]);
  const registeredFrozenFrame = typeof freeze === "number" ? freeze : null;
  const getCurrentFrame = useMemo22(() => getSequenceCurrentFrame.bind(null, currentFrameRef), [currentFrameRef]);
  const registeredTrimBefore = trimBefore === 0 ? null : trimBefore;
  const parentCumulatedNegativeFrom = parentSequence?.cumulatedNegativeFrom ?? 0;
  const startMediaFrom = isMedia && isMedia.type !== "image" ? isMedia.data.startMediaFrom + parentCumulatedNegativeFrom - cumulatedNegativeFrom : null;
  const mediaFrameAtSequenceZero = isMedia && isMedia.type !== "image" ? isMedia.data.startMediaFrom + parentCumulatedNegativeFrom : null;
  const mediaFreezeFrame = registeredFrozenFrame ?? (contentVisible && !parentDormant && !premounting && !postmounting ? inheritedFrozenFrame : null);
  const frozenMediaFrame = isMedia && isMedia.type !== "image" && mediaFrameAtSequenceZero !== null && mediaFreezeFrame !== null ? mediaFrameAtSequenceZero + (resolvedLoopDisplay ? mediaFreezeFrame % resolvedLoopDisplay.durationInFrames : mediaFreezeFrame) * isMedia.data.playbackRate : null;
  const controlsSchema = controls?.schema;
  const controlsRuntimeValues = controls?.runtimeValues;
  const controlsOverrideId = controls?.overrideId;
  const controlsSupportsEffects = controls?.supportsEffects;
  const controlsComponentIdentity = controls?.componentIdentity;
  const controlsComponentName = controls?.componentName;
  const controlsVideoConfigValues = controls?.videoConfigValues;
  const canInferDuration = (controlsComponentIdentity === "dev.remotion.remotion.Series" || controlsComponentIdentity === "dev.remotion.transitions.TransitionSeries") && !loop && registeredFrozenFrame === null && inheritedFrozenFrame === null && !hidden;
  const autoDuration = canInferDuration && durationInFrames === undefined;
  const isSeriesChild = controlsComponentIdentity === "dev.remotion.remotion.Series.Sequence" || controlsComponentIdentity === "dev.remotion.transitions.TransitionSeries.Sequence" || controlsComponentIdentity === "dev.remotion.transitions.TransitionSeries.Transition" || controlsComponentIdentity === "dev.remotion.transitions.TransitionSeries.Overlay";
  const effectRuntimeValues = useMemo22(() => _remotionInternalEffects?.runtimeValues ?? null, [_remotionInternalEffects]);
  const registrationControls = useMemo22(() => {
    if (controlsSchema === undefined || controlsRuntimeValues === undefined || controlsOverrideId === undefined || controlsSupportsEffects === undefined || controlsComponentIdentity === undefined || controlsComponentName === undefined || controlsVideoConfigValues === undefined) {
      return null;
    }
    return {
      schema: controlsSchema,
      runtimeValues: controlsRuntimeValues,
      overrideId: controlsOverrideId,
      supportsEffects: controlsSupportsEffects,
      componentIdentity: controlsComponentIdentity,
      componentName: controlsComponentName,
      videoConfigValues: controlsVideoConfigValues
    };
  }, [
    controlsComponentIdentity,
    controlsComponentName,
    controlsVideoConfigValues,
    controlsOverrideId,
    controlsRuntimeValues,
    controlsSchema,
    controlsSupportsEffects
  ]);
  const sequenceForRegistration = useMemo22(() => {
    const trackRegistration = timelineTrack ? {
      timelineTrack: {
        ...timelineTrack,
        role: timelineTrackRole,
        seriesOffset
      }
    } : {};
    if (isMedia) {
      if (isMedia.type === "image") {
        return {
          ...trackRegistration,
          sequencePlaybackRate: playbackRate,
          type: "image",
          controls: registrationControls,
          effects: _remotionInternalEffects ?? EMPTY_EFFECTS,
          effectRuntimeValues,
          displayName: timelineClipName,
          documentationLink: resolvedDocumentationLink,
          duration: actualDurationInFrames,
          from,
          trimBefore: registeredTrimBefore,
          id,
          loopDisplay: resolvedLoopDisplay,
          parent: parentSequence?.id ?? null,
          postmountDisplay: postmountDisplay ?? null,
          premountDisplay: premountDisplay ?? null,
          showInTimeline,
          timelineOrder: null,
          src: isMedia.src,
          animated: isMedia.animated,
          getStack,
          getCurrentFrame,
          refForOutline: refForOutline ?? null,
          isInsideSeries,
          frozenFrame: registeredFrozenFrame,
          singleChildComponent: singleChildComponent ?? null,
          getSingleChildProps: getRegisteredSingleChildProps
        };
      }
      return {
        ...trackRegistration,
        type: isMedia.type,
        sequencePlaybackRate: playbackRate,
        controls: registrationControls,
        effects: _remotionInternalEffects ?? EMPTY_EFFECTS,
        effectRuntimeValues,
        displayName: timelineClipName,
        documentationLink: resolvedDocumentationLink,
        duration: actualDurationInFrames,
        from,
        trimBefore: registeredTrimBefore,
        id,
        loopDisplay: resolvedLoopDisplay,
        parent: parentSequence?.id ?? null,
        playbackRate: isMedia.data.playbackRate,
        postmountDisplay: postmountDisplay ?? null,
        premountDisplay: premountDisplay ?? null,
        showInTimeline,
        timelineOrder: null,
        src: isMedia.data.src,
        getStack,
        getCurrentFrame,
        startMediaFrom: startMediaFrom ?? isMedia.data.startMediaFrom,
        mediaFrameAtSequenceZero,
        muted: isMedia.data.muted,
        refForOutline: refForOutline ?? null,
        isInsideSeries,
        frozenFrame: registeredFrozenFrame,
        frozenMediaFrame,
        singleChildComponent: singleChildComponent ?? null,
        getSingleChildProps: getRegisteredSingleChildProps
      };
    }
    return {
      ...trackRegistration,
      from,
      sequencePlaybackRate: playbackRate,
      trimBefore: registeredTrimBefore,
      duration: actualDurationInFrames,
      ...autoDuration ? { autoDuration: true } : {},
      ...canInferDuration ? { canInferDuration: true } : {},
      ...isSeriesChild ? { unclippedDuration: effectiveDurationInFrames } : {},
      id,
      displayName: timelineClipName,
      documentationLink: resolvedDocumentationLink,
      parent: parentSequence?.id ?? null,
      type: "sequence",
      showInTimeline,
      timelineOrder: null,
      loopDisplay: resolvedLoopDisplay,
      getStack,
      getCurrentFrame,
      premountDisplay: premountDisplay ?? null,
      postmountDisplay: postmountDisplay ?? null,
      controls: registrationControls,
      effects: _remotionInternalEffects ?? EMPTY_EFFECTS,
      effectRuntimeValues,
      refForOutline: refForOutline ?? null,
      isInsideSeries,
      frozenFrame: registeredFrozenFrame,
      singleChildComponent: singleChildComponent ?? null,
      getSingleChildProps: getRegisteredSingleChildProps
    };
  }, [
    id,
    timelineTrack,
    timelineTrackRole,
    seriesOffset,
    getCurrentFrame,
    getStack,
    timelineClipName,
    playbackRate,
    parentSequence?.id,
    actualDurationInFrames,
    autoDuration,
    canInferDuration,
    isSeriesChild,
    effectiveDurationInFrames,
    from,
    registeredTrimBefore,
    showInTimeline,
    resolvedLoopDisplay,
    premountDisplay,
    postmountDisplay,
    registrationControls,
    _remotionInternalEffects,
    effectRuntimeValues,
    isMedia,
    resolvedDocumentationLink,
    refForOutline,
    isInsideSeries,
    registeredFrozenFrame,
    startMediaFrom,
    mediaFrameAtSequenceZero,
    frozenMediaFrame,
    singleChildComponent,
    getRegisteredSingleChildProps
  ]);
  const getSequenceForRegistration = useMemo22(() => getSequenceRegistration.bind(null, sequenceForRegistration), [sequenceForRegistration]);
  const registration = useSequenceRegistration({
    getSequence: env.isStudio || sequenceRegistrationEnabled ? getSequenceForRegistration : null,
    id
  });
  const activityDormant = parentDormant || !contentVisible;
  const admitted = useSequenceActivityAdmission(activityEnabled && !hidden ? {
    id,
    parent: parentSequence?.id ?? null,
    compositionId: videoConfig.id,
    from: firstFrame,
    end: cumulatedFrom + (from + actualDurationInFrames) / parentPlaybackRate
  } : null);
  const renderActivity = activityEnabled && (!activityDormant || admitted || activitySuspended && hadActivity.current);
  const useCommitEffect = React27.useInsertionEffect ?? useLayoutEffect9;
  useCommitEffect(() => {
    hadActivity.current = renderActivity;
  }, [renderActivity]);
  const content = (activityEnabled ? renderActivity : contentVisible) ? children : null;
  const frozenContent = content === null || typeof freeze === "undefined" || freeze === null ? content : /* @__PURE__ */ jsx17(Freeze, {
    frame: freeze,
    children: content
  });
  const loopedContent = frozenContent === null || loopContextValue === null ? frozenContent : /* @__PURE__ */ jsx17(LoopContext.Provider, {
    value: loopContextValue,
    children: frozenContent
  });
  const styleIfThere = other.layout === "none" ? undefined : other.style;
  const cropClipPath = getSequenceCropClipPath({
    left: resolvedCropLeft,
    right: resolvedCropRight,
    top: resolvedCropTop,
    bottom: resolvedCropBottom,
    style: styleIfThere
  });
  const sequenceRef = useMemo22(() => setSequenceWrapperRef.bind(null, ref, wrapperRefForOutline), [ref, wrapperRefForOutline]);
  const defaultStyle = useMemo22(() => {
    return {
      flexDirection: undefined,
      ...width ? { width } : {},
      ...height ? { height } : {},
      ...styleIfThere ?? {},
      ...cropClipPath ? {
        clipPath: cropClipPath
      } : {}
    };
  }, [cropClipPath, height, styleIfThere, width]);
  if (ref !== null && layout === "none") {
    throw new TypeError('It is not supported to pass both a `ref` and `layout="none"` to <Sequence />.');
  }
  const metadata = useMemo22(() => shouldDiscoverOutline || registration !== null ? {
    type: "sequence",
    id,
    value: registration,
    outlineChildrenRef: automaticOutlineRef
  } : null, [automaticOutlineRef, id, registration, shouldDiscoverOutline]);
  if (hidden) {
    return shouldDiscoverOutline || registration !== null ? /* @__PURE__ */ jsx17(SequenceContextProvider, {
      value: contextValue,
      _remotionCommitMetadata: metadata,
      children: null
    }) : null;
  }
  const retainSeriesRegistration = env.isStudio && canInferDuration;
  const contentForLayout = renderActivity ? /* @__PURE__ */ jsx17(SequenceActivityContent, {
    dormant: activityDormant,
    children: loopedContent
  }) : loopedContent;
  const renderedContent = loopedContent === null ? retainSeriesRegistration ? children : null : other.layout === "none" ? contentForLayout : /* @__PURE__ */ jsx17(AbsoluteFillElement, {
    ref: sequenceRef,
    style: defaultStyle,
    className: other.className,
    children: contentForLayout
  });
  const activityContent = renderActivity ? /* @__PURE__ */ jsx17(SequenceActivityBoundary, {
    dormant: activityDormant,
    frame: firstFrame,
    children: renderedContent
  }) : renderedContent;
  const sequenceContent = /* @__PURE__ */ jsx17(SequenceContextProvider, {
    value: contextValue,
    _remotionCommitMetadata: metadata,
    children: retainSeriesRegistration ? /* @__PURE__ */ jsx17(SeriesContentVisibilityContext.Provider, {
      value: renderActivity || contentVisible,
      children: activityContent
    }) : activityContent
  });
  const sequence = /* @__PURE__ */ jsx17(TimelineTrackContext.Provider, {
    value: timelineTrackRole === "track" || timelineTrackRole === "clip" && !showInTimeline ? timelineTrack : null,
    children: sequenceContent
  });
  return sequence;
};
var RegularSequenceContent = React27.memo(forwardRef3(RegularSequenceContentRefForwardingFunction));
var SequenceFrameCommit = ({ currentFrame, currentFrameRef }) => {
  useLayoutEffect9(() => {
    currentFrameRef.current = currentFrame;
  }, [currentFrame, currentFrameRef]);
  return null;
};
var RegularSequenceRefForwardingFunction = (props, ref) => {
  const {
    from = 0,
    trimBefore = 0,
    playbackRate = 1,
    loop = false,
    durationInFrames,
    freeze
  } = props;
  const parentSequence = useContext28(SequenceContext);
  const parentPlaybackRate = parentSequence?.playbackRate ?? 1;
  const cumulatedFrom = parentSequence ? parentSequence.cumulatedFrom + parentSequence.relativeFrom : 0;
  const activityRequested = useContext28(SequenceActivityContext);
  const parentDormant = useContext28(SequenceActivityDormantContext);
  const env = useRemotionEnvironment();
  const activityEnabled = activityRequested && env.isStudio && !env.isRendering;
  const seriesContentVisible = useContext28(SeriesContentVisibilityContext);
  const videoConfig = useVideoConfig();
  const contentDurationInFrames = resolveSequenceContentDuration({
    durationInFrames
  });
  const absoluteFrame = useTimelinePosition();
  const lastPlaybackRate = useRef8({ playbackRate, frame: absoluteFrame });
  if (typeof playbackRate !== "number" || !Number.isFinite(playbackRate) || playbackRate <= 0) {
    throw new TypeError(`The "playbackRate" prop of <Sequence /> must be a positive finite number, but got ${playbackRate}.`);
  }
  if (lastPlaybackRate.current.frame !== absoluteFrame && lastPlaybackRate.current.playbackRate !== playbackRate) {
    throw new Error('The "playbackRate" prop of <Sequence /> must be constant. Animating playbackRate is not supported.');
  }
  useLayoutEffect9(() => {
    lastPlaybackRate.current = { playbackRate, frame: absoluteFrame };
  }, [absoluteFrame, playbackRate]);
  const effectiveDurationInFrames = resolveSequenceDuration({
    durationInFrames,
    playbackRate,
    loop
  });
  const windowRelativeFrom = from - trimBefore / playbackRate;
  const parentSequenceDuration = parentSequence ? Math.min(parentSequence.durationInFrames - windowRelativeFrom, effectiveDurationInFrames) : effectiveDurationInFrames;
  const actualDurationInFrames = Math.max(0, Math.min(videoConfig.durationInFrames - from, parentSequenceDuration));
  const frameInParent = (absoluteFrame - cumulatedFrom) * parentPlaybackRate;
  const loopPeriod = loop && Number.isFinite(contentDurationInFrames) ? contentDurationInFrames / playbackRate : null;
  let loopIteration = 0;
  if (loopPeriod !== null && (!activityEnabled || !parentDormant && frameInParent >= from && frameInParent < from + actualDurationInFrames)) {
    const loopsElapsed = (frameInParent - from) / loopPeriod;
    const nearestIteration = Math.round(loopsElapsed);
    const isAtBoundary = Math.abs(loopsElapsed - nearestIteration) <= Number.EPSILON * Math.max(1, Math.abs(loopsElapsed)) * 4;
    const lastIteration = Math.ceil(actualDurationInFrames / loopPeriod) - 1;
    loopIteration = Math.max(0, Math.min(lastIteration, isAtBoundary ? nearestIteration : Math.floor(loopsElapsed)));
  }
  const endThreshold = from + effectiveDurationInFrames;
  const boundaryTolerance = getSequenceBoundaryTolerance({
    absoluteFrame,
    cumulatedFrom,
    from,
    parentPlaybackRate,
    durationInFrames: effectiveDurationInFrames
  });
  const contentVisible = seriesContentVisible && frameInParent - from >= -boundaryTolerance && frameInParent - endThreshold < -boundaryTolerance;
  const loopOffset = loopPeriod === null ? 0 : loopIteration * loopPeriod;
  const currentSequenceStart = cumulatedFrom + (from + loopOffset - trimBefore / playbackRate) / parentPlaybackRate;
  const currentFrame = typeof freeze === "number" ? freeze : (absoluteFrame - currentSequenceStart) * (parentPlaybackRate * playbackRate);
  const inheritedFrozenFrame = useIsInsideNonPremountFreeze() ? currentFrame : null;
  const currentFrameRef = useRef8(currentFrame);
  const timing = useMemo22(() => ({
    contentDurationInFrames,
    effectiveDurationInFrames,
    actualDurationInFrames,
    loopPeriod,
    loopIteration,
    contentVisible,
    inheritedFrozenFrame,
    currentFrameRef
  }), [
    contentDurationInFrames,
    effectiveDurationInFrames,
    actualDurationInFrames,
    loopPeriod,
    loopIteration,
    contentVisible,
    inheritedFrozenFrame
  ]);
  return /* @__PURE__ */ jsxs2(React27.Fragment, {
    children: [
      /* @__PURE__ */ jsx17(SequenceFrameCommit, {
        currentFrame,
        currentFrameRef
      }),
      /* @__PURE__ */ jsx17(RegularSequenceContent, {
        ...props,
        ref,
        timing
      })
    ]
  });
};
var RegularSequence = forwardRef3(RegularSequenceRefForwardingFunction);
var PremountedSequenceContentRefForwardingFunction = ({
  freezeFrame,
  isPremountingOrPostmounting,
  premountingActive,
  postmountingActive,
  premountingStyle,
  from = 0,
  durationInFrames,
  premountFor = 0,
  postmountFor = 0,
  style: _style,
  styleWhilePremounted: _styleWhilePremounted,
  styleWhilePostmounted: _styleWhilePostmounted,
  ...otherProps
}, ref) => {
  return /* @__PURE__ */ jsx17(Freeze, {
    frame: freezeFrame,
    active: isPremountingOrPostmounting,
    _remotionInternalIsPremounting: premountingActive,
    children: /* @__PURE__ */ jsx17(RegularSequence, {
      ref,
      from,
      durationInFrames,
      style: premountingStyle ?? undefined,
      _remotionInternalPremountDisplay: premountFor,
      _remotionInternalPostmountDisplay: postmountFor,
      _remotionInternalIsPremounting: premountingActive,
      _remotionInternalIsPostmounting: postmountingActive,
      ...otherProps
    })
  });
};
var PremountedSequenceContent = React27.memo(forwardRef3(PremountedSequenceContentRefForwardingFunction));
var PremountedPostmountedSequenceRefForwardingFunction = (props, ref) => {
  if (props.layout === "none") {
    throw new Error('`<Sequence>` with `premountFor` and `postmountFor` props does not support layout="none"');
  }
  const {
    style: passedStyle,
    from = 0,
    durationInFrames,
    premountFor = 0,
    postmountFor = 0,
    styleWhilePremounted,
    styleWhilePostmounted,
    ...otherProps
  } = props;
  const {
    freezeFrame,
    isPremountingOrPostmounting,
    postmountingActive,
    premountingActive,
    premountingStyle
  } = usePremounting({
    from,
    durationInFrames: resolveSequenceDuration({
      durationInFrames,
      playbackRate: otherProps.playbackRate,
      loop: otherProps.loop
    }),
    premountFor,
    postmountFor,
    style: passedStyle ?? null,
    styleWhilePremounted: styleWhilePremounted ?? null,
    styleWhilePostmounted: styleWhilePostmounted ?? null,
    hideWhilePremounted: "opacity"
  });
  return /* @__PURE__ */ jsx17(PremountedSequenceContent, {
    ...props,
    ref,
    freezeFrame,
    isPremountingOrPostmounting,
    postmountingActive,
    premountingActive,
    premountingStyle
  });
};
var PremountedPostmountedSequence = forwardRef3(PremountedPostmountedSequenceRefForwardingFunction);
var SequenceRefForwardingFunction = (props, ref) => {
  const env = useRemotionEnvironment();
  const { fps } = useVideoConfig();
  const defaultPremountInSeconds = useContext28(DefaultPremountContext);
  if (props.layout !== "none" && !env.isRendering) {
    const effectivePremountFor = props.premountFor ?? Math.round(defaultPremountInSeconds * fps);
    if (effectivePremountFor || props.postmountFor) {
      return /* @__PURE__ */ jsx17(PremountedPostmountedSequence, {
        ref,
        ...props,
        premountFor: effectivePremountFor
      });
    }
  }
  return /* @__PURE__ */ jsx17(RegularSequence, {
    ...props,
    ref
  });
};
var SequenceInner = forwardRef3(SequenceRefForwardingFunction);
var SequenceWithoutSchema = SequenceInner;
var Sequence = withInteractivitySchema({
  Component: SequenceInner,
  componentName: "<Sequence>",
  componentIdentity: "dev.remotion.remotion.Sequence",
  schema: sequenceSchema,
  supportsEffects: false
});
var SequenceWithoutFrom = withInteractivitySchema({
  Component: SequenceInner,
  componentName: "<Sequence>",
  componentIdentity: null,
  schema: sequenceSchemaWithoutFrom,
  supportsEffects: false
});

// src/AbsoluteFill.tsx
import { useCallback as useCallback6 } from "react";
import { jsx as jsx18 } from "react/jsx-runtime";
var absoluteFillSchema = {
  ...baseSchema,
  ...premountSchema,
  ...transformSchema,
  ...backgroundSchema,
  ...borderSchema,
  ...borderRadiusSchema,
  ...textSchema,
  ...childrenSchema
};
var setRef = (ref, value) => {
  if (typeof ref === "function") {
    ref(value);
  } else if (ref) {
    ref.current = value;
  }
};
var AbsoluteFillWithTiming = ({
  ref: callbackRef,
  from,
  premountFor,
  postmountFor,
  styleWhilePremounted,
  styleWhilePostmounted,
  trimBefore,
  playbackRate,
  loop,
  freeze,
  durationInFrames,
  hidden,
  name,
  showInTimeline,
  stack,
  controls,
  children,
  ...divProps
}) => {
  const {
    effectivePremountFor,
    effectivePostmountFor,
    freezeFrame,
    isPremountingOrPostmounting,
    premountingActive,
    postmountingActive,
    premountingStyle
  } = usePremounting({
    from: from ?? 0,
    durationInFrames: resolveSequenceDuration({
      durationInFrames,
      playbackRate,
      loop
    }),
    premountFor: premountFor ?? null,
    postmountFor: postmountFor ?? null,
    style: divProps.style ?? null,
    styleWhilePremounted: styleWhilePremounted ?? null,
    styleWhilePostmounted: styleWhilePostmounted ?? null,
    hideWhilePremounted: "opacity"
  });
  return /* @__PURE__ */ jsx18(Freeze, {
    frame: freezeFrame,
    active: isPremountingOrPostmounting,
    _remotionInternalIsPremounting: premountingActive,
    children: /* @__PURE__ */ jsx18(Sequence, {
      layout: "none",
      from: from ?? 0,
      trimBefore,
      playbackRate,
      loop,
      freeze,
      durationInFrames,
      hidden,
      name: name ?? "<AbsoluteFill>",
      showInTimeline: showInTimeline ?? true,
      controls,
      _remotionInternalStack: stack,
      _remotionInternalDocumentationLink: "https://www.remotion.dev/docs/absolute-fill",
      _remotionInternalPremountDisplay: effectivePremountFor || null,
      _remotionInternalPostmountDisplay: effectivePostmountFor || null,
      _remotionInternalIsPremounting: premountingActive,
      _remotionInternalIsPostmounting: postmountingActive,
      children: /* @__PURE__ */ jsx18(AbsoluteFillElement, {
        ref: callbackRef,
        ...divProps,
        style: premountingStyle ?? undefined,
        children
      })
    })
  });
};
var AbsoluteFillInner = ({
  ref,
  from,
  premountFor,
  postmountFor,
  styleWhilePremounted,
  styleWhilePostmounted,
  trimBefore,
  playbackRate,
  loop,
  freeze,
  durationInFrames,
  hidden,
  name,
  showInTimeline,
  stack,
  controls,
  children,
  ...divProps
}) => {
  const videoConfig = useUnsafeVideoConfig();
  const callbackRef = useCallback6((element) => {
    setRef(ref, element);
  }, [ref]);
  if (videoConfig === null) {
    return hidden ? null : /* @__PURE__ */ jsx18(AbsoluteFillElement, {
      ref: callbackRef,
      ...divProps,
      children
    });
  }
  return /* @__PURE__ */ jsx18(AbsoluteFillWithTiming, {
    ...divProps,
    ref: callbackRef,
    from,
    premountFor,
    postmountFor,
    styleWhilePremounted,
    styleWhilePostmounted,
    trimBefore,
    playbackRate,
    loop,
    freeze,
    durationInFrames,
    hidden,
    name,
    showInTimeline,
    stack,
    controls,
    children
  });
};
var AbsoluteFill = withInteractivitySchema({
  Component: AbsoluteFillInner,
  componentName: "<AbsoluteFill>",
  componentIdentity: "dev.remotion.remotion.AbsoluteFill",
  schema: absoluteFillSchema,
  supportsEffects: false
});
addSequenceStackTraces(AbsoluteFill);
// src/animated-image/AnimatedImage.tsx
import {
  forwardRef as forwardRef4,
  useImperativeHandle as useImperativeHandle2,
  useLayoutEffect as useLayoutEffect10,
  useMemo as useMemo26,
  useRef as useRef11,
  useState as useState12
} from "react";

// src/get-canvas-props-from-sequence-props.ts
var getCanvasPropsFromSequenceProps = (props) => {
  const canvasProps = {};
  const mutableCanvasProps = canvasProps;
  for (const key in props) {
    if (Object.prototype.hasOwnProperty.call(props, key) && (key.startsWith("data-") || key.startsWith("aria-"))) {
      mutableCanvasProps[key] = props[key];
    }
  }
  return canvasProps;
};

// src/use-crop-style.ts
import { useMemo as useMemo23 } from "react";
var useCropStyle = ({
  cropLeft,
  cropRight,
  cropTop,
  cropBottom,
  style,
  componentName
}) => {
  validateSequenceCrop({ cropLeft, cropRight, cropTop, cropBottom }, componentName);
  return useMemo23(() => {
    const cropClipPath = getSequenceCropClipPath({
      ...resolveSequenceCrop({ cropLeft, cropRight, cropTop, cropBottom }),
      style
    });
    if (cropClipPath === null) {
      return style;
    }
    return { ...style, clipPath: cropClipPath };
  }, [cropBottom, cropLeft, cropRight, cropTop, style]);
};

// src/animated-image/canvas.tsx
import React29, {
  useCallback as useCallback7,
  useEffect as useEffect8,
  useImperativeHandle,
  useMemo as useMemo25,
  useRef as useRef10
} from "react";

// src/calculate-image-fit.ts
var calculateImageFit = (fit, imageSize, canvasSize) => {
  switch (fit) {
    case "fill": {
      return [
        0,
        0,
        imageSize.width,
        imageSize.height,
        0,
        0,
        canvasSize.width,
        canvasSize.height
      ];
    }
    case "contain": {
      const ratio = Math.min(canvasSize.width / imageSize.width, canvasSize.height / imageSize.height);
      const centerX = (canvasSize.width - imageSize.width * ratio) / 2;
      const centerY = (canvasSize.height - imageSize.height * ratio) / 2;
      return [
        0,
        0,
        imageSize.width,
        imageSize.height,
        centerX,
        centerY,
        imageSize.width * ratio,
        imageSize.height * ratio
      ];
    }
    case "cover": {
      const ratio = Math.max(canvasSize.width / imageSize.width, canvasSize.height / imageSize.height);
      const centerX = (canvasSize.width - imageSize.width * ratio) / 2;
      const centerY = (canvasSize.height - imageSize.height * ratio) / 2;
      return [
        0,
        0,
        imageSize.width,
        imageSize.height,
        centerX,
        centerY,
        imageSize.width * ratio,
        imageSize.height * ratio
      ];
    }
    default:
      throw new Error("Unknown fit: " + fit);
  }
};

// src/effects/reset-webgl-state.ts
var createWebGLStateReset = (gl, textureUnits) => {
  const drawBuffers = [gl.BACK];
  const capabilities = [
    gl.BLEND,
    gl.DEPTH_TEST,
    gl.STENCIL_TEST,
    gl.CULL_FACE,
    gl.SCISSOR_TEST,
    gl.RASTERIZER_DISCARD,
    gl.POLYGON_OFFSET_FILL,
    gl.SAMPLE_ALPHA_TO_COVERAGE,
    gl.SAMPLE_COVERAGE
  ];
  const pixelStoreParameters = [
    gl.PACK_ROW_LENGTH,
    gl.PACK_SKIP_PIXELS,
    gl.PACK_SKIP_ROWS,
    gl.UNPACK_ROW_LENGTH,
    gl.UNPACK_IMAGE_HEIGHT,
    gl.UNPACK_SKIP_PIXELS,
    gl.UNPACK_SKIP_ROWS,
    gl.UNPACK_SKIP_IMAGES
  ];
  return (width, height, flipSourceY) => {
    gl.bindFramebuffer(gl.FRAMEBUFFER, null);
    gl.drawBuffers(drawBuffers);
    gl.readBuffer(gl.BACK);
    gl.viewport(0, 0, width, height);
    gl.scissor(0, 0, width, height);
    for (const capability of capabilities) {
      gl.disable(capability);
    }
    gl.enable(gl.DITHER);
    gl.colorMask(true, true, true, true);
    gl.depthMask(true);
    gl.stencilMask(4294967295);
    gl.clearColor(0, 0, 0, 0);
    gl.clearDepth(1);
    gl.clearStencil(0);
    gl.useProgram(null);
    gl.bindVertexArray(null);
    gl.bindBuffer(gl.ARRAY_BUFFER, null);
    gl.bindBuffer(gl.PIXEL_PACK_BUFFER, null);
    gl.bindBuffer(gl.PIXEL_UNPACK_BUFFER, null);
    for (let unit = 0;unit < textureUnits; unit++) {
      gl.bindSampler(unit, null);
    }
    gl.activeTexture(gl.TEXTURE0);
    gl.pixelStorei(gl.PACK_ALIGNMENT, 4);
    gl.pixelStorei(gl.UNPACK_ALIGNMENT, 4);
    for (const parameter of pixelStoreParameters) {
      gl.pixelStorei(parameter, 0);
    }
    gl.pixelStorei(gl.UNPACK_PREMULTIPLY_ALPHA_WEBGL, true);
    gl.pixelStorei(gl.UNPACK_FLIP_Y_WEBGL, flipSourceY);
    gl.pixelStorei(gl.UNPACK_COLORSPACE_CONVERSION_WEBGL, gl.BROWSER_DEFAULT_WEBGL);
  };
};

// src/effects/webgl-context-lost-error.ts
class WebGLContextLostError extends Error {
  canvas;
  constructor(canvas) {
    super("WebGL context was lost while rendering effects");
    this.name = "WebGLContextLostError";
    this.canvas = canvas;
  }
}

// src/effects/webgl2-context-error.ts
var WEBGL_CONTEXT_DOCS_URL = "https://remotion.dev/docs/troubleshooting/webgl2-context";
class WebGL2ContextCreationError extends Error {
}
var webGlContextErrorMessage = (versionLabel, effectName) => `Failed to acquire ${versionLabel} context for ${effectName}. ` + 'Pass --gl=angle when using the CLI, set chromiumOptions: { gl: "angle" } when using SSR APIs, ' + 'or set "OpenGL render backend" to "angle" in the Advanced section when rendering in the Studio. ' + `See ${WEBGL_CONTEXT_DOCS_URL}`;
var createWebGLContextError = (effectName) => new Error(webGlContextErrorMessage("WebGL", effectName));
var createWebGL2ContextError = (effectName) => new WebGL2ContextCreationError(webGlContextErrorMessage("WebGL2", effectName));

// src/effects/canvas-pool.ts
var scheduleContextLoss = (gl) => {
  setTimeout(() => {
    gl.getExtension("WEBGL_lose_context")?.loseContext();
  }, 0);
};

class CanvasPool {
  width;
  height;
  pairs = new Map;
  allocated = new Map;
  lostContexts = new Set;
  onContextLost;
  disposed = false;
  constructor(width, height, onContextLost) {
    this.width = width;
    this.height = height;
    this.onContextLost = onContextLost;
  }
  resize(width, height) {
    this.width = width;
    this.height = height;
    for (const canvas of this.allocated.keys()) {
      if (canvas.width !== width)
        canvas.width = width;
      if (canvas.height !== height)
        canvas.height = height;
    }
  }
  owns(canvas) {
    return this.allocated.has(canvas);
  }
  assertWebGLContextsNotLost() {
    for (const [canvas, entry] of this.allocated) {
      if (entry.gl)
        this.getCheckedEntry(canvas);
    }
  }
  getCanvas(backend, index) {
    if (this.disposed) {
      throw new Error("Effect chain state was used after it had been cleaned up");
    }
    let pair = this.pairs.get(backend);
    if (!pair) {
      pair = [null, null];
      this.pairs.set(backend, pair);
    }
    pair[index] ??= this.allocateCanvas(backend);
    return pair[index];
  }
  getPair(backend) {
    this.getCanvas(backend, 0);
    this.getCanvas(backend, 1);
    return this.pairs.get(backend);
  }
  getCheckedEntry(canvas) {
    const entry = this.allocated.get(canvas);
    if (this.lostContexts.has(canvas) || entry?.gl?.isContextLost()) {
      throw new WebGLContextLostError(canvas);
    }
    return entry ?? null;
  }
  assertContextNotLost(canvas) {
    this.getCheckedEntry(canvas);
  }
  prepareWebGL(canvas, flipSourceY) {
    const entry = this.getCheckedEntry(canvas);
    if (!entry?.reset) {
      throw new Error("WebGL effect target is not owned by this pool");
    }
    entry.reset(canvas.width, canvas.height, flipSourceY);
  }
  retireWebGL(canvas) {
    const entry = this.allocated.get(canvas);
    if (!entry)
      return;
    const { gl } = entry;
    this.allocated.delete(canvas);
    const pair = this.pairs.get("webgl2");
    if (pair) {
      if (pair[0] === canvas)
        pair[0] = null;
      if (pair[1] === canvas)
        pair[1] = null;
    }
    try {
      if (gl)
        scheduleContextLoss(gl);
      this.onContextLost(canvas);
    } finally {
      canvas.width = 0;
      canvas.height = 0;
      this.lostContexts.delete(canvas);
    }
  }
  dispose() {
    if (this.disposed) {
      return;
    }
    this.disposed = true;
    for (const [canvas, { gl }] of this.allocated) {
      if (gl)
        scheduleContextLoss(gl);
      canvas.width = 0;
      canvas.height = 0;
    }
    this.allocated.clear();
    this.pairs.clear();
    this.lostContexts.clear();
  }
  allocateCanvas(backend) {
    const canvas = document.createElement("canvas");
    canvas.width = this.width;
    canvas.height = this.height;
    switch (backend) {
      case "2d": {
        const ctx = canvas.getContext("2d", {
          colorSpace: "srgb"
        });
        if (!ctx) {
          throw new Error("Failed to acquire 2D context for effects");
        }
        this.allocated.set(canvas, { gl: null, reset: null });
        return canvas;
      }
      case "webgl2": {
        const ctx = canvas.getContext("webgl2", {
          premultipliedAlpha: true,
          alpha: true,
          preserveDrawingBuffer: true
        });
        if (!ctx) {
          throw createWebGL2ContextError("effects");
        }
        canvas.addEventListener("webglcontextlost", () => {
          if (this.disposed || !this.allocated.has(canvas)) {
            return;
          }
          this.lostContexts.add(canvas);
          this.onContextLost(canvas);
        });
        canvas.addEventListener("webglcontextrestored", () => {
          if (this.disposed || !this.allocated.has(canvas)) {
            return;
          }
          ctx.pixelStorei(ctx.UNPACK_PREMULTIPLY_ALPHA_WEBGL, true);
          this.lostContexts.delete(canvas);
        });
        ctx.pixelStorei(ctx.UNPACK_PREMULTIPLY_ALPHA_WEBGL, true);
        this.allocated.set(canvas, {
          gl: ctx,
          reset: createWebGLStateReset(ctx, ctx.getParameter(ctx.MAX_COMBINED_TEXTURE_IMAGE_UNITS))
        });
        return canvas;
      }
      case "webgpu": {
        if (typeof navigator === "undefined" || !("gpu" in navigator) || !canvas.getContext("webgpu")) {
          throw new Error("WebGPU is not available in this environment for effects");
        }
        this.allocated.set(canvas, { gl: null, reset: null });
        return canvas;
      }
      default: {
        const exhaustive = backend;
        throw new Error(`Unknown effect backend: ${exhaustive}`);
      }
    }
  }
}

// src/effects/effect-internals.ts
var groupByBackend = (effects) => {
  const runs = [];
  let current = [];
  let currentBackend = null;
  for (const eff of effects) {
    const { backend } = eff.definition;
    if (currentBackend === null || backend === currentBackend) {
      current.push(eff);
      currentBackend = backend;
    } else {
      runs.push({ backend: currentBackend, effects: current });
      current = [eff];
      currentBackend = backend;
    }
  }
  if (currentBackend !== null && current.length > 0) {
    runs.push({ backend: currentBackend, effects: current });
  }
  return runs;
};

// src/effects/gpu-device.ts
var deviceLost = false;
var devicePromise = null;
var getGpuDevice = () => {
  if (deviceLost && typeof window !== "undefined" && window.remotion_puppeteerTimeout !== undefined) {
    throw new Error('WebGPU device was lost during rendering. Retry the render or use preferredEffectBackend: "webgl2".');
  }
  if (devicePromise) {
    return devicePromise;
  }
  devicePromise = (async () => {
    if (typeof navigator === "undefined" || !("gpu" in navigator)) {
      return null;
    }
    const { gpu } = navigator;
    const adapter = await gpu.requestAdapter();
    if (!adapter) {
      return null;
    }
    const device = await adapter.requestDevice();
    let supportsCanvasTargets = false;
    try {
      const canvas = document.createElement("canvas");
      canvas.width = 1;
      canvas.height = 1;
      const context = canvas.getContext("webgpu");
      if (!context)
        return null;
      let validationError = null;
      try {
        device.pushErrorScope("validation");
        try {
          context.configure({
            device,
            format: gpu.getPreferredCanvasFormat(),
            alphaMode: "premultiplied"
          });
          context.getCurrentTexture().createView();
        } finally {
          validationError = await device.popErrorScope();
        }
      } finally {
        context.unconfigure();
      }
      if (validationError)
        return null;
      supportsCanvasTargets = true;
    } finally {
      if (!supportsCanvasTargets)
        device.destroy();
    }
    device.lost?.then(() => {
      deviceLost = true;
      devicePromise = Promise.resolve(null);
    });
    return device;
  })().catch(() => null);
  return devicePromise;
};

// src/effects/shared-webgl-pool.ts
var pools = [];
var leased = false;
var waiters = [];
var cleanups = [];
var listeners3 = new Set;
var release = () => {
  const errors = [];
  try {
    while (cleanups.length > 0) {
      try {
        cleanups.shift()();
      } catch (error) {
        errors.push(error);
      }
    }
  } finally {
    const next = waiters.shift();
    if (next) {
      next();
    } else {
      leased = false;
    }
  }
  if (errors.length === 1)
    throw errors[0];
  if (errors.length > 1)
    throw new AggregateError(errors, "Shared WebGL cleanup failed");
};
var cleanupWithSharedWebGLPool = (cleanup) => {
  cleanups.push(cleanup);
  if (!leased) {
    leased = true;
    release();
  }
};
var subscribeToSharedWebGLContextLoss = (onContextLost) => {
  listeners3.add(onContextLost);
  return () => {
    listeners3.delete(onContextLost);
    if (listeners3.size === 0) {
      for (const entry of pools)
        entry.pool.dispose();
      pools.length = 0;
    }
  };
};
var acquireSharedWebGLPool = async (width, height) => {
  await new Promise((resolve) => {
    if (leased) {
      waiters.push(resolve);
    } else {
      leased = true;
      resolve();
    }
  });
  try {
    const index = pools.findIndex((candidate) => candidate.width === width && candidate.height === height);
    const cached = index === -1 ? null : pools.splice(index, 1)[0];
    const entry = cached ?? (pools.length === 2 ? pools.shift() : null);
    if (entry) {
      entry.pool.resize(width, height);
      entry.width = width;
      entry.height = height;
      pools.push(entry);
      return { pool: entry.pool, release };
    }
    const pool = new CanvasPool(width, height, (canvas) => {
      const errors = [];
      for (const listener of [...listeners3]) {
        try {
          listener(canvas);
        } catch (error) {
          errors.push(error);
        }
      }
      if (pool.owns(canvas)) {
        cleanupWithSharedWebGLPool(() => pool.retireWebGL(canvas));
      }
      if (errors.length === 1)
        throw errors[0];
      if (errors.length > 1)
        throw new AggregateError(errors, "Shared WebGL invalidation failed");
    });
    pools.push({ pool, width, height });
    return { pool, release };
  } catch (error) {
    release();
    throw error;
  }
};

// src/effects/run-effect-chain.ts
var cleanupEntries = (entries) => {
  const errors = [];
  for (const entry of entries) {
    try {
      entry.definition.cleanup(entry.state);
    } catch (error) {
      errors.push(error);
    }
  }
  if (errors.length === 1)
    throw errors[0];
  if (errors.length > 1)
    throw new AggregateError(errors, "Effect cleanup failed");
};
var disposeEffectChainState = (state) => {
  const entries = state.cleanupRegistry;
  state.cleanupRegistry = [];
  state.setupCache = new WeakMap;
  try {
    cleanupEntries(entries);
  } finally {
    try {
      state.unsubscribeWebGL?.();
      state.unsubscribeWebGL = null;
      state.webglPool = null;
      state.requestRedraw = null;
    } finally {
      state.pool.dispose();
    }
  }
};
var createEffectChainState = (width, height) => {
  const state = {
    width,
    height,
    preferredEffectBackend: typeof window === "undefined" ? "auto" : window.remotion_preferredEffectBackend ?? "auto",
    gpuDevice: null,
    selections: new WeakMap,
    pool: new CanvasPool(width, height, () => {
      return;
    }),
    webglPool: null,
    releaseWebGL: null,
    unsubscribeWebGL: null,
    webglGeneration: 0,
    lastLostWebGLCanvas: null,
    requestRedraw: null,
    onWebGLContextLost: (canvas) => {
      const dead = state.cleanupRegistry.filter((entry) => entry.target === canvas);
      if (dead.length === 0 && !(state.releaseWebGL && state.webglPool?.owns(canvas)))
        return;
      state.webglGeneration++;
      state.lastLostWebGLCanvas = canvas;
      state.cleanupRegistry = state.cleanupRegistry.filter((entry) => entry.target !== canvas);
      for (const entry of dead) {
        state.setupCache.get(entry.definition)?.delete(canvas);
      }
      try {
        cleanupEntries(dead);
      } finally {
        if (!state.pendingRun && !state.cleanupRequested)
          state.requestRedraw?.();
      }
    },
    setupCache: new WeakMap,
    cleanupRegistry: [],
    currentRunId: 0,
    pendingRun: null,
    cleanupRequested: false
  };
  return state;
};
var cleanupEffectChainState = (state) => {
  if (state.cleanupRequested)
    return;
  state.cleanupRequested = true;
  state.currentRunId++;
  invalidateEffectChainSources(state);
  if (!state.pendingRun) {
    if (state.webglPool) {
      cleanupWithSharedWebGLPool(() => disposeEffectChainState(state));
    } else {
      disposeEffectChainState(state);
    }
  }
};
var ensureSetup = (state, def, target, backend) => {
  const widened = def;
  let cacheForDefinition = state.setupCache.get(widened);
  if (!cacheForDefinition) {
    cacheForDefinition = new WeakMap;
    state.setupCache.set(widened, cacheForDefinition);
  }
  if (cacheForDefinition.has(target)) {
    return cacheForDefinition.get(target);
  }
  if (backend === "webgl2")
    state.webglPool.prepareWebGL(target, false);
  let setupState;
  try {
    setupState = def.setup(target);
  } catch (error) {
    if (backend === "webgl2") {
      state.webglPool.assertContextNotLost(target);
      try {
        state.webglPool.retireWebGL(target);
      } catch (cleanupError) {
        throw new AggregateError([error, cleanupError], "Effect setup and cleanup failed");
      }
    }
    throw error;
  }
  cacheForDefinition.set(target, setupState);
  state.cleanupRegistry.push({
    backend,
    definition: widened,
    state: setupState,
    target
  });
  return setupState;
};
var runEffectChainWithoutResize = async ({ state, source, output, width, height }, initialFlipSourceY, runId, {
  resolved,
  gpuDevice
}) => {
  const isCancelled = () => state.currentRunId !== runId;
  const { webglGeneration } = state;
  const assertWebGLValid = () => {
    if (!state.releaseWebGL)
      return;
    if (state.webglGeneration !== webglGeneration && state.lastLostWebGLCanvas) {
      throw new WebGLContextLostError(state.lastLostWebGLCanvas);
    }
    state.webglPool.assertWebGLContextsNotLost();
  };
  const runs = groupByBackend(resolved);
  let currentImage = source;
  let lastTarget = null;
  if (runs.length === 0) {
    if (source === output) {
      return true;
    }
    const ctx = output.getContext("2d");
    if (!ctx) {
      throw new Error("Failed to acquire 2D context for output canvas");
    }
    ctx.clearRect(0, 0, width, height);
    ctx.drawImage(currentImage, 0, 0, width, height);
    return true;
  }
  let flipWebGLSourceY = initialFlipSourceY;
  let bridgeBitmap = null;
  try {
    for (let runIndex = 0;runIndex < runs.length; runIndex++) {
      const run = runs[runIndex];
      let canvasIndex = 0;
      for (const eff of run.effects) {
        if (isCancelled())
          return false;
        const canvasPool = run.backend === "webgl2" ? state.webglPool : state.pool;
        const dst = canvasPool.getCanvas(run.backend, canvasIndex);
        const def = eff.implementation;
        const setupState = ensureSetup(state, def, dst, run.backend);
        if (isCancelled())
          return false;
        assertWebGLValid();
        publishEffectSource(eff.original, currentImage, state);
        if (isCancelled())
          return false;
        if (run.backend === "webgl2")
          canvasPool.prepareWebGL(dst, flipWebGLSourceY);
        def.apply({
          source: currentImage,
          target: dst,
          state: setupState,
          params: eff.params,
          width: state.width,
          height: state.height,
          gpuDevice,
          flipSourceY: run.backend === "webgl2" ? flipWebGLSourceY : false
        });
        if (run.backend === "webgl2")
          canvasPool.assertContextNotLost(dst);
        if (isCancelled())
          return false;
        bridgeBitmap?.close();
        bridgeBitmap = null;
        if (run.backend === "webgl2") {
          flipWebGLSourceY = true;
        }
        currentImage = dst;
        canvasIndex = canvasIndex === 0 ? 1 : 0;
      }
      lastTarget = currentImage ?? lastTarget;
      const nextRun = runs[runIndex + 1];
      if (nextRun && nextRun.backend !== run.backend && lastTarget) {
        if (run.backend === "2d" && nextRun.backend === "webgl2") {
          currentImage = lastTarget;
          flipWebGLSourceY = true;
        } else {
          bridgeBitmap = await createImageBitmap(lastTarget, {
            imageOrientation: nextRun.backend === "webgl2" ? "flipY" : "none"
          });
          if (isCancelled()) {
            return false;
          }
          assertWebGLValid();
          currentImage = bridgeBitmap;
          if (nextRun.backend === "webgl2") {
            flipWebGLSourceY = false;
          }
        }
      }
    }
  } finally {
    bridgeBitmap?.close();
  }
  if (isCancelled())
    return false;
  assertWebGLValid();
  if (!lastTarget) {
    return true;
  }
  const outCtx = output.getContext("2d");
  if (!outCtx) {
    throw new Error("Failed to acquire 2D context for output canvas");
  }
  outCtx.clearRect(0, 0, width, height);
  outCtx.drawImage(lastTarget, 0, 0, width, height);
  return true;
};
var runEffectChainWithResize = async (options, runId, allowBackendFallback) => {
  const { state, source, width, height, effects } = options;
  const order = ["webgpu", "webgl2", "2d"];
  if (state.preferredEffectBackend !== "auto") {
    order.splice(order.indexOf(state.preferredEffectBackend), 1);
    order.unshift(state.preferredEffectBackend);
  }
  const resolved = [];
  let gpuDevice = null;
  for (const effect of effects) {
    if (effect.params.disabled)
      continue;
    const implementations = effect.definition.implementations ?? {
      [effect.definition.backend]: effect.definition
    };
    let selected = false;
    const cached = state.selections.get(effect.definition);
    const candidates = cached === undefined ? order : [
      cached.backend,
      ...order.filter((backend) => backend !== cached.backend)
    ];
    for (const backend of candidates) {
      const implementation = implementations[backend];
      if (!implementation)
        continue;
      if (backend === "webgpu") {
        if (typeof window !== "undefined" && window.remotion_disableWebGpuEffects)
          continue;
        gpuDevice = await getGpuDevice();
        if (state.currentRunId !== runId)
          return false;
        if (!gpuDevice)
          continue;
        const { limits } = gpuDevice;
        if (limits && (state.width > limits.maxTextureDimension2D || state.height > limits.maxTextureDimension2D))
          continue;
      }
      if (backend === "webgl2" && !state.releaseWebGL) {
        state.unsubscribeWebGL ??= subscribeToSharedWebGLContextLoss(state.onWebGLContextLost);
        const lease = await acquireSharedWebGLPool(state.width, state.height);
        state.webglPool = lease.pool;
        state.releaseWebGL = lease.release;
        if (state.currentRunId !== runId)
          return false;
      }
      if (Object.keys(implementations).length > 1) {
        try {
          (backend === "webgl2" ? state.webglPool : state.pool).getCanvas(backend, 0);
        } catch (error) {
          if (!allowBackendFallback)
            throw error;
          continue;
        }
      }
      state.selections.set(effect.definition, { backend, implementation });
      resolved.push({
        definition: { backend },
        implementation,
        original: effect,
        params: effect.params
      });
      selected = true;
      break;
    }
    if (!selected)
      throw new Error(`No supported implementation for effect "${effect.definition.type}" (preferred backend: ${state.preferredEffectBackend})`);
  }
  const deviceChanged = gpuDevice !== state.gpuDevice;
  const activeImplementations = new Set(resolved.map((effect) => effect.implementation));
  let entries = state.cleanupRegistry.filter((entry) => deviceChanged || !activeImplementations.has(entry.definition));
  if (entries.length > 0) {
    const retiredWebGpuTargets = new Set(entries.filter((entry) => entry.backend === "webgpu").map((entry) => entry.target));
    if (retiredWebGpuTargets.size > 0) {
      entries = state.cleanupRegistry.filter((entry) => deviceChanged || !activeImplementations.has(entry.definition) || retiredWebGpuTargets.has(entry.target));
    }
    const retiredEntries = new Set(entries);
    state.cleanupRegistry = state.cleanupRegistry.filter((entry) => !retiredEntries.has(entry));
    for (const entry of entries) {
      state.setupCache.get(entry.definition)?.delete(entry.target);
    }
    if (state.webglPool && !state.releaseWebGL) {
      try {
        cleanupEntries(entries.filter((entry) => entry.backend !== "webgl2"));
      } finally {
        const webglEntries = entries.filter((entry) => entry.backend === "webgl2");
        if (webglEntries.length > 0) {
          cleanupWithSharedWebGLPool(() => cleanupEntries(webglEntries));
        }
      }
    } else {
      cleanupEntries(entries);
    }
  }
  state.gpuDevice = gpuDevice;
  if (state.currentRunId !== runId)
    return false;
  if (state.width === width && state.height === height || !effects.some((effect) => !effect.params.disabled)) {
    return runEffectChainWithoutResize(options, true, runId, {
      resolved,
      gpuDevice
    });
  }
  const firstEnabledEffect = resolved[0];
  const resized = await createImageBitmap(source, {
    resizeWidth: state.width,
    resizeHeight: state.height,
    imageOrientation: firstEnabledEffect.definition.backend === "webgl2" ? "flipY" : "none"
  });
  try {
    if (state.currentRunId !== runId) {
      return false;
    }
    return await runEffectChainWithoutResize({ ...options, source: resized }, false, runId, { resolved, gpuDevice });
  } finally {
    resized.close();
  }
};
var runEffectChain = async (options) => {
  const { state } = options;
  if (state.cleanupRequested) {
    throw new Error("Effect chain state was used after it had been cleaned up");
  }
  const runId = ++state.currentRunId;
  const previousRun = state.pendingRun;
  let release;
  const completion = new Promise((resolve) => {
    release = resolve;
  });
  state.pendingRun = completion;
  try {
    if (previousRun)
      await previousRun;
    if (state.currentRunId !== runId)
      return false;
    for (let attempt = 0;; attempt++) {
      try {
        return await runEffectChainWithResize(options, runId, attempt === 0);
      } catch (error) {
        if (state.currentRunId !== runId)
          return false;
        let failure = error;
        if (state.releaseWebGL) {
          try {
            state.webglPool.assertWebGLContextsNotLost();
          } catch (contextError) {
            failure = contextError;
          }
        }
        if (!(failure instanceof WebGLContextLostError) && !(attempt > 0 && failure instanceof WebGL2ContextCreationError))
          throw failure;
        if (attempt === 2) {
          if (failure instanceof WebGLContextLostError) {
            state.webglPool.retireWebGL(failure.canvas);
          }
          throw new Error("WebGL context was lost repeatedly while rendering effects. " + "Recovery failed after two retries. Try reducing rendering concurrency or GPU memory usage.", { cause: failure });
        }
        if (failure instanceof WebGLContextLostError) {
          state.webglPool.retireWebGL(failure.canvas);
        }
        await new Promise((resolve) => setTimeout(resolve, attempt * 50));
        if (state.currentRunId !== runId)
          return false;
      }
    }
  } finally {
    try {
      if (state.pendingRun === completion) {
        state.pendingRun = null;
        if (state.cleanupRequested)
          disposeEffectChainState(state);
      }
    } finally {
      try {
        const { releaseWebGL } = state;
        state.releaseWebGL = null;
        releaseWebGL?.();
      } finally {
        release();
      }
    }
  }
};

// src/effects/use-effect-chain-state.ts
import { useContext as useContext29, useEffect as useEffect7, useMemo as useMemo24, useRef as useRef9, useState as useState11 } from "react";

// src/effects/preferred-effect-backend.ts
import { createContext as createContext29 } from "react";

// src/effects/validate-preferred-effect-backend.ts
var validatePreferredEffectBackend = (value) => {
  if (value !== "auto" && value !== "webgpu" && value !== "webgl2" && value !== "2d") {
    throw new TypeError(`preferredEffectBackend must be "auto", "webgpu", "webgl2" or "2d", got ${String(value)}`);
  }
  return value;
};

// src/effects/preferred-effect-backend.ts
var PreferredEffectBackendContext = createContext29(null);

// src/effects/use-effect-chain-state.ts
var useEffectChainState = (effectsOutputSize = null) => {
  const preferredEffectBackend = validatePreferredEffectBackend(useContext29(PreferredEffectBackendContext) ?? (typeof window === "undefined" ? "auto" : window.remotion_preferredEffectBackend ?? "auto"));
  const effectWidth = effectsOutputSize?.width;
  const effectHeight = effectsOutputSize?.height;
  if (effectsOutputSize) {
    validateDimension(effectWidth, "effectsOutputSize.width", "on an effect-capable component");
    validateDimension(effectHeight, "effectsOutputSize.height", "on an effect-capable component");
  }
  const chainStateRef = useRef9(null);
  const sizeRef = useRef9(null);
  const unmountedRef = useRef9(false);
  const [recoveryRevision, setRecoveryRevision] = useState11(0);
  useEffect7(() => {
    unmountedRef.current = false;
    return () => {
      unmountedRef.current = true;
      if (chainStateRef.current) {
        cleanupEffectChainState(chainStateRef.current);
        chainStateRef.current = null;
        sizeRef.current = null;
      }
    };
  }, []);
  return useMemo24(() => ({
    recoveryRevision,
    get: (width, height) => {
      width = effectWidth ?? width;
      height = effectHeight ?? height;
      if (unmountedRef.current) {
        return null;
      }
      if (!sizeRef.current || sizeRef.current.width !== width || sizeRef.current.height !== height || chainStateRef.current?.preferredEffectBackend !== preferredEffectBackend) {
        if (chainStateRef.current) {
          cleanupEffectChainState(chainStateRef.current);
        }
        chainStateRef.current = createEffectChainState(width, height);
        chainStateRef.current.requestRedraw = () => {
          if (!unmountedRef.current)
            setRecoveryRevision((revision) => revision + 1);
        };
        chainStateRef.current.preferredEffectBackend = preferredEffectBackend;
        sizeRef.current = { width, height };
      }
      return chainStateRef.current;
    }
  }), [effectWidth, effectHeight, preferredEffectBackend, recoveryRevision]);
};

// src/animated-image/canvas.tsx
import { jsx as jsx19 } from "react/jsx-runtime";
var CanvasRefForwardingFunction = ({ width, height, fit, className, style, effects, effectsOutputSize, ...props }, ref) => {
  const canvasRef = useRef10(null);
  const chainState = useEffectChainState(effectsOutputSize);
  const lastDrawRef = useRef10(null);
  const drawCountRef = useRef10(0);
  const sourceCanvas = useMemo25(() => {
    if (typeof document === "undefined") {
      return null;
    }
    return document.createElement("canvas");
  }, []);
  const draw = useCallback7((imageData) => {
    const canvas = canvasRef.current;
    const canvasWidth = width ?? imageData.displayWidth;
    const canvasHeight = height ?? imageData.displayHeight;
    if (!canvas) {
      throw new Error("Canvas ref is not set");
    }
    if (!sourceCanvas) {
      throw new Error("Source canvas is not available");
    }
    const lastDraw = lastDrawRef.current;
    if (lastDraw && lastDraw.canvas === canvas && lastDraw.chainState === chainState && lastDraw.imageData === imageData && lastDraw.effects === effects && lastDraw.fit === fit && lastDraw.canvasWidth === canvasWidth && lastDraw.canvasHeight === canvasHeight) {
      return Promise.resolve(true);
    }
    lastDrawRef.current = null;
    const drawId = ++drawCountRef.current;
    sourceCanvas.width = canvasWidth;
    sourceCanvas.height = canvasHeight;
    const sourceCtx = sourceCanvas.getContext("2d");
    if (!sourceCtx) {
      throw new Error("Could not get 2d context for source canvas");
    }
    sourceCtx.drawImage(imageData, ...calculateImageFit(fit, {
      height: imageData.displayHeight,
      width: imageData.displayWidth
    }, {
      width: canvasWidth,
      height: canvasHeight
    }));
    canvas.width = canvasWidth;
    canvas.height = canvasHeight;
    return runEffectChain({
      state: chainState.get(canvasWidth, canvasHeight),
      source: sourceCanvas,
      effects,
      output: canvas,
      width: canvasWidth,
      height: canvasHeight
    }).then((completed) => {
      if (completed && drawCountRef.current === drawId) {
        lastDrawRef.current = {
          canvas,
          chainState,
          imageData,
          effects,
          fit,
          canvasWidth,
          canvasHeight
        };
      }
      return completed;
    });
  }, [chainState, effects, fit, height, sourceCanvas, width]);
  useEffect8(() => {
    const canvas = canvasRef.current;
    if (!canvas) {
      return;
    }
    const invalidate = () => {
      lastDrawRef.current = null;
      drawCountRef.current++;
    };
    canvas.addEventListener("contextrestored", invalidate);
    return () => {
      canvas.removeEventListener("contextrestored", invalidate);
    };
  }, []);
  useImperativeHandle(ref, () => {
    return {
      draw,
      getCanvas: () => {
        if (!canvasRef.current) {
          throw new Error("Canvas ref is not set");
        }
        return canvasRef.current;
      },
      clear: () => {
        const ctx = canvasRef.current?.getContext("2d");
        if (!ctx) {
          throw new Error("Could not get 2d context");
        }
        lastDrawRef.current = null;
        drawCountRef.current++;
        ctx.clearRect(0, 0, canvasRef.current.width, canvasRef.current.height);
      }
    };
  }, [draw]);
  return /* @__PURE__ */ jsx19("canvas", {
    ref: canvasRef,
    className,
    style,
    ...props
  });
};
var Canvas = React29.forwardRef(CanvasRefForwardingFunction);

// src/animated-image/create-image-decoder.ts
var createImageDecoder = async ({
  resolvedSrc,
  signal,
  requestInit,
  contentType
}) => {
  if (typeof ImageDecoder === "undefined") {
    throw new Error("Your browser does not support the WebCodecs ImageDecoder API.");
  }
  const response = await fetch(resolvedSrc, { ...requestInit, signal });
  const { body } = response;
  if (!body) {
    throw new Error("Got no body");
  }
  const decoder = new ImageDecoder({
    data: body,
    type: contentType ?? response.headers.get("Content-Type") ?? "image/gif"
  });
  await Promise.all([decoder.completed, decoder.tracks.ready]);
  const { selectedTrack } = decoder.tracks;
  if (!selectedTrack) {
    decoder.close();
    throw new Error("No selected track");
  }
  return { decoder, selectedTrack };
};

// src/animated-image/decode-image.ts
var CACHE_SIZE = 5;
var getActualTime = ({
  loopBehavior,
  durationFound,
  timeInSec
}) => {
  return loopBehavior === "loop" ? durationFound ? timeInSec % durationFound : timeInSec : Math.min(timeInSec, durationFound || Infinity);
};
var decodeImage = async ({
  resolvedSrc,
  signal,
  requestInit,
  currentTime,
  initialLoopBehavior
}) => {
  const { decoder, selectedTrack } = await createImageDecoder({
    resolvedSrc,
    signal,
    requestInit,
    contentType: null
  });
  const cache = [];
  let durationFound = null;
  const getFrameByIndex = async (frameIndex) => {
    const foundInCache = cache.find((c) => c.frameIndex === frameIndex);
    if (foundInCache && foundInCache.frame) {
      return foundInCache;
    }
    const frame = await decoder.decode({
      frameIndex,
      completeFramesOnly: true
    });
    if (foundInCache) {
      foundInCache.frame = frame.image;
    } else {
      cache.push({
        frame: frame.image,
        frameIndex,
        timeInSeconds: frame.image.timestamp / 1e6
      });
    }
    return {
      frame: frame.image,
      frameIndex,
      timeInSeconds: frame.image.timestamp / 1e6
    };
  };
  const clearCache = (closeToTimeInSec) => {
    const itemsInCache = cache.filter((c) => c.frame);
    const sortByClosestToCurrentTime = itemsInCache.sort((a, b) => {
      const aDiff = Math.abs(a.timeInSeconds - closeToTimeInSec);
      const bDiff = Math.abs(b.timeInSeconds - closeToTimeInSec);
      return aDiff - bDiff;
    });
    for (let i = 0;i < sortByClosestToCurrentTime.length; i++) {
      if (i < CACHE_SIZE) {
        continue;
      }
      const item = sortByClosestToCurrentTime[i];
      item.frame?.close();
      item.frame = null;
    }
  };
  const ensureFrameBeforeAndAfter = async ({
    timeInSec,
    loopBehavior
  }) => {
    const actualTimeInSec = getActualTime({
      durationFound,
      loopBehavior,
      timeInSec
    });
    const framesBefore = cache.filter((c) => c.timeInSeconds <= actualTimeInSec);
    const biggestIndex = framesBefore.map((c) => c.frameIndex).reduce((a, b) => Math.max(a, b), 0);
    let i = biggestIndex;
    while (true) {
      const f = await getFrameByIndex(i);
      i++;
      if (!f.frame) {
        throw new Error("No frame found");
      }
      if (!f.frame.duration) {
        break;
      }
      if (i === selectedTrack.frameCount && durationFound === null) {
        const duration = (f.frame.timestamp + f.frame.duration) / 1e6;
        durationFound = duration;
      }
      if (f.timeInSeconds > actualTimeInSec || i === selectedTrack.frameCount) {
        break;
      }
    }
    if (selectedTrack.frameCount - biggestIndex < 3 && loopBehavior === "loop") {
      await getFrameByIndex(0);
    }
    clearCache(actualTimeInSec);
  };
  await ensureFrameBeforeAndAfter({
    timeInSec: currentTime,
    loopBehavior: initialLoopBehavior
  });
  await ensureFrameBeforeAndAfter({
    timeInSec: currentTime,
    loopBehavior: initialLoopBehavior
  });
  const getFrame = async (timeInSec, loopBehavior) => {
    if (durationFound !== null && timeInSec > durationFound && loopBehavior === "clear-after-finish") {
      return null;
    }
    const actualTimeInSec = getActualTime({
      loopBehavior,
      durationFound,
      timeInSec
    });
    await ensureFrameBeforeAndAfter({ timeInSec: actualTimeInSec, loopBehavior });
    const itemsInCache = cache.filter((c) => c.frame);
    const closest = itemsInCache.reduce((a, b) => {
      const aDiff = Math.abs(a.timeInSeconds - actualTimeInSec);
      const bDiff = Math.abs(b.timeInSeconds - actualTimeInSec);
      return aDiff < bDiff ? a : b;
    });
    if (!closest.frame) {
      throw new Error("No frame found");
    }
    return closest;
  };
  return {
    close: () => {
      for (const item of cache) {
        item.frame?.close();
        item.frame = null;
      }
      decoder.close();
    },
    getFrame,
    frameCount: selectedTrack.frameCount
  };
};

// src/animated-image/get-current-time.ts
var getCurrentTime = ({
  frame,
  playbackRate,
  fps
}) => {
  return frame * playbackRate / fps;
};

// src/animated-image/get-duration-in-seconds.ts
var getAnimatedImageDurationInSeconds = async ({
  resolvedSrc,
  signal,
  requestInit,
  contentType
}) => {
  const { decoder, selectedTrack } = await createImageDecoder({
    resolvedSrc,
    signal,
    requestInit,
    contentType
  });
  try {
    const { image } = await decoder.decode({
      frameIndex: selectedTrack.frameCount - 1,
      completeFramesOnly: true
    });
    try {
      if (image.duration === null) {
        throw new Error("Could not determine animated image duration");
      }
      return (image.timestamp + image.duration) / 1e6;
    } finally {
      image.close();
    }
  } finally {
    decoder.close();
  }
};

// src/animated-image/request-init.ts
var serializeRequestInit = (requestInit) => {
  if (!requestInit) {
    return null;
  }
  const requestInitWithoutSignal = { ...requestInit };
  delete requestInitWithoutSignal.signal;
  const { headers, ...rest } = requestInitWithoutSignal;
  return JSON.stringify({
    ...rest,
    headers: headers ? Array.from(new Headers(headers).entries()) : null
  });
};

// src/animated-image/resolve-image-source.tsx
var resolveAnimatedImageSource = (src) => {
  if (typeof window === "undefined") {
    return src;
  }
  return new URL(src, document.baseURI).href;
};

// src/animated-image/AnimatedImage.tsx
import { jsx as jsx20 } from "react/jsx-runtime";
import { createElement } from "react";
var animatedImageSchema = {
  src: {
    type: "asset",
    assetType: "image",
    default: undefined,
    description: "Source",
    keyframable: false
  },
  ...baseSchema,
  loop: loopField,
  ...cropSchema,
  ...premountSchema,
  ...transformSchema,
  ...backgroundSchema,
  ...borderSchema,
  ...borderRadiusSchema
};
var AnimatedImageContent = forwardRef4(({
  src,
  width,
  height,
  onError,
  loopBehavior = "loop",
  playbackRate = 1,
  fit = "fill",
  requestInit,
  effects,
  effectsOutputSize,
  controls,
  ...props
}, canvasRef) => {
  const resolvedSrc = resolveAnimatedImageSource(src);
  const [decodedImage, setDecodedImage] = useState12(null);
  const imageDecoder = decodedImage?.decoder ?? null;
  const activeDecoderRef = useRef11(null);
  const { delayRender, continueRender, cancelRender } = useDelayRender();
  const frame = useCurrentFrame();
  const { fps } = useVideoConfig();
  const currentTime = getCurrentTime({ frame, playbackRate, fps });
  const currentTimeRef = useRef11(currentTime);
  currentTimeRef.current = currentTime;
  const requestInitKey = serializeRequestInit(requestInit);
  const requestInitRef = useRef11(requestInit);
  requestInitRef.current = requestInit;
  const ref = useRef11(null);
  const memoizedEffects = useMemoizedEffects({
    effects,
    overrideId: controls?.overrideId ?? null,
    videoConfigValues: controls?.videoConfigValues ?? null
  });
  useImperativeHandle2(canvasRef, () => {
    const c = ref.current?.getCanvas();
    if (!c) {
      throw new Error("Canvas ref is not set");
    }
    return c;
  }, []);
  const [initialLoopBehavior] = useState12(() => loopBehavior);
  useLayoutEffect10(() => {
    const decodeHandle = delayRender(`Rendering <AnimatedImage/> with src="${resolvedSrc}"`);
    const controller = new AbortController;
    let cancelled = false;
    let continued = false;
    let decoder = null;
    const continueRenderOnce = () => {
      if (continued) {
        return;
      }
      continued = true;
      continueRender(decodeHandle);
    };
    decodeImage({
      resolvedSrc,
      signal: controller.signal,
      requestInit: requestInitRef.current,
      currentTime: currentTimeRef.current,
      initialLoopBehavior
    }).then((d) => {
      if (cancelled) {
        d.close();
        return;
      }
      decoder = d;
      activeDecoderRef.current = d;
      setDecodedImage({ decoder: d, handle: decodeHandle });
    }).catch((err) => {
      if (cancelled) {
        return;
      }
      if (err.name === "AbortError") {
        continueRenderOnce();
        return;
      }
      if (onError) {
        onError?.(err);
        continueRenderOnce();
      } else {
        cancelRender(err);
      }
    });
    return () => {
      cancelled = true;
      activeDecoderRef.current = null;
      decoder?.close();
      controller.abort();
      continueRenderOnce();
    };
  }, [
    resolvedSrc,
    onError,
    requestInitKey,
    initialLoopBehavior,
    continueRender,
    delayRender,
    cancelRender
  ]);
  useLayoutEffect10(() => {
    if (!imageDecoder || !decodedImage || activeDecoderRef.current !== imageDecoder) {
      return;
    }
    const delay = delayRender(`Rendering frame at ${currentTime} of <AnimatedImage src="${src}"/>`);
    continueRender(decodedImage.handle);
    let cancelled = false;
    imageDecoder.getFrame(currentTime, loopBehavior).then(async (videoFrame) => {
      if (cancelled) {
        return;
      }
      if (videoFrame === null) {
        ref.current?.clear();
        continueRender(delay);
        return;
      }
      const completed = await ref.current?.draw(videoFrame.frame);
      if (completed && !cancelled) {
        continueRender(delay);
      }
    }).catch((err) => {
      if (cancelled) {
        return;
      }
      if (onError) {
        onError(err);
        continueRender(delay);
      } else {
        cancelRender(err);
      }
    });
    return () => {
      cancelled = true;
      continueRender(delay);
    };
  }, [
    currentTime,
    imageDecoder,
    decodedImage,
    loopBehavior,
    onError,
    src,
    continueRender,
    delayRender,
    memoizedEffects,
    fit,
    width,
    height,
    cancelRender,
    effectsOutputSize?.width,
    effectsOutputSize?.height
  ]);
  return /* @__PURE__ */ jsx20(Canvas, {
    ref,
    width,
    height,
    fit,
    effects: memoizedEffects,
    effectsOutputSize: effectsOutputSize ?? null,
    ...props
  });
});
AnimatedImageContent.displayName = "AnimatedImageContent";
var AnimatedImageInner = ({
  src,
  width,
  height,
  onError,
  fit,
  playbackRate,
  loopBehavior,
  id,
  className,
  style,
  durationInFrames,
  from,
  premountFor,
  postmountFor,
  styleWhilePremounted,
  styleWhilePostmounted,
  cropLeft,
  cropRight,
  cropTop,
  cropBottom,
  requestInit,
  effects = [],
  effectsOutputSize,
  controls,
  ref,
  ...sequenceProps
}) => {
  const actualRef = useRef11(null);
  const isMedia = useMemo26(() => ({
    type: "image",
    src: resolveAnimatedImageSource(src),
    animated: {
      loopBehavior: loopBehavior ?? "loop",
      requestInit: requestInit ?? null
    }
  }), [src, loopBehavior, requestInit]);
  const memoizedEffectDefinitions = useMemoizedEffectDefinitions(effects);
  useImperativeHandle2(ref, () => {
    return actualRef.current;
  }, []);
  const {
    effectivePostmountFor,
    effectivePremountFor,
    freezeFrame,
    isPremountingOrPostmounting,
    postmountingActive,
    premountingActive,
    premountingStyle
  } = usePremounting({
    from: from ?? 0,
    durationInFrames: resolveSequenceDuration({
      durationInFrames,
      playbackRate,
      loop: sequenceProps.loop
    }),
    premountFor: premountFor ?? null,
    postmountFor: postmountFor ?? null,
    style: style ?? null,
    styleWhilePremounted: styleWhilePremounted ?? null,
    styleWhilePostmounted: styleWhilePostmounted ?? null,
    hideWhilePremounted: "display-none"
  });
  const croppedStyle = useCropStyle({
    cropLeft,
    cropRight,
    cropTop,
    cropBottom,
    style: premountingStyle,
    componentName: "<AnimatedImage />"
  });
  const canvasProps = getCanvasPropsFromSequenceProps(sequenceProps);
  const animatedImageProps = {
    src,
    width,
    height,
    onError,
    fit,
    loopBehavior,
    id,
    className,
    style: croppedStyle ?? undefined,
    requestInit,
    ...canvasProps
  };
  return /* @__PURE__ */ jsx20(Freeze, {
    frame: freezeFrame,
    active: isPremountingOrPostmounting,
    _remotionInternalIsPremounting: premountingActive,
    children: /* @__PURE__ */ jsx20(Sequence, {
      layout: "none",
      from: from ?? 0,
      playbackRate,
      durationInFrames,
      name: "<AnimatedImage>",
      _remotionInternalDocumentationLink: "https://www.remotion.dev/docs/animatedimage",
      controls,
      _remotionInternalEffects: memoizedEffectDefinitions,
      _remotionInternalPremountDisplay: effectivePremountFor || null,
      _remotionInternalPostmountDisplay: effectivePostmountFor || null,
      _remotionInternalIsPremounting: premountingActive,
      _remotionInternalIsPostmounting: postmountingActive,
      _remotionInternalIsMedia: isMedia,
      ...sequenceProps,
      children: /* @__PURE__ */ jsx20(SequenceContent, {
        children: /* @__PURE__ */ jsx20(AnimatedImageContent, {
          ...animatedImageProps,
          ref: actualRef,
          effects,
          effectsOutputSize: effectsOutputSize ?? null,
          controls
        })
      })
    })
  });
};
var AnimatedImageWithIntrinsicDuration = (props) => {
  const { fps } = useVideoConfig();
  const { delayRender, continueRender, cancelRender } = useDelayRender();
  const { src, requestInit, trimBefore } = props;
  const requestInitRef = useRef11(requestInit);
  requestInitRef.current = requestInit;
  const onErrorRef = useRef11(props.onError);
  onErrorRef.current = props.onError;
  const [duration, setDuration] = useState12(null);
  const [failedHandle, setFailedHandle] = useState12(null);
  useLayoutEffect10(() => {
    const handle = delayRender(`Finding duration of <AnimatedImage src="${src}" />`);
    const controller = new AbortController;
    let cancelled = false;
    getAnimatedImageDurationInSeconds({
      resolvedSrc: resolveAnimatedImageSource(src),
      signal: controller.signal,
      requestInit: requestInitRef.current,
      contentType: null
    }).then((durationInSeconds) => {
      if (!cancelled) {
        setDuration({
          durationInFrames: Math.ceil(durationInSeconds * fps) - (trimBefore ?? 0),
          handle
        });
      }
    }).catch((error) => {
      if (cancelled) {
        return;
      }
      if (onErrorRef.current) {
        onErrorRef.current(error);
        setFailedHandle(handle);
      } else {
        cancelRender(error);
      }
    });
    return () => {
      cancelled = true;
      controller.abort();
      continueRender(handle);
    };
  }, [cancelRender, continueRender, delayRender, fps, src, trimBefore]);
  useLayoutEffect10(() => {
    if (duration !== null) {
      continueRender(duration.handle);
    }
    if (failedHandle !== null) {
      continueRender(failedHandle);
    }
  }, [continueRender, duration, failedHandle]);
  if (duration === null || failedHandle !== null) {
    return null;
  }
  return /* @__PURE__ */ jsx20(AnimatedImageInner, {
    ...props,
    durationInFrames: duration.durationInFrames
  });
};
var AnimatedImageComponent = (props) => {
  if (props.loop && props.durationInFrames === undefined) {
    const resolvedSrc = resolveAnimatedImageSource(props.src);
    const requestInitKey = serializeRequestInit(props.requestInit);
    return /* @__PURE__ */ createElement(AnimatedImageWithIntrinsicDuration, {
      ...props,
      key: `${resolvedSrc}-${requestInitKey}-${props.trimBefore ?? 0}`
    });
  }
  return /* @__PURE__ */ jsx20(AnimatedImageInner, {
    ...props
  });
};
var AnimatedImage = withInteractivitySchema({
  Component: AnimatedImageComponent,
  componentName: "<AnimatedImage>",
  componentIdentity: "dev.remotion.remotion.AnimatedImage",
  schema: animatedImageSchema,
  supportsEffects: true
});
AnimatedImage.displayName = "AnimatedImage";
addSequenceStackTraces(AnimatedImage);
// src/effects/create-effect.ts
var disabledEffectField = {
  type: "boolean",
  default: false,
  description: "Disabled"
};
var createEffectImplementation = (implementation) => {
  return implementation;
};
var createEffect = (input) => {
  const backend = "backend" in input ? input.backend : ["webgpu", "webgl2", "2d"].find((b) => input.implementations[b]);
  if (!backend)
    throw new Error(`Effect "${input.type}" must provide at least one implementation`);
  const definition = "backend" in input ? input : {
    ...input,
    ...input.implementations[backend],
    backend
  };
  const { calculateKey: userCalculateKey, validateParams } = definition;
  const widened = {
    ...definition,
    documentationLink: definition.documentationLink ?? null,
    calculateKey: (params) => {
      const disabled = params.disabled ?? false;
      return `${userCalculateKey(params)}-disabled-${disabled}`;
    },
    schema: {
      disabled: disabledEffectField,
      ...definition.schema
    }
  };
  const factory = (params = {}) => {
    validateParams(params);
    return {
      definition: widened,
      params,
      effectKey: widened.calculateKey(params),
      memoized: false
    };
  };
  return factory;
};
// src/Artifact.tsx
import { useContext as useContext30, useLayoutEffect as useLayoutEffect12, useState as useState14 } from "react";

// src/RenderAssetManager.tsx
import {
  createContext as createContext30,
  useCallback as useCallback8,
  useImperativeHandle as useImperativeHandle3,
  useLayoutEffect as useLayoutEffect11,
  useMemo as useMemo27,
  useRef as useRef12,
  useState as useState13
} from "react";

// src/validation/validate-artifact.ts
var validateArtifactFilename = (filename) => {
  if (typeof filename !== "string") {
    throw new TypeError(`The "filename" must be a string, but you passed a value of type ${typeof filename}`);
  }
  if (filename.trim() === "") {
    throw new Error("The `filename` must not be empty");
  }
  if (!filename.match(/^([0-9a-zA-Z-!_.*'()/:&$@=;+,?]+)/g)) {
    throw new Error('The `filename` must match "/^([0-9a-zA-Z-!_.*\'()/:&$@=;+,?]+)/g". Use forward slashes only, even on Windows.');
  }
};
var validateContent = (content) => {
  if (typeof content !== "string" && !(content instanceof Uint8Array)) {
    throw new TypeError(`The "content" must be a string or Uint8Array, but you passed a value of type ${typeof content}`);
  }
  if (typeof content === "string" && content.trim() === "") {
    throw new Error("The `content` must not be empty");
  }
};
var validateRenderAsset = (artifact) => {
  if (artifact.type !== "artifact") {
    return;
  }
  validateArtifactFilename(artifact.filename);
  if (artifact.contentType === "thumbnail") {
    return;
  }
  validateContent(artifact.content);
};

// src/RenderAssetManager.tsx
import { jsx as jsx21 } from "react/jsx-runtime";
var RenderAssetManager = createContext30({
  registerRenderAsset: () => {
    return;
  },
  unregisterRenderAsset: () => {
    return;
  },
  renderAssets: []
});
var RenderAssetManagerProvider = ({ children, collectAssets }) => {
  const [renderAssets, setRenderAssets] = useState13([]);
  const renderAssetsRef = useRef12([]);
  const registerRenderAsset = useCallback8((renderAsset) => {
    validateRenderAsset(renderAsset);
    renderAssetsRef.current = [...renderAssetsRef.current, renderAsset];
    setRenderAssets(renderAssetsRef.current);
  }, []);
  if (collectAssets) {
    useImperativeHandle3(collectAssets, () => {
      return {
        collectAssets: () => {
          const assets = renderAssetsRef.current;
          renderAssetsRef.current = [];
          setRenderAssets([]);
          return assets;
        }
      };
    }, []);
  }
  const unregisterRenderAsset = useCallback8((id) => {
    renderAssetsRef.current = renderAssetsRef.current.filter((a) => a.id !== id);
    setRenderAssets(renderAssetsRef.current);
  }, []);
  useLayoutEffect11(() => {
    if (typeof window !== "undefined") {
      window.remotion_collectAssets = () => {
        const assets = renderAssetsRef.current;
        renderAssetsRef.current = [];
        setRenderAssets([]);
        return assets;
      };
    }
  }, []);
  const contextValue = useMemo27(() => {
    return {
      registerRenderAsset,
      unregisterRenderAsset,
      renderAssets
    };
  }, [renderAssets, registerRenderAsset, unregisterRenderAsset]);
  return /* @__PURE__ */ jsx21(RenderAssetManager.Provider, {
    value: contextValue,
    children
  });
};

// src/Artifact.tsx
var ArtifactThumbnail = Symbol("Thumbnail");
var encodeBinaryArtifact = (bytes) => {
  if ("toBase64" in bytes && typeof bytes.toBase64 === "function") {
    return bytes.toBase64();
  }
  let binary = "";
  for (let offset = 0;offset < bytes.length; offset += 32768) {
    binary += String.fromCharCode(...bytes.subarray(offset, offset + 32768));
  }
  return btoa(binary);
};
var Artifact = ({ filename, content, downloadBehavior }) => {
  const { registerRenderAsset, unregisterRenderAsset } = useContext30(RenderAssetManager);
  const env = useRemotionEnvironment();
  const frame = useCurrentFrame();
  const [id] = useState14(() => {
    return String(Math.random());
  });
  useLayoutEffect12(() => {
    if (!env.isRendering) {
      return;
    }
    if (content instanceof Uint8Array) {
      registerRenderAsset({
        type: "artifact",
        id,
        content: encodeBinaryArtifact(content),
        filename,
        frame,
        contentType: "binary",
        downloadBehavior: downloadBehavior ?? null
      });
    } else if (content === ArtifactThumbnail) {
      registerRenderAsset({
        type: "artifact",
        id,
        filename,
        frame,
        contentType: "thumbnail",
        downloadBehavior: downloadBehavior ?? null
      });
    } else {
      registerRenderAsset({
        type: "artifact",
        id,
        content,
        filename,
        frame,
        contentType: "text",
        downloadBehavior: downloadBehavior ?? null
      });
    }
    return () => {
      return unregisterRenderAsset(id);
    };
  }, [
    content,
    env.isRendering,
    filename,
    frame,
    id,
    registerRenderAsset,
    unregisterRenderAsset,
    downloadBehavior
  ]);
  return null;
};
Artifact.Thumbnail = ArtifactThumbnail;
// src/audio/html5-audio.tsx
import { forwardRef as forwardRef7, useCallback as useCallback16, useContext as useContext45, useMemo as useMemo39 } from "react";

// src/absolute-src.ts
var getAbsoluteSrc = (relativeSrc) => {
  if (typeof window === "undefined") {
    return relativeSrc;
  }
  if (relativeSrc.startsWith("http://") || relativeSrc.startsWith("https://") || relativeSrc.startsWith("file://") || relativeSrc.startsWith("blob:") || relativeSrc.startsWith("data:")) {
    return relativeSrc;
  }
  return new URL(relativeSrc, document.baseURI).href;
};

// src/calculate-media-duration.ts
var calculateMediaDuration = ({
  trimAfter,
  mediaDurationInFrames,
  playbackRate,
  trimBefore
}) => {
  let duration = mediaDurationInFrames;
  if (typeof trimAfter !== "undefined") {
    duration = trimAfter;
  }
  if (typeof trimBefore !== "undefined") {
    duration -= trimBefore;
  }
  return duration / playbackRate;
};
var getMediaTrimAfter = ({
  durationInFrames,
  trimAfter,
  trimBefore
}) => {
  const durationAsTrimAfter = durationInFrames === undefined ? undefined : (trimBefore ?? 0) + durationInFrames;
  if (durationAsTrimAfter === undefined) {
    return trimAfter;
  }
  return trimAfter === undefined ? durationAsTrimAfter : Math.min(trimAfter, durationAsTrimAfter);
};

// src/loop/index.tsx
import React30, { createContext as createContext31, useContext as useContext31, useMemo as useMemo28 } from "react";
import { jsx as jsx22 } from "react/jsx-runtime";
var LoopTimelineContext = createContext31(null);
var useLoop = () => {
  return React30.useContext(LoopContext);
};
var Loop = ({
  durationInFrames,
  times = Infinity,
  children,
  name,
  showInTimeline,
  playbackRate,
  ...props
}) => {
  const currentFrame = useCurrentFrame();
  const { durationInFrames: compDuration } = useVideoConfig();
  const parentSequence = useContext31(SequenceContext);
  const parentPlaybackRate = parentSequence?.playbackRate ?? 1;
  const playbackRateValue = playbackRate ?? 1;
  const iterationDurationInFrames = durationInFrames / playbackRateValue;
  const loopStartFrame = parentSequence ? parentSequence.cumulatedFrom + parentSequence.relativeFrom : 0;
  const firstVisibleFrame = loopStartFrame - (parentSequence?.cumulatedNegativeFrom ?? 0) / parentPlaybackRate;
  const endFrame = loopStartFrame + Math.min(compDuration, iterationDurationInFrames * times) / parentPlaybackRate;
  validateDurationInFrames(durationInFrames, {
    component: "of the <Loop /> component",
    allowFloats: true
  });
  if (typeof times !== "number") {
    throw new TypeError(`You passed to "times" an argument of type ${typeof times}, but it must be a number.`);
  }
  if (times !== Infinity && times % 1 !== 0) {
    throw new TypeError(`The "times" prop of a loop must be an integer, but got ${times}.`);
  }
  if (times < 0) {
    throw new TypeError(`The "times" prop of a loop must be at least 0, but got ${times}`);
  }
  const maxTimes = Math.ceil(compDuration / iterationDurationInFrames);
  const actualTimes = Math.min(maxTimes, times);
  const maxFrame = iterationDurationInFrames * (actualTimes - 1);
  const loopsElapsed = currentFrame / iterationDurationInFrames;
  const nearestIteration = Math.round(loopsElapsed);
  const isAtBoundary = Math.abs(loopsElapsed - nearestIteration) <= Number.EPSILON * Math.max(1, Math.abs(loopsElapsed)) * 4;
  const iteration = Math.max(0, Math.min(actualTimes - 1, isAtBoundary ? nearestIteration : Math.floor(loopsElapsed)));
  const start = isAtBoundary ? currentFrame : iteration * iterationDurationInFrames;
  const from = Math.max(0, Math.min(start, maxFrame));
  const loopDisplay = useMemo28(() => {
    return {
      numberOfTimes: Math.min(compDuration / iterationDurationInFrames, times),
      startOffset: -from,
      durationInFrames: iterationDurationInFrames
    };
  }, [compDuration, from, iterationDurationInFrames, times]);
  const loopContext = useMemo28(() => {
    return {
      iteration,
      durationInFrames
    };
  }, [iteration, durationInFrames]);
  const timelineContext = useMemo28(() => ({
    startFrame: loopStartFrame,
    firstVisibleFrame,
    endFrame,
    playbackRate: parentPlaybackRate
  }), [loopStartFrame, firstVisibleFrame, endFrame, parentPlaybackRate]);
  if (actualTimes === 0) {
    return null;
  }
  return /* @__PURE__ */ jsx22(LoopTimelineContext.Provider, {
    value: timelineContext,
    children: /* @__PURE__ */ jsx22(LoopContext.Provider, {
      value: loopContext,
      children: /* @__PURE__ */ jsx22(Sequence, {
        durationInFrames,
        from,
        name: name ?? "<Loop>",
        _remotionInternalDocumentationLink: "https://www.remotion.dev/docs/loop",
        _remotionInternalLoopDisplay: loopDisplay,
        ...props,
        showInTimeline,
        playbackRate,
        children
      })
    })
  });
};
Loop.useLoop = useLoop;

// src/prefetch.ts
import { useContext as useContext32 } from "react";

// src/playback-logging.ts
var playbackLogging = ({
  logLevel,
  tag,
  message,
  mountTime
}) => {
  const tags = [mountTime ? Date.now() - mountTime + "ms " : null, tag].filter(Boolean).join(" ");
  Log.trace({ logLevel, tag: null }, `[${tags}]`, message);
};

// src/prefetch-state.tsx
import { createContext as createContext32, useEffect as useEffect9, useState as useState15 } from "react";
import { jsx as jsx23 } from "react/jsx-runtime";
var PreloadContext = createContext32({});
var preloads = {};
var updaters = [];
var setPreloads = (updater) => {
  preloads = updater(preloads);
  updaters.forEach((u) => u());
};
var PrefetchProvider = ({ children }) => {
  const [_preloads, _setPreloads] = useState15(() => preloads);
  useEffect9(() => {
    const updaterFunction = () => {
      _setPreloads(preloads);
    };
    updaters.push(updaterFunction);
    return () => {
      updaters = updaters.filter((u) => u !== updaterFunction);
    };
  }, []);
  return /* @__PURE__ */ jsx23(PreloadContext.Provider, {
    value: _preloads,
    children
  });
};

// src/prefetch.ts
var removeAndGetHashFragment = (src) => {
  const hashIndex = src.indexOf("#");
  if (hashIndex === -1) {
    return null;
  }
  return hashIndex;
};
var getSrcWithoutHash = (src) => {
  const hashIndex = removeAndGetHashFragment(src);
  if (hashIndex === null) {
    return src;
  }
  return src.slice(0, hashIndex);
};
var usePreload = (src) => {
  const preloads = useContext32(PreloadContext);
  const hashFragmentIndex = removeAndGetHashFragment(src);
  const withoutHashFragment = getSrcWithoutHash(src);
  if (!preloads[withoutHashFragment]) {
    return src;
  }
  if (hashFragmentIndex !== null) {
    return preloads[withoutHashFragment] + src.slice(hashFragmentIndex);
  }
  return preloads[withoutHashFragment];
};
var activePrefetches = new Map;
var blobToBase64 = function(blob) {
  const reader = new FileReader;
  return new Promise((resolve, reject) => {
    reader.onload = function() {
      const dataUrl = reader.result;
      resolve(dataUrl);
    };
    reader.onerror = (err) => {
      return reject(err);
    };
    reader.readAsDataURL(blob);
  });
};
var getBlobFromReader = async ({
  reader,
  contentType,
  contentLength,
  onProgress
}) => {
  let receivedLength = 0;
  const chunks = [];
  while (true) {
    const { done, value } = await reader.read();
    if (done) {
      break;
    }
    chunks.push(value);
    receivedLength += value.length;
    if (onProgress) {
      onProgress({ loadedBytes: receivedLength, totalBytes: contentLength });
    }
  }
  const chunksAll = new Uint8Array(receivedLength);
  let position = 0;
  for (const chunk of chunks) {
    chunksAll.set(chunk, position);
    position += chunk.length;
  }
  return new Blob([chunksAll], {
    type: contentType ?? undefined
  });
};
var prefetch = (src, options) => {
  const method = options?.method ?? "blob-url";
  const logLevel = options?.logLevel ?? "info";
  const srcWithoutHash = getSrcWithoutHash(src);
  if (getRemotionEnvironment().isRendering) {
    return {
      free: () => {
        return;
      },
      waitUntilDone: () => Promise.resolve(srcWithoutHash)
    };
  }
  Log.verbose({ logLevel, tag: "prefetch" }, `Starting prefetch ${srcWithoutHash}`);
  let canceled = false;
  let objectUrl = null;
  let resolve = () => {
    return;
  };
  let reject = () => {
    return;
  };
  const waitUntilDone = new Promise((res, rej) => {
    resolve = res;
    reject = rej;
  });
  waitUntilDone.catch(() => {
    return;
  });
  const controller = new AbortController;
  const prefetchId = Symbol("prefetch");
  let reader = null;
  fetch(srcWithoutHash, {
    signal: controller.signal,
    credentials: options?.credentials ?? undefined
  }).then((res) => {
    if (canceled) {
      return null;
    }
    if (!res.ok) {
      throw new Error(`HTTP error, status = ${res.status}`);
    }
    const headerContentType = res.headers.get("Content-Type");
    const contentType = options?.contentType ?? headerContentType;
    const hasProperContentType = contentType && (contentType.startsWith("video/") || contentType.startsWith("audio/") || contentType.startsWith("image/"));
    if (!hasProperContentType) {
      console.warn(`Called prefetch() on ${srcWithoutHash} which returned a "Content-Type" of ${headerContentType}. Prefetched content should have a proper content type (video/... or audio/...) or a contentType passed the options of prefetch(). Otherwise, prefetching will not work properly in all browsers.`);
    }
    if (!res.body) {
      throw new Error(`HTTP response of ${srcWithoutHash} has no body`);
    }
    const responseReader = res.body.getReader();
    reader = responseReader;
    return getBlobFromReader({
      reader: responseReader,
      contentType: options?.contentType ?? headerContentType ?? null,
      contentLength: res.headers.get("Content-Length") ? parseInt(res.headers.get("Content-Length"), 10) : null,
      onProgress: options?.onProgress
    });
  }).then((buf) => {
    if (!buf || canceled) {
      return;
    }
    const actualBlob = options?.contentType ? new Blob([buf], { type: options.contentType }) : buf;
    if (method === "base64") {
      return blobToBase64(actualBlob);
    }
    return URL.createObjectURL(actualBlob);
  }).then((url) => {
    if (canceled) {
      if (url && method === "blob-url") {
        URL.revokeObjectURL(url);
      }
      return;
    }
    playbackLogging({
      logLevel,
      tag: "prefetch",
      message: `Finished prefetch ${srcWithoutHash} with method ${method}`,
      mountTime: null
    });
    objectUrl = url;
    const prefetchesForSrc = activePrefetches.get(srcWithoutHash) ?? new Map;
    prefetchesForSrc.set(prefetchId, objectUrl);
    activePrefetches.set(srcWithoutHash, prefetchesForSrc);
    setPreloads((p) => ({
      ...p,
      [srcWithoutHash]: objectUrl
    }));
    resolve(objectUrl);
  }).catch((err) => {
    if (err?.message.includes("free() called")) {
      return;
    }
    reject(err);
  });
  return {
    free: () => {
      if (canceled) {
        return;
      }
      canceled = true;
      playbackLogging({
        logLevel,
        tag: "prefetch",
        message: `Freeing ${srcWithoutHash}`,
        mountTime: null
      });
      if (objectUrl) {
        if (method === "blob-url") {
          URL.revokeObjectURL(objectUrl);
        }
        const prefetchesForSrc = activePrefetches.get(srcWithoutHash);
        prefetchesForSrc?.delete(prefetchId);
        const remainingUrl = prefetchesForSrc ? [...prefetchesForSrc.values()].pop() : undefined;
        if (prefetchesForSrc?.size === 0) {
          activePrefetches.delete(srcWithoutHash);
        }
        setPreloads((p) => {
          if (p[srcWithoutHash] === remainingUrl) {
            return p;
          }
          const copy = { ...p };
          if (remainingUrl === undefined) {
            delete copy[srcWithoutHash];
          } else {
            copy[srcWithoutHash] = remainingUrl;
          }
          return copy;
        });
      } else {
        const cancellationError = new Error("free() called");
        reject(cancellationError);
        try {
          controller.abort(cancellationError);
        } catch {}
        reader?.cancel(cancellationError).catch(() => {
          return;
        });
      }
    },
    waitUntilDone: () => {
      return waitUntilDone;
    }
  };
};

// src/validate-media-props.ts
var validateMediaProps = (props, component) => {
  if (typeof props.volume !== "number" && typeof props.volume !== "function" && typeof props.volume !== "undefined") {
    throw new TypeError(`You have passed a volume of type ${typeof props.volume} to your <${component} /> component. Volume must be a number or a function with the signature '(frame: number) => number' undefined.`);
  }
  if (typeof props.volume === "number" && props.volume < 0) {
    throw new TypeError(`You have passed a volume below 0 to your <${component} /> component. Volume must be between 0 and 1`);
  }
  if (typeof props.playbackRate !== "number" && typeof props.playbackRate !== "undefined") {
    throw new TypeError(`You have passed a playbackRate of type ${typeof props.playbackRate} to your <${component} /> component. Playback rate must a real number or undefined.`);
  }
  if (typeof props.playbackRate === "number" && (isNaN(props.playbackRate) || !Number.isFinite(props.playbackRate) || props.playbackRate <= 0)) {
    throw new TypeError(`You have passed a playbackRate of ${props.playbackRate} to your <${component} /> component. Playback rate must be a real number above 0.`);
  }
  if (typeof props.preservePitch !== "boolean" && typeof props.preservePitch !== "undefined") {
    throw new TypeError(`'preservePitch' must be a boolean or undefined but got '${typeof props.preservePitch}' instead`);
  }
};

// src/validate-start-from-props.ts
var validateStartFromProps = (startFrom, endAt) => {
  if (typeof startFrom !== "undefined") {
    if (typeof startFrom !== "number") {
      throw new TypeError(`type of startFrom prop must be a number, instead got type ${typeof startFrom}.`);
    }
    if (isNaN(startFrom) || startFrom === Infinity) {
      throw new TypeError("startFrom prop can not be NaN or Infinity.");
    }
    if (startFrom < 0) {
      throw new TypeError(`startFrom must be greater than equal to 0 instead got ${startFrom}.`);
    }
  }
  if (typeof endAt !== "undefined") {
    if (typeof endAt !== "number") {
      throw new TypeError(`type of endAt prop must be a number, instead got type ${typeof endAt}.`);
    }
    if (isNaN(endAt)) {
      throw new TypeError("endAt prop can not be NaN.");
    }
    if (endAt <= 0) {
      throw new TypeError(`endAt must be a positive number, instead got ${endAt}.`);
    }
  }
  if (endAt < startFrom) {
    throw new TypeError("endAt prop must be greater than startFrom prop.");
  }
};
var validateTrimProps = (trimBefore, trimAfter) => {
  if (typeof trimBefore !== "undefined") {
    if (typeof trimBefore !== "number") {
      throw new TypeError(`type of trimBefore prop must be a number, instead got type ${typeof trimBefore}.`);
    }
    if (isNaN(trimBefore) || trimBefore === Infinity) {
      throw new TypeError("trimBefore prop can not be NaN or Infinity.");
    }
    if (trimBefore < 0) {
      throw new TypeError(`trimBefore must be greater than equal to 0 instead got ${trimBefore}.`);
    }
  }
  if (typeof trimAfter !== "undefined") {
    if (typeof trimAfter !== "number") {
      throw new TypeError(`type of trimAfter prop must be a number, instead got type ${typeof trimAfter}.`);
    }
    if (isNaN(trimAfter)) {
      throw new TypeError("trimAfter prop can not be NaN.");
    }
    if (trimAfter <= 0) {
      throw new TypeError(`trimAfter must be a positive number, instead got ${trimAfter}.`);
    }
  }
  if (trimAfter <= trimBefore) {
    throw new TypeError("trimAfter prop must be greater than trimBefore prop.");
  }
};
var validateMediaTrimProps = ({
  startFrom,
  endAt,
  trimBefore,
  trimAfter
}) => {
  if (typeof startFrom !== "undefined" && typeof trimBefore !== "undefined") {
    throw new TypeError("Cannot use both startFrom and trimBefore props. Use trimBefore instead as startFrom is deprecated.");
  }
  if (typeof endAt !== "undefined" && typeof trimAfter !== "undefined") {
    throw new TypeError("Cannot use both endAt and trimAfter props. Use trimAfter instead as endAt is deprecated.");
  }
  const hasNewProps = typeof trimBefore !== "undefined" || typeof trimAfter !== "undefined";
  const hasOldProps = typeof startFrom !== "undefined" || typeof endAt !== "undefined";
  if (hasNewProps) {
    validateTrimProps(trimBefore, trimAfter);
  } else if (hasOldProps) {
    validateStartFromProps(startFrom, endAt);
  }
};
var resolveTrimProps = ({
  startFrom,
  endAt,
  trimBefore,
  trimAfter
}) => {
  const trimBeforeValue = trimBefore ?? startFrom ?? undefined;
  const trimAfterValue = trimAfter ?? endAt ?? undefined;
  return { trimBeforeValue, trimAfterValue };
};

// src/video/duration-state.tsx
import { createContext as createContext33, useMemo as useMemo29, useReducer } from "react";
import { jsx as jsx24 } from "react/jsx-runtime";
var durationReducer = (state, action) => {
  switch (action.type) {
    case "got-duration": {
      const absoluteSrc = getAbsoluteSrc(action.src);
      if (state[absoluteSrc] === action.durationInSeconds) {
        return state;
      }
      return {
        ...state,
        [absoluteSrc]: action.durationInSeconds
      };
    }
    default:
      return state;
  }
};
var onMediaDuration = (setDurations, src, durationInSeconds) => {
  setDurations({ type: "got-duration", durationInSeconds, src });
};
var DurationsContext = createContext33({
  durations: {},
  setDurations: () => {
    throw new Error("context missing");
  }
});
var DurationsContextProvider = ({ children }) => {
  const [durations, setDurations] = useReducer(durationReducer, {});
  const value = useMemo29(() => {
    return {
      durations,
      setDurations
    };
  }, [durations]);
  return /* @__PURE__ */ jsx24(DurationsContext.Provider, {
    value,
    children
  });
};

// src/audio/AudioForPreview.tsx
import { useCallback as useCallback15 } from "react";
import React36, {
  forwardRef as forwardRef5,
  useContext as useContext42,
  useImperativeHandle as useImperativeHandle4,
  useMemo as useMemo36,
  useState as useState20
} from "react";

// src/get-cross-origin-value.ts
var getCrossOriginValue = ({
  crossOrigin,
  requestsVideoFrame,
  isClientSideRendering
}) => {
  if (crossOrigin !== undefined && crossOrigin !== null) {
    return crossOrigin;
  }
  if (isClientSideRendering) {
    return "anonymous";
  }
  if (requestsVideoFrame) {
    return "anonymous";
  }
  return;
};

// src/random.ts
function mulberry32(a) {
  let t = a + 1831565813;
  t = Math.imul(t ^ t >>> 15, t | 1);
  t ^= t + Math.imul(t ^ t >>> 7, t | 61);
  return ((t ^ t >>> 14) >>> 0) / 4294967296;
}
function hashCode(str) {
  let i = 0;
  let chr = 0;
  let hash = 0;
  for (i = 0;i < str.length; i++) {
    chr = str.charCodeAt(i);
    hash = (hash << 5) - hash + chr;
    hash |= 0;
  }
  return hash;
}
var random = (seed, dummy) => {
  if (dummy !== undefined) {
    throw new TypeError("random() takes only one argument");
  }
  if (seed === null) {
    return Math.random();
  }
  if (typeof seed === "string") {
    return mulberry32(hashCode(seed));
  }
  if (typeof seed === "number") {
    return mulberry32(seed * 10000000000);
  }
  throw new Error("random() argument must be a number or a string");
};

// src/use-amplification.ts
import { useContext as useContext34, useLayoutEffect as useLayoutEffect14, useRef as useRef16 } from "react";

// src/audio/shared-audio-tags.tsx
import React33, {
  createContext as createContext34,
  createRef as createRef2,
  useCallback as useCallback9,
  useContext as useContext33,
  useEffect as useEffect11,
  useLayoutEffect as useLayoutEffect13,
  useMemo as useMemo30,
  useRef as useRef14,
  useState as useState17
} from "react";

// src/play-and-handle-not-allowed-error.ts
var playAndHandleNotAllowedError = ({
  mediaRef,
  mediaType,
  onAutoPlayError,
  logLevel,
  mountTime,
  reason,
  isPlayer
}) => {
  const { current } = mediaRef;
  if (!current) {
    return;
  }
  playbackLogging({
    logLevel,
    tag: "play",
    message: `Attempting to play ${current.src}. Reason: ${reason}`,
    mountTime
  });
  const prom = current.play();
  if (!prom.catch) {
    return;
  }
  prom.catch((err) => {
    if (!current) {
      return;
    }
    if (err.message.includes("request was interrupted by a call to pause")) {
      return;
    }
    if (err.message.includes("The operation was aborted.")) {
      return;
    }
    if (err.message.includes("The fetching process for the media resource was aborted by the user agent")) {
      return;
    }
    if (err.message.includes("request was interrupted by a new load request")) {
      return;
    }
    if (err.message.includes("because the media was removed from the document")) {
      return;
    }
    if (err.message.includes("user didn't interact with the document") && current.muted) {
      return;
    }
    console.log(`Could not play ${mediaType} due to following error: `, err);
    if (!current.muted) {
      if (onAutoPlayError) {
        onAutoPlayError();
        return;
      }
      if (mediaType === "video" && isPlayer) {
        Log.info({ logLevel, tag: "<" + mediaType + ">" }, `The video will be muted and we'll retry playing it.`);
        Log.info({ logLevel, tag: "<" + mediaType + ">" }, "Use onAutoPlayError() to handle this error yourself.");
        current.muted = true;
        current.play();
      }
    }
  });
};

// src/audio/shared-element-source-node.ts
var makeSharedElementSourceNode = ({
  audioContext,
  ref
}) => {
  let connected = null;
  let disposed = false;
  let currentAudioContext = audioContext;
  return {
    setAudioContext: (newAudioContext) => {
      currentAudioContext = newAudioContext;
    },
    attemptToConnect: () => {
      if (disposed) {
        throw new Error("SharedElementSourceNode has been disposed");
      }
      if (!connected && ref.current && currentAudioContext) {
        const mediaElementSourceNode = currentAudioContext.createMediaElementSource(ref.current);
        connected = mediaElementSourceNode;
      }
    },
    get: () => {
      if (!connected) {
        throw new Error("Audio element not connected");
      }
      return connected;
    },
    cleanup: () => {
      if (connected) {
        connected.disconnect();
        connected = null;
      }
      disposed = true;
    }
  };
};

// src/audio/use-audio-context.ts
import { useEffect as useEffect10, useRef as useRef13, useState as useState16 } from "react";
var warned = false;
var warnOnce = (logLevel) => {
  if (warned) {
    return;
  }
  warned = true;
  if (typeof window !== "undefined") {
    Log.warn({ logLevel, tag: null }, "AudioContext is not supported in this browser");
  }
};
var useSingletonAudioContext = ({
  logLevel,
  latencyHint,
  audioEnabled,
  sampleRate
}) => {
  const env = useRemotionEnvironment();
  const initialSampleRate = useRef13(sampleRate);
  if (sampleRate !== initialSampleRate.current) {
    throw new Error(`Changing the AudioContext sample rate dynamically is not supported. The sample rate was initialized with ${initialSampleRate.current} Hz, but ${sampleRate} Hz was passed later.`);
  }
  const [context, setContext] = useState16(null);
  useEffect10(() => {
    if (env.isRendering) {
      setContext(null);
      return;
    }
    if (!audioEnabled) {
      setContext(null);
      return;
    }
    if (typeof AudioContext === "undefined") {
      warnOnce(logLevel);
      setContext(null);
      return;
    }
    const audioContext = new AudioContext({
      latencyHint,
      sampleRate
    });
    const gainNode = audioContext.createGain();
    gainNode.connect(audioContext.destination);
    Log.trace({ logLevel, tag: "audio" }, "Creating new audio context");
    audioContext.suspend();
    let transitionTarget = null;
    let transitionId = 0;
    let pendingResume = null;
    const getState = () => {
      const nativeState = audioContext.state;
      if (transitionTarget === "running" && nativeState !== "running") {
        return "suspended-to-running";
      }
      if (transitionTarget === "suspended" && nativeState !== "suspended") {
        return "running-to-suspended";
      }
      return nativeState;
    };
    const resume = () => {
      const id = ++transitionId;
      transitionTarget = "running";
      const promise = audioContext.resume();
      pendingResume = promise;
      return promise.finally(() => {
        if (pendingResume === promise) {
          pendingResume = null;
        }
        if (transitionId === id) {
          transitionTarget = null;
        }
      });
    };
    const suspend = () => {
      const id = ++transitionId;
      transitionTarget = "suspended";
      const promise = pendingResume ? pendingResume.catch(() => {}).then(() => {
        if (transitionId !== id) {
          return;
        }
        return audioContext.suspend();
      }) : audioContext.suspend();
      return promise.finally(() => {
        if (transitionId === id) {
          transitionTarget = null;
        }
      });
    };
    setContext({ audioContext, gainNode, getState, resume, suspend });
    return () => {
      transitionId++;
      transitionTarget = null;
      gainNode.disconnect(audioContext.destination);
      audioContext.close();
    };
  }, [logLevel, latencyHint, env.isRendering, audioEnabled, sampleRate]);
  return context;
};

// src/audio/wait-until-actually-resumed.ts
var RESUME_WAIT_TIMEOUT = 1000;
var waitUntilActuallyResumed = (audioContext, logLevel, signal, isAutoPlayAttempt) => {
  return new Promise((resolve) => {
    const startCurrentTime = audioContext.currentTime;
    const start = audioContext.getOutputTimestamp();
    const startOutputPerformanceTime = start.performanceTime;
    const startWallClock = performance.now();
    let animationFrame = null;
    let timeout = null;
    let settled = false;
    let onAbort = () => {
      return;
    };
    const finish = (result) => {
      if (settled) {
        return;
      }
      settled = true;
      if (animationFrame !== null) {
        cancelAnimationFrame(animationFrame);
      }
      if (timeout !== null) {
        clearTimeout(timeout);
      }
      signal.removeEventListener("abort", onAbort);
      resolve(result);
    };
    onAbort = () => finish("cancelled");
    const hasAudiblyStarted = (startPerformanceTime) => {
      const outputTimestamp = audioContext.getOutputTimestamp();
      return startPerformanceTime !== undefined && outputTimestamp.performanceTime !== undefined && outputTimestamp.performanceTime > startPerformanceTime && outputTimestamp.contextTime !== undefined && outputTimestamp.contextTime > startCurrentTime;
    };
    const check = () => {
      animationFrame = null;
      const { currentTime } = audioContext;
      const outputTimestamp = audioContext.getOutputTimestamp();
      const elapsedWallClock = performance.now() - startWallClock;
      if (hasAudiblyStarted(startOutputPerformanceTime)) {
        Log.verbose({ logLevel, tag: "audio" }, `waitUntilActuallyResumed: getOutputTimestamp.performanceTime advanced from ${startOutputPerformanceTime.toFixed(6)} to ${outputTimestamp.performanceTime?.toFixed(6)} after ${elapsedWallClock.toFixed(1)}ms. currentTime=${currentTime.toFixed(6)} (advanced by ${(currentTime - startCurrentTime).toFixed(6)}), getOutputTimestamp.performanceTime=${outputTimestamp.performanceTime?.toFixed(1) ?? "undefined"}`);
        finish("resumed");
        return;
      }
      animationFrame = requestAnimationFrame(check);
    };
    if (signal.aborted) {
      finish("cancelled");
      return;
    }
    signal.addEventListener("abort", onAbort, { once: true });
    if (isAutoPlayAttempt) {
      timeout = setTimeout(() => {
        if (hasAudiblyStarted(startOutputPerformanceTime)) {
          finish("resumed");
          return;
        }
        Log.warn({ logLevel, tag: "audio" }, "WARNING: You enabled autoPlay on an unmuted <Player /> and the browser did not allow the video to be started. Remotion muted the <Player /> so it can play. To properly handle this, either set the `muted` prop or remove the `autoPlay` prop");
        finish("failed");
      }, RESUME_WAIT_TIMEOUT);
    }
    animationFrame = requestAnimationFrame(check);
  });
};

// src/audio/shared-audio-tags.tsx
import { jsx as jsx25, jsxs as jsxs3 } from "react/jsx-runtime";
var EMPTY_AUDIO = "data:audio/mp3;base64,/+MYxAAJcAV8AAgAABn//////+/gQ5BAMA+D4Pg+BAQBAEAwD4Pg+D4EBAEAQDAPg++hYBH///hUFQVBUFREDQNHmf///////+MYxBUGkAGIMAAAAP/29Xt6lUxBTUUzLjEwMFVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVV/+MYxDUAAANIAAAAAFVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVV";
var useAudioContextLayoutEffect = typeof window === "undefined" ? useEffect11 : useLayoutEffect13;
var compareProps = (obj1, obj2) => {
  const keysA = Object.keys(obj1).sort();
  const keysB = Object.keys(obj2).sort();
  if (keysA.length !== keysB.length) {
    return false;
  }
  for (let i = 0;i < keysA.length; i++) {
    if (keysA[i] !== keysB[i]) {
      return false;
    }
    if (obj1[keysA[i]] !== obj2[keysB[i]]) {
      return false;
    }
  }
  return true;
};
var didPropChange = (key, newProp, prevProp) => {
  if (key === "src" && !prevProp.startsWith("data:") && !newProp.startsWith("data:")) {
    return new URL(prevProp, document.baseURI).toString() !== new URL(newProp, document.baseURI).toString();
  }
  if (prevProp === newProp) {
    return false;
  }
  return true;
};
var SharedAudioContext = createContext34(null);
var SharedAudioTagsContext = createContext34(null);
var shouldSaveForLater = (state) => {
  if (state === "suspended" || state === "running-to-suspended" || state === "interrupted") {
    return true;
  }
  if (state === "running" || state === "suspended-to-running") {
    return false;
  }
  throw new Error(`Unexpected audio context state: ${state}`);
};
var SharedAudioContextProvider = ({
  children,
  audioLatencyHint,
  audioEnabled,
  previewSampleRate,
  _experimentalKeepAudioContextAlive
}) => {
  const logLevel = useLogLevel();
  const env = useRemotionEnvironment();
  const sampleRate = previewSampleRate ?? 48000;
  const ctxAndGain = useSingletonAudioContext({
    logLevel,
    latencyHint: audioLatencyHint,
    audioEnabled,
    sampleRate
  });
  const audioContextIsPlayingEventually = useRef14(null);
  const playbackRequested = useRef14(false);
  const initialExperimentalKeepAudioContextAlive = useRef14(_experimentalKeepAudioContextAlive);
  if (initialExperimentalKeepAudioContextAlive.current !== _experimentalKeepAudioContextAlive) {
    throw new Error("`_experimentalKeepAudioContextAlive` cannot be changed dynamically.");
  }
  const isResuming = useRef14(null);
  const nextResumeAttemptId = useRef14(0);
  const nextResumeIsAutoPlayAttempt = useRef14(false);
  const audioSyncAnchor = useMemo30(() => ({ value: 0 }), []);
  const audioSyncAnchorListeners = useRef14([]);
  const audioSyncAnchorEmitter = useMemo30(() => {
    return {
      dispatch: (event) => {
        audioSyncAnchorListeners.current.forEach((l) => l(event));
      },
      subscribe: (listener) => {
        audioSyncAnchorListeners.current.push(listener);
        return {
          remove: () => {
            audioSyncAnchorListeners.current = audioSyncAnchorListeners.current.filter((l) => l !== listener);
          }
        };
      }
    };
  }, []);
  const prevEndTimes = useRef14({ scheduledEndTime: null, mediaEndTime: null });
  const nodesToResume = useRef14(new Map);
  const unscheduleAudioNode = useCallback9((node) => {
    return nodesToResume.current.delete(node);
  }, []);
  const scheduleAudioNode = useMemo30(() => {
    return ({
      node,
      mediaTimestamp,
      sourceOffset,
      scheduledTime,
      duration,
      offset,
      originalUnloopedMediaTimestamp
    }) => {
      if (!ctxAndGain) {
        throw new Error("Audio context not found");
      }
      const currentState = ctxAndGain.getState();
      if (currentState === "closed") {
        return {
          type: "not-started",
          reason: "audio context is closed"
        };
      }
      const saveForLater = shouldSaveForLater(currentState) || _experimentalKeepAudioContextAlive && audioContextIsPlayingEventually.current !== ctxAndGain.audioContext;
      if (duration > 0) {
        if (saveForLater) {
          nodesToResume.current.set(node, {
            scheduledTime,
            offset,
            duration
          });
        } else {
          node.start(scheduledTime, offset, duration);
        }
      }
      const scheduledEndTime = scheduledTime + duration / node.playbackRate.value;
      const mediaTime = mediaTimestamp + offset - sourceOffset;
      const mediaEndTime = mediaTime + duration;
      const latency = ctxAndGain.audioContext.baseLatency + ctxAndGain.audioContext.outputLatency;
      const timeDiff = scheduledTime - ctxAndGain.audioContext.currentTime;
      const prev = prevEndTimes.current;
      const scheduledMismatch = prev.scheduledEndTime !== null && Math.abs(scheduledTime - prev.scheduledEndTime) > 0.001;
      const mediaMismatch = prev.mediaEndTime !== null && Math.abs(mediaTime - prev.mediaEndTime) > 0.001;
      Log.verbose({ logLevel, tag: "audio-scheduling" }, "scheduled %c%s%c %s %c%s%c %s %c%s%c %s %s %s %s %s", scheduledMismatch ? "color: red; font-weight: bold" : "", scheduledTime.toFixed(4), "", scheduledEndTime.toFixed(4), mediaMismatch ? "color: red; font-weight: bold" : "", mediaTime.toFixed(4), "", mediaEndTime.toFixed(4), duration < 0 ? "color: red; font-weight: bold" : timeDiff < 0 ? "color: red; font-weight: bold" : "color: blue; font-weight: bold", duration < 0 ? "missed " + Math.abs(offset).toFixed(2) + "s" : Math.abs(timeDiff).toFixed(2) + (timeDiff < 0 ? " delay" : " ahead"), "", "current=" + ctxAndGain.audioContext.currentTime.toFixed(4), "offset=" + offset.toFixed(4), "latency=" + latency.toFixed(4), "state=" + ctxAndGain.audioContext.state, originalUnloopedMediaTimestamp !== mediaTime ? "original_ts=" + originalUnloopedMediaTimestamp.toFixed(4) : "", "action=" + (saveForLater ? "schedule" : "start"), "");
      prev.scheduledEndTime = scheduledEndTime;
      prev.mediaEndTime = mediaEndTime;
      return duration > 0 ? {
        type: "started",
        scheduledTime
      } : {
        type: "not-started",
        reason: "missed " + Math.abs(offset).toFixed(2) + "s"
      };
    };
  }, [ctxAndGain, _experimentalKeepAudioContextAlive, logLevel]);
  const resume = useCallback9(() => {
    playbackRequested.current = true;
    if (!ctxAndGain) {
      return Promise.resolve();
    }
    const isAutoPlayAttempt = nextResumeIsAutoPlayAttempt.current;
    nextResumeIsAutoPlayAttempt.current = false;
    if (audioContextIsPlayingEventually.current === ctxAndGain.audioContext) {
      return Promise.resolve();
    }
    audioContextIsPlayingEventually.current = ctxAndGain.audioContext;
    ctxAndGain.gainNode.gain.cancelScheduledValues(ctxAndGain.audioContext.currentTime);
    ctxAndGain.gainNode.gain.setValueAtTime(0, ctxAndGain.audioContext.currentTime);
    ctxAndGain.gainNode.gain.linearRampToValueAtTime(1, ctxAndGain.audioContext.currentTime + 0.03);
    nodesToResume.current.forEach((r, node) => {
      node.start(r.scheduledTime, r.offset, r.duration);
    });
    nodesToResume.current.clear();
    if (_experimentalKeepAudioContextAlive && ctxAndGain.audioContext.state === "running") {
      return Promise.resolve();
    }
    const resumePromise = ctxAndGain.resume();
    const abortController = new AbortController;
    const resumeAttemptId = nextResumeAttemptId.current++;
    const waitPromise = new Promise((resolve) => {
      waitUntilActuallyResumed(ctxAndGain.audioContext, logLevel, abortController.signal, isAutoPlayAttempt).then(resolve);
      resumePromise.catch((err) => {
        Log.warn({ logLevel, tag: "audio" }, "AudioContext resume rejected, muting playback and continuing without audio", err);
        abortController.abort();
        resolve("failed");
      });
    }).finally(() => {
      if (isResuming.current?.id === resumeAttemptId) {
        isResuming.current = null;
      }
    });
    isResuming.current = {
      abortController,
      id: resumeAttemptId,
      promise: waitPromise
    };
    return resumePromise.catch(() => {});
  }, [ctxAndGain, _experimentalKeepAudioContextAlive, logLevel]);
  const resumeAsAutoPlay = useCallback9(() => {
    nextResumeIsAutoPlayAttempt.current = true;
    return resume();
  }, [resume]);
  const getIsResumingAudioContext = useCallback9(() => {
    return isResuming.current?.promise ?? null;
  }, []);
  const suspend = useCallback9(() => {
    playbackRequested.current = false;
    nextResumeIsAutoPlayAttempt.current = false;
    isResuming.current?.abortController.abort();
    if (!ctxAndGain) {
      return Promise.resolve();
    }
    if (audioContextIsPlayingEventually.current !== ctxAndGain.audioContext) {
      return Promise.resolve();
    }
    audioContextIsPlayingEventually.current = null;
    if (_experimentalKeepAudioContextAlive) {
      ctxAndGain.gainNode.gain.cancelScheduledValues(ctxAndGain.audioContext.currentTime);
      ctxAndGain.gainNode.gain.setValueAtTime(0, ctxAndGain.audioContext.currentTime);
      return Promise.resolve();
    }
    return ctxAndGain.suspend();
  }, [ctxAndGain, _experimentalKeepAudioContextAlive]);
  useAudioContextLayoutEffect(() => {
    if (!_experimentalKeepAudioContextAlive) {
      return;
    }
    if (!ctxAndGain) {
      return;
    }
    if (typeof window === "undefined") {
      return;
    }
    const wake = () => {
      if (ctxAndGain.audioContext.state === "running") {
        return;
      }
      ctxAndGain.resume().catch(() => {});
    };
    wake();
    window.addEventListener("pointerdown", wake, {
      capture: true,
      passive: true
    });
    window.addEventListener("keydown", wake, { capture: true, passive: true });
    return () => {
      window.removeEventListener("pointerdown", wake, { capture: true });
      window.removeEventListener("keydown", wake, { capture: true });
    };
  }, [ctxAndGain, _experimentalKeepAudioContextAlive]);
  const audioContextPending = audioEnabled && !env.isRendering && typeof AudioContext !== "undefined" && ctxAndGain === null;
  const audioContextValue = useMemo30(() => {
    return {
      sampleRate,
      audioContextPending,
      audioContext: ctxAndGain?.audioContext ?? null,
      getAudioContextState: () => ctxAndGain?.getState() ?? null,
      gainNode: ctxAndGain?.gainNode ?? null,
      audioSyncAnchor,
      audioSyncAnchorEmitter,
      scheduleAudioNode,
      resume,
      resumeAsAutoPlay,
      suspend,
      getIsResumingAudioContext,
      unscheduleAudioNode,
      _experimentalKeepAudioContextAlive
    };
  }, [
    sampleRate,
    audioContextPending,
    ctxAndGain,
    audioSyncAnchor,
    audioSyncAnchorEmitter,
    scheduleAudioNode,
    resume,
    resumeAsAutoPlay,
    suspend,
    getIsResumingAudioContext,
    unscheduleAudioNode,
    _experimentalKeepAudioContextAlive
  ]);
  useAudioContextLayoutEffect(() => {
    const queuedNodes = nodesToResume.current;
    if (playbackRequested.current) {
      resume();
    }
    return () => {
      isResuming.current?.abortController.abort();
      queuedNodes.clear();
    };
  }, [resume]);
  return /* @__PURE__ */ jsx25(SharedAudioContext.Provider, {
    value: audioContextValue,
    children
  });
};
var SharedAudioTagsContextProvider = ({ children, numberOfAudioTags }) => {
  const audios = useRef14([]);
  const [initialNumberOfAudioTags] = useState17(numberOfAudioTags);
  if (numberOfAudioTags !== initialNumberOfAudioTags) {
    throw new Error("The number of shared audio tags has changed dynamically. Once you have set this property, you cannot change it afterwards.");
  }
  const logLevel = useLogLevel();
  const mountTime = useMountTime();
  const env = useRemotionEnvironment();
  const audioCtx = useContext33(SharedAudioContext);
  const audioContext = audioCtx?.audioContext ?? null;
  const resume = audioCtx?.resume;
  const [refs] = useState17(() => {
    return new Array(numberOfAudioTags).fill(true).map(() => {
      const ref = createRef2();
      return {
        id: Math.random(),
        ref,
        mediaElementSourceNode: makeSharedElementSourceNode({
          audioContext,
          ref
        })
      };
    });
  });
  for (const { mediaElementSourceNode } of refs) {
    mediaElementSourceNode?.setAudioContext(audioContext);
  }
  const effectToUse = React33.useInsertionEffect ?? React33.useLayoutEffect;
  effectToUse(() => {
    return () => {
      requestAnimationFrame(() => {
        refs.forEach(({ mediaElementSourceNode }) => {
          mediaElementSourceNode?.cleanup();
        });
      });
    };
  }, [refs]);
  const takenAudios = useRef14(new Array(numberOfAudioTags).fill(false));
  const rerenderAudios = useCallback9(() => {
    refs.forEach(({ ref, id }) => {
      const data = audios.current?.find((a) => a.id === id);
      const { current } = ref;
      if (!current) {
        return;
      }
      if (data === undefined) {
        if (current.src !== EMPTY_AUDIO) {
          current.src = EMPTY_AUDIO;
        }
        return;
      }
      if (!data) {
        throw new TypeError("Expected audio data to be there");
      }
      Object.keys(data.props).forEach((key) => {
        if (didPropChange(key, data.props[key], current[key])) {
          current[key] = data.props[key];
        }
      });
    });
  }, [refs]);
  const registerAudio = useCallback9((options) => {
    const { aud, audioId, premounting, postmounting } = options;
    const found = audios.current?.find((a) => a.audioId === audioId);
    if (found) {
      return found;
    }
    const firstFreeAudio = takenAudios.current.findIndex((a) => a === false);
    if (firstFreeAudio === -1) {
      throw new Error(`Tried to simultaneously mount ${numberOfAudioTags + 1} <Html5Audio /> tags at the same time. With the current settings, the maximum amount of <Html5Audio /> tags is limited to ${numberOfAudioTags} at the same time. Remotion pre-mounts silent audio tags to help avoid browser autoplay restrictions. See https://remotion.dev/docs/player/autoplay#using-the-numberofsharedaudiotags-prop for more information on how to increase this limit.`);
    }
    const { id, ref, mediaElementSourceNode } = refs[firstFreeAudio];
    const cloned = [...takenAudios.current];
    cloned[firstFreeAudio] = id;
    takenAudios.current = cloned;
    const newElem = {
      props: aud,
      id,
      el: ref,
      audioId,
      mediaElementSourceNode,
      premounting,
      audioMounted: Boolean(ref.current),
      postmounting,
      cleanupOnMediaTagUnmount: () => {}
    };
    audios.current?.push(newElem);
    rerenderAudios();
    return newElem;
  }, [numberOfAudioTags, refs, rerenderAudios]);
  const unregisterAudio = useCallback9((id) => {
    const cloned = [...takenAudios.current];
    const index = refs.findIndex((r) => r.id === id);
    if (index === -1) {
      throw new TypeError(`Unknown audio ref ${id}; refs: ${refs.map((r) => r.id).join(", ")}`);
    }
    cloned[index] = false;
    takenAudios.current = cloned;
    audios.current = audios.current?.filter((a) => a.id !== id);
    rerenderAudios();
  }, [refs, rerenderAudios]);
  const updateAudio = useCallback9(({
    aud,
    audioId,
    id,
    premounting,
    postmounting
  }) => {
    let changed = false;
    audios.current = audios.current?.map((prevA) => {
      const audioMounted = Boolean(prevA.el.current);
      if (prevA.audioMounted !== audioMounted) {
        changed = true;
      }
      if (prevA.id === id) {
        const isTheSame = compareProps(aud, prevA.props) && prevA.premounting === premounting && prevA.postmounting === postmounting;
        if (isTheSame) {
          return prevA.audioMounted === audioMounted ? prevA : { ...prevA, audioMounted };
        }
        changed = true;
        return {
          ...prevA,
          props: aud,
          premounting,
          postmounting,
          audioId,
          audioMounted
        };
      }
      return prevA.audioMounted === audioMounted ? prevA : { ...prevA, audioMounted };
    });
    if (changed) {
      rerenderAudios();
    }
  }, [rerenderAudios]);
  const playAllAudios = useCallback9(() => {
    refs.forEach((ref) => {
      const audio = audios.current.find((a) => a.el === ref.ref);
      if (audio?.premounting) {
        return;
      }
      playAndHandleNotAllowedError({
        mediaRef: ref.ref,
        mediaType: "audio",
        onAutoPlayError: null,
        logLevel,
        mountTime,
        reason: "playing all audios",
        isPlayer: env.isPlayer
      });
    });
    resume?.();
  }, [logLevel, mountTime, refs, env.isPlayer, resume]);
  const audioTagsValue = useMemo30(() => {
    return {
      registerAudio,
      unregisterAudio,
      updateAudio,
      playAllAudios,
      numberOfAudioTags
    };
  }, [
    numberOfAudioTags,
    playAllAudios,
    registerAudio,
    unregisterAudio,
    updateAudio
  ]);
  const sharedAudioTagElements = useMemo30(() => {
    return refs.map(({ id, ref }) => {
      return /* @__PURE__ */ jsx25("audio", {
        ref,
        preload: "metadata",
        src: EMPTY_AUDIO
      }, id);
    });
  }, [refs]);
  return /* @__PURE__ */ jsxs3(SharedAudioTagsContext.Provider, {
    value: audioTagsValue,
    children: [
      sharedAudioTagElements,
      children
    ]
  });
};
var useSharedAudio = ({
  aud,
  audioId,
  premounting,
  postmounting
}) => {
  const audioCtx = useContext33(SharedAudioContext);
  const tagsCtx = useContext33(SharedAudioTagsContext);
  const unregisterAudio = tagsCtx && tagsCtx.numberOfAudioTags > 0 ? tagsCtx.unregisterAudio : null;
  const [elem] = useState17(() => {
    if (tagsCtx && tagsCtx.numberOfAudioTags > 0) {
      return tagsCtx.registerAudio({ aud, audioId, premounting, postmounting });
    }
    const el = React33.createRef();
    const mediaElementSourceNode = makeSharedElementSourceNode({
      audioContext: audioCtx?.audioContext ?? null,
      ref: el
    });
    return {
      el,
      id: Math.random(),
      props: aud,
      audioId,
      mediaElementSourceNode,
      premounting,
      audioMounted: Boolean(el.current),
      postmounting,
      cleanupOnMediaTagUnmount: () => {
        mediaElementSourceNode?.cleanup();
      }
    };
  });
  elem.mediaElementSourceNode?.setAudioContext(audioCtx?.audioContext ?? null);
  const effectToUse = React33.useInsertionEffect ?? React33.useLayoutEffect;
  if (typeof document !== "undefined") {
    effectToUse(() => {
      if (tagsCtx && tagsCtx.numberOfAudioTags > 0) {
        tagsCtx.updateAudio({
          id: elem.id,
          aud,
          audioId,
          premounting,
          postmounting
        });
      }
    }, [aud, tagsCtx, elem.id, audioId, premounting, postmounting]);
    effectToUse(() => {
      return () => unregisterAudio?.(elem.id);
    }, [unregisterAudio, elem.id]);
  }
  return elem;
};

// src/is-approximately-the-same.ts
var FLOATING_POINT_ERROR_THRESHOLD = 0.00001;
var isApproximatelyTheSame = (num1, num2) => {
  return Math.abs(num1 - num2) < FLOATING_POINT_ERROR_THRESHOLD;
};

// src/video/video-fragment.ts
import { useRef as useRef15 } from "react";
var toSeconds = (time, fps) => {
  return Math.round(time / fps * 100) / 100;
};
var isSafari = () => {
  if (typeof window === "undefined") {
    return false;
  }
  const isAppleWebKit = /AppleWebKit/.test(window.navigator.userAgent);
  if (!isAppleWebKit) {
    return false;
  }
  const isNotChrome = !window.navigator.userAgent.includes("Chrome/");
  return isNotChrome;
};
var isIosSafari = () => {
  if (typeof window === "undefined") {
    return false;
  }
  const { userAgent, platform, maxTouchPoints } = window.navigator;
  const isIpadIPodIPhone = /iP(ad|od|hone)/i.test(userAgent);
  const isIpadOsDesktopMode = platform === "MacIntel" && maxTouchPoints > 1;
  return (isIpadIPodIPhone || isIpadOsDesktopMode) && isSafari();
};
var isIOSSafariAndBlob = (actualSrc) => {
  return isIosSafari() && actualSrc.startsWith("blob:");
};
var getVideoFragmentStart = ({
  actualFrom,
  fps
}) => {
  return toSeconds(Math.max(0, -actualFrom), fps);
};
var getVideoFragmentEnd = ({
  duration,
  fps
}) => {
  return toSeconds(duration, fps);
};
var appendVideoFragment = ({
  actualSrc,
  actualFrom,
  duration,
  fps
}) => {
  if (isIOSSafariAndBlob(actualSrc)) {
    return actualSrc;
  }
  if (actualSrc.startsWith("data:")) {
    return actualSrc;
  }
  const existingHash = Boolean(new URL(actualSrc, (typeof window === "undefined" ? null : window.location.href) ?? "http://localhost:3000").hash);
  if (existingHash) {
    return actualSrc;
  }
  if (!Number.isFinite(actualFrom)) {
    return actualSrc;
  }
  const withStartHash = `${actualSrc}#t=${getVideoFragmentStart({ actualFrom, fps })}`;
  if (!Number.isFinite(duration)) {
    return withStartHash;
  }
  return `${withStartHash},${getVideoFragmentEnd({ duration, fps })}`;
};
var isSubsetOfDuration = ({
  prevStartFrom,
  newStartFrom,
  prevDuration,
  newDuration,
  fps
}) => {
  const previousFrom = getVideoFragmentStart({ actualFrom: prevStartFrom, fps });
  const newFrom = getVideoFragmentStart({ actualFrom: newStartFrom, fps });
  const previousEnd = getVideoFragmentEnd({ duration: prevDuration, fps });
  const newEnd = getVideoFragmentEnd({ duration: newDuration, fps });
  if (newFrom < previousFrom) {
    return false;
  }
  if (newEnd > previousEnd) {
    return false;
  }
  return true;
};
var useAppendVideoFragment = ({
  actualSrc: initialActualSrc,
  actualFrom: initialActualFrom,
  duration: initialDuration,
  fps
}) => {
  const actualFromRef = useRef15(initialActualFrom);
  const actualDuration = useRef15(initialDuration);
  const actualSrc = useRef15(initialActualSrc);
  if (!isSubsetOfDuration({
    prevStartFrom: actualFromRef.current,
    newStartFrom: initialActualFrom,
    prevDuration: actualDuration.current,
    newDuration: initialDuration,
    fps
  }) || initialActualSrc !== actualSrc.current) {
    actualFromRef.current = initialActualFrom;
    actualDuration.current = initialDuration;
    actualSrc.current = initialActualSrc;
  }
  const appended = appendVideoFragment({
    actualSrc: actualSrc.current,
    actualFrom: actualFromRef.current,
    duration: actualDuration.current,
    fps
  });
  return appended;
};

// src/use-amplification.ts
var warned2 = false;
var warnSafariOnce = (logLevel) => {
  if (warned2) {
    return;
  }
  warned2 = true;
  Log.warn({ logLevel, tag: null }, "In Safari, setting a volume and a playback rate at the same time is buggy.");
  Log.warn({ logLevel, tag: null }, "In Desktop Safari, only volumes <= 1 will be applied.");
  Log.warn({ logLevel, tag: null }, logLevel, "In Mobile Safari, the volume will be ignored and set to 1 if a playbackRate is set.");
};
var useVolume = ({
  mediaRef,
  volume,
  logLevel,
  source,
  shouldUseWebAudioApi
}) => {
  const audioStuffRef = useRef16(null);
  const currentVolumeRef = useRef16(volume);
  currentVolumeRef.current = volume;
  const sharedAudioContext = useContext34(SharedAudioContext);
  if (!sharedAudioContext) {
    throw new Error("useAmplification must be used within a SharedAudioContext");
  }
  const { audioContext, gainNode: masterGainNode } = sharedAudioContext;
  if (typeof window !== "undefined") {
    useLayoutEffect14(() => {
      if (!audioContext) {
        return;
      }
      if (!mediaRef.current) {
        return;
      }
      if (!shouldUseWebAudioApi) {
        return;
      }
      if (mediaRef.current.playbackRate !== 1 && isSafari()) {
        warnSafariOnce(logLevel);
        return;
      }
      if (!source) {
        return;
      }
      if (!masterGainNode) {
        return;
      }
      const gainNode = new GainNode(audioContext, {
        gain: currentVolumeRef.current
      });
      source.attemptToConnect();
      source.get().connect(gainNode);
      gainNode.connect(masterGainNode);
      audioStuffRef.current = {
        gainNode
      };
      Log.trace({ logLevel, tag: null }, `Starting to amplify ${mediaRef.current?.src}. Gain = ${currentVolumeRef.current}, playbackRate = ${mediaRef.current?.playbackRate}`);
      return () => {
        audioStuffRef.current = null;
        gainNode.disconnect();
        source.get().disconnect();
      };
    }, [
      logLevel,
      mediaRef,
      audioContext,
      source,
      shouldUseWebAudioApi,
      masterGainNode
    ]);
  }
  if (audioStuffRef.current) {
    const valueToSet = volume;
    if (!isApproximatelyTheSame(audioStuffRef.current.gainNode.gain.value, valueToSet)) {
      audioStuffRef.current.gainNode.gain.value = valueToSet;
      Log.trace({ logLevel, tag: null }, `Setting gain to ${valueToSet} for ${mediaRef.current?.src}`);
    }
  }
  const safariCase = isSafari() && mediaRef.current && mediaRef.current?.playbackRate !== 1;
  const shouldUseTraditionalVolume = safariCase || !shouldUseWebAudioApi;
  if (shouldUseTraditionalVolume && mediaRef.current && !isApproximatelyTheSame(volume, mediaRef.current?.volume)) {
    mediaRef.current.volume = Math.min(volume, 1);
  }
  return audioStuffRef;
};

// src/use-media-duration.ts
import { useEffect as useEffect12, useRef as useRef17 } from "react";
var subscribeToMediaDuration = (mediaRef, onDurationRef, src) => {
  const { current } = mediaRef;
  if (!current) {
    return;
  }
  if (current.duration) {
    onDurationRef.current?.(src ?? current.src, current.duration);
    return;
  }
  const onLoadedMetadata = () => {
    onDurationRef.current?.(src ?? current.src, current.duration);
  };
  current.addEventListener("loadedmetadata", onLoadedMetadata);
  return () => {
    current.removeEventListener("loadedmetadata", onLoadedMetadata);
  };
};
var useMediaDuration = (mediaRef, onDuration, src, useCurrentSrc) => {
  const onDurationRef = useRef17(onDuration);
  onDurationRef.current = onDuration;
  useEffect12(subscribeToMediaDuration.bind(null, mediaRef, onDurationRef, useCurrentSrc ? null : src), [mediaRef, src, useCurrentSrc]);
};
var scheduleMediaSourceCleanup = (cleanup) => {
  requestAnimationFrame(() => cleanup?.());
};

// src/use-media-in-timeline.ts
import { useCallback as useCallback10, useContext as useContext36, useMemo as useMemo31 } from "react";

// src/audio/use-audio-frame.ts
import { createContext as createContext35, useContext as useContext35 } from "react";
var Html5MediaTrimContext = createContext35(0);
var useMediaStartsAt = () => {
  const parentSequence = useContext35(SequenceContext);
  return parentSequence?.cumulatedNegativeFrom ?? 0;
};
var useFrameForVolumeProp = (behavior) => {
  const loop = Loop.useLoop();
  const loopTimeline = useContext35(LoopTimelineContext);
  const sequenceContext = useContext35(SequenceContext);
  const frame = useCurrentFrame();
  const startsAt = useMediaStartsAt();
  if (behavior === "repeat" || loop === null) {
    return frame + startsAt;
  }
  return frame + startsAt + loop.durationInFrames * loop.iteration * (sequenceContext?.playbackRate ?? 1) / (loopTimeline?.playbackRate ?? 1);
};

// src/get-asset-file-name.ts
var getAssetDisplayName = (filename) => {
  if (filename.startsWith("data:")) {
    return "Data URL";
  }
  if (filename.startsWith("blob:")) {
    const staticFile = typeof window === "undefined" ? undefined : window.remotion_staticFiles?.find((file) => file.src === filename);
    return staticFile ? getAssetDisplayName(staticFile.name) : "Blob URL";
  }
  const splitted = filename.split("/").map((s) => s.split("\\")).flat(1);
  const name = splitted[splitted.length - 1];
  try {
    return decodeURIComponent(name);
  } catch {
    return name;
  }
};

// src/get-timeline-duration.ts
var getTimelineDuration = ({
  compositionDurationInFrames,
  playbackRate,
  trimBefore,
  trimAfter,
  parentSequenceDurationInFrames,
  loop
}) => {
  if (loop) {
    return compositionDurationInFrames;
  }
  const mediaDuration = calculateMediaDuration({
    mediaDurationInFrames: compositionDurationInFrames * playbackRate + (trimBefore ?? 0),
    playbackRate,
    trimBefore,
    trimAfter
  });
  if (parentSequenceDurationInFrames !== null) {
    const cappedDuration = Math.min(parentSequenceDurationInFrames, mediaDuration);
    return Number(cappedDuration.toFixed(10));
  }
  return mediaDuration;
};

// src/use-media-in-timeline.ts
var EMPTY_EFFECTS2 = [];
var useBasicMediaInTimeline = ({
  src,
  displayName,
  trimBefore,
  trimAfter,
  playbackRate,
  sequenceDurationInFrames,
  mediaStartsAt,
  loop,
  muted
}) => {
  if (!src) {
    throw new Error("No src passed");
  }
  const parentSequence = useContext36(SequenceContext);
  const duration = getTimelineDuration({
    compositionDurationInFrames: sequenceDurationInFrames,
    playbackRate,
    trimBefore,
    trimAfter,
    parentSequenceDurationInFrames: parentSequence?.durationInFrames ?? null,
    loop
  });
  const startMediaFrom = 0 - mediaStartsAt + (trimBefore ?? 0);
  const memoizedResult = useMemo31(() => {
    return {
      duration,
      finalDisplayName: displayName ?? getAssetDisplayName(src),
      startMediaFrom,
      src,
      playbackRate,
      muted
    };
  }, [duration, displayName, src, startMediaFrom, playbackRate, muted]);
  return memoizedResult;
};
var useMediaInTimelineRegistration = ({
  src,
  mediaType,
  playbackRate,
  displayName,
  id,
  getStack,
  showInTimeline,
  premountDisplay,
  postmountDisplay,
  loopDisplay,
  documentationLink,
  muted
}) => {
  const parentSequence = useContext36(SequenceContext);
  const timelineTrack = useContext36(TimelineTrackContext);
  const mediaTrimBefore = useContext36(Html5MediaTrimContext);
  const sequenceRegistrationEnabled = useContext36(SequenceRegistrationContext);
  const { durationInFrames } = useVideoConfig();
  const mediaStartsAt = useMediaStartsAt();
  const canvasOutlinesEnabled = useContext36(SequenceOutlineContext);
  const { isStudio } = useRemotionEnvironment();
  const stack = getStack();
  const getStackForRegistration = useCallback10(() => stack, [stack]);
  const automaticOutlineRef = useMemo31(() => mediaType === "video" && (isStudio || canvasOutlinesEnabled) ? SequenceOutlineInternals.createRef() : null, [canvasOutlinesEnabled, isStudio, mediaType]);
  const { duration, finalDisplayName } = useBasicMediaInTimeline({
    src,
    displayName,
    trimAfter: undefined,
    trimBefore: undefined,
    playbackRate,
    sequenceDurationInFrames: durationInFrames,
    mediaStartsAt,
    loop: false,
    muted
  });
  const getSequenceForRegistration = useCallback10(() => {
    if (!src) {
      throw new Error("No src passed");
    }
    return {
      effectRuntimeValues: null,
      ...timelineTrack ? {
        timelineTrack: {
          ...timelineTrack,
          role: "clip",
          seriesOffset: null
        }
      } : {},
      type: mediaType,
      src,
      id,
      duration,
      from: 0,
      trimBefore: null,
      parent: parentSequence?.id ?? null,
      displayName: finalDisplayName,
      documentationLink,
      muted,
      showInTimeline: true,
      timelineOrder: null,
      startMediaFrom: mediaTrimBefore,
      mediaFrameAtSequenceZero: mediaTrimBefore * (1 - playbackRate),
      loopDisplay,
      playbackRate,
      sequencePlaybackRate: 1,
      getStack: getStackForRegistration,
      premountDisplay,
      postmountDisplay,
      controls: null,
      effects: EMPTY_EFFECTS2,
      refForOutline: automaticOutlineRef,
      isInsideSeries: false,
      frozenFrame: null,
      frozenMediaFrame: null
    };
  }, [
    duration,
    id,
    timelineTrack,
    parentSequence?.id,
    src,
    mediaType,
    mediaTrimBefore,
    playbackRate,
    getStackForRegistration,
    premountDisplay,
    postmountDisplay,
    loopDisplay,
    documentationLink,
    finalDisplayName,
    automaticOutlineRef,
    muted
  ]);
  const registrationEnabled = isStudio || sequenceRegistrationEnabled || typeof window !== "undefined" && window.process?.env?.NODE_ENV === "test";
  const registration = useSequenceRegistration({
    getSequence: registrationEnabled && showInTimeline ? getSequenceForRegistration : null,
    id
  });
  return { automaticOutlineRef, registration };
};

// src/use-media-playback.ts
import {
  useCallback as useCallback13,
  useContext as useContext39,
  useEffect as useEffect16,
  useLayoutEffect as useLayoutEffect16,
  useRef as useRef20
} from "react";

// src/buffer-until-first-frame.ts
import { useCallback as useCallback12, useMemo as useMemo34, useRef as useRef18 } from "react";

// src/use-buffer-state.ts
import { useContext as useContext38, useMemo as useMemo33 } from "react";

// src/buffering.tsx
import React34, {
  useCallback as useCallback11,
  useContext as useContext37,
  useEffect as useEffect13,
  useLayoutEffect as useLayoutEffect15,
  useMemo as useMemo32,
  useState as useState18
} from "react";
import { jsx as jsx26 } from "react/jsx-runtime";
var useBufferManager = (logLevel, mountTime, setBuffering, isBuffering) => {
  const [blockCount, setBlockCount] = useState18(0);
  const env = useRemotionEnvironment();
  const rendering = env.isRendering;
  const addBlock = useCallback11(() => {
    if (rendering) {
      return {
        unblock: () => {
          return;
        }
      };
    }
    let unblocked = false;
    setBlockCount((count) => count + 1);
    return {
      unblock: () => {
        if (unblocked) {
          return;
        }
        unblocked = true;
        setBlockCount((count) => count - 1);
      }
    };
  }, [rendering]);
  useEffect13(() => {
    if (rendering) {
      return;
    }
    if (blockCount > 0 && !isBuffering()) {
      setBuffering(true);
      playbackLogging({
        logLevel,
        message: "Player is entering buffer state",
        mountTime,
        tag: "player"
      });
    }
  }, [blockCount]);
  if (typeof window !== "undefined") {
    useLayoutEffect15(() => {
      if (rendering) {
        return;
      }
      if (blockCount === 0 && isBuffering()) {
        setBuffering(false);
        playbackLogging({
          logLevel,
          message: "Player is exiting buffer state",
          mountTime,
          tag: "player"
        });
      }
    }, [blockCount]);
  }
  return useMemo32(() => ({ addBlock }), [addBlock]);
};
var BufferingContextReact = React34.createContext(null);
var BufferingProvider = ({ children }) => {
  const { logLevel, mountTime } = useContext37(LogLevelContext);
  const { isBuffering, setBuffering } = useContext37(SetTimelineContext);
  const bufferManager = useBufferManager(logLevel ?? "info", mountTime, setBuffering, isBuffering);
  return /* @__PURE__ */ jsx26(BufferingContextReact.Provider, {
    value: bufferManager,
    children
  });
};

// src/use-buffer-state.ts
var useBufferState = () => {
  const buffer = useContext38(BufferingContextReact);
  const logLevel = useLogLevel();
  const addBlock = buffer ? buffer.addBlock : null;
  return useMemo33(() => ({
    delayPlayback: () => {
      if (!addBlock) {
        throw new Error("Tried to enable the buffering state, but a Remotion context was not found. This API can only be called in a component that was passed to the Remotion Player or a <Composition>. Or you might have experienced a version mismatch - run `npx remotion versions` and ensure all packages have the same version. This error is thrown by the buffer state https://remotion.dev/docs/player/buffer-state");
      }
      Log.trace({ logLevel, tag: "[buffer-state]" }, "Adding buffer handle", new Error().stack);
      const { unblock } = addBlock();
      let unblocked = false;
      return {
        unblock: () => {
          if (unblocked) {
            return;
          }
          unblocked = true;
          Log.trace({ logLevel, tag: "[buffer-state]" }, "Removing buffer handle");
          unblock();
        }
      };
    }
  }), [addBlock, logLevel]);
};

// src/buffer-until-first-frame.ts
var isSafariWebkit = () => {
  const isSafari = /^((?!chrome|android).)*safari/i.test(window.navigator.userAgent);
  return isSafari;
};
var useBufferUntilFirstFrame = ({
  mediaRef,
  mediaType,
  onVariableFpsVideoDetected,
  pauseWhenBuffering,
  logLevel,
  mountTime
}) => {
  const bufferingRef = useRef18(false);
  const { delayPlayback } = useBufferState();
  const bufferUntilFirstFrame = useCallback12((requestedTime) => {
    if (mediaType !== "video") {
      return;
    }
    if (!pauseWhenBuffering) {
      return;
    }
    const current = mediaRef.current;
    if (!current) {
      return;
    }
    if (current.readyState >= current.HAVE_FUTURE_DATA && !isSafariWebkit()) {
      playbackLogging({
        logLevel,
        message: `Not using buffer until first frame, because readyState is ${current.readyState} and is not Safari or Desktop Chrome`,
        mountTime,
        tag: "buffer"
      });
      return;
    }
    if (!current.requestVideoFrameCallback) {
      playbackLogging({
        logLevel,
        message: `Not using buffer until first frame, because requestVideoFrameCallback is not supported`,
        mountTime,
        tag: "buffer"
      });
      return;
    }
    bufferingRef.current = true;
    playbackLogging({
      logLevel,
      message: `Buffering ${mediaRef.current?.src} until the first frame is received`,
      mountTime,
      tag: "buffer"
    });
    const playback = delayPlayback();
    const unblock = () => {
      playback.unblock();
      current.removeEventListener("ended", unblock, {
        once: true
      });
      current.removeEventListener("pause", unblock, {
        once: true
      });
      bufferingRef.current = false;
    };
    const onEndedOrPauseOrCanPlay = () => {
      unblock();
    };
    current.requestVideoFrameCallback((_, info) => {
      const differenceFromRequested = Math.abs(info.mediaTime - requestedTime);
      if (differenceFromRequested > 0.5) {
        onVariableFpsVideoDetected();
      }
      unblock();
    });
    current.addEventListener("ended", onEndedOrPauseOrCanPlay, { once: true });
    current.addEventListener("pause", onEndedOrPauseOrCanPlay, { once: true });
    current.addEventListener("canplay", onEndedOrPauseOrCanPlay, {
      once: true
    });
  }, [
    delayPlayback,
    logLevel,
    mediaRef,
    mediaType,
    mountTime,
    onVariableFpsVideoDetected,
    pauseWhenBuffering
  ]);
  return useMemo34(() => {
    return {
      isBuffering: () => bufferingRef.current,
      bufferUntilFirstFrame
    };
  }, [bufferUntilFirstFrame]);
};

// src/get-media-sync-action.ts
var getMediaSyncAction = (input) => {
  const {
    duration,
    currentTime,
    paused,
    ended,
    desiredUnclampedTime,
    mediaTagTime,
    rvcTime,
    isVariableFpsVideo,
    acceptableTimeShift,
    lastSeekDueToShift,
    playing,
    playbackRate,
    mediaTagBufferingOrStalled,
    playerBuffering,
    absoluteFrame,
    onlyWarnForMediaSeekingError,
    isPremounting,
    isPostmounting,
    pauseWhenBuffering,
    mediaType
  } = input;
  const shouldBeTime = !Number.isNaN(duration) && Number.isFinite(duration) ? Math.min(duration, desiredUnclampedTime) : desiredUnclampedTime;
  const timeShift = Math.abs(shouldBeTime - mediaTagTime);
  if (timeShift > acceptableTimeShift && lastSeekDueToShift !== shouldBeTime) {
    return {
      type: "seek-due-to-shift",
      shouldBeTime,
      why: `because time shift is too big. shouldBeTime = ${shouldBeTime}, isTime = ${mediaTagTime}, requestVideoCallbackTime = ${rvcTime}, timeShift = ${timeShift}${isVariableFpsVideo ? ", isVariableFpsVideo = true" : ""}, isPremounting = ${isPremounting}, isPostmounting = ${isPostmounting}, pauseWhenBuffering = ${pauseWhenBuffering}`,
      bufferUntilFirstFrame: playing && playbackRate > 0,
      playReason: playing && paused ? "player is playing but media tag is paused, and just seeked" : null,
      warnAboutNonSeekable: !onlyWarnForMediaSeekingError
    };
  }
  const seekThreshold = playing ? 0.15 : 0.01;
  const makesSenseToSeek = Math.abs(currentTime - shouldBeTime) > seekThreshold;
  const audioLead = currentTime - shouldBeTime;
  const holdAudioUntilTimelineCatchesUp = mediaType === "audio" && playing && playbackRate > 0 && makesSenseToSeek && audioLead > 0 && audioLead <= acceptableTimeShift;
  const isSomethingElseBuffering = playerBuffering && !mediaTagBufferingOrStalled;
  if (!playing || isSomethingElseBuffering) {
    return {
      type: "seek-if-not-playing",
      shouldBeTime,
      why: makesSenseToSeek && !holdAudioUntilTimelineCatchesUp ? `not playing or something else is buffering. time offset is over seek threshold (${seekThreshold})` : null
    };
  }
  if (!playing || playerBuffering) {
    return { type: "none" };
  }
  const pausedCondition = paused && !ended;
  if (pausedCondition && holdAudioUntilTimelineCatchesUp) {
    return { type: "none" };
  }
  const firstFrameCondition = absoluteFrame === 0;
  if (pausedCondition || firstFrameCondition) {
    const reason = pausedCondition ? "media tag is paused" : "absolute frame is 0";
    return {
      type: "play-and-seek",
      shouldBeTime,
      why: makesSenseToSeek ? `is over timeshift threshold (threshold = ${seekThreshold}) and ${reason}` : null,
      playReason: `player is playing and ${reason}`,
      bufferUntilFirstFrame: !isVariableFpsVideo && playbackRate > 0
    };
  }
  return { type: "none" };
};

// src/media-tag-current-time-timestamp.ts
import React35 from "react";
var useCurrentTimeOfMediaTag = (mediaRef) => {
  const currentTime = React35.useRef({
    time: mediaRef.current?.currentTime ?? 0
  });
  const nowCurrentTime = mediaRef.current?.currentTime ?? null;
  if (nowCurrentTime !== null) {
    currentTime.current.time = nowCurrentTime;
  }
  return currentTime;
};

// src/seek.ts
var seek = ({
  mediaRef,
  time,
  logLevel,
  why,
  mountTime
}) => {
  const timeToSet = isIosSafari() ? Number(time.toFixed(1)) : time;
  playbackLogging({
    logLevel,
    tag: "seek",
    message: `Seeking from ${mediaRef.currentTime} to ${timeToSet}. src= ${mediaRef.src} Reason: ${why}`,
    mountTime
  });
  mediaRef.currentTime = timeToSet;
  return timeToSet;
};

// src/use-media-buffering.ts
import { useEffect as useEffect14, useState as useState19 } from "react";
var useMediaBuffering = ({
  element,
  shouldBuffer,
  isPremounting,
  isPostmounting,
  logLevel,
  mountTime,
  src
}) => {
  const buffer = useBufferState();
  const [isBuffering, setIsBuffering] = useState19(false);
  useEffect14(() => {
    let cleanupFns = [];
    const { current } = element;
    if (!current) {
      return;
    }
    if (!shouldBuffer) {
      return;
    }
    if (isPremounting || isPostmounting) {
      if ((isPremounting || isPostmounting) && current.readyState < current.HAVE_FUTURE_DATA) {
        if (!navigator.userAgent.includes("Firefox/")) {
          playbackLogging({
            logLevel,
            message: `Calling .load() on ${current.src} because readyState is ${current.readyState} and it is not Firefox. Element is premounted ${current.playbackRate}`,
            tag: "load",
            mountTime
          });
          const previousPlaybackRate = current.playbackRate;
          current.load();
          current.playbackRate = previousPlaybackRate;
        }
      }
      return;
    }
    const cleanup = (reason) => {
      let didDoSomething = false;
      cleanupFns.forEach((fn) => {
        fn(reason);
        didDoSomething = true;
      });
      cleanupFns = [];
      setIsBuffering((previous) => {
        if (previous) {
          didDoSomething = true;
        }
        return false;
      });
      if (didDoSomething) {
        playbackLogging({
          logLevel,
          message: `Unmarking as buffering: ${current.src}. Reason: ${reason}`,
          tag: "buffer",
          mountTime
        });
      }
    };
    const blockMedia = (reason) => {
      setIsBuffering(true);
      playbackLogging({
        logLevel,
        message: `Marking as buffering: ${current.src}. Reason: ${reason}`,
        tag: "buffer",
        mountTime
      });
      const { unblock } = buffer.delayPlayback();
      const onCanPlay = () => {
        cleanup('"canplay" was fired');
        init();
      };
      const onError = () => {
        cleanup('"error" event was occurred');
        init();
      };
      current.addEventListener("canplay", onCanPlay, {
        once: true
      });
      cleanupFns.push(() => {
        current.removeEventListener("canplay", onCanPlay);
      });
      current.addEventListener("error", onError, {
        once: true
      });
      cleanupFns.push(() => {
        current.removeEventListener("error", onError);
      });
      cleanupFns.push((cleanupReason) => {
        playbackLogging({
          logLevel,
          message: `Unblocking ${current.src} from buffer. Reason: ${cleanupReason}`,
          tag: "buffer",
          mountTime
        });
        unblock();
      });
    };
    const init = () => {
      if (current.readyState < current.HAVE_FUTURE_DATA) {
        blockMedia(`readyState is ${current.readyState}, which is less than HAVE_FUTURE_DATA`);
        if (!navigator.userAgent.includes("Firefox/")) {
          playbackLogging({
            logLevel,
            message: `Calling .load() on ${src} because readyState is ${current.readyState} and it is not Firefox. ${current.playbackRate}`,
            tag: "load",
            mountTime
          });
          const previousPlaybackRate = current.playbackRate;
          current.load();
          current.playbackRate = previousPlaybackRate;
        }
      } else {
        const onWaiting = () => {
          blockMedia('"waiting" event was fired');
        };
        current.addEventListener("waiting", onWaiting);
        cleanupFns.push(() => {
          current.removeEventListener("waiting", onWaiting);
        });
      }
    };
    init();
    return () => {
      cleanup("element was unmounted or prop changed");
    };
  }, [
    buffer,
    src,
    element,
    isPremounting,
    isPostmounting,
    logLevel,
    shouldBuffer,
    mountTime
  ]);
  return isBuffering;
};

// src/use-request-video-callback-time.ts
import { useEffect as useEffect15, useRef as useRef19 } from "react";
var useRequestVideoCallbackTime = ({
  mediaRef,
  mediaType,
  lastSeek,
  onVariableFpsVideoDetected
}) => {
  const currentTime = useRef19(null);
  useEffect15(() => {
    const { current } = mediaRef;
    if (current) {
      currentTime.current = {
        time: current.currentTime
      };
    } else {
      currentTime.current = null;
      return;
    }
    if (mediaType !== "video") {
      currentTime.current = null;
      return;
    }
    const videoTag = current;
    if (!videoTag.requestVideoFrameCallback) {
      return;
    }
    let cancel = () => {
      return;
    };
    const request = () => {
      if (!videoTag) {
        return;
      }
      const cb = videoTag.requestVideoFrameCallback((_, info) => {
        if (currentTime.current !== null) {
          const difference = Math.abs(currentTime.current.time - info.mediaTime);
          const differenceToLastSeek = Math.abs(lastSeek.current === null ? Infinity : info.mediaTime - lastSeek.current);
          if (difference > 0.5 && differenceToLastSeek > 0.5 && info.mediaTime > currentTime.current.time) {
            onVariableFpsVideoDetected();
          }
        }
        currentTime.current = {
          time: info.mediaTime
        };
        request();
      });
      cancel = () => {
        videoTag.cancelVideoFrameCallback(cb);
        cancel = () => {
          return;
        };
      };
    };
    request();
    return () => {
      cancel();
    };
  }, [lastSeek, mediaRef, mediaType, onVariableFpsVideoDetected]);
  return currentTime;
};

// src/video/get-current-time.ts
var getExpectedMediaFrameUncorrected = ({
  frame,
  playbackRate,
  startFrom
}) => {
  return interpolate(frame, [-1, startFrom, startFrom + 1], [-1, startFrom, startFrom + playbackRate]);
};
var getMediaTime = ({
  fps,
  frame,
  playbackRate,
  startFrom
}) => {
  const expectedFrame = getExpectedMediaFrameUncorrected({
    frame,
    playbackRate,
    startFrom
  });
  const msPerFrame = 1000 / fps;
  return expectedFrame * msPerFrame / 1000;
};

// src/warn-about-non-seekable-media.ts
var alreadyWarned = {};
var warnAboutNonSeekableMedia = (ref, type) => {
  if (ref === null) {
    return;
  }
  if (ref.seekable.length === 0) {
    return;
  }
  if (ref.seekable.length > 1) {
    return;
  }
  if (alreadyWarned[ref.src]) {
    return;
  }
  const range = { start: ref.seekable.start(0), end: ref.seekable.end(0) };
  if (range.start === 0 && range.end === 0) {
    const msg = [
      `The media ${ref.src} cannot be seeked. This could be one of few reasons:`,
      "1) The media resource was replaced while the video is playing but it was not loaded yet.",
      "2) The media does not support seeking.",
      "3) The media was loaded with security headers prventing it from being included.",
      "Please see https://remotion.dev/docs/non-seekable-media for assistance."
    ].join(`
`);
    if (type === "console-error") {
      console.error(msg);
    } else if (type === "console-warning") {
      console.warn(`The media ${ref.src} does not support seeking. The video will render fine, but may not play correctly in the Remotion Studio and in the <Player>. See https://remotion.dev/docs/non-seekable-media for an explanation.`);
    } else {
      throw new Error(msg);
    }
    alreadyWarned[ref.src] = true;
  }
};

// src/use-media-playback.ts
var DEFAULT_ACCEPTABLE_TIMESHIFT_WITH_AMPLIFICATION = 0.65;
var getPauseReason = ({
  reason,
  isPremounting,
  isPostmounting
}) => {
  if (reason === "buffering") {
    return "player is buffering but media tag is not";
  }
  if (isPremounting) {
    return "media is premounting";
  }
  if (isPostmounting) {
    return "media is postmounting";
  }
  return "Player is not playing";
};
var useMediaPlayback = ({
  mediaRef,
  src,
  mediaType,
  playbackRate: localPlaybackRate,
  preservePitch = true,
  onlyWarnForMediaSeekingError,
  acceptableTimeshift,
  pauseWhenBuffering,
  isPremounting,
  isPostmounting,
  onAutoPlayError
}) => {
  const { playbackRate: globalPlaybackRate } = usePlaybackRate();
  const frame = useCurrentFrame();
  const absoluteFrame = useTimelinePosition();
  const playing = usePlaying();
  const playerBuffering = useBuffering();
  const { fps } = useVideoConfig();
  const mediaTrimBefore = useContext39(Html5MediaTrimContext);
  const lastSeekDueToShift = useRef20(null);
  const lastSeek = useRef20(null);
  const logLevel = useLogLevel();
  const mountTime = useMountTime();
  const isVariableFpsVideoMap = useRef20({});
  const onVariableFpsVideoDetected = useCallback13(() => {
    if (!src) {
      return;
    }
    if (isVariableFpsVideoMap.current[src]) {
      return;
    }
    Log.verbose({ logLevel, tag: null }, `Detected ${src} as a variable FPS video. Disabling buffering while seeking.`);
    isVariableFpsVideoMap.current[src] = true;
  }, [logLevel, src]);
  const rvcCurrentTime = useRequestVideoCallbackTime({
    mediaRef,
    mediaType,
    lastSeek,
    onVariableFpsVideoDetected
  });
  const mediaTagCurrentTime = useCurrentTimeOfMediaTag(mediaRef);
  const desiredUnclampedTime = getMediaTime({
    frame,
    playbackRate: localPlaybackRate,
    startFrom: mediaTrimBefore,
    fps
  });
  const isMediaTagBuffering = useMediaBuffering({
    element: mediaRef,
    shouldBuffer: pauseWhenBuffering,
    isPremounting,
    isPostmounting,
    logLevel,
    mountTime,
    src: src ?? null
  });
  const { bufferUntilFirstFrame, isBuffering } = useBufferUntilFirstFrame({
    mediaRef,
    mediaType,
    onVariableFpsVideoDetected,
    pauseWhenBuffering,
    logLevel,
    mountTime
  });
  const sequenceContext = useContext39(SequenceContext);
  const playbackRate = localPlaybackRate * globalPlaybackRate * (sequenceContext?.playbackRate ?? 1);
  const acceptableTimeShiftButLessThanDuration = (() => {
    if (mediaRef.current?.duration) {
      return Math.min(mediaRef.current.duration, acceptableTimeshift ?? DEFAULT_ACCEPTABLE_TIMESHIFT_WITH_AMPLIFICATION);
    }
    return acceptableTimeshift ?? DEFAULT_ACCEPTABLE_TIMESHIFT_WITH_AMPLIFICATION;
  })();
  const env = useRemotionEnvironment();
  useLayoutEffect16(() => {
    const playbackRateToSet = Math.max(0, playbackRate);
    if (mediaRef.current && mediaRef.current.defaultPlaybackRate !== playbackRateToSet) {
      mediaRef.current.defaultPlaybackRate = playbackRateToSet;
    }
    if (mediaRef.current && mediaRef.current.playbackRate !== playbackRateToSet) {
      mediaRef.current.playbackRate = playbackRateToSet;
    }
    if (mediaRef.current && mediaRef.current.preservesPitch !== preservePitch) {
      mediaRef.current.preservesPitch = preservePitch;
    }
  }, [mediaRef, playbackRate, preservePitch]);
  useEffect16(() => {
    const tagName = mediaType === "audio" ? "<Html5Audio>" : "<Html5Video>";
    if (!mediaRef.current) {
      throw new Error(`No ${mediaType} ref found`);
    }
    if (!src) {
      throw new Error(`No 'src' attribute was passed to the ${tagName} element.`);
    }
    const { current } = mediaRef;
    const isMediaTagBufferingOrStalled = isMediaTagBuffering || isBuffering();
    let pauseReason = null;
    if (!playing) {
      pauseReason = "not-playing";
    } else if (playerBuffering && !isMediaTagBufferingOrStalled) {
      pauseReason = "buffering";
    }
    if (!current.paused && pauseReason !== null) {
      playbackLogging({
        logLevel,
        tag: "pause",
        message: `Pausing ${current.src} because ${getPauseReason({
          reason: pauseReason,
          isPremounting,
          isPostmounting
        })}`,
        mountTime
      });
      current.pause();
    }
    const action = getMediaSyncAction({
      duration: current.duration,
      currentTime: current.currentTime,
      paused: current.paused,
      ended: current.ended,
      desiredUnclampedTime,
      mediaTagTime: mediaTagCurrentTime.current.time,
      rvcTime: rvcCurrentTime.current?.time ?? null,
      isVariableFpsVideo: Boolean(isVariableFpsVideoMap.current[src]),
      acceptableTimeShift: acceptableTimeShiftButLessThanDuration,
      lastSeekDueToShift: lastSeekDueToShift.current,
      playing,
      playbackRate,
      mediaTagBufferingOrStalled: isMediaTagBufferingOrStalled,
      playerBuffering,
      absoluteFrame,
      onlyWarnForMediaSeekingError,
      isPremounting,
      isPostmounting,
      pauseWhenBuffering,
      mediaType
    });
    if (action.type === "none") {
      return;
    }
    if (action.type === "seek-due-to-shift") {
      lastSeek.current = seek({
        mediaRef: current,
        time: action.shouldBeTime,
        logLevel,
        why: action.why,
        mountTime
      });
      lastSeekDueToShift.current = lastSeek.current;
      if (action.bufferUntilFirstFrame) {
        bufferUntilFirstFrame(action.shouldBeTime);
      }
      if (action.playReason !== null) {
        playAndHandleNotAllowedError({
          mediaRef,
          mediaType,
          onAutoPlayError,
          logLevel,
          mountTime,
          reason: action.playReason,
          isPlayer: env.isPlayer
        });
      }
      if (action.warnAboutNonSeekable) {
        warnAboutNonSeekableMedia(current, "console-error");
      }
      return;
    }
    if (action.type === "seek-if-not-playing") {
      if (action.why !== null) {
        lastSeek.current = seek({
          mediaRef: current,
          time: action.shouldBeTime,
          logLevel,
          why: action.why,
          mountTime
        });
      }
      return;
    }
    if (action.why !== null) {
      lastSeek.current = seek({
        mediaRef: current,
        time: action.shouldBeTime,
        logLevel,
        why: action.why,
        mountTime
      });
    }
    playAndHandleNotAllowedError({
      mediaRef,
      mediaType,
      onAutoPlayError,
      logLevel,
      mountTime,
      reason: action.playReason,
      isPlayer: env.isPlayer
    });
    if (action.bufferUntilFirstFrame) {
      bufferUntilFirstFrame(action.shouldBeTime);
    }
  }, [
    absoluteFrame,
    acceptableTimeShiftButLessThanDuration,
    bufferUntilFirstFrame,
    rvcCurrentTime,
    logLevel,
    desiredUnclampedTime,
    isBuffering,
    isMediaTagBuffering,
    mediaRef,
    mediaType,
    onlyWarnForMediaSeekingError,
    playbackRate,
    playerBuffering,
    playing,
    src,
    onAutoPlayError,
    isPremounting,
    isPostmounting,
    pauseWhenBuffering,
    mountTime,
    mediaTagCurrentTime,
    env.isPlayer
  ]);
};

// src/use-media-tag.ts
import { useContext as useContext40, useEffect as useEffect17, useRef as useRef21 } from "react";
var useMediaTag = ({
  mediaRef,
  id,
  mediaType,
  onAutoPlayError,
  isPremounting,
  isPostmounting
}) => {
  const { audioAndVideoTags, isPlaying } = useTimelineContext();
  const { subscribePlaying } = useContext40(SetTimelineContext);
  const isPlayingRef = useRef21(isPlaying);
  isPlayingRef.current = isPlaying;
  const logLevel = useLogLevel();
  const mountTime = useMountTime();
  const env = useRemotionEnvironment();
  useEffect17(() => {
    const tag = {
      id,
      play: (reason) => {
        if (!isPlayingRef.current()) {
          return;
        }
        if (isPremounting || isPostmounting) {
          return;
        }
        return playAndHandleNotAllowedError({
          mediaRef,
          mediaType,
          onAutoPlayError,
          logLevel,
          mountTime,
          reason,
          isPlayer: env.isPlayer
        });
      }
    };
    audioAndVideoTags.current.push(tag);
    const unsubscribe = subscribePlaying((state) => {
      if (state.playing) {
        return;
      }
      const media = mediaRef.current;
      if (!media || media.paused) {
        return;
      }
      playbackLogging({
        logLevel,
        tag: "pause",
        message: `Pausing ${media.src} because Player is not playing`,
        mountTime
      });
      media.pause();
    });
    return () => {
      unsubscribe();
      audioAndVideoTags.current = audioAndVideoTags.current.filter((a) => a.id !== id);
    };
  }, [
    audioAndVideoTags,
    id,
    mediaRef,
    mediaType,
    onAutoPlayError,
    isPremounting,
    isPostmounting,
    logLevel,
    mountTime,
    env.isPlayer,
    subscribePlaying
  ]);
};

// src/volume-position-state.ts
import { createContext as createContext36, useCallback as useCallback14, useContext as useContext41, useMemo as useMemo35, useRef as useRef22 } from "react";
import { flushSync } from "react-dom";
var MediaVolumeContext = createContext36({
  playerMuted: false,
  mediaVolume: 1
});
var SetMediaVolumeContext = createContext36({
  setPlayerMuted: () => {
    throw new Error("default");
  },
  setMediaVolume: () => {
    throw new Error("default");
  }
});
var useResumeAudioOnUnmute = () => {
  const volume = useContext41(MediaVolumeContext);
  const audioContext = useContext41(SharedAudioContext);
  const audioTags = useContext41(SharedAudioTagsContext);
  const { isPlaying } = useContext41(SetTimelineContext);
  const current = useRef22({ volume, audioContext, audioTags });
  current.current = { volume, audioContext, audioTags };
  return useCallback14((update) => {
    const before = current.current.volume;
    if (!isPlaying() || !before.playerMuted && before.mediaVolume > 0) {
      update();
      return;
    }
    flushSync(update);
    const after = current.current;
    if (after.volume.playerMuted || after.volume.mediaVolume === 0) {
      return;
    }
    after.audioContext?.resume();
    after.audioTags?.playAllAudios();
  }, [isPlaying]);
};
var useMediaVolumeState = () => {
  const { mediaVolume } = useContext41(MediaVolumeContext);
  const { setMediaVolume } = useContext41(SetMediaVolumeContext);
  const updateAndResume = useResumeAudioOnUnmute();
  const setVolume = useCallback14((volume) => updateAndResume(() => setMediaVolume(volume)), [setMediaVolume, updateAndResume]);
  return useMemo35(() => {
    return [mediaVolume, setVolume];
  }, [mediaVolume, setVolume]);
};
var usePlayerMutedState = () => {
  const { playerMuted } = useContext41(MediaVolumeContext);
  const { setPlayerMuted } = useContext41(SetMediaVolumeContext);
  const updateAndResume = useResumeAudioOnUnmute();
  const setMuted = useCallback14((muted) => updateAndResume(() => setPlayerMuted(muted)), [setPlayerMuted, updateAndResume]);
  return useMemo35(() => {
    return [playerMuted, setMuted];
  }, [playerMuted, setMuted]);
};

// src/volume-prop.ts
var evaluateVolume = ({
  frame,
  volume,
  mediaVolume = 1
}) => {
  if (typeof volume === "number") {
    return volume * mediaVolume;
  }
  if (typeof volume === "undefined") {
    return Number(mediaVolume);
  }
  const evaluated = volume(frame) * mediaVolume;
  if (typeof evaluated !== "number") {
    throw new TypeError(`You passed in a a function to the volume prop but it did not return a number but a value of type ${typeof evaluated} for frame ${frame}`);
  }
  if (Number.isNaN(evaluated)) {
    throw new TypeError(`You passed in a function to the volume prop but it returned NaN for frame ${frame}.`);
  }
  if (!Number.isFinite(evaluated)) {
    throw new TypeError(`You passed in a function to the volume prop but it returned a non-finite number for frame ${frame}.`);
  }
  return Math.max(0, evaluated);
};

// src/volume-safeguard.ts
var warnAboutTooHighVolume = (volume) => {
  if (volume >= 100) {
    throw new Error(`Volume was set to ${volume}, but regular volume is 1, not 100. Did you forget to divide by 100? Set a volume of less than 100 to dismiss this error.`);
  }
};

// src/audio/use-media-audio-state.ts
var resolveMediaAudioState = ({
  muted,
  playerMuted,
  volume,
  isInsideFreeze,
  audioEnabled
}) => {
  const isMutedForTimeline = muted || isInsideFreeze;
  const isMutedForPlayback = isMutedForTimeline || playerMuted || volume !== null && volume <= 0;
  return {
    isMutedForTimeline,
    isMutedForPlayback,
    shouldUseAudio: audioEnabled && !isMutedForPlayback
  };
};
var useMediaAudioState = ({
  muted,
  volume,
  audioEnabled
}) => {
  const [playerMuted] = usePlayerMutedState();
  const isInsideFreeze = useIsInsideFreeze();
  return resolveMediaAudioState({
    muted,
    playerMuted,
    volume,
    isInsideFreeze,
    audioEnabled
  });
};

// src/audio/AudioForPreview.tsx
import { jsx as jsx27 } from "react/jsx-runtime";
var AudioForDevelopmentForwardRefFunction = (props, ref) => {
  const [initialShouldPreMountAudioElements] = useState20(props.shouldPreMountAudioTags);
  if (props.shouldPreMountAudioTags !== initialShouldPreMountAudioElements) {
    throw new Error("Cannot change the behavior for pre-mounting audio tags dynamically.");
  }
  const logLevel = useLogLevel();
  const {
    timelineId,
    userPreferredVolume,
    isMutedForPlayback,
    volume,
    muted,
    playbackRate,
    preservePitch,
    shouldPreMountAudioTags,
    src,
    onDuration,
    acceptableTimeShiftInSeconds,
    _remotionInternalNeedsDurationCalculation,
    _remotionInternalNativeLoopPassed,
    _remotionInternalStack,
    allowAmplificationDuringRender,
    name,
    pauseWhenBuffering,
    showInTimeline,
    loopVolumeCurveBehavior,
    crossOrigin,
    delayRenderRetries,
    delayRenderTimeoutInMilliseconds,
    toneFrequency,
    useWebAudioApi,
    onError,
    onNativeError,
    audioStreamIndex,
    ...nativeProps
  } = props;
  const _propsValid = true;
  if (!_propsValid) {
    throw new Error("typecheck error");
  }
  if (!src) {
    throw new TypeError("No 'src' was passed to <Html5Audio>.");
  }
  const preloadedSrc = usePreload(src);
  const sequenceContext = useContext42(SequenceContext);
  warnAboutTooHighVolume(userPreferredVolume);
  const crossOriginValue = getCrossOriginValue({
    crossOrigin,
    requestsVideoFrame: false,
    isClientSideRendering: false
  });
  const propsToPass = useMemo36(() => {
    return {
      muted: isMutedForPlayback,
      src: preloadedSrc,
      loop: _remotionInternalNativeLoopPassed,
      crossOrigin: crossOriginValue,
      ...nativeProps
    };
  }, [
    _remotionInternalNativeLoopPassed,
    isMutedForPlayback,
    nativeProps,
    preloadedSrc,
    crossOriginValue
  ]);
  const id = useMemo36(() => `audio-${random(src ?? "")}-${sequenceContext?.relativeFrom}-${sequenceContext?.cumulatedFrom}-${sequenceContext?.durationInFrames}-muted:${props.muted}-loop:${props.loop}`, [
    src,
    sequenceContext?.relativeFrom,
    sequenceContext?.cumulatedFrom,
    sequenceContext?.durationInFrames,
    props.muted,
    props.loop
  ]);
  const {
    el: audioRef,
    mediaElementSourceNode,
    cleanupOnMediaTagUnmount
  } = useSharedAudio({
    aud: propsToPass,
    audioId: id,
    premounting: Boolean(sequenceContext?.premounting),
    postmounting: Boolean(sequenceContext?.postmounting)
  });
  useMediaPlayback({
    mediaRef: audioRef,
    src,
    mediaType: "audio",
    playbackRate: playbackRate ?? 1,
    preservePitch,
    onlyWarnForMediaSeekingError: false,
    acceptableTimeshift: acceptableTimeShiftInSeconds ?? null,
    isPremounting: Boolean(sequenceContext?.premounting),
    isPostmounting: Boolean(sequenceContext?.postmounting),
    pauseWhenBuffering,
    onAutoPlayError: null
  });
  useMediaTag({
    id: timelineId,
    isPostmounting: Boolean(sequenceContext?.postmounting),
    isPremounting: Boolean(sequenceContext?.premounting),
    mediaRef: audioRef,
    mediaType: "audio",
    onAutoPlayError: null
  });
  useVolume({
    logLevel,
    mediaRef: audioRef,
    source: mediaElementSourceNode,
    volume: userPreferredVolume,
    shouldUseWebAudioApi: useWebAudioApi ?? false
  });
  const effectToUse = React36.useInsertionEffect ?? React36.useLayoutEffect;
  effectToUse(() => {
    return scheduleMediaSourceCleanup.bind(null, cleanupOnMediaTagUnmount);
  }, [cleanupOnMediaTagUnmount]);
  useImperativeHandle4(ref, () => {
    return audioRef.current;
  }, [audioRef]);
  useMediaDuration(audioRef, onDuration, src, true);
  if (initialShouldPreMountAudioElements) {
    return null;
  }
  const audio = /* @__PURE__ */ jsx27("audio", {
    ref: audioRef,
    preload: "metadata",
    crossOrigin: crossOriginValue,
    ...propsToPass
  });
  return audio;
};
var AudioForPreviewContent = forwardRef5(AudioForDevelopmentForwardRefFunction);
var AudioForPreviewRefForwardingFunction = (props, ref) => {
  const {
    volume,
    muted,
    playbackRate,
    src,
    name,
    _remotionInternalStack,
    showInTimeline,
    loopVolumeCurveBehavior
  } = props;
  const [timelineId] = useState20(() => String(Math.random()));
  const sequenceContext = useContext42(SequenceContext);
  const { isStudio } = useRemotionEnvironment();
  const [mediaVolume] = useMediaVolumeState();
  const volumePropFrame = useFrameForVolumeProp(loopVolumeCurveBehavior ?? "repeat");
  const userPreferredVolume = evaluateVolume({
    frame: volumePropFrame,
    volume,
    mediaVolume
  });
  const { isMutedForTimeline, isMutedForPlayback } = useMediaAudioState({
    muted: muted ?? false,
    volume: userPreferredVolume,
    audioEnabled: true
  });
  const getStack = useCallback15(() => {
    return _remotionInternalStack ?? null;
  }, [_remotionInternalStack]);
  const { registration } = useMediaInTimelineRegistration({
    src,
    mediaType: "audio",
    playbackRate: playbackRate ?? 1,
    displayName: name ?? null,
    id: timelineId,
    getStack,
    showInTimeline,
    premountDisplay: sequenceContext?.premountDisplay ?? null,
    postmountDisplay: sequenceContext?.postmountDisplay ?? null,
    loopDisplay: undefined,
    documentationLink: "https://www.remotion.dev/docs/html5-audio",
    muted: isMutedForTimeline
  });
  const metadata = useMemo36(() => isStudio || registration !== null ? {
    type: "sequence",
    id: timelineId,
    value: registration,
    outlineChildrenRef: null
  } : null, [isStudio, registration, timelineId]);
  return /* @__PURE__ */ jsx27(CommittedMetadataProvider, {
    value: null,
    _remotionCommitMetadata: metadata,
    children: /* @__PURE__ */ jsx27(SequenceContent, {
      children: /* @__PURE__ */ jsx27(AudioForPreviewContent, {
        ...props,
        ref,
        timelineId,
        userPreferredVolume,
        isMutedForPlayback
      })
    })
  });
};
var AudioForPreview = forwardRef5(AudioForPreviewRefForwardingFunction);

// src/audio/AudioForRendering.tsx
import React37, {
  forwardRef as forwardRef6,
  useContext as useContext44,
  useEffect as useEffect18,
  useImperativeHandle as useImperativeHandle5,
  useLayoutEffect as useLayoutEffect17,
  useMemo as useMemo38,
  useRef as useRef23
} from "react";

// src/use-media-enabled.tsx
import { createContext as createContext37, useContext as useContext43, useMemo as useMemo37 } from "react";
import { jsx as jsx28 } from "react/jsx-runtime";
var MediaEnabledContext = createContext37(null);
var useVideoEnabled = () => {
  const context = useContext43(MediaEnabledContext);
  if (!context) {
    return window.remotion_videoEnabled;
  }
  if (context.videoEnabled === null) {
    return window.remotion_videoEnabled;
  }
  return context.videoEnabled;
};
var useAudioEnabled = () => {
  const context = useContext43(MediaEnabledContext);
  if (!context) {
    return window.remotion_audioEnabled;
  }
  if (context.audioEnabled === null) {
    return window.remotion_audioEnabled;
  }
  return context.audioEnabled;
};
var MediaEnabledProvider = ({
  children,
  videoEnabled,
  audioEnabled
}) => {
  const value = useMemo37(() => ({ videoEnabled, audioEnabled }), [videoEnabled, audioEnabled]);
  return /* @__PURE__ */ jsx28(MediaEnabledContext.Provider, {
    value,
    children
  });
};

// src/audio/AudioForRendering.tsx
import { jsx as jsx29 } from "react/jsx-runtime";
var AudioForRenderingRefForwardingFunction = (props, ref) => {
  const audioRef = useRef23(null);
  const {
    registerRenderAsset,
    unregisterRenderAsset,
    volume: volumeProp,
    playbackRate,
    allowAmplificationDuringRender,
    onDuration,
    toneFrequency,
    _remotionInternalNeedsDurationCalculation,
    _remotionInternalNativeLoopPassed,
    acceptableTimeShiftInSeconds,
    name,
    onNativeError,
    delayRenderRetries,
    delayRenderTimeoutInMilliseconds,
    loopVolumeCurveBehavior,
    pauseWhenBuffering,
    audioStreamIndex,
    preservePitch,
    ...nativeProps
  } = props;
  const absoluteFrame = useTimelinePosition();
  const volumePropFrame = useFrameForVolumeProp(loopVolumeCurveBehavior ?? "repeat");
  const frame = useCurrentFrame();
  const sequenceContext = useContext44(SequenceContext);
  const sequencePlaybackRate = sequenceContext?.playbackRate ?? 1;
  const audioStartFrame = useContext44(Html5MediaTrimContext);
  const { delayRender, continueRender } = useDelayRender();
  const id = useMemo38(() => `audio-${random(props.src ?? "")}-${sequenceContext?.relativeFrom}-${sequenceContext?.cumulatedFrom}-${sequenceContext?.durationInFrames}`, [
    props.src,
    sequenceContext?.relativeFrom,
    sequenceContext?.cumulatedFrom,
    sequenceContext?.durationInFrames
  ]);
  const volume = evaluateVolume({
    volume: volumeProp,
    frame: volumePropFrame,
    mediaVolume: 1
  });
  warnAboutTooHighVolume(volume);
  const audioEnabled = useAudioEnabled();
  const { shouldUseAudio } = useMediaAudioState({
    muted: props.muted ?? false,
    volume,
    audioEnabled
  });
  useImperativeHandle5(ref, () => {
    return audioRef.current;
  }, []);
  useEffect18(() => {
    if (!props.src) {
      throw new Error("No src passed");
    }
    if (!shouldUseAudio) {
      return;
    }
    registerRenderAsset({
      type: "audio",
      src: getAbsoluteSrc(props.src),
      id,
      frame: absoluteFrame,
      volume,
      mediaFrame: audioStartFrame + (frame - audioStartFrame) / sequencePlaybackRate,
      playbackRate: (props.playbackRate ?? 1) * sequencePlaybackRate,
      toneFrequency: toneFrequency ?? 1,
      audioStartFrame,
      audioStreamIndex: audioStreamIndex ?? 0,
      preservePitch: preservePitch ?? true
    });
    return () => unregisterRenderAsset(id);
  }, [
    shouldUseAudio,
    props.src,
    registerRenderAsset,
    absoluteFrame,
    id,
    unregisterRenderAsset,
    volume,
    volumePropFrame,
    frame,
    playbackRate,
    props.playbackRate,
    toneFrequency,
    audioStartFrame,
    sequencePlaybackRate,
    audioStreamIndex,
    preservePitch
  ]);
  const { src } = props;
  const needsToRenderAudioTag = ref || _remotionInternalNeedsDurationCalculation;
  useLayoutEffect17(() => {
    if (window.process?.env?.NODE_ENV === "test") {
      return;
    }
    if (!needsToRenderAudioTag) {
      return;
    }
    const newHandle = delayRender("Loading <Html5Audio> duration with src=" + src, {
      retries: delayRenderRetries ?? undefined,
      timeoutInMilliseconds: delayRenderTimeoutInMilliseconds ?? undefined
    });
    const { current } = audioRef;
    const didLoad = () => {
      if (current?.duration) {
        onDuration(current.src, current.duration);
      }
      continueRender(newHandle);
    };
    if (current?.duration) {
      onDuration(current.src, current.duration);
      continueRender(newHandle);
    } else {
      current?.addEventListener("loadedmetadata", didLoad, { once: true });
    }
    return () => {
      current?.removeEventListener("loadedmetadata", didLoad);
      continueRender(newHandle);
    };
  }, [
    src,
    onDuration,
    needsToRenderAudioTag,
    delayRenderRetries,
    delayRenderTimeoutInMilliseconds,
    continueRender,
    delayRender
  ]);
  if (!needsToRenderAudioTag) {
    return null;
  }
  return /* @__PURE__ */ jsx29("audio", {
    ref: audioRef,
    ...nativeProps,
    onError: onNativeError
  });
};
var MemoAudioForRendering = React37.memo(forwardRef6(AudioForRenderingRefForwardingFunction));
var AudioForRendering = forwardRef6((props, ref) => {
  const { registerRenderAsset, unregisterRenderAsset } = useContext44(RenderAssetManager);
  return /* @__PURE__ */ jsx29(MemoAudioForRendering, {
    ...props,
    ref,
    registerRenderAsset,
    unregisterRenderAsset
  });
});

// src/audio/html5-audio.tsx
import { jsx as jsx30 } from "react/jsx-runtime";
var AudioRefForwardingFunction = (props, ref) => {
  const audioTagsContext = useContext45(SharedAudioTagsContext);
  const propsWithFreeze = props;
  const {
    startFrom,
    endAt,
    trimBefore,
    trimAfter,
    durationInFrames,
    name,
    _remotionInternalStack,
    pauseWhenBuffering,
    showInTimeline,
    onError: onRemotionError,
    freeze,
    ...otherProps
  } = propsWithFreeze;
  const { loop, freeze: _freeze, ...propsOtherThanLoop } = propsWithFreeze;
  const { fps } = useVideoConfig();
  const environment = useRemotionEnvironment();
  const shouldPauseWhenBuffering = resolveV5Default(pauseWhenBuffering);
  if (environment.isClientSideRendering) {
    throw new Error("<Html5Audio> is not supported in @remotion/web-renderer. Use <Audio> from @remotion/media instead. See https://remotion.dev/docs/client-side-rendering/limitations");
  }
  if (typeof freeze !== "undefined") {
    throw new TypeError('The "freeze" prop is not supported on <Html5Audio />. Use <Sequence freeze={...}> to freeze media playback.');
  }
  const { durations, setDurations } = useContext45(DurationsContext);
  if (typeof props.src !== "string") {
    throw new TypeError(`The \`<Html5Audio>\` tag requires a string for \`src\`, but got ${JSON.stringify(props.src)} instead.`);
  }
  const preloadedSrc = usePreload(props.src);
  const onError = useCallback16((e) => {
    console.log(e.currentTarget.error);
    const errMessage = `Could not play audio with src ${preloadedSrc}: ${e.currentTarget.error}. See https://remotion.dev/docs/media-playback-error for help.`;
    if (loop) {
      if (onRemotionError) {
        onRemotionError(new Error(errMessage));
        return;
      }
      cancelRender(new Error(errMessage));
    } else {
      onRemotionError?.(new Error(errMessage));
      console.warn(errMessage);
    }
  }, [loop, onRemotionError, preloadedSrc]);
  const onDuration = useMemo39(() => onMediaDuration.bind(null, setDurations), [setDurations]);
  const durationFetched = durations[getAbsoluteSrc(preloadedSrc)] ?? durations[getAbsoluteSrc(props.src)];
  validateMediaTrimProps({ startFrom, endAt, trimBefore, trimAfter });
  if (durationInFrames !== undefined) {
    validateDurationInFrames(durationInFrames, {
      component: "of the <Html5Audio /> component",
      allowFloats: true
    });
  }
  const { trimBeforeValue, trimAfterValue } = resolveTrimProps({
    startFrom,
    endAt,
    trimBefore,
    trimAfter
  });
  const effectiveTrimAfter = getMediaTrimAfter({
    durationInFrames,
    trimAfter: trimAfterValue,
    trimBefore: trimBeforeValue
  });
  const loopDuration = effectiveTrimAfter ?? (durationFetched === undefined ? undefined : durationFetched * fps);
  if (loop && loopDuration !== undefined) {
    if (!Number.isFinite(loopDuration)) {
      return /* @__PURE__ */ jsx30(Html5Audio, {
        ...propsOtherThanLoop,
        ref,
        _remotionInternalNativeLoopPassed: true
      });
    }
    return /* @__PURE__ */ jsx30(Loop, {
      layout: "none",
      durationInFrames: calculateMediaDuration({
        trimAfter: effectiveTrimAfter,
        mediaDurationInFrames: loopDuration,
        playbackRate: props.playbackRate ?? 1,
        trimBefore: trimBeforeValue
      }),
      children: /* @__PURE__ */ jsx30(Html5Audio, {
        ...propsOtherThanLoop,
        ref,
        _remotionInternalNativeLoopPassed: true
      })
    });
  }
  if (typeof trimBeforeValue !== "undefined" || typeof effectiveTrimAfter !== "undefined") {
    return /* @__PURE__ */ jsx30(Html5MediaTrimContext.Provider, {
      value: trimBeforeValue ?? 0,
      children: /* @__PURE__ */ jsx30(Sequence, {
        layout: "none",
        from: 0 - (trimBeforeValue ?? 0),
        showInTimeline: false,
        durationInFrames: effectiveTrimAfter === undefined ? undefined : (trimBeforeValue ?? 0) + (effectiveTrimAfter - (trimBeforeValue ?? 0)) / (props.playbackRate ?? 1),
        name,
        children: /* @__PURE__ */ jsx30(Html5Audio, {
          _remotionInternalNeedsDurationCalculation: Boolean(loop),
          pauseWhenBuffering: shouldPauseWhenBuffering,
          ...otherProps,
          ref
        })
      })
    });
  }
  validateMediaProps({
    playbackRate: props.playbackRate,
    preservePitch: props.preservePitch,
    volume: props.volume
  }, "Html5Audio");
  if (environment.isRendering) {
    return /* @__PURE__ */ jsx30(AudioForRendering, {
      onDuration,
      ...props,
      ref,
      onNativeError: onError,
      _remotionInternalNeedsDurationCalculation: Boolean(loop)
    });
  }
  return /* @__PURE__ */ jsx30(AudioForPreview, {
    _remotionInternalNativeLoopPassed: props._remotionInternalNativeLoopPassed ?? false,
    _remotionInternalStack: _remotionInternalStack ?? null,
    shouldPreMountAudioTags: audioTagsContext !== null && audioTagsContext.numberOfAudioTags > 0,
    ...props,
    ref,
    onNativeError: onError,
    onDuration,
    pauseWhenBuffering: shouldPauseWhenBuffering,
    _remotionInternalNeedsDurationCalculation: Boolean(loop),
    showInTimeline: showInTimeline ?? true
  });
};
var Html5Audio = forwardRef7(AudioRefForwardingFunction);
addSequenceStackTraces(Html5Audio);
var Audio = Html5Audio;
// src/effects/Solid.tsx
import {
  forwardRef as forwardRef8,
  useCallback as useCallback17,
  useEffect as useEffect19,
  useImperativeHandle as useImperativeHandle6,
  useMemo as useMemo40,
  useRef as useRef24,
  useState as useState21
} from "react";
import { jsx as jsx31 } from "react/jsx-runtime";
var resolveSolidPixelDensity = (pixelDensity) => {
  if (pixelDensity === undefined) {
    return 1;
  }
  if (typeof pixelDensity !== "number" || !Number.isFinite(pixelDensity) || pixelDensity <= 0) {
    throw new Error(`<Solid>: \`pixelDensity\` must be a positive finite number. Received: ${String(pixelDensity)}.`);
  }
  return pixelDensity;
};
var solidSchema = {
  ...baseSchema,
  ...premountSchema,
  color: {
    type: "color",
    default: "transparent",
    description: "Color"
  },
  width: {
    type: "number",
    min: 1,
    step: 1,
    default: 1920,
    description: "Width",
    hiddenFromList: false
  },
  height: {
    type: "number",
    min: 1,
    step: 1,
    default: 1080,
    description: "Height",
    hiddenFromList: false
  },
  pixelDensity: {
    type: "number",
    min: 1,
    max: 3,
    step: 0.1,
    default: 1,
    description: "Pixel density",
    hiddenFromList: false
  },
  ...transformSchema,
  ...backgroundSchema,
  ...borderSchema,
  ...borderRadiusSchema,
  ...cropSchema
};
var SolidInner = ({
  color,
  width,
  height,
  effects = [],
  effectsOutputSize = null,
  className,
  style,
  pixelDensity,
  overrideId,
  videoConfigValues,
  reference,
  canvasProps
}) => {
  const { delayRender, continueRender, cancelRender } = useDelayRender();
  const resolvedPixelDensity = resolveSolidPixelDensity(pixelDensity);
  const canvasWidth = Math.ceil(width * resolvedPixelDensity);
  const canvasHeight = Math.ceil(height * resolvedPixelDensity);
  const [outputCanvas, setOutputCanvas] = useState21(null);
  const memoizedEffects = useMemoizedEffects({
    effects,
    overrideId: overrideId ?? null,
    videoConfigValues
  });
  const sourceCanvas = useMemo40(() => {
    if (typeof document === "undefined") {
      return null;
    }
    const canvas = document.createElement("canvas");
    canvas.width = 1;
    canvas.height = 1;
    return canvas;
  }, []);
  const chainState = useEffectChainState(effectsOutputSize);
  const canvasRef = useCallback17((canvas) => {
    setOutputCanvas(canvas);
    if (typeof reference === "function") {
      reference(canvas);
    } else if (reference) {
      reference.current = canvas;
    }
  }, [reference]);
  useEffect19(() => {
    if (!outputCanvas || !sourceCanvas) {
      return;
    }
    const handle = delayRender("Solid effect chain");
    if (!chainState) {
      continueRender(handle);
      return () => {
        continueRender(handle);
      };
    }
    const ctx = sourceCanvas.getContext("2d", { colorSpace: "srgb" });
    if (!ctx) {
      cancelRender(new Error("Failed to acquire 2D context for <Solid> source"));
      return;
    }
    ctx.clearRect(0, 0, 1, 1);
    if (color !== undefined) {
      ctx.fillStyle = color;
      ctx.fillRect(0, 0, 1, 1);
    }
    runEffectChain({
      state: chainState.get(canvasWidth, canvasHeight),
      source: sourceCanvas,
      effects: memoizedEffects,
      output: outputCanvas,
      width: canvasWidth,
      height: canvasHeight
    }).then((completed) => {
      if (completed) {
        continueRender(handle);
      }
    }).catch((err) => {
      cancelRender(err);
    });
    return () => {
      continueRender(handle);
    };
  }, [
    color,
    outputCanvas,
    sourceCanvas,
    chainState,
    canvasWidth,
    canvasHeight,
    delayRender,
    continueRender,
    cancelRender,
    memoizedEffects
  ]);
  const canvasStyle = useMemo40(() => {
    return {
      width,
      height,
      ...style ?? {}
    };
  }, [height, style, width]);
  return /* @__PURE__ */ jsx31("canvas", {
    ...canvasProps,
    ref: canvasRef,
    width: canvasWidth,
    height: canvasHeight,
    className,
    style: canvasStyle
  });
};
var SolidOuter = forwardRef8(({
  effects = [],
  effectsOutputSize = null,
  controls,
  color,
  height,
  width,
  className,
  durationInFrames,
  style,
  name,
  from,
  premountFor,
  postmountFor,
  styleWhilePremounted,
  styleWhilePostmounted,
  trimBefore,
  playbackRate,
  loop,
  freeze,
  hidden,
  showInTimeline,
  pixelDensity,
  cropLeft,
  cropRight,
  cropTop,
  cropBottom,
  ...props
}, ref) => {
  const memoizedEffectDefinitions = useMemoizedEffectDefinitions(effects);
  const actualRef = useRef24(null);
  useImperativeHandle6(ref, () => {
    return actualRef.current;
  }, []);
  const {
    effectivePremountFor,
    effectivePostmountFor,
    freezeFrame,
    isPremountingOrPostmounting,
    premountingActive,
    postmountingActive,
    premountingStyle
  } = usePremounting({
    from: from ?? 0,
    durationInFrames: resolveSequenceDuration({
      durationInFrames,
      playbackRate,
      loop
    }),
    premountFor: premountFor ?? null,
    postmountFor: postmountFor ?? null,
    style: style ?? null,
    styleWhilePremounted: styleWhilePremounted ?? null,
    styleWhilePostmounted: styleWhilePostmounted ?? null,
    hideWhilePremounted: "opacity"
  });
  const croppedStyle = useCropStyle({
    cropLeft,
    cropRight,
    cropTop,
    cropBottom,
    style: premountingStyle,
    componentName: "<Solid />"
  });
  return /* @__PURE__ */ jsx31(Freeze, {
    frame: freezeFrame,
    active: isPremountingOrPostmounting,
    _remotionInternalIsPremounting: premountingActive,
    children: /* @__PURE__ */ jsx31(Sequence, {
      layout: "none",
      from,
      trimBefore,
      playbackRate,
      loop,
      freeze,
      hidden,
      showInTimeline,
      controls,
      _remotionInternalEffects: memoizedEffectDefinitions,
      durationInFrames,
      name: name ?? "<Solid>",
      _remotionInternalDocumentationLink: "https://www.remotion.dev/docs/solid",
      ...props,
      _remotionInternalPremountDisplay: effectivePremountFor || null,
      _remotionInternalPostmountDisplay: effectivePostmountFor || null,
      _remotionInternalIsPremounting: premountingActive,
      _remotionInternalIsPostmounting: postmountingActive,
      children: /* @__PURE__ */ jsx31(SequenceContent, {
        children: /* @__PURE__ */ jsx31(SolidInner, {
          canvasProps: getCanvasPropsFromSequenceProps(props),
          reference: actualRef,
          videoConfigValues: controls?.videoConfigValues ?? null,
          overrideId: controls?.overrideId ?? null,
          color,
          height,
          width,
          className,
          style: croppedStyle ?? undefined,
          effects,
          effectsOutputSize,
          pixelDensity
        })
      })
    })
  });
});
var Solid = withInteractivitySchema({
  Component: SolidOuter,
  componentName: "<Solid>",
  componentIdentity: "dev.remotion.remotion.Solid",
  schema: solidSchema,
  supportsEffects: true
});
Solid.displayName = "Solid";
addSequenceStackTraces(Solid);
// src/HtmlInCanvas.tsx
import {
  createContext as createContext38,
  forwardRef as forwardRef9,
  useCallback as useCallback18,
  useContext as useContext46,
  useLayoutEffect as useLayoutEffect18,
  useMemo as useMemo41,
  useRef as useRef25
} from "react";

// src/HtmlInCanvasFallback.tsx
import { jsx as jsx32, jsxs as jsxs4 } from "react/jsx-runtime";
var HtmlInCanvasFallback = ({ children, style, label }) => {
  const currentScale = useCurrentScale({ dontThrowIfOutsideOfRemotion: true });
  const scale = currentScale > 0 ? currentScale : 1;
  return /* @__PURE__ */ jsxs4("div", {
    style: { position: "relative", ...style },
    children: [
      children,
      /* @__PURE__ */ jsxs4("div", {
        className: "css-reset",
        style: {
          position: "absolute",
          top: 8 / scale,
          right: 8 / scale,
          zIndex: 1000,
          transform: `scale(${1 / scale})`,
          transformOrigin: "top right",
          maxWidth: `calc(${scale * 100}% - 16px)`,
          padding: "8px 10px",
          borderRadius: 6,
          border: "1px solid #7f3540",
          backgroundColor: "#2b171c",
          boxShadow: "0 2px 8px #0003",
          pointerEvents: "none",
          textAlign: "left"
        },
        children: [
          /* @__PURE__ */ jsx32("div", {
            style: {
              fontFamily: "Arial, Helvetica, sans-serif",
              fontSize: 12,
              fontWeight: 600,
              lineHeight: 1.5,
              color: "#ffabb5"
            },
            children: "HTML-in-canvas is not available"
          }),
          /* @__PURE__ */ jsx32("div", {
            style: {
              fontFamily: "Arial, Helvetica, sans-serif",
              fontSize: 11,
              fontWeight: 400,
              lineHeight: 1.5,
              color: "#e8bdc3"
            },
            children: label
          })
        ]
      })
    ]
  });
};

// src/HtmlInCanvas.tsx
import { jsx as jsx33, jsxs as jsxs5 } from "react/jsx-runtime";
var transferredOffscreenCanvases = new WeakMap;
var getTransferredOffscreenCanvas = (canvas) => {
  const existing = transferredOffscreenCanvases.get(canvas);
  if (existing) {
    return existing;
  }
  const offscreen = canvas.transferControlToOffscreen();
  transferredOffscreenCanvases.set(canvas, offscreen);
  return offscreen;
};
var cachedSupport = null;
var isHtmlInCanvasSupported = () => {
  if (cachedSupport !== null) {
    return cachedSupport;
  }
  if (typeof document === "undefined") {
    return false;
  }
  const canvas = document.createElement("canvas");
  const ctx = canvas.getContext("2d");
  cachedSupport = typeof ctx?.drawElementImage === "function" && typeof canvas.requestPaint === "function" && typeof canvas.captureElementImage === "function" && "transferControlToOffscreen" in HTMLCanvasElement.prototype;
  return cachedSupport;
};
var MINIMUM_CHROME_VERSION_FOR_NESTED_HTML_IN_CANVAS = 157;
var isHtmlInCanvasNestingSupported = () => {
  if (!isHtmlInCanvasSupported() || typeof navigator === "undefined") {
    return false;
  }
  const chromeVersion = navigator.userAgent.match(/(?:Chrome|Chromium)\/(\d+)/)?.[1];
  return chromeVersion !== undefined && Number(chromeVersion) >= MINIMUM_CHROME_VERSION_FOR_NESTED_HTML_IN_CANVAS;
};
var HTML_IN_CANVAS_UNSUPPORTED_MESSAGE = "HTML in Canvas requires Chrome 149 or newer with Canvas Draw Element enabled at chrome://flags/#canvas-draw-element.";
var getHtmlInCanvasUnsupportedMessage = () => {
  if (typeof document === "undefined") {
    return `HTML in Canvas is unavailable because there is no browser document. ${HTML_IN_CANVAS_UNSUPPORTED_MESSAGE}`;
  }
  const userAgent = typeof navigator === "undefined" ? "" : navigator.userAgent;
  const chromiumVersion = userAgent.match(/(?:Chrome|Chromium)\/(\d+)/)?.[1];
  let browser = "this browser";
  if (userAgent.includes("Edg/")) {
    browser = "Microsoft Edge";
  } else if (userAgent.includes("Chromium/")) {
    browser = "Chromium";
  } else if (chromiumVersion) {
    browser = "Chrome";
  } else if (userAgent.includes("Firefox/")) {
    browser = "Firefox";
  } else if (userAgent.includes("Safari/")) {
    browser = "Safari";
  }
  if (chromiumVersion && Number(chromiumVersion) >= 149) {
    const flagUrl = browser === "Microsoft Edge" ? "edge://flags/#canvas-draw-element" : "chrome://flags/#canvas-draw-element";
    return `HTML in Canvas is unavailable. Enable Canvas Draw Element at ${flagUrl} and fully restart ${browser}.`;
  }
  if (chromiumVersion) {
    return `HTML in Canvas is not supported in ${browser} ${chromiumVersion}. Use a Chromium-based browser running version 149 or newer.`;
  }
  return `HTML in Canvas is not supported in ${browser}. Use Chrome 149 or newer.`;
};
function assertHtmlInCanvasDimensions(width, height) {
  if (typeof width !== "number" || typeof height !== "number") {
    throw new Error(`HtmlInCanvas: \`width\` and \`height\` must be numbers. Received width=${String(width)}, height=${String(height)}.`);
  }
  if (!Number.isInteger(width) || width <= 0) {
    throw new Error(`HtmlInCanvas: \`width\` must be a positive integer. Received: ${String(width)}.`);
  }
  if (!Number.isInteger(height) || height <= 0) {
    throw new Error(`HtmlInCanvas: \`height\` must be a positive integer. Received: ${String(height)}.`);
  }
}
function resolveHtmlInCanvasPixelDensity(pixelDensity) {
  if (pixelDensity === undefined) {
    return 1;
  }
  if (typeof pixelDensity !== "number" || !Number.isFinite(pixelDensity) || pixelDensity <= 0) {
    throw new Error(`HtmlInCanvas: \`pixelDensity\` must be a positive finite number. Received: ${String(pixelDensity)}.`);
  }
  return pixelDensity;
}
var isMissingPaintRecordError = (error) => {
  return error instanceof DOMException && error.name === "InvalidStateError";
};
var missingPaintRecordMessage = "HtmlInCanvas: Expected the element to be inside the viewport during rendering, but Chrome had no cached paint record for it.";
var resizePaintTarget = ({
  target,
  width,
  height
}) => {
  if (target.width !== width) {
    target.width = width;
  }
  if (target.height !== height) {
    target.height = height;
  }
};
var defaultOnPaint = ({
  canvas,
  elementImage
}) => {
  const ctx = canvas.getContext("2d");
  if (!ctx) {
    throw new Error("Failed to acquire 2D context for <HtmlInCanvas> canvas");
  }
  ctx.reset();
  ctx.drawElementImage(elementImage, 0, 0);
};
var HtmlInCanvasAncestorContext = createContext38(null);
var useHtmlInCanvasUnsupportedMessage = () => {
  const ancestorPaintState = useContext46(HtmlInCanvasAncestorContext);
  if (!isHtmlInCanvasSupported()) {
    return getHtmlInCanvasUnsupportedMessage();
  }
  if (ancestorPaintState && !isHtmlInCanvasNestingSupported()) {
    return `Nested <HtmlInCanvas> components require Chrome ${MINIMUM_CHROME_VERSION_FOR_NESTED_HTML_IN_CANVAS} or newer with HTML-in-canvas enabled.`;
  }
  return null;
};
var HtmlInCanvasContent = forwardRef9(({
  width,
  height,
  effects,
  effectsOutputSize,
  children,
  canvasSiblings,
  onPaint,
  onInit,
  pixelDensity,
  controls,
  style,
  renderFrame
}, ref) => {
  const ancestorPaintState = useContext46(HtmlInCanvasAncestorContext);
  assertHtmlInCanvasDimensions(width, height);
  if (ancestorPaintState && !isHtmlInCanvasNestingSupported()) {
    throw new Error(`Nested <HtmlInCanvas> components require Chrome ${MINIMUM_CHROME_VERSION_FOR_NESTED_HTML_IN_CANVAS} or newer with HTML-in-canvas enabled.`);
  }
  const resolvedPixelDensity = resolveHtmlInCanvasPixelDensity(pixelDensity);
  const canvasWidth = Math.ceil(width * resolvedPixelDensity);
  const canvasHeight = Math.ceil(height * resolvedPixelDensity);
  const { delayRender, continueRender, cancelRender } = useDelayRender();
  const { isClientSideRendering, isRendering } = useRemotionEnvironment();
  const canRetryMissingPaintRecord = !isRendering || isClientSideRendering;
  const usesDirectLayoutCanvas = onPaint === undefined && onInit === undefined;
  const paintTargetMode = ancestorPaintState ? "copied" : usesDirectLayoutCanvas ? "direct" : isRendering ? "copied" : "transferred";
  if (!isHtmlInCanvasSupported()) {
    cancelRender(new Error(getHtmlInCanvasUnsupportedMessage()));
  }
  const canvas2dRef = useRef25(null);
  const outputCanvasRef = useRef25(null);
  const paintTargetRef = useRef25(null);
  const divRef = useRef25(null);
  const canvasSizeKey = `${width}x${height}@${resolvedPixelDensity}-${paintTargetMode}`;
  const paintState = useMemo41(() => {
    const state = {
      pendingChildren: 0,
      generation: 0,
      release: null,
      blockPaint: () => {
        state.pendingChildren++;
        state.generation++;
        if (state.release === null) {
          const handle = delayRender("waiting for nested HtmlInCanvas paint");
          const releaseAncestor = ancestorPaintState?.blockPaint();
          state.release = () => {
            continueRender(handle);
            releaseAncestor?.();
          };
        }
        let released = false;
        return () => {
          if (released) {
            return;
          }
          released = true;
          state.pendingChildren--;
          if (state.pendingChildren === 0) {
            canvas2dRef.current?.requestPaint?.();
          }
        };
      }
    };
    return state;
  }, [continueRender, delayRender, ancestorPaintState]);
  const setVisibleCanvasRef = useCallback18((node) => {
    if (paintTargetMode === "copied") {
      outputCanvasRef.current = node;
    } else {
      canvas2dRef.current = node;
    }
    if (typeof ref === "function") {
      ref(node);
    } else if (ref) {
      ref.current = node;
    }
  }, [ref, paintTargetMode]);
  const chainState = useEffectChainState(effectsOutputSize);
  const memoizedEffects = useMemoizedEffects({
    effects,
    overrideId: controls?.overrideId ?? null,
    videoConfigValues: controls?.videoConfigValues ?? null
  });
  const effectsRef = useRef25(memoizedEffects);
  effectsRef.current = memoizedEffects;
  const onPaintRef = useRef25(onPaint);
  onPaintRef.current = onPaint;
  const onInitRef = useRef25(onInit);
  onInitRef.current = onInit;
  const initializedRef = useRef25(false);
  const onInitCleanupRef = useRef25(null);
  const unmountedRef = useRef25(false);
  const effectScratchCanvasesRef = useRef25(null);
  const paintingTargets = useRef25(new WeakMap);
  const onPaintCb = useCallback18(async () => {
    if (isRendering && paintState.pendingChildren > 0) {
      return;
    }
    const childrenGeneration = paintState.generation;
    const element = divRef.current;
    if (!element) {
      throw new Error("Canvas or scene element not found");
    }
    const paintTarget = paintTargetRef.current;
    if (!paintTarget) {
      throw new Error("HtmlInCanvas: paint target is not ready because the canvas is remounting");
    }
    const inProgress = paintingTargets.current.get(paintTarget);
    if (isRendering && inProgress) {
      inProgress.repaint = true;
      return;
    }
    const painting = { repaint: false };
    if (isRendering) {
      paintingTargets.current.set(paintTarget, painting);
    }
    resizePaintTarget({
      target: paintTarget,
      width: canvasWidth,
      height: canvasHeight
    });
    const releaseAncestor = isRendering ? ancestorPaintState?.blockPaint() : null;
    let canReleasePaint = false;
    try {
      const placeholderCanvas = canvas2dRef.current;
      if (!placeholderCanvas) {
        throw new Error("Canvas not found");
      }
      const outputCanvas = outputCanvasRef.current;
      const handle = delayRender("onPaint");
      if (!initializedRef.current) {
        const currentOnInit = onInitRef.current;
        if (!currentOnInit) {
          initializedRef.current = true;
        } else {
          let initImage;
          try {
            initImage = placeholderCanvas.captureElementImage(element);
          } catch (error) {
            if (isMissingPaintRecordError(error) && canRetryMissingPaintRecord) {
              canReleasePaint = true;
              continueRender(handle);
              return;
            }
            if (isMissingPaintRecordError(error)) {
              throw new Error(missingPaintRecordMessage);
            }
            throw error;
          }
          initializedRef.current = true;
          try {
            if (paintTarget instanceof HTMLCanvasElement) {
              throw new Error("HtmlInCanvas: onInit requires an OffscreenCanvas paint target");
            }
            const cleanup = await currentOnInit({
              canvas: paintTarget,
              element,
              elementImage: initImage,
              pixelDensity: resolvedPixelDensity
            });
            if (typeof cleanup !== "function") {
              throw new Error("HtmlInCanvas: when `onInit` is provided, it must return a cleanup function, or a Promise that resolves to one.");
            }
            if (unmountedRef.current || paintTargetRef.current !== paintTarget) {
              cleanup();
              continueRender(handle);
              return;
            }
            onInitCleanupRef.current = cleanup;
          } finally {
            initImage.close();
          }
        }
      }
      let elImage;
      try {
        elImage = placeholderCanvas.captureElementImage(element);
      } catch (error) {
        if (isMissingPaintRecordError(error) && canRetryMissingPaintRecord) {
          canReleasePaint = true;
          continueRender(handle);
          return;
        }
        if (isMissingPaintRecordError(error)) {
          throw new Error(missingPaintRecordMessage);
        }
        throw error;
      }
      let effectSourceCanvas = null;
      try {
        const currentOnPaint = onPaintRef.current;
        if (currentOnPaint) {
          if (paintTarget instanceof HTMLCanvasElement) {
            throw new Error("HtmlInCanvas: onPaint requires an OffscreenCanvas paint target");
          }
          const paintResult = currentOnPaint({
            canvas: paintTarget,
            element,
            elementImage: elImage,
            pixelDensity: resolvedPixelDensity
          });
          if (paintResult) {
            await paintResult;
          }
        } else if (paintTarget instanceof HTMLCanvasElement && effectsRef.current.some((effect) => !effect.params.disabled)) {
          effectScratchCanvasesRef.current ??= {
            source: document.createElement("canvas"),
            previousOutput: document.createElement("canvas")
          };
          const { source: effectSource, previousOutput } = effectScratchCanvasesRef.current;
          resizePaintTarget({
            target: effectSource,
            width: canvasWidth,
            height: canvasHeight
          });
          resizePaintTarget({
            target: previousOutput,
            width: canvasWidth,
            height: canvasHeight
          });
          const effectSourceCtx = effectSource.getContext("2d");
          const previousOutputCtx = previousOutput.getContext("2d");
          const paintTargetCtx = paintTarget.getContext("2d");
          if (!effectSourceCtx || !previousOutputCtx || !paintTargetCtx) {
            throw new Error("Failed to acquire 2D context for <HtmlInCanvas> canvas");
          }
          previousOutputCtx.reset();
          previousOutputCtx.drawImage(paintTarget, 0, 0);
          defaultOnPaint({
            canvas: paintTarget,
            element,
            elementImage: elImage,
            pixelDensity: resolvedPixelDensity
          });
          effectSourceCtx.reset();
          effectSourceCtx.drawImage(paintTarget, 0, 0);
          paintTargetCtx.reset();
          paintTargetCtx.drawImage(previousOutput, 0, 0);
          effectSourceCanvas = effectSource;
        } else {
          defaultOnPaint({
            canvas: paintTarget,
            element,
            elementImage: elImage,
            pixelDensity: resolvedPixelDensity
          });
        }
        const state = chainState.get(canvasWidth, canvasHeight);
        if (state) {
          await runEffectChain({
            state,
            source: effectSourceCanvas ?? paintTarget,
            effects: effectsRef.current,
            output: paintTarget,
            width: canvasWidth,
            height: canvasHeight
          });
        }
      } finally {
        elImage.close();
      }
      if (paintTargetMode === "copied" && paintTargetRef.current === paintTarget && outputCanvas) {
        const ctx = outputCanvas.getContext("2d");
        if (!ctx) {
          throw new Error("HtmlInCanvas: could not get layout canvas context");
        }
        ctx.reset();
        ctx.drawImage(paintTarget, 0, 0);
      }
      canReleasePaint = true;
      continueRender(handle);
    } catch (error) {
      cancelRender(error);
    } finally {
      if (canReleasePaint && paintState.pendingChildren === 0 && paintState.generation === childrenGeneration) {
        const { release } = paintState;
        paintState.release = null;
        release?.();
      }
      releaseAncestor?.();
      paintingTargets.current.delete(paintTarget);
      if (painting.repaint && paintTargetRef.current === paintTarget) {
        canvas2dRef.current?.requestPaint?.();
      }
    }
  }, [
    canvasHeight,
    canvasWidth,
    chainState,
    continueRender,
    cancelRender,
    delayRender,
    resolvedPixelDensity,
    canRetryMissingPaintRecord,
    paintTargetMode,
    isRendering,
    paintState,
    ancestorPaintState
  ]);
  useLayoutEffect18(() => {
    return () => {
      paintState.release?.();
      paintState.release = null;
    };
  }, [paintState]);
  useLayoutEffect18(() => {
    const placeholder = canvas2dRef.current;
    if (!placeholder) {
      throw new Error("Canvas not found");
    }
    placeholder.setAttribute("content", "drawable");
    placeholder.layoutSubtree = true;
    divRef.current?.setAttribute("drawable", "");
    const paintTarget = paintTargetMode === "direct" ? placeholder : getTransferredOffscreenCanvas(placeholder);
    paintTargetRef.current = paintTarget;
    resizePaintTarget({
      target: paintTarget,
      width: canvasWidth,
      height: canvasHeight
    });
    initializedRef.current = false;
    unmountedRef.current = false;
    placeholder.addEventListener("paint", onPaintCb);
    return () => {
      placeholder.removeEventListener("paint", onPaintCb);
      paintTargetRef.current = null;
      initializedRef.current = false;
      unmountedRef.current = true;
      onInitCleanupRef.current?.();
      onInitCleanupRef.current = null;
    };
  }, [onPaintCb, cancelRender, canvasWidth, canvasHeight, paintTargetMode]);
  const onPaintChangedRef = useRef25(false);
  useLayoutEffect18(() => {
    if (!onPaintChangedRef.current) {
      onPaintChangedRef.current = true;
      return;
    }
    const canvas = canvas2dRef.current;
    if (!canvas) {
      return;
    }
    canvas.requestPaint?.();
  }, [onPaint, memoizedEffects]);
  useLayoutEffect18(() => {
    const canvas = canvas2dRef.current;
    if (!canvas) {
      return;
    }
    const handle = delayRender("waiting for HtmlInCanvas paint");
    const releaseAncestor = isRendering ? ancestorPaintState?.blockPaint() : null;
    const onPainted = () => {
      continueRender(handle);
      releaseAncestor?.();
    };
    canvas.addEventListener("paint", onPainted, { once: true });
    canvas.requestPaint?.();
    return () => {
      canvas.removeEventListener("paint", onPainted);
      onPainted();
    };
  }, [
    width,
    height,
    continueRender,
    delayRender,
    canvasSizeKey,
    renderFrame,
    isRendering,
    ancestorPaintState
  ]);
  const innerStyle = useMemo41(() => {
    return {
      width,
      height
    };
  }, [width, height]);
  const canvasStyle = useMemo41(() => {
    return {
      width,
      height,
      ...style ?? {}
    };
  }, [height, style, width]);
  return /* @__PURE__ */ jsxs5(HtmlInCanvasAncestorContext.Provider, {
    value: paintState,
    children: [
      /* @__PURE__ */ jsx33("canvas", {
        ref: paintTargetMode === "copied" ? canvas2dRef : setVisibleCanvasRef,
        width: canvasWidth,
        height: canvasHeight,
        style: paintTargetMode === "copied" ? {
          ...canvasStyle,
          position: "absolute",
          visibility: "hidden",
          pointerEvents: "none"
        } : canvasStyle,
        children: /* @__PURE__ */ jsxs5(DefaultPremountContext.Provider, {
          value: 0,
          children: [
            /* @__PURE__ */ jsx33("div", {
              ref: divRef,
              style: paintTargetMode === "copied" ? { ...innerStyle, visibility: "visible" } : innerStyle,
              children
            }),
            canvasSiblings
          ]
        })
      }, canvasSizeKey),
      paintTargetMode === "copied" ? /* @__PURE__ */ jsx33("canvas", {
        ref: setVisibleCanvasRef,
        width: canvasWidth,
        height: canvasHeight,
        style: canvasStyle
      }, `output-${canvasSizeKey}`) : null
    ]
  });
});
HtmlInCanvasContent.displayName = "HtmlInCanvasContent";
var HtmlInCanvasContentForRendering = forwardRef9((props, ref) => {
  const frame = useCurrentFrame();
  return /* @__PURE__ */ jsx33(HtmlInCanvasContent, {
    ...props,
    ref,
    renderFrame: frame
  });
});
HtmlInCanvasContentForRendering.displayName = "HtmlInCanvasContentForRendering";
var HtmlInCanvasInner = forwardRef9(({
  width,
  height,
  effects = [],
  effectsOutputSize,
  children,
  onPaint,
  onInit,
  pixelDensity,
  _remotionInternalCanvasSiblings,
  _remotionInternalFallbackLabel = "Effects are not visible",
  controls,
  style,
  cropLeft,
  cropRight,
  cropTop,
  cropBottom,
  durationInFrames,
  premountFor,
  postmountFor,
  styleWhilePremounted,
  styleWhilePostmounted,
  name,
  ...sequenceProps
}, ref) => {
  const { isRendering } = useRemotionEnvironment();
  const unsupportedMessage = useHtmlInCanvasUnsupportedMessage();
  assertHtmlInCanvasDimensions(width, height);
  resolveHtmlInCanvasPixelDensity(pixelDensity);
  const Content = isRendering ? HtmlInCanvasContentForRendering : HtmlInCanvasContent;
  const memoizedEffectDefinitions = useMemoizedEffectDefinitions(effects);
  const actualRef = useRef25(null);
  const setCanvasRef = useCallback18((node) => {
    actualRef.current = node;
    if (typeof ref === "function") {
      ref(node);
    } else if (ref) {
      ref.current = node;
    }
  }, [ref]);
  const {
    effectivePremountFor,
    effectivePostmountFor,
    freezeFrame,
    isPremountingOrPostmounting,
    premountingActive,
    postmountingActive,
    premountingStyle
  } = usePremounting({
    from: sequenceProps.from ?? 0,
    durationInFrames: resolveSequenceDuration({
      durationInFrames,
      playbackRate: sequenceProps.playbackRate,
      loop: sequenceProps.loop
    }),
    premountFor: premountFor ?? null,
    postmountFor: postmountFor ?? null,
    style: style ?? null,
    styleWhilePremounted: styleWhilePremounted ?? null,
    styleWhilePostmounted: styleWhilePostmounted ?? null,
    hideWhilePremounted: "opacity"
  });
  const croppedStyle = useCropStyle({
    cropLeft,
    cropRight,
    cropTop,
    cropBottom,
    style: premountingStyle,
    componentName: "<HtmlInCanvas />"
  });
  return /* @__PURE__ */ jsx33(Freeze, {
    frame: freezeFrame,
    active: isPremountingOrPostmounting,
    _remotionInternalIsPremounting: premountingActive,
    children: /* @__PURE__ */ jsx33(Sequence, {
      layout: "none",
      durationInFrames,
      name: name ?? "<HtmlInCanvas>",
      _remotionInternalDocumentationLink: "https://www.remotion.dev/docs/remotion/html-in-canvas",
      controls,
      _remotionInternalEffects: memoizedEffectDefinitions,
      ...sequenceProps,
      _remotionInternalPremountDisplay: effectivePremountFor || null,
      _remotionInternalPostmountDisplay: effectivePostmountFor || null,
      _remotionInternalIsPremounting: premountingActive,
      _remotionInternalIsPostmounting: postmountingActive,
      children: !isRendering && unsupportedMessage !== null ? /* @__PURE__ */ jsx33(HtmlInCanvasFallback, {
        style: { width, height, ...croppedStyle },
        label: _remotionInternalFallbackLabel,
        children: /* @__PURE__ */ jsx33(DefaultPremountContext.Provider, {
          value: 0,
          children: /* @__PURE__ */ jsx33("div", {
            style: { width, height },
            children
          })
        })
      }) : /* @__PURE__ */ jsx33(Content, {
        ref: setCanvasRef,
        renderFrame: null,
        width,
        height,
        effects,
        effectsOutputSize: effectsOutputSize ?? null,
        onPaint,
        onInit,
        pixelDensity,
        canvasSiblings: _remotionInternalCanvasSiblings ?? null,
        controls,
        style: croppedStyle ?? undefined,
        children
      })
    })
  });
});
HtmlInCanvasInner.displayName = "HtmlInCanvas";
var htmlInCanvasSchema = {
  ...baseSchema,
  ...premountSchema,
  pixelDensity: {
    type: "number",
    min: 1,
    max: 3,
    step: 0.1,
    default: 1,
    description: "Pixel density",
    hiddenFromList: false
  },
  ...transformSchema,
  ...backgroundSchema,
  ...borderSchema,
  ...borderRadiusSchema,
  ...cropSchema
};
var HtmlInCanvasWrapped = withInteractivitySchema({
  Component: HtmlInCanvasInner,
  componentName: "<HtmlInCanvas>",
  componentIdentity: "dev.remotion.remotion.HtmlInCanvas",
  schema: htmlInCanvasSchema,
  supportsEffects: true
});
var HtmlInCanvas = Object.assign(HtmlInCanvasWrapped, {
  isSupported: isHtmlInCanvasSupported,
  isNestingSupported: isHtmlInCanvasNestingSupported
});
HtmlInCanvas.displayName = "HtmlInCanvas";
addSequenceStackTraces(HtmlInCanvas);
// src/canvas-image/CanvasImage.tsx
import {
  forwardRef as forwardRef10,
  useContext as useContext47,
  useImperativeHandle as useImperativeHandle7,
  useLayoutEffect as useLayoutEffect19,
  useMemo as useMemo42,
  useRef as useRef26,
  useState as useState22
} from "react";

// src/truncate-src-for-label.ts
function truncateSrcForLabel(src) {
  if (typeof src !== "string") {
    return String(src);
  }
  if (src.length > 100 && (src.startsWith("data:") || src.startsWith("blob:"))) {
    return src.slice(0, 60) + "...[" + src.length + " chars total]";
  }
  return src;
}

// src/canvas-image/CanvasImage.tsx
import { jsx as jsx34 } from "react/jsx-runtime";
var canvasImageSchema = {
  src: {
    type: "asset",
    assetType: "image",
    default: undefined,
    description: "Source",
    keyframable: false
  },
  ...baseSchemaWithoutPlaybackRate,
  ...cropSchema,
  ...premountSchema,
  fit: {
    type: "enum",
    default: "fill",
    description: "Fit",
    variants: {
      fill: {},
      contain: {},
      cover: {}
    }
  },
  ...transformSchema,
  ...backgroundSchema,
  ...borderSchema,
  ...borderRadiusSchema
};
var continueImageLoadDelay = (pendingLoadDelayRef, setIsLoadPending, continueRender, { markAsReady }) => {
  const pending = pendingLoadDelayRef.current;
  if (!pending || pending.continued) {
    return;
  }
  pending.continued = true;
  if (markAsReady) {
    setIsLoadPending(false);
  }
  continueRender(pending.handle);
  pendingLoadDelayRef.current = null;
};
var setCanvasRef = (setOutputCanvas, ref, canvas) => {
  setOutputCanvas(canvas);
  if (typeof ref === "function") {
    ref(canvas);
  } else if (ref) {
    ref.current = canvas;
  }
};
var makeAbortError = () => {
  if (typeof DOMException !== "undefined") {
    return new DOMException("Image loading was aborted", "AbortError");
  }
  const error = new Error("Image loading was aborted");
  error.name = "AbortError";
  return error;
};
var loadImage = ({
  src,
  signal,
  crossOrigin
}) => {
  return new Promise((resolve, reject) => {
    const image = new Image;
    let settled = false;
    function cleanup() {
      image.onload = null;
      image.onerror = null;
    }
    function settle(callback) {
      if (settled) {
        return;
      }
      settled = true;
      cleanup();
      callback();
    }
    function onAbort() {
      settle(() => reject(makeAbortError()));
    }
    image.onload = () => {
      Promise.resolve(image.decode?.()).catch(() => {
        return;
      }).then(() => {
        const imageWidth = image.naturalWidth || image.width;
        const imageHeight = image.naturalHeight || image.height;
        if (imageWidth <= 0 || imageHeight <= 0) {
          settle(() => reject(new Error(`Could not determine dimensions for <CanvasImage> with src="${truncateSrcForLabel(src)}"`)));
          return;
        }
        settle(() => resolve({ element: image, width: imageWidth, height: imageHeight }));
      });
    };
    image.onerror = () => {
      settle(() => reject(new Error(`Could not load <CanvasImage> with src="${truncateSrcForLabel(src)}"`)));
    };
    signal.addEventListener("abort", onAbort, { once: true });
    if (signal.aborted) {
      onAbort();
      return;
    }
    image.crossOrigin = crossOrigin || "anonymous";
    image.src = src;
  });
};
function exponentialBackoff(errorCount) {
  return 1000 * 2 ** (errorCount - 1);
}
var waitForNextFrame = ({
  onFrame
}) => {
  if (typeof requestAnimationFrame === "undefined") {
    onFrame();
    return () => {
      return;
    };
  }
  const frame = requestAnimationFrame(onFrame);
  return () => cancelAnimationFrame(frame);
};
var CanvasImageContent = forwardRef10(({
  src,
  crossOrigin,
  width,
  height,
  fit = "fill",
  effects,
  effectsOutputSize,
  controls,
  onError,
  className,
  style,
  id,
  pauseWhenLoading,
  maxRetries = 2,
  delayRenderRetries,
  delayRenderTimeoutInMilliseconds,
  ...canvasProps
}, ref) => {
  const { delayRender, continueRender, cancelRender } = useDelayRender();
  const { delayPlayback } = useBufferState();
  const [outputCanvas, setOutputCanvas] = useState22(null);
  const [loadedImage, setLoadedImage] = useState22(null);
  const actualSrc = usePreload(src);
  const chainState = useEffectChainState(effectsOutputSize);
  const memoizedEffects = useMemoizedEffects({
    effects,
    overrideId: controls?.overrideId ?? null,
    videoConfigValues: controls?.videoConfigValues ?? null
  });
  const sequenceContext = useContext47(SequenceContext);
  const pendingLoadDelayRef = useRef26(null);
  const [isLoadPending, setIsLoadPending] = useState22(false);
  const isPremounting = Boolean(sequenceContext?.premounting);
  const isPostmounting = Boolean(sequenceContext?.postmounting);
  const continuePendingLoadDelay = useMemo42(() => continueImageLoadDelay.bind(null, pendingLoadDelayRef, setIsLoadPending, continueRender), [continueRender]);
  const sourceCanvas = useMemo42(() => {
    if (typeof document === "undefined") {
      return null;
    }
    return document.createElement("canvas");
  }, []);
  const canvasRef = useMemo42(() => setCanvasRef.bind(null, setOutputCanvas, ref), [ref]);
  useLayoutEffect19(() => {
    if (!pauseWhenLoading || !isLoadPending || isPremounting || isPostmounting) {
      return;
    }
    return delayPlayback().unblock;
  }, [
    delayPlayback,
    isLoadPending,
    isPostmounting,
    isPremounting,
    pauseWhenLoading
  ]);
  useLayoutEffect19(() => {
    const handle = delayRender(`Rendering <CanvasImage> with src="${truncateSrcForLabel(actualSrc)}"`, {
      retries: delayRenderRetries ?? undefined,
      timeoutInMilliseconds: delayRenderTimeoutInMilliseconds ?? undefined
    });
    const controller = new AbortController;
    let cancelled = false;
    let errorCount = 0;
    let timeoutId = null;
    setLoadedImage(null);
    setIsLoadPending(true);
    pendingLoadDelayRef.current = {
      handle,
      continued: false
    };
    const attemptLoad = () => {
      loadImage({ src: actualSrc, signal: controller.signal, crossOrigin }).then((image) => {
        if (cancelled) {
          return;
        }
        setLoadedImage(image);
      }).catch((err) => {
        if (err.name === "AbortError") {
          continuePendingLoadDelay({ markAsReady: false });
          return;
        }
        errorCount++;
        if (errorCount <= maxRetries) {
          const backoff = exponentialBackoff(errorCount);
          console.warn(`Could not load <CanvasImage> with src="${truncateSrcForLabel(actualSrc)}", retrying in ${backoff}ms`);
          timeoutId = setTimeout(() => {
            if (!cancelled) {
              attemptLoad();
            }
          }, backoff);
        } else if (onError) {
          onError(err);
          continuePendingLoadDelay({ markAsReady: true });
        } else {
          cancelRender(err);
        }
      });
    };
    attemptLoad();
    return () => {
      cancelled = true;
      if (timeoutId !== null) {
        clearTimeout(timeoutId);
      }
      controller.abort();
      continuePendingLoadDelay({ markAsReady: false });
    };
  }, [
    actualSrc,
    cancelRender,
    continuePendingLoadDelay,
    crossOrigin,
    delayRender,
    delayRenderRetries,
    delayRenderTimeoutInMilliseconds,
    maxRetries,
    onError
  ]);
  useLayoutEffect19(() => {
    if (!loadedImage || !outputCanvas || !sourceCanvas) {
      return;
    }
    const handle = delayRender(`Applying effects to <CanvasImage> with src="${truncateSrcForLabel(actualSrc)}"`);
    let cancelled = false;
    let continued = false;
    let cancelWaitForNextFrame = () => {
      return;
    };
    const continueRenderOnce = () => {
      if (continued) {
        return;
      }
      continued = true;
      continueRender(handle);
    };
    const canvasWidth = width ?? loadedImage.width;
    const canvasHeight = height ?? loadedImage.height;
    const sourceContext = sourceCanvas.getContext("2d", {
      colorSpace: "srgb"
    });
    if (!sourceContext) {
      cancelRender(new Error("Could not get 2D context for <CanvasImage> source canvas"));
      continueRenderOnce();
      return () => {
        continueRenderOnce();
      };
    }
    sourceCanvas.width = canvasWidth;
    sourceCanvas.height = canvasHeight;
    outputCanvas.width = canvasWidth;
    outputCanvas.height = canvasHeight;
    sourceContext.clearRect(0, 0, canvasWidth, canvasHeight);
    sourceContext.drawImage(loadedImage.element, ...calculateImageFit(fit, { width: loadedImage.width, height: loadedImage.height }, { width: canvasWidth, height: canvasHeight }));
    runEffectChain({
      state: chainState.get(canvasWidth, canvasHeight),
      source: sourceCanvas,
      effects: memoizedEffects,
      output: outputCanvas,
      width: canvasWidth,
      height: canvasHeight
    }).then((completed) => {
      if (completed && !cancelled) {
        cancelWaitForNextFrame = waitForNextFrame({
          onFrame: () => {
            if (cancelled) {
              return;
            }
            continueRenderOnce();
            continuePendingLoadDelay({ markAsReady: true });
          }
        });
      }
    }).catch((err) => {
      if (cancelled) {
        return;
      }
      if (onError) {
        onError(err);
        continueRenderOnce();
        continuePendingLoadDelay({ markAsReady: true });
      } else {
        cancelRender(err);
      }
    });
    return () => {
      cancelled = true;
      cancelWaitForNextFrame();
      continueRenderOnce();
    };
  }, [
    actualSrc,
    cancelRender,
    chainState,
    continueRender,
    continuePendingLoadDelay,
    delayRender,
    fit,
    height,
    loadedImage,
    memoizedEffects,
    onError,
    outputCanvas,
    sourceCanvas,
    width
  ]);
  return /* @__PURE__ */ jsx34("canvas", {
    ...canvasProps,
    ref: canvasRef,
    width,
    height,
    className,
    style,
    id
  });
});
CanvasImageContent.displayName = "CanvasImageContent";
var CanvasImageInner = forwardRef10(({
  src,
  crossOrigin,
  width,
  height,
  fit,
  effects = [],
  effectsOutputSize,
  className,
  style,
  id,
  onError,
  pauseWhenLoading,
  maxRetries,
  delayRenderRetries,
  delayRenderTimeoutInMilliseconds,
  durationInFrames,
  from,
  trimBefore,
  loop,
  freeze,
  premountFor,
  postmountFor,
  styleWhilePremounted,
  styleWhilePostmounted,
  hidden,
  name,
  showInTimeline,
  cropLeft,
  cropRight,
  cropTop,
  cropBottom,
  controls,
  _remotionInternalDocumentationLink,
  _remotionInternalCropComponentName,
  ...canvasProps
}, ref) => {
  if (!src) {
    throw new Error('No "src" prop was passed to <CanvasImage>.');
  }
  const isMedia = useMemo42(() => ({
    type: "image",
    src,
    animated: null
  }), [src]);
  const memoizedEffectDefinitions = useMemoizedEffectDefinitions(effects);
  const actualRef = useRef26(null);
  useImperativeHandle7(ref, () => {
    return actualRef.current;
  }, []);
  const {
    effectivePostmountFor,
    effectivePremountFor,
    freezeFrame,
    isPremountingOrPostmounting,
    postmountingActive,
    premountingActive,
    premountingStyle
  } = usePremounting({
    from: from ?? 0,
    durationInFrames: resolveSequenceDuration({
      durationInFrames,
      playbackRate: undefined,
      loop
    }),
    premountFor: premountFor ?? null,
    postmountFor: postmountFor ?? null,
    style: style ?? null,
    styleWhilePremounted: styleWhilePremounted ?? null,
    styleWhilePostmounted: styleWhilePostmounted ?? null,
    hideWhilePremounted: "display-none"
  });
  const croppedStyle = useCropStyle({
    cropLeft,
    cropRight,
    cropTop,
    cropBottom,
    style: premountingStyle,
    componentName: _remotionInternalCropComponentName ?? "<CanvasImage />"
  });
  return /* @__PURE__ */ jsx34(Freeze, {
    frame: freezeFrame,
    active: isPremountingOrPostmounting,
    _remotionInternalIsPremounting: premountingActive,
    children: /* @__PURE__ */ jsx34(Sequence, {
      layout: "none",
      from: from ?? 0,
      trimBefore,
      loop,
      durationInFrames,
      freeze,
      hidden,
      showInTimeline: showInTimeline ?? true,
      name: name ?? "<CanvasImage>",
      _remotionInternalDocumentationLink: _remotionInternalDocumentationLink ?? "https://www.remotion.dev/docs/canvasimage",
      controls,
      _remotionInternalEffects: memoizedEffectDefinitions,
      _remotionInternalIsMedia: isMedia,
      _remotionInternalPremountDisplay: effectivePremountFor || null,
      _remotionInternalPostmountDisplay: effectivePostmountFor || null,
      _remotionInternalIsPremounting: premountingActive,
      _remotionInternalIsPostmounting: postmountingActive,
      children: /* @__PURE__ */ jsx34(SequenceContent, {
        children: /* @__PURE__ */ jsx34(CanvasImageContent, {
          ref: actualRef,
          src,
          crossOrigin,
          width,
          height,
          fit,
          effects,
          effectsOutputSize: effectsOutputSize ?? null,
          controls,
          className,
          style: croppedStyle ?? undefined,
          id,
          onError,
          pauseWhenLoading,
          maxRetries,
          delayRenderRetries,
          delayRenderTimeoutInMilliseconds,
          ...canvasProps
        })
      })
    })
  });
});
var CanvasImage = withInteractivitySchema({
  Component: CanvasImageInner,
  componentName: "<CanvasImage>",
  componentIdentity: "dev.remotion.remotion.CanvasImage",
  schema: canvasImageSchema,
  supportsEffects: true
});
CanvasImage.displayName = "CanvasImage";
addSequenceStackTraces(CanvasImage);
// src/get-static-files.ts
var warnedServer = false;
var warnedPlayer = false;
var warnServerOnce = () => {
  if (warnedServer) {
    return;
  }
  warnedServer = true;
  console.warn("Called getStaticFiles() on the server. The API is only available in the browser. An empty array was returned.");
};
var warnPlayerOnce = () => {
  if (warnedPlayer) {
    return;
  }
  warnedPlayer = true;
  console.warn("Called getStaticFiles() while using the Remotion Player. The API is only available while using the Remotion Studio. An empty array was returned.");
};
var getStaticFiles = () => {
  if (ENABLE_V5_BREAKING_CHANGES) {
    throw new Error("getStaticFiles() has moved into the `@remotion/studio` package. Update your imports.");
  }
  if (typeof document === "undefined") {
    warnServerOnce();
    return [];
  }
  if (window.remotion_isPlayer) {
    warnPlayerOnce();
    return [];
  }
  return window.remotion_staticFiles;
};
// src/IFrame.tsx
import { forwardRef as forwardRef11, useCallback as useCallback19, useLayoutEffect as useLayoutEffect20, useRef as useRef27 } from "react";
import { jsx as jsx35 } from "react/jsx-runtime";
var IFrameRefForwarding = ({
  onLoad,
  onError,
  delayRenderRetries,
  delayRenderTimeoutInMilliseconds,
  ...props
}, ref) => {
  const { delayRender, continueRender } = useDelayRender();
  const handle = useRef27(null);
  const loadedSource = useRef27(null);
  const { src, srcDoc } = props;
  useLayoutEffect20(() => {
    if (loadedSource.current?.src === src && loadedSource.current?.srcDoc === srcDoc && loadedSource.current !== null) {
      return;
    }
    const newHandle = delayRender(`Loading <IFrame> with source ${src}`, {
      retries: delayRenderRetries ?? undefined,
      timeoutInMilliseconds: delayRenderTimeoutInMilliseconds ?? undefined
    });
    loadedSource.current = null;
    handle.current = newHandle;
    return () => {
      continueRender(newHandle);
      handle.current = null;
    };
  }, [
    continueRender,
    delayRender,
    delayRenderRetries,
    delayRenderTimeoutInMilliseconds,
    src,
    srcDoc
  ]);
  const didLoad = useCallback19((e) => {
    loadedSource.current = { src, srcDoc };
    if (handle.current !== null) {
      continueRender(handle.current);
      handle.current = null;
    }
    onLoad?.(e);
  }, [onLoad, continueRender, src, srcDoc]);
  const didGetError = useCallback19((e) => {
    loadedSource.current = { src, srcDoc };
    if (handle.current !== null) {
      continueRender(handle.current);
      handle.current = null;
    }
    if (onError) {
      onError(e);
    } else {
      console.error("Error loading iframe:", e, "Handle the event using the onError() prop to make this message disappear.");
    }
  }, [onError, continueRender, src, srcDoc]);
  return /* @__PURE__ */ jsx35("iframe", {
    referrerPolicy: "strict-origin-when-cross-origin",
    ...props,
    ref,
    onError: didGetError,
    onLoad: didLoad
  });
};
var IFrame = forwardRef11(IFrameRefForwarding);
// src/Img.tsx
import {
  useContext as useContext48,
  useLayoutEffect as useLayoutEffect21,
  useMemo as useMemo43,
  useRef as useRef28,
  useState as useState23
} from "react";
import { jsx as jsx36 } from "react/jsx-runtime";
function exponentialBackoff2(errorCount) {
  return 1000 * 2 ** (errorCount - 1);
}
var setImageRef = (imageRef, ref, img) => {
  imageRef.current = img;
  if (typeof ref === "function") {
    ref(img);
  } else if (ref) {
    ref.current = img;
  }
};
var retryImage = (imageRef, timeout) => {
  if (!imageRef.current) {
    return;
  }
  const currentSrc = imageRef.current.src;
  setTimeout(() => {
    if (!imageRef.current) {
      return;
    }
    const newSrc = imageRef.current?.src;
    if (newSrc !== currentSrc) {
      return;
    }
    imageRef.current.removeAttribute("src");
    imageRef.current.setAttribute("src", newSrc);
  }, timeout);
};
var handleImageError = ({
  errors,
  imageRef,
  onError,
  onImageError,
  maxRetries,
  cancelRender,
  retryIn
}, e) => {
  if (!errors.current) {
    return;
  }
  errors.current[imageRef.current?.src] = (errors.current[imageRef.current?.src] ?? 0) + 1;
  if ((onError || onImageError) && (errors.current[imageRef.current?.src] ?? 0) > maxRetries) {
    onError?.(e);
    onImageError?.(new Error("Error loading image with src: " + truncateSrcForLabel(imageRef.current?.src)));
    return;
  }
  if ((errors.current[imageRef.current?.src] ?? 0) <= maxRetries) {
    const backoff = exponentialBackoff2(errors.current[imageRef.current?.src] ?? 0);
    console.warn(`Could not load image with source ${truncateSrcForLabel(imageRef.current?.src)}, retrying again in ${backoff}ms`);
    retryIn(backoff);
    return;
  }
  try {
    cancelRender("Error loading image with src: " + truncateSrcForLabel(imageRef.current?.src));
  } catch {}
};
var loadImage2 = ({
  imageRef,
  errors,
  actualSrc,
  delayRenderRetries,
  delayRenderTimeoutInMilliseconds,
  onImageFrame,
  delayRender,
  continueRender,
  setIsLoading
}) => {
  if (window.process?.env?.NODE_ENV === "test") {
    if (imageRef.current) {
      imageRef.current.src = actualSrc;
    }
    return;
  }
  const { current } = imageRef;
  if (!current) {
    return;
  }
  setIsLoading(true);
  const newHandle = delayRender("Loading <Img> with src=" + truncateSrcForLabel(actualSrc), {
    retries: delayRenderRetries ?? undefined,
    timeoutInMilliseconds: delayRenderTimeoutInMilliseconds ?? undefined
  });
  let unmounted = false;
  const onComplete = () => {
    if (unmounted) {
      continueRender(newHandle);
      return;
    }
    if ((errors.current[imageRef.current?.src] ?? 0) > 0) {
      delete errors.current[imageRef.current?.src];
      console.info(`Retry successful - ${truncateSrcForLabel(imageRef.current?.src)} is now loaded`);
    }
    if (current) {
      onImageFrame?.(current);
    }
    setIsLoading(false);
    continueRender(newHandle);
  };
  if (!imageRef.current) {
    onComplete();
    return;
  }
  current.src = actualSrc;
  current.decode().then(onComplete).catch((err) => {
    console.warn(err);
    if (current.complete && current.naturalWidth > 0 && current.naturalHeight > 0) {
      onComplete();
    } else {
      current.addEventListener("load", onComplete);
    }
  });
  return () => {
    unmounted = true;
    current.removeEventListener("load", onComplete);
    continueRender(newHandle);
  };
};
var ImgContent = ({
  onError,
  onImageError,
  maxRetries = 2,
  src,
  pauseWhenLoading,
  delayRenderRetries,
  delayRenderTimeoutInMilliseconds,
  onImageFrame,
  crossOrigin,
  decoding,
  ref,
  ...props
}) => {
  const imageRef = useRef28(null);
  const errors = useRef28({});
  const { delayPlayback } = useBufferState();
  const sequenceContext = useContext48(SequenceContext);
  const [isLoading, setIsLoading] = useState23(false);
  const _propsValid = true;
  if (!_propsValid) {
    throw new Error("typecheck error");
  }
  const imageCallbackRef = useMemo43(() => setImageRef.bind(null, imageRef, ref ?? null), [ref]);
  const actualSrc = usePreload(src);
  const retryIn = useMemo43(() => retryImage.bind(null, imageRef), []);
  const { delayRender, continueRender, cancelRender } = useDelayRender();
  const isPremounting = Boolean(sequenceContext?.premounting);
  const isPostmounting = Boolean(sequenceContext?.postmounting);
  const didGetError = useMemo43(() => handleImageError.bind(null, {
    errors,
    imageRef,
    onError: onError ?? null,
    onImageError: onImageError ?? null,
    maxRetries,
    cancelRender,
    retryIn
  }), [cancelRender, maxRetries, onError, onImageError, retryIn]);
  if (typeof window !== "undefined") {
    useLayoutEffect21(() => {
      if (!pauseWhenLoading || !isLoading || isPremounting || isPostmounting) {
        return;
      }
      return delayPlayback().unblock;
    }, [
      delayPlayback,
      isLoading,
      isPostmounting,
      isPremounting,
      pauseWhenLoading
    ]);
    useLayoutEffect21(loadImage2.bind(null, {
      imageRef,
      errors,
      actualSrc,
      delayRenderRetries: delayRenderRetries ?? null,
      delayRenderTimeoutInMilliseconds: delayRenderTimeoutInMilliseconds ?? null,
      onImageFrame: onImageFrame ?? null,
      delayRender,
      continueRender,
      setIsLoading
    }), [
      actualSrc,
      delayRenderRetries,
      delayRenderTimeoutInMilliseconds,
      onImageFrame,
      continueRender,
      delayRender
    ]);
  }
  const { isClientSideRendering, isRendering } = useRemotionEnvironment();
  const crossOriginValue = getCrossOriginValue({
    crossOrigin,
    requestsVideoFrame: false,
    isClientSideRendering
  });
  return /* @__PURE__ */ jsx36("img", {
    ...props,
    ref: imageCallbackRef,
    crossOrigin: crossOriginValue,
    onError: didGetError,
    decoding: isRendering ? "sync" : decoding
  });
};
var NativeImgInner = ({
  hidden,
  name,
  showInTimeline,
  src,
  from,
  trimBefore,
  loop,
  durationInFrames,
  freeze,
  premountFor,
  postmountFor,
  style,
  styleWhilePremounted,
  styleWhilePostmounted,
  cropLeft,
  cropRight,
  cropTop,
  cropBottom,
  controls,
  ...props
}) => {
  if (!src) {
    throw new Error('No "src" prop was passed to <Img>.');
  }
  const isMedia = useMemo43(() => ({
    type: "image",
    src,
    animated: null
  }), [src]);
  const {
    effectivePostmountFor,
    effectivePremountFor,
    freezeFrame,
    isPremountingOrPostmounting,
    postmountingActive,
    premountingActive,
    premountingStyle
  } = usePremounting({
    from: from ?? 0,
    durationInFrames: resolveSequenceDuration({
      durationInFrames,
      playbackRate: undefined,
      loop
    }),
    premountFor: premountFor ?? null,
    postmountFor: postmountFor ?? null,
    style: style ?? null,
    styleWhilePremounted: styleWhilePremounted ?? null,
    styleWhilePostmounted: styleWhilePostmounted ?? null,
    hideWhilePremounted: "display-none"
  });
  const croppedStyle = useCropStyle({
    cropLeft,
    cropRight,
    cropTop,
    cropBottom,
    style: premountingStyle,
    componentName: "<Img />"
  });
  return /* @__PURE__ */ jsx36(Freeze, {
    frame: freezeFrame,
    active: isPremountingOrPostmounting,
    _remotionInternalIsPremounting: premountingActive,
    children: /* @__PURE__ */ jsx36(Sequence, {
      layout: "none",
      from: from ?? 0,
      trimBefore,
      loop,
      durationInFrames,
      freeze,
      _remotionInternalDocumentationLink: "https://www.remotion.dev/docs/img",
      _remotionInternalIsMedia: isMedia,
      _remotionInternalPremountDisplay: effectivePremountFor || null,
      _remotionInternalPostmountDisplay: effectivePostmountFor || null,
      _remotionInternalIsPremounting: premountingActive,
      _remotionInternalIsPostmounting: postmountingActive,
      name: name ?? "<Img>",
      controls,
      showInTimeline: showInTimeline ?? true,
      hidden,
      children: /* @__PURE__ */ jsx36(SequenceContent, {
        children: /* @__PURE__ */ jsx36(ImgContent, {
          src,
          style: croppedStyle ?? undefined,
          ...props
        })
      })
    })
  });
};
var CanvasImageWithPrivateProps = CanvasImage;
var imgSchema = {
  src: {
    type: "asset",
    assetType: "image",
    default: undefined,
    description: "Source",
    keyframable: false
  },
  ...baseSchemaWithoutPlaybackRate,
  ...cropSchema,
  ...premountSchema,
  ...transformSchema,
  ...backgroundSchema,
  ...borderSchema,
  ...borderRadiusSchema
};
var imgCanvasFallbackIncompatibleProps = new Set([
  "alt",
  "decoding",
  "fetchPriority",
  "loading",
  "onError",
  "onImageFrame",
  "onLoad",
  "sizes",
  "srcSet",
  "useMap"
]);
var getIncompatiblePropNames = (props) => Object.keys(props).filter((key) => props[key] !== undefined && imgCanvasFallbackIncompatibleProps.has(key));
var formatPropList = (props) => {
  return props.map((prop) => `"${prop}"`).join(", ");
};
var validateCanvasImageFallbackProps = ({
  props,
  ref,
  width,
  height
}) => {
  if (typeof width === "string" || typeof height === "string") {
    throw new Error('The "width" and "height" props must be numbers on <Img> when effects are passed, because <Img> renders a <CanvasImage>. Use numeric props or CSS dimensions in "style".');
  }
  const conflictingProps = getIncompatiblePropNames(props);
  if (ref !== null && ref !== undefined) {
    conflictingProps.unshift("ref");
  }
  if (conflictingProps.length === 0) {
    return;
  }
  throw new Error(`The ${formatPropList(conflictingProps)} prop${conflictingProps.length === 1 ? "" : "s"} cannot be used on <Img> when effects are passed, because <Img> renders a <canvas> instead of a native <img>. Remove ${conflictingProps.length === 1 ? "this prop" : "these props"}.`);
};
var getFitFromObjectFit = (style) => {
  const objectFit = style?.objectFit;
  if (objectFit === "fill" || objectFit === "contain" || objectFit === "cover") {
    return objectFit;
  }
  return;
};
var ImgInner = ({
  effects = [],
  effectsOutputSize,
  ref,
  hidden,
  name,
  showInTimeline,
  src,
  from,
  trimBefore,
  durationInFrames,
  freeze,
  premountFor,
  postmountFor,
  styleWhilePremounted,
  styleWhilePostmounted,
  controls,
  width,
  height,
  className,
  style,
  cropLeft,
  cropRight,
  cropTop,
  cropBottom,
  id,
  pauseWhenLoading,
  maxRetries,
  delayRenderRetries,
  delayRenderTimeoutInMilliseconds,
  onImageError,
  ...props
}) => {
  const shouldPauseWhenLoading = resolveV5Default(pauseWhenLoading);
  if (effects.length === 0) {
    return /* @__PURE__ */ jsx36(NativeImgInner, {
      ...props,
      ref,
      hidden,
      name,
      showInTimeline,
      src,
      from,
      trimBefore,
      durationInFrames,
      freeze,
      premountFor,
      postmountFor,
      styleWhilePremounted,
      styleWhilePostmounted,
      controls,
      width,
      height,
      className,
      style,
      cropLeft,
      cropRight,
      cropTop,
      cropBottom,
      id,
      pauseWhenLoading: shouldPauseWhenLoading,
      maxRetries,
      delayRenderRetries,
      delayRenderTimeoutInMilliseconds,
      onImageError
    });
  }
  if (!src) {
    throw new Error('No "src" prop was passed to <Img>.');
  }
  validateCanvasImageFallbackProps({
    props,
    ref,
    width,
    height
  });
  const canvasWidth = typeof width === "number" ? width : undefined;
  const canvasHeight = typeof height === "number" ? height : undefined;
  const canvasProps = props;
  const canvasFit = getFitFromObjectFit(style) ?? "fill";
  return /* @__PURE__ */ jsx36(CanvasImageWithPrivateProps, {
    src,
    width: canvasWidth,
    height: canvasHeight,
    fit: canvasFit,
    effects,
    effectsOutputSize,
    className,
    style,
    cropLeft,
    cropRight,
    cropTop,
    cropBottom,
    id,
    onError: onImageError,
    pauseWhenLoading: shouldPauseWhenLoading,
    maxRetries,
    delayRenderRetries,
    delayRenderTimeoutInMilliseconds,
    from,
    trimBefore,
    durationInFrames,
    freeze,
    premountFor,
    postmountFor,
    styleWhilePremounted,
    styleWhilePostmounted,
    hidden,
    name: name ?? "<Img>",
    showInTimeline,
    _remotionInternalDocumentationLink: "https://www.remotion.dev/docs/img",
    _remotionInternalCropComponentName: "<Img />",
    controls,
    ...canvasProps
  });
};
var Img = withInteractivitySchema({
  Component: ImgInner,
  componentName: "<Img>",
  componentIdentity: "dev.remotion.remotion.Img",
  schema: imgSchema,
  supportsEffects: true
});
addSequenceStackTraces(Img);
// src/Interactive.tsx
import React43, { forwardRef as forwardRef12, useCallback as useCallback20, useContext as useContext49 } from "react";
import { jsx as jsx37 } from "react/jsx-runtime";
var sourcePathToIdentityPrefix = (packageName) => {
  if (packageName === "remotion") {
    return "dev.remotion.remotion";
  }
  if (packageName.startsWith("@remotion/")) {
    const normalizedPackageName = packageName.slice("@remotion/".length).replace(/-([a-z])/g, (_, char) => char.toUpperCase());
    return `dev.remotion.${normalizedPackageName}`;
  }
  throw new Error(`Unsupported Remotion package name: ${packageName}`);
};
var makeRemotionComponentIdentity = ({
  packageName,
  componentName
}) => {
  return `${sourcePathToIdentityPrefix(packageName)}.${componentName}`;
};
var interactiveElementSchema = {
  ...baseSchema,
  ...premountSchema,
  ...transformSchema,
  ...cropSchema
};
var interactiveBackgroundElementSchema = {
  ...interactiveElementSchema,
  ...backgroundSchema
};
var interactiveBorderElementSchema = {
  ...interactiveBackgroundElementSchema,
  ...borderSchema,
  ...borderRadiusSchema
};
var interactiveTextElementSchema = {
  ...interactiveBorderElementSchema,
  ...textSchema,
  ...childrenSchema
};
var interactiveSvgTextElementSchema = {
  ...interactiveElementSchema,
  ...svgPaintSchema,
  ...textSchema,
  ...childrenSchema
};
var interactiveSvgElementSchema = {
  ...interactiveElementSchema,
  ...svgPaintSchema
};
var interactiveSvgPathElementSchema = {
  ...interactiveSvgElementSchema,
  d: {
    type: "svg-path",
    default: undefined,
    description: "Path",
    keyframable: true
  }
};
var interactiveSvgStrokeElementSchema = {
  ...interactiveElementSchema,
  ...svgStrokeSchema
};
var interactiveSvgRootElementSchema = {
  ...interactiveBorderElementSchema,
  ...svgPaintSchema
};
var setRef2 = (ref, value) => {
  if (typeof ref === "function") {
    ref(value);
  } else if (ref) {
    ref.current = value;
  }
};
var withSchema = (untypedOptions) => {
  const options = untypedOptions;
  if (!options.wrapInSequence) {
    const LegacyWrapped = withInteractivitySchema(options);
    addSequenceStackTraces(LegacyWrapped);
    return LegacyWrapped;
  }
  const {
    Component,
    componentName,
    schema,
    wrapInSequence: _,
    layout = "none",
    ...rest
  } = options;
  const ComponentWrappedInSequence = forwardRef12((props, ref) => {
    const { canvasContent, compositions } = useContext49(CompositionManager);
    const componentIdentity = resolveComponentIdentity(Wrapped);
    const isCurrentComposition = compositions.some((composition) => canvasContent?.type === "composition" && composition.id === canvasContent.compositionId && composition.componentFromProps === componentIdentity);
    const { width, height, ...propsWithoutDimensions } = props;
    const {
      durationInFrames,
      from,
      trimBefore,
      playbackRate,
      loop,
      freeze,
      hidden,
      name,
      showInTimeline,
      controls,
      premountFor,
      postmountFor,
      styleWhilePremounted,
      styleWhilePostmounted,
      ...componentProps
    } = layout === "absolute-fill" ? propsWithoutDimensions : props;
    const {
      cropLeft,
      cropRight,
      cropTop,
      cropBottom,
      style,
      ...componentPropsWithoutCropping
    } = componentProps;
    const {
      effectivePremountFor,
      effectivePostmountFor,
      freezeFrame,
      isPremountingOrPostmounting,
      premountingActive,
      postmountingActive,
      premountingStyle
    } = usePremounting({
      from: from ?? 0,
      durationInFrames: resolveSequenceDuration({
        durationInFrames,
        playbackRate,
        loop
      }),
      premountFor: premountFor ?? null,
      postmountFor: postmountFor ?? null,
      style: style ?? null,
      styleWhilePremounted: styleWhilePremounted ?? null,
      styleWhilePostmounted: styleWhilePostmounted ?? null,
      hideWhilePremounted: "opacity"
    });
    const croppedStyle = useCropStyle({
      cropLeft,
      cropRight,
      cropTop,
      cropBottom,
      style: premountingStyle,
      componentName
    });
    return /* @__PURE__ */ jsx37(Freeze, {
      frame: freezeFrame,
      active: isPremountingOrPostmounting,
      children: /* @__PURE__ */ jsx37(SequenceWithoutSchema, {
        _remotionInternalSingleChildComponent: isCurrentComposition ? null : componentIdentity,
        layout,
        ...layout === "absolute-fill" ? {
          width,
          height,
          style: { overflow: "hidden", ...croppedStyle },
          ref
        } : {},
        durationInFrames,
        from,
        trimBefore,
        playbackRate,
        loop,
        freeze,
        hidden,
        name: name ?? componentName,
        _remotionInternalDocumentationLink: "https://www.remotion.dev/docs/interactive-create",
        showInTimeline: isCurrentComposition ? false : showInTimeline,
        controls,
        _remotionInternalPremountDisplay: effectivePremountFor || null,
        _remotionInternalPostmountDisplay: effectivePostmountFor || null,
        _remotionInternalIsPremounting: premountingActive,
        _remotionInternalIsPostmounting: postmountingActive,
        children: React43.createElement(Component, {
          ...componentPropsWithoutCropping,
          ...layout === "none" ? { style: croppedStyle ?? undefined, ref } : {}
        })
      })
    });
  });
  const Wrapped = withInteractivitySchema({
    ...rest,
    Component: ComponentWrappedInSequence,
    componentName,
    schema: {
      ...schema,
      ...transformSchema,
      ...baseSchema,
      ...premountSchema,
      ...cropSchema
    },
    supportsEffects: false
  });
  addSequenceStackTraces(Wrapped);
  return Wrapped;
};
var create = (untypedOptions) => {
  const options = untypedOptions;
  return withSchema({
    ...options,
    wrapInSequence: true,
    schema: options.schema ?? {},
    componentName: options.componentName ?? (options.Component.displayName || options.Component.name?.replace(/(.+)Inner$/, "$1") || "Component")
  });
};
var makeInteractiveElement = (tag, displayName, schema) => {
  const Inner = forwardRef12((propsWithControls, ref) => {
    const {
      durationInFrames,
      from,
      premountFor,
      postmountFor,
      styleWhilePremounted,
      styleWhilePostmounted,
      trimBefore,
      playbackRate,
      loop,
      freeze,
      hidden,
      name,
      showInTimeline,
      controls,
      cropLeft,
      cropRight,
      cropTop,
      cropBottom,
      style,
      ...props
    } = propsWithControls;
    const {
      effectivePremountFor,
      effectivePostmountFor,
      freezeFrame,
      isPremountingOrPostmounting,
      premountingActive,
      postmountingActive,
      premountingStyle
    } = usePremounting({
      from: from ?? 0,
      durationInFrames: resolveSequenceDuration({
        durationInFrames,
        playbackRate,
        loop
      }),
      premountFor: premountFor ?? null,
      postmountFor: postmountFor ?? null,
      style: style ?? null,
      styleWhilePremounted: styleWhilePremounted ?? null,
      styleWhilePostmounted: styleWhilePostmounted ?? null,
      hideWhilePremounted: "opacity"
    });
    const croppedStyle = useCropStyle({
      cropLeft,
      cropRight,
      cropTop,
      cropBottom,
      style: premountingStyle,
      componentName: displayName
    });
    const callbackRef = useCallback20((element) => {
      setRef2(ref, element);
    }, [ref]);
    return /* @__PURE__ */ jsx37(Freeze, {
      frame: freezeFrame,
      active: isPremountingOrPostmounting,
      _remotionInternalIsPremounting: premountingActive,
      children: /* @__PURE__ */ jsx37(Sequence, {
        layout: "none",
        from: from ?? 0,
        trimBefore,
        playbackRate,
        loop,
        durationInFrames,
        freeze,
        hidden,
        name: name ?? displayName,
        showInTimeline: showInTimeline ?? true,
        controls,
        _remotionInternalDocumentationLink: "https://www.remotion.dev/docs/interactive",
        _remotionInternalPremountDisplay: effectivePremountFor || null,
        _remotionInternalPostmountDisplay: effectivePostmountFor || null,
        _remotionInternalIsPremounting: premountingActive,
        _remotionInternalIsPostmounting: postmountingActive,
        children: React43.createElement(tag, {
          ...props,
          style: croppedStyle ?? undefined,
          ref: callbackRef
        })
      })
    });
  });
  Inner.displayName = displayName;
  const Wrapped = withSchema({
    Component: Inner,
    componentName: displayName,
    componentIdentity: makeRemotionComponentIdentity({
      packageName: "remotion",
      componentName: displayName.slice(1, -1)
    }),
    schema,
    supportsEffects: false
  });
  Wrapped.displayName = displayName;
  return Wrapped;
};
var makeInteractiveTextElement = (tag, displayName) => {
  return makeInteractiveElement(tag, displayName, interactiveTextElementSchema);
};
var makeInteractiveSvgElement = (tag, displayName) => {
  return makeInteractiveElement(tag, displayName, interactiveSvgElementSchema);
};
var makeInteractiveSvgStrokeElement = (tag, displayName) => {
  return makeInteractiveElement(tag, displayName, interactiveSvgStrokeElementSchema);
};
var Interactive = {
  baseSchema,
  captionsSchema,
  childrenSchema,
  transformSchema,
  textSchema,
  backgroundSchema,
  borderSchema,
  borderRadiusSchema,
  cropSchema,
  svgPaintSchema,
  svgStrokeSchema,
  premountSchema,
  sequenceSchema,
  withSchema,
  create,
  _internalMakeRemotionComponentIdentity: makeRemotionComponentIdentity,
  A: makeInteractiveTextElement("a", "<Interactive.A>"),
  Article: makeInteractiveTextElement("article", "<Interactive.Article>"),
  Aside: makeInteractiveTextElement("aside", "<Interactive.Aside>"),
  Button: makeInteractiveTextElement("button", "<Interactive.Button>"),
  Circle: makeInteractiveSvgElement("circle", "<Interactive.Circle>"),
  Code: makeInteractiveTextElement("code", "<Interactive.Code>"),
  Div: makeInteractiveTextElement("div", "<Interactive.Div>"),
  Ellipse: makeInteractiveSvgElement("ellipse", "<Interactive.Ellipse>"),
  Em: makeInteractiveTextElement("em", "<Interactive.Em>"),
  Footer: makeInteractiveTextElement("footer", "<Interactive.Footer>"),
  G: makeInteractiveSvgElement("g", "<Interactive.G>"),
  H1: makeInteractiveTextElement("h1", "<Interactive.H1>"),
  H2: makeInteractiveTextElement("h2", "<Interactive.H2>"),
  H3: makeInteractiveTextElement("h3", "<Interactive.H3>"),
  H4: makeInteractiveTextElement("h4", "<Interactive.H4>"),
  H5: makeInteractiveTextElement("h5", "<Interactive.H5>"),
  H6: makeInteractiveTextElement("h6", "<Interactive.H6>"),
  Header: makeInteractiveTextElement("header", "<Interactive.Header>"),
  Label: makeInteractiveTextElement("label", "<Interactive.Label>"),
  Li: makeInteractiveTextElement("li", "<Interactive.Li>"),
  Line: makeInteractiveSvgStrokeElement("line", "<Interactive.Line>"),
  Main: makeInteractiveTextElement("main", "<Interactive.Main>"),
  Nav: makeInteractiveTextElement("nav", "<Interactive.Nav>"),
  Ol: makeInteractiveTextElement("ol", "<Interactive.Ol>"),
  P: makeInteractiveTextElement("p", "<Interactive.P>"),
  Path: makeInteractiveElement("path", "<Interactive.Path>", interactiveSvgPathElementSchema),
  Pre: makeInteractiveTextElement("pre", "<Interactive.Pre>"),
  Rect: makeInteractiveSvgElement("rect", "<Interactive.Rect>"),
  Section: makeInteractiveTextElement("section", "<Interactive.Section>"),
  Small: makeInteractiveTextElement("small", "<Interactive.Small>"),
  Span: makeInteractiveTextElement("span", "<Interactive.Span>"),
  Strong: makeInteractiveTextElement("strong", "<Interactive.Strong>"),
  Svg: makeInteractiveElement("svg", "<Interactive.Svg>", interactiveSvgRootElementSchema),
  Text: makeInteractiveElement("text", "<Interactive.Text>", interactiveSvgTextElementSchema),
  Ul: makeInteractiveTextElement("ul", "<Interactive.Ul>")
};
// src/internals.ts
import { createRef as createRef3 } from "react";

// src/audio/get-audio-sync-anchor-tolerance.ts
var ALLOWED_GLOBAL_TIME_ANCHOR_SHIFT = 0.1;
var getAudioSyncAnchorTolerance = (audioContext) => {
  const { baseLatency, outputLatency } = audioContext;
  const safeOutputLatency = outputLatency === 0 ? 0.3 : outputLatency;
  return ALLOWED_GLOBAL_TIME_ANCHOR_SHIFT + baseLatency + safeOutputLatency;
};

// src/CompositionManager.tsx
import React44 from "react";
var compositionsRef = React44.createRef();

// src/CompositionManagerProvider.tsx
import {
  useCallback as useCallback22,
  useImperativeHandle as useImperativeHandle9,
  useMemo as useMemo45,
  useRef as useRef30,
  useState as useState25
} from "react";

// src/CompositionRegistryProvider.tsx
import {
  forwardRef as forwardRef13,
  useCallback as useCallback21,
  useEffect as useEffect20,
  useImperativeHandle as useImperativeHandle8,
  useLayoutEffect as useLayoutEffect22,
  useMemo as useMemo44,
  useRef as useRef29,
  useState as useState24
} from "react";
import { jsx as jsx38 } from "react/jsx-runtime";
var useIsomorphicLayoutEffect6 = typeof window === "undefined" ? useEffect20 : useLayoutEffect22;
var CompositionRegistryFallbackProvider = withCommittedMetadata(CompositionRegistryFallbackContext.Provider);
var CompositionRegistryProvider = forwardRef13(({ children, onSnapshot }, flushSnapshotRef) => {
  const { isStudio } = useRemotionEnvironment();
  const [managerId] = useState24(() => String(Math.random()));
  const [useCommitObserver, setUseCommitObserver] = useState24(() => isStudio && isCommitRegistrationObserverInstalled());
  const observedCommitRef = useRef29(false);
  const observerFailedRef = useRef29(false);
  const unmountedRef = useRef29(false);
  const onSnapshotRef = useRef29(onSnapshot);
  const lastSnapshotRef = useRef29(null);
  const pendingSnapshotRef = useRef29(null);
  const flushSnapshot = useCallback21(() => {
    const pending = pendingSnapshotRef.current;
    pendingSnapshotRef.current = null;
    if (pending === null || unmountedRef.current) {
      return;
    }
    const committed = typeof pending === "function" ? pending() : pending;
    const previous = lastSnapshotRef.current;
    if (previous !== null && (previous.compositions === committed.compositions || previous.compositions.length === committed.compositions.length && previous.compositions.every((composition, index) => composition === committed.compositions[index])) && (previous.folders === committed.folders || previous.folders.length === committed.folders.length && previous.folders.every((folder, index) => folder === committed.folders[index])) && (previous.orderIds === committed.orderIds || previous.orderIds.length === committed.orderIds.length && previous.orderIds.every((id, index) => id === committed.orderIds[index]))) {
      return;
    }
    lastSnapshotRef.current = committed;
    onSnapshotRef.current(committed);
  }, []);
  useImperativeHandle8(flushSnapshotRef, () => flushSnapshot, [flushSnapshot]);
  const queueSnapshot = useCallback21((snapshot) => {
    const alreadyPending = pendingSnapshotRef.current !== null;
    pendingSnapshotRef.current = snapshot;
    if (alreadyPending) {
      return;
    }
    queueMicrotask(flushSnapshot);
  }, [flushSnapshot]);
  const onObservedSnapshot = useCallback21((snapshot) => {
    if (observerFailedRef.current) {
      return;
    }
    observedCommitRef.current = true;
    queueSnapshot(snapshot);
  }, [queueSnapshot]);
  const fallbackRegistry = useMemo44(() => {
    const entries = new Map;
    const getSnapshot = () => {
      const compositions = [];
      const folders = [];
      const orderIds = [];
      for (const entry of entries.values()) {
        if (entry.type === "composition") {
          compositions.push(entry.value);
          orderIds.push(getCompositionAndFolderOrderKey({
            type: "composition",
            id: entry.value.id
          }));
        } else {
          folders.push(entry.value);
          orderIds.push(getCompositionAndFolderOrderKey({
            type: "folder",
            id: getFolderOrderId(entry.value)
          }));
        }
      }
      return { compositions, folders, orderIds };
    };
    return { entries, notifyCommit: () => queueSnapshot(getSnapshot) };
  }, [queueSnapshot]);
  useIsomorphicLayoutEffect6(() => {
    if (onSnapshotRef.current !== onSnapshot) {
      const previous = lastSnapshotRef.current;
      lastSnapshotRef.current = null;
      if (useCommitObserver && previous !== null) {
        queueSnapshot(previous);
      }
    }
    onSnapshotRef.current = onSnapshot;
    if (!useCommitObserver) {
      fallbackRegistry.notifyCommit();
    }
  }, [fallbackRegistry, onSnapshot, queueSnapshot, useCommitObserver]);
  useIsomorphicLayoutEffect6(() => {
    unmountedRef.current = false;
    let unmounted = false;
    const onRegistrationError = () => {
      if (observerFailedRef.current) {
        return;
      }
      observerFailedRef.current = true;
      pendingSnapshotRef.current = null;
      queueMicrotask(() => {
        if (!unmountedRef.current) {
          setUseCommitObserver(false);
        }
      });
    };
    if (isStudio) {
      window.addEventListener(COMMIT_REGISTRATION_ERROR_EVENT, onRegistrationError);
      if (useCommitObserver) {
        queueMicrotask(() => {
          if (!unmounted && !observedCommitRef.current) {
            onRegistrationError();
          }
        });
      }
    }
    return () => {
      unmounted = true;
      unmountedRef.current = true;
      if (isStudio) {
        window.removeEventListener(COMMIT_REGISTRATION_ERROR_EVENT, onRegistrationError);
      }
    };
  }, [isStudio, useCommitObserver]);
  const metadata = useMemo44(() => isStudio ? {
    type: "composition-manager",
    id: managerId,
    onCommit: useCommitObserver ? onObservedSnapshot : null
  } : null, [isStudio, managerId, onObservedSnapshot, useCommitObserver]);
  return /* @__PURE__ */ jsx38(CompositionRegistryFallbackProvider, {
    value: useCommitObserver ? null : fallbackRegistry,
    _remotionCommitMetadata: metadata,
    children
  });
});

// src/CompositionManagerProvider.tsx
import { jsx as jsx39 } from "react/jsx-runtime";
var CompositionManagerProvider = ({
  children,
  onlyRenderComposition,
  currentCompositionMetadata,
  initialCompositions,
  initialCanvasContent
}) => {
  const committedKeysRef = useRef30(new Set);
  const flushSnapshotRef = useRef30(null);
  const committedDescriptorsRef = useRef30(new Map);
  const [registrationError, setRegistrationError] = useState25(null);
  const [registry] = useState25(() => createRegistryStore({
    compositions: initialCompositions.map((composition, order) => ({
      ...composition,
      order
    })),
    folders: []
  }));
  const { compositions, folders } = useSyncExternalStore2(registry.subscribe, registry.getSnapshot, registry.getSnapshot);
  const [canvasContent, setCanvasContent] = useState25(initialCanvasContent);
  const [currentAssetMetadata, setCurrentAssetMetadata] = useState25(null);
  const onCommitRegistrations = useCallback22((pending) => {
    const previousKeys = committedKeysRef.current;
    const previousDescriptors = committedDescriptorsRef.current;
    const existingIds = new Set(registry.getSnapshot().compositions.map((composition) => composition.id));
    const descriptors = new Map;
    for (const composition of pending.compositions) {
      const key = `composition:${composition.id}`;
      if (descriptors.has(key) || !previousKeys.has(key) && existingIds.has(composition.id)) {
        setRegistrationError(new Error(`Multiple composition with id ${composition.id} are registered.`));
        return;
      }
      descriptors.set(key, composition);
    }
    for (const folder of pending.folders) {
      descriptors.set(`folder:${getFolderOrderId(folder)}`, folder);
    }
    const nextKeys = new Set(descriptors.keys());
    const order = new Map(pending.orderIds.map((id, index) => [id, index]));
    committedKeysRef.current = nextKeys;
    committedDescriptorsRef.current = descriptors;
    registry.setSnapshot((current) => {
      const nextCompositions = reconcileRegistryEntries({
        current: current.compositions,
        entries: pending.compositions,
        previousDescriptors,
        previousKeys,
        nextKeys,
        getKey: (composition) => `composition:${composition.id}`,
        order,
        orderProperty: "order"
      });
      const nextFolders = reconcileRegistryEntries({
        current: current.folders,
        entries: pending.folders,
        previousDescriptors,
        previousKeys,
        nextKeys,
        getKey: (folder) => `folder:${getFolderOrderId(folder)}`,
        order,
        orderProperty: "order"
      });
      return nextCompositions === current.compositions && nextFolders === current.folders ? current : { compositions: nextCompositions, folders: nextFolders };
    });
  }, [registry]);
  useImperativeHandle9(compositionsRef, () => {
    return {
      getCompositions: () => {
        flushSnapshotRef.current?.();
        return registry.getSnapshot().compositions;
      }
    };
  }, [registry]);
  const compositionManagerSetters = useMemo45(() => ({
    setCanvasContent,
    setCurrentAssetMetadata,
    onlyRenderComposition
  }), [onlyRenderComposition]);
  const compositionManagerContextValue = useMemo45(() => {
    return {
      compositions,
      folders,
      currentCompositionMetadata,
      currentAssetMetadata,
      canvasContent
    };
  }, [
    compositions,
    folders,
    currentCompositionMetadata,
    currentAssetMetadata,
    canvasContent
  ]);
  const compositionManagerRef = useRef30(compositionManagerContextValue);
  compositionManagerRef.current = compositionManagerContextValue;
  if (registrationError !== null) {
    throw registrationError;
  }
  return /* @__PURE__ */ jsx39(CompositionRegistryProvider, {
    ref: flushSnapshotRef,
    onSnapshot: onCommitRegistrations,
    children: /* @__PURE__ */ jsx39(CompositionManager.Provider, {
      value: compositionManagerContextValue,
      children: /* @__PURE__ */ jsx39(CompositionManagerRefContext.Provider, {
        value: compositionManagerRef,
        children: /* @__PURE__ */ jsx39(CompositionSetters.Provider, {
          value: compositionManagerSetters,
          children
        })
      })
    })
  });
};

// src/create-element-source-proxy.ts
var componentsToAddStacksTo2 = getComponentsToAddStacksTo();
var internalStackProp = REMOTION_INTERNAL_STACK_PROP;
var createElementSourceProxy = (api, sourceArgumentIndex, getSourceFileName) => {
  return new Proxy(api, {
    apply(target, thisArg, argArray) {
      const component = argArray[0];
      if (componentsToAddStacksTo2.includes(component)) {
        const [first, props, ...rest] = argArray;
        const source = sourceArgumentIndex === null ? null : argArray[sourceArgumentIndex];
        const existingStack = props?.[internalStackProp];
        const controlsStack = !existingStack && component === getSequenceComponent() && props?.controls ? getStackForControls(props.controls) : null;
        let stack = existingStack || controlsStack;
        if (!stack) {
          if (source && typeof source.fileName === "string" && typeof source.lineNumber === "number" && typeof source.columnNumber === "number") {
            stack = makeOriginalSourceStack({
              fileName: getSourceFileName(source.fileName),
              lineNumber: source.lineNumber,
              columnNumber: source.columnNumber - 1
            }, typeof source.__remotionCompiledSourceHash === "string" ? source.__remotionCompiledSourceHash : null);
          } else {
            const { stackTraceLimit } = Error;
            const canLimitStack = typeof stackTraceLimit === "number" && stackTraceLimit > 2 && Object.getOwnPropertyDescriptor(Error, "stackTraceLimit")?.writable;
            let capturedError;
            try {
              if (canLimitStack) {
                Error.stackTraceLimit = 2;
              }
              capturedError = new Error;
            } finally {
              if (canLimitStack) {
                Error.stackTraceLimit = stackTraceLimit;
              }
            }
            const capturedStack = capturedError.stack;
            if (capturedStack) {
              const firstFrameEnd = capturedStack.indexOf(`
`, capturedStack.startsWith(`Error
`) ? 6 : 0);
              const callerEnd = firstFrameEnd === -1 ? -1 : capturedStack.indexOf(`
`, firstFrameEnd + 1);
              stack = callerEnd === -1 ? capturedStack : capturedStack.slice(0, callerEnd);
            } else {
              stack = capturedStack;
            }
          }
        }
        const newProps = existingStack ? { ...props } : {
          ...props ?? {},
          [internalStackProp]: stack
        };
        return Reflect.apply(target, thisArg, [first, newProps, ...rest]);
      }
      return Reflect.apply(target, thisArg, argArray);
    }
  });
};

// src/default-css.ts
var injected = {};
var injectCSS = (css) => {
  if (typeof document === "undefined") {
    return () => {};
  }
  if (injected[css]) {
    return () => {};
  }
  const head = document.head || document.getElementsByTagName("head")[0];
  const style = document.createElement("style");
  style.appendChild(document.createTextNode(css));
  head.prepend(style);
  injected[css] = style;
  return () => {
    const styleElement = injected[css];
    if (styleElement) {
      if (styleElement.parentNode) {
        styleElement.parentNode.removeChild(styleElement);
      }
      delete injected[css];
    }
  };
};
var OBJECTFIT_CONTAIN_CLASS_NAME = "__remotion_objectfitcontain";
var makeDefaultPreviewCSS = (scope, backgroundColor) => {
  if (!scope) {
    return `
    * {
      box-sizing: border-box;
    }
    body {
      margin: 0;
	    background-color: ${backgroundColor};
    }
    .${OBJECTFIT_CONTAIN_CLASS_NAME} {
      object-fit: contain;
    }
    `;
  }
  return `
    ${scope} * {
      box-sizing: border-box;
    }
    ${scope} *:-webkit-full-screen {
      width: 100%;
      height: 100%;
    }
    ${scope} .${OBJECTFIT_CONTAIN_CLASS_NAME} {
      object-fit: contain;
    }
  `;
};

// src/effects/create-curve-sampler.ts
var createCurveSampler = (points, interpolation) => {
  const distances = points.slice(1).map((point, index) => Math.hypot(point[0] - points[index][0], point[1] - points[index][1]));
  const tangents = points.map(() => [0, 0]);
  if (interpolation === "smooth" && points.length > 2) {
    for (let axis = 0;axis < 2; axis++) {
      const slopes = distances.map((distance, index) => (points[index + 1][axis] - points[index][axis]) / distance);
      const curvatures = new Array(points.length).fill(0);
      const upper = new Array(points.length).fill(0);
      for (let index = 1;index < points.length - 1; index++) {
        const diagonal = 2 * (distances[index - 1] + distances[index]) - distances[index - 1] * upper[index - 1];
        upper[index] = distances[index] / diagonal;
        curvatures[index] = (6 * (slopes[index] - slopes[index - 1]) - distances[index - 1] * curvatures[index - 1]) / diagonal;
      }
      for (let index = points.length - 2;index > 0; index--) {
        curvatures[index] -= upper[index] * curvatures[index + 1];
      }
      for (let index = 0;index < points.length; index++) {
        tangents[index][axis] = index === 0 ? slopes[0] - distances[0] * curvatures[1] / 6 : slopes[index - 1] + distances[index - 1] * (curvatures[index - 1] + 2 * curvatures[index]) / 6;
      }
    }
    for (let index = 0;index < points.length; index++) {
      const maxTangent = 3 * Math.min(index === 0 ? Infinity : (points[index][0] - points[index - 1][0]) / distances[index - 1], index === points.length - 1 ? Infinity : (points[index + 1][0] - points[index][0]) / distances[index]);
      if (tangents[index][0] > maxTangent) {
        tangents[index][1] *= maxTangent / tangents[index][0];
      }
      tangents[index][0] = Math.max(0, Math.min(maxTangent, tangents[index][0]));
    }
  }
  return (input) => {
    if (input <= points[0][0])
      return points[0][1];
    if (input >= points[points.length - 1][0]) {
      return points[points.length - 1][1];
    }
    const index = points.findIndex((point) => point[0] > input) - 1;
    const start = points[index];
    const end = points[index + 1];
    if (input === start[0])
      return start[1];
    if (interpolation === "linear" || points.length === 2) {
      return start[1] + (end[1] - start[1]) * ((input - start[0]) / (end[0] - start[0]));
    }
    const handleLength = distances[index] / 3;
    const firstX = start[0] + handleLength * tangents[index][0];
    const secondX = end[0] - handleLength * tangents[index + 1][0];
    let low = 0;
    let high = 1;
    for (let iteration = 0;iteration < 32; iteration++) {
      const candidate = (low + high) / 2;
      const inverse = 1 - candidate;
      const x = inverse ** 3 * start[0] + 3 * inverse ** 2 * candidate * firstX + 3 * inverse * candidate ** 2 * secondX + candidate ** 3 * end[0];
      if (x < input)
        low = candidate;
      else
        high = candidate;
    }
    const progress = (low + high) / 2;
    const remaining = 1 - progress;
    const firstY = start[1] + handleLength * tangents[index][1];
    const secondY = end[1] - handleLength * tangents[index + 1][1];
    const value = remaining ** 3 * start[1] + 3 * remaining ** 2 * progress * firstY + 3 * remaining * progress ** 2 * secondY + progress ** 3 * end[1];
    return Math.max(0, Math.min(1, value));
  };
};

// src/get-preview-dom-element.ts
var REMOTION_STUDIO_CONTAINER_ELEMENT = "__remotion-studio-container";
var getPreviewDomElement = () => {
  return document.getElementById(REMOTION_STUDIO_CONTAINER_ELEMENT);
};

// src/max-video-cache-size.ts
import React45 from "react";
var MaxMediaCacheSizeContext = React45.createContext(null);

// src/media-resource-manager.ts
var disposeResource = (resource) => {
  if (resource.disposed) {
    return;
  }
  resource.disposed = true;
  resource.values.clear();
  resource.dispose();
};
var makeMediaResourceManager = () => {
  const resources = new Map;
  let disposed = false;
  return {
    acquire: ({
      key,
      create
    }) => {
      if (disposed) {
        throw new Error("Media resource manager has already been disposed");
      }
      let entry = resources.get(key);
      if (!entry) {
        const created = create();
        entry = {
          resource: created.resource,
          dispose: created.dispose,
          refCount: 0,
          disposeGeneration: 0,
          disposed: false,
          values: new Map
        };
        resources.set(key, entry);
      }
      entry.refCount++;
      entry.disposeGeneration++;
      let released = false;
      return {
        resource: entry.resource,
        getOrCreateValue: (valueKey, createValue) => {
          if (entry.values.has(valueKey)) {
            return entry.values.get(valueKey);
          }
          const value = createValue();
          entry.values.set(valueKey, value);
          return value;
        },
        release: () => {
          if (released) {
            return;
          }
          released = true;
          entry.refCount--;
          if (entry.refCount !== 0) {
            return;
          }
          const disposeGeneration = ++entry.disposeGeneration;
          queueMicrotask(() => {
            if (entry.refCount !== 0 || entry.disposeGeneration !== disposeGeneration) {
              return;
            }
            if (resources.get(key) === entry) {
              resources.delete(key);
            }
            disposeResource(entry);
          });
        }
      };
    },
    invalidate: (key) => {
      const entry = resources.get(key);
      if (!entry) {
        return;
      }
      resources.delete(key);
      entry.disposeGeneration++;
      if (entry.refCount === 0) {
        disposeResource(entry);
      }
    },
    dispose: () => {
      if (disposed) {
        return;
      }
      disposed = true;
      const entries = Array.from(resources.values());
      resources.clear();
      let firstError = null;
      for (const entry of entries) {
        try {
          disposeResource(entry);
        } catch (error) {
          firstError ??= error;
        }
      }
      if (firstError !== null) {
        throw firstError;
      }
    }
  };
};
var getMediabunnyInputResourceKey = ({
  src,
  credentials,
  requestInitFingerprint,
  revision
}) => JSON.stringify([
  "mediabunny-input",
  src,
  credentials,
  requestInitFingerprint,
  revision
]);
var MEDIABUNNY_DURATION_VALUE_KEY = "mediabunny-duration";
var globalMediaResourceManager = makeMediaResourceManager();

// src/playback-pitch-context.ts
import { createContext as createContext39 } from "react";
var PlaybackPitchContext = createContext39(false);

// src/register-root.ts
var Root = null;
var listeners4 = [];
var registerRoot = (comp) => {
  if (!comp) {
    throw new Error(`You must pass a React component to registerRoot(), but ${JSON.stringify(comp)} was passed.`);
  }
  if (Root) {
    throw new Error("registerRoot() was called more than once.");
  }
  Root = comp;
  listeners4.forEach((l) => {
    l(comp);
  });
};
var getRoot = () => {
  return Root;
};
var waitForRoot = (fn) => {
  if (Root) {
    fn(Root);
    return () => {
      return;
    };
  }
  listeners4.push(fn);
  return () => {
    listeners4 = listeners4.filter((l) => l !== fn);
  };
};

// src/RemotionRoot.tsx
import { useMemo as useMemo46 } from "react";
import { jsx as jsx40 } from "react/jsx-runtime";
var RemotionRootContexts = ({
  children,
  numberOfAudioTags,
  logLevel,
  audioLatencyHint,
  previewSampleRate,
  videoEnabled,
  audioEnabled,
  frameState,
  _experimentalKeepAudioContextAlive
}) => {
  const logging = useMemo46(() => {
    return { logLevel, mountTime: Date.now() };
  }, [logLevel]);
  return /* @__PURE__ */ jsx40(LogLevelContext.Provider, {
    value: logging,
    children: /* @__PURE__ */ jsx40(TimelineContextProvider, {
      frameState,
      children: /* @__PURE__ */ jsx40(MediaEnabledProvider, {
        videoEnabled,
        audioEnabled,
        children: /* @__PURE__ */ jsx40(EditorPropsProvider, {
          children: /* @__PURE__ */ jsx40(PrefetchProvider, {
            children: /* @__PURE__ */ jsx40(SequenceManagerProvider, {
              children: /* @__PURE__ */ jsx40(DurationsContextProvider, {
                children: /* @__PURE__ */ jsx40(BufferingProvider, {
                  children: /* @__PURE__ */ jsx40(SharedAudioContextProvider, {
                    audioLatencyHint,
                    audioEnabled,
                    previewSampleRate,
                    _experimentalKeepAudioContextAlive,
                    children: /* @__PURE__ */ jsx40(SharedAudioTagsContextProvider, {
                      numberOfAudioTags,
                      children: /* @__PURE__ */ jsx40(VideoProvider, {
                        children
                      })
                    })
                  })
                })
              })
            })
          })
        })
      })
    })
  });
};

// src/render-resource-manager.ts
import React47 from "react";
var makeRenderResourceManager = () => {
  const resources = new Map;
  let disposed = false;
  return {
    getOrCreateResource: ({
      key,
      create
    }) => {
      if (disposed) {
        throw new Error("Render resource manager has already been disposed");
      }
      const existing = resources.get(key);
      if (existing) {
        return existing.resource;
      }
      const created = create();
      resources.set(key, created);
      return created.resource;
    },
    dispose: () => {
      if (disposed) {
        return;
      }
      disposed = true;
      const resourcesToDispose = Array.from(resources.values());
      resources.clear();
      let firstError = null;
      for (const resource of resourcesToDispose) {
        try {
          resource.dispose();
        } catch (error) {
          firstError ??= error;
        }
      }
      if (firstError !== null) {
        throw firstError;
      }
    }
  };
};
var RenderResourceManagerContext = React47.createContext(null);

// src/codec.ts
var validCodecs = [
  "h264",
  "h265",
  "vp8",
  "vp9",
  "av1",
  "mp3",
  "aac",
  "wav",
  "prores",
  "h264-mkv",
  "h264-ts",
  "gif"
];

// src/validation/validate-default-codec.ts
function validateCodec(defaultCodec, location, name) {
  if (typeof defaultCodec === "undefined") {
    return;
  }
  if (typeof defaultCodec !== "string") {
    throw new TypeError(`The "${name}" prop ${location} must be a string, but you passed a value of type ${typeof defaultCodec}.`);
  }
  if (!validCodecs.includes(defaultCodec)) {
    throw new Error(`The "${name}" prop ${location} must be one of ${validCodecs.join(", ")}, but you passed ${defaultCodec}.`);
  }
}

// src/resolve-video-config.ts
var validateCalculated = ({
  calculated,
  compositionId,
  compositionFps,
  compositionHeight,
  compositionWidth,
  compositionDurationInFrames
}) => {
  const calculateMetadataErrorLocation = `calculated by calculateMetadata() for the composition "${compositionId}"`;
  const defaultErrorLocation = `of the "<Composition />" component with the id "${compositionId}"`;
  const width = calculated?.width ?? compositionWidth ?? undefined;
  validateDimension(width, "width", calculated?.width ? calculateMetadataErrorLocation : defaultErrorLocation);
  const height = calculated?.height ?? compositionHeight ?? undefined;
  validateDimension(height, "height", calculated?.height ? calculateMetadataErrorLocation : defaultErrorLocation);
  const fps = calculated?.fps ?? compositionFps ?? null;
  validateFps(fps, calculated?.fps ? calculateMetadataErrorLocation : defaultErrorLocation, false);
  const durationInFrames = calculated?.durationInFrames ?? compositionDurationInFrames ?? null;
  validateDurationInFrames(durationInFrames, {
    allowFloats: false,
    component: `of the "<Composition />" component with the id "${compositionId}"`
  });
  const defaultCodec = calculated?.defaultCodec;
  validateCodec(defaultCodec, calculateMetadataErrorLocation, "defaultCodec");
  const defaultOutName = calculated?.defaultOutName;
  const defaultVideoImageFormat = calculated?.defaultVideoImageFormat;
  const defaultPixelFormat = calculated?.defaultPixelFormat;
  const defaultProResProfile = calculated?.defaultProResProfile;
  const defaultSampleRate = calculated?.defaultSampleRate;
  return {
    width,
    height,
    fps,
    durationInFrames,
    defaultCodec,
    defaultOutName,
    defaultVideoImageFormat,
    defaultPixelFormat,
    defaultProResProfile,
    defaultSampleRate
  };
};
var makeVideoConfigWithMetadata = ({
  calculated,
  compositionDurationInFrames,
  compositionFps,
  compositionHeight,
  compositionId,
  compositionWidth,
  defaultProps,
  originalProps
}) => {
  const data = validateCalculated({
    calculated,
    compositionDurationInFrames,
    compositionFps,
    compositionHeight,
    compositionWidth,
    compositionId
  });
  return {
    metadataSource: {
      durationInFrames: calculated?.durationInFrames === undefined ? "composition" : "calculate-metadata",
      fps: calculated?.fps === undefined ? "composition" : "calculate-metadata",
      height: calculated?.height === undefined ? "composition" : "calculate-metadata",
      width: calculated?.width === undefined ? "composition" : "calculate-metadata"
    },
    videoConfig: {
      ...data,
      id: compositionId,
      defaultProps: serializeThenDeserializeInStudio(defaultProps ?? {}),
      props: serializeThenDeserializeInStudio(calculated?.props ?? originalProps),
      defaultCodec: data.defaultCodec ?? null,
      defaultOutName: data.defaultOutName ?? null,
      defaultVideoImageFormat: data.defaultVideoImageFormat ?? null,
      defaultPixelFormat: data.defaultPixelFormat ?? null,
      defaultProResProfile: data.defaultProResProfile ?? null,
      defaultSampleRate: data.defaultSampleRate ?? null
    }
  };
};
var resolveVideoConfigWithMetadata = ({
  calculateMetadata,
  signal,
  defaultProps,
  inputProps: originalProps,
  compositionId,
  compositionDurationInFrames,
  compositionFps,
  compositionHeight,
  compositionWidth
}) => {
  const calculatedProm = calculateMetadata ? calculateMetadata({
    defaultProps,
    props: originalProps,
    abortSignal: signal,
    compositionId,
    isRendering: getRemotionEnvironment().isRendering
  }) : null;
  if (calculatedProm !== null && typeof calculatedProm === "object" && "then" in calculatedProm) {
    return calculatedProm.then((c) => {
      return makeVideoConfigWithMetadata({
        calculated: c,
        compositionDurationInFrames,
        compositionFps,
        compositionHeight,
        compositionWidth,
        compositionId,
        defaultProps,
        originalProps
      });
    });
  }
  return makeVideoConfigWithMetadata({
    calculated: calculatedProm,
    compositionDurationInFrames,
    compositionFps,
    compositionHeight,
    compositionWidth,
    compositionId,
    defaultProps,
    originalProps
  });
};
var resolveVideoConfig = (params) => {
  const resolved = resolveVideoConfigWithMetadata(params);
  if (typeof resolved === "object" && "then" in resolved) {
    return resolved.then(({ videoConfig }) => videoConfig);
  }
  return resolved.videoConfig;
};
var resolveVideoConfigWithMetadataOrCatch = (params) => {
  try {
    return {
      type: "success",
      result: resolveVideoConfigWithMetadata(params)
    };
  } catch (err) {
    return {
      type: "error",
      error: err
    };
  }
};
var resolveVideoConfigOrCatch = (params) => {
  try {
    const promiseOrReturnValue = resolveVideoConfig(params);
    return {
      type: "success",
      result: promiseOrReturnValue
    };
  } catch (err) {
    return {
      type: "error",
      error: err
    };
  }
};

// src/sequence-stack-traces.ts
import React48 from "react";
var SequenceStackTracesUpdateContext = React48.createContext(() => {});

// src/setup-env-variables.ts
var getEnvVariables = () => {
  if (getRemotionEnvironment().isRendering) {
    const param = window.remotion_envVariables;
    if (!param) {
      return {};
    }
    return { ...JSON.parse(param), NODE_ENV: "production" };
  }
  if (false) {}
  return {
    NODE_ENV: "production"
  };
};
var setupEnvVariables = () => {
  const env = getEnvVariables();
  if (!window.process) {
    window.process = {};
  }
  if (!window.process.env) {
    window.process.env = {};
  }
  Object.keys(env).forEach((key) => {
    window.process.env[key] = env[key];
  });
};

// src/Track.tsx
import { useMemo as useMemo47, useState as useState26 } from "react";
import { jsx as jsx41 } from "react/jsx-runtime";
var {
  freeze: _freeze,
  layout: _layout,
  ...trackSequenceSchema
} = sequenceSchema;
var trackSchema = {
  ...trackSequenceSchema,
  ...sequenceTimingSchema
};
var TrackWithoutSchema = ({
  name = "Track",
  children,
  layout = "none",
  ...props
}) => {
  const [id] = useState26(() => String(Math.random()));
  const value = useMemo47(() => ({ id, name }), [id, name]);
  return /* @__PURE__ */ jsx41(TimelineTrackContext.Provider, {
    value,
    children: /* @__PURE__ */ jsx41(SequenceWithoutSchema, {
      _remotionInternalDocumentationLink: "https://www.remotion.dev/docs/track",
      ...props,
      name,
      layout,
      _remotionInternalTimelineTrack: { role: "track", seriesOffset: null },
      children
    })
  });
};
var Track = withInteractivitySchema({
  Component: (props) => /* @__PURE__ */ jsx41(TrackWithoutSchema, {
    ...props,
    layout: "none"
  }),
  componentName: "<Track>",
  componentIdentity: "dev.remotion.remotion.Track",
  schema: trackSchema,
  supportsEffects: false
});
addSequenceStackTraces(Track);

// src/use-pixel-density.ts
import React50, { useContext as useContext50 } from "react";
var PixelDensityContext = React50.createContext(null);
var getBrowserPixelDensity = () => {
  if (typeof window === "undefined") {
    return 1;
  }
  return window.devicePixelRatio || 1;
};
var usePixelDensity = (options) => {
  const pixelDensity = useContext50(PixelDensityContext);
  const canUseRemotionHooks = useContext50(CanUseRemotionHooks);
  if (pixelDensity !== null) {
    return pixelDensity;
  }
  if (canUseRemotionHooks || options?.dontThrowIfOutsideOfRemotion) {
    return getBrowserPixelDensity();
  }
  throw new Error([
    "usePixelDensity() was called outside of a Remotion context.",
    "This hook can only be called in a component that is being rendered by Remotion.",
    "If you want this hook to return the browser pixel density outside of Remotion, pass {dontThrowIfOutsideOfRemotion: true} as an option.",
    "If you think you called this hook in a Remotion component, make sure all versions of Remotion are aligned."
  ].join(`
`));
};

// src/video/OffthreadVideo.tsx
import { useCallback as useCallback25 } from "react";

// src/video/OffthreadVideoForRendering.tsx
import {
  useCallback as useCallback23,
  useContext as useContext51,
  useEffect as useEffect21,
  useLayoutEffect as useLayoutEffect23,
  useMemo as useMemo48,
  useState as useState27
} from "react";

// src/video/offthread-video-source.ts
var getOffthreadVideoSource = ({
  src,
  transparent,
  currentTime,
  toneMapped
}) => {
  return `http://localhost:${window.remotion_proxyPort}/proxy?src=${encodeURIComponent(getAbsoluteSrc(src))}&time=${encodeURIComponent(Math.max(0, currentTime))}&transparent=${String(transparent)}&toneMapped=${String(toneMapped)}`;
};

// src/video/OffthreadVideoForRendering.tsx
import { jsx as jsx42 } from "react/jsx-runtime";
var OffthreadVideoForRendering = ({
  onError,
  volume: volumeProp,
  playbackRate,
  src,
  muted,
  allowAmplificationDuringRender,
  transparent,
  toneMapped,
  toneFrequency,
  name,
  loopVolumeCurveBehavior,
  delayRenderRetries,
  delayRenderTimeoutInMilliseconds,
  onVideoFrame,
  crossOrigin,
  audioStreamIndex,
  preservePitch,
  ...props
}) => {
  const absoluteFrame = useTimelinePosition();
  const frame = useCurrentFrame();
  const volumePropsFrame = useFrameForVolumeProp(loopVolumeCurveBehavior);
  const videoConfig = useUnsafeVideoConfig();
  const sequenceContext = useContext51(SequenceContext);
  const sequencePlaybackRate = sequenceContext?.playbackRate ?? 1;
  const audioStartFrame = useContext51(Html5MediaTrimContext);
  const { registerRenderAsset, unregisterRenderAsset } = useContext51(RenderAssetManager);
  if (!src) {
    throw new TypeError("No `src` was passed to <OffthreadVideo>.");
  }
  const id = useMemo48(() => `offthreadvideo-${random(src)}-${sequenceContext?.cumulatedFrom}-${sequenceContext?.relativeFrom}-${sequenceContext?.durationInFrames}`, [
    src,
    sequenceContext?.cumulatedFrom,
    sequenceContext?.relativeFrom,
    sequenceContext?.durationInFrames
  ]);
  const volume = evaluateVolume({
    volume: volumeProp,
    frame: volumePropsFrame,
    mediaVolume: 1
  });
  warnAboutTooHighVolume(volume);
  const audioEnabled = useAudioEnabled();
  const { shouldUseAudio } = useMediaAudioState({
    muted,
    volume,
    audioEnabled
  });
  if (!videoConfig) {
    throw new Error("No video config found");
  }
  useEffect21(() => {
    if (!src) {
      throw new Error("No src passed");
    }
    if (!shouldUseAudio) {
      return;
    }
    registerRenderAsset({
      type: "video",
      src: getAbsoluteSrc(src),
      id,
      frame: absoluteFrame,
      volume,
      mediaFrame: audioStartFrame + (frame - audioStartFrame) / sequencePlaybackRate,
      playbackRate: playbackRate * sequencePlaybackRate,
      toneFrequency,
      audioStartFrame,
      audioStreamIndex,
      preservePitch: preservePitch ?? true
    });
    return () => unregisterRenderAsset(id);
  }, [
    shouldUseAudio,
    src,
    registerRenderAsset,
    id,
    unregisterRenderAsset,
    volume,
    frame,
    absoluteFrame,
    playbackRate,
    toneFrequency,
    audioStartFrame,
    sequencePlaybackRate,
    audioStreamIndex,
    preservePitch
  ]);
  const currentTime = useMemo48(() => {
    return getExpectedMediaFrameUncorrected({
      frame,
      playbackRate: playbackRate || 1,
      startFrom: audioStartFrame
    }) / videoConfig.fps;
  }, [frame, audioStartFrame, playbackRate, videoConfig.fps]);
  const actualSrc = useMemo48(() => {
    return getOffthreadVideoSource({
      src,
      currentTime,
      transparent,
      toneMapped
    });
  }, [toneMapped, currentTime, src, transparent]);
  const [imageSrc, setImageSrc] = useState27(null);
  const { delayRender, continueRender, cancelRender } = useDelayRender();
  useLayoutEffect23(() => {
    if (!window.remotion_videoEnabled) {
      return;
    }
    const cleanup = [];
    setImageSrc(null);
    const controller = new AbortController;
    const newHandle = delayRender(`Fetching ${actualSrc} from server`, {
      retries: delayRenderRetries ?? undefined,
      timeoutInMilliseconds: delayRenderTimeoutInMilliseconds ?? undefined
    });
    const execute = async () => {
      try {
        const res = await fetch(actualSrc, {
          signal: controller.signal,
          cache: "no-store"
        });
        if (res.status !== 200) {
          if (res.status === 500) {
            const json = await res.json();
            if (json.error) {
              const cleanedUpErrorMessage = json.error.replace(/^Error: /, "");
              throw new Error(cleanedUpErrorMessage);
            }
          }
          throw new Error(`Server returned status ${res.status} while fetching ${actualSrc}`);
        }
        const blob = new Blob([await res.arrayBuffer()], {
          type: res.headers.get("Content-Type") ?? ""
        });
        const url = URL.createObjectURL(blob);
        cleanup.push(() => URL.revokeObjectURL(url));
        setImageSrc({
          src: url,
          handle: newHandle
        });
      } catch (err) {
        if (err.message.includes("aborted")) {
          continueRender(newHandle);
          return;
        }
        if (controller.signal.aborted) {
          continueRender(newHandle);
          return;
        }
        if (err.message.includes("Failed to fetch")) {
          err = new Error(`Failed to fetch ${actualSrc}. This could be caused by Chrome rejecting the request because the disk space is low. Consider increasing the disk size of your environment.`, { cause: err });
        }
        if (onError) {
          onError(err);
        } else {
          cancelRender(err);
        }
      }
    };
    execute();
    cleanup.push(() => {
      if (controller.signal.aborted) {
        return;
      }
      controller.abort();
    });
    return () => {
      cleanup.forEach((c) => c());
    };
  }, [
    actualSrc,
    delayRenderRetries,
    delayRenderTimeoutInMilliseconds,
    onError,
    continueRender,
    cancelRender,
    delayRender
  ]);
  const onErr = useCallback23(() => {
    if (onError) {
      onError?.(new Error("Failed to load image with src " + imageSrc));
    } else {
      cancelRender("Failed to load image with src " + imageSrc);
    }
  }, [imageSrc, onError, cancelRender]);
  const className = useMemo48(() => {
    return [OBJECTFIT_CONTAIN_CLASS_NAME, props.className].filter(truthy).join(" ");
  }, [props.className]);
  const onImageFrame = useCallback23((img) => {
    if (onVideoFrame) {
      onVideoFrame(img);
    }
  }, [onVideoFrame]);
  if (!imageSrc || !window.remotion_videoEnabled) {
    return null;
  }
  continueRender(imageSrc.handle);
  return /* @__PURE__ */ jsx42(Img, {
    src: imageSrc.src,
    delayRenderRetries,
    delayRenderTimeoutInMilliseconds,
    onImageFrame,
    ...props,
    onError: onErr,
    className
  });
};

// src/video/VideoForPreview.tsx
import React52, {
  forwardRef as forwardRef14,
  useCallback as useCallback24,
  useContext as useContext52,
  useEffect as useEffect23,
  useImperativeHandle as useImperativeHandle10,
  useMemo as useMemo49,
  useRef as useRef31,
  useState as useState28
} from "react";

// src/video/emit-video-frame.ts
import { useEffect as useEffect22 } from "react";
var useEmitVideoFrame = ({
  ref,
  onVideoFrame
}) => {
  useEffect22(() => {
    const { current } = ref;
    if (!current) {
      return;
    }
    if (!onVideoFrame) {
      return;
    }
    let handle = 0;
    const callback = (_now, metadata) => {
      if (!ref.current) {
        return;
      }
      onVideoFrame(ref.current, _now, metadata);
      handle = ref.current.requestVideoFrameCallback(callback);
    };
    onVideoFrame(current);
    if (!current.requestVideoFrameCallback) {
      return;
    }
    handle = current.requestVideoFrameCallback(callback);
    return () => {
      if (handle) {
        current.cancelVideoFrameCallback(handle);
      }
    };
  }, [onVideoFrame, ref]);
};

// src/video/MediaPlaybackError.ts
class MediaPlaybackError extends Error {
  src;
  constructor({ message, src }) {
    super(message);
    this.name = "MediaPlaybackError";
    this.src = src;
  }
}

// src/video/VideoForPreview.tsx
import { jsx as jsx43 } from "react/jsx-runtime";
var VideoForDevelopmentRefForwardingFunction = (props, ref) => {
  const context = useContext52(SharedAudioContext);
  if (!context) {
    throw new Error("SharedAudioContext not found");
  }
  const videoRef = useRef31(null);
  const sharedSource = useMemo49(() => {
    if (!context.audioContext) {
      return null;
    }
    return makeSharedElementSourceNode({
      audioContext: context.audioContext,
      ref: videoRef
    });
  }, [context.audioContext]);
  const effectToUse = React52.useInsertionEffect ?? React52.useLayoutEffect;
  effectToUse(() => {
    return scheduleMediaSourceCleanup.bind(null, sharedSource?.cleanup ?? null);
  }, [sharedSource]);
  const {
    timelineId,
    userPreferredVolume,
    isMutedForPlayback,
    volume,
    muted,
    playbackRate,
    preservePitch,
    onlyWarnForMediaSeekingError,
    src,
    onDuration,
    acceptableTimeShift,
    acceptableTimeShiftInSeconds,
    toneFrequency,
    name,
    _remotionInternalNativeLoopPassed,
    _remotionInternalStack,
    style,
    pauseWhenBuffering,
    showInTimeline,
    loopVolumeCurveBehavior,
    onError,
    onAutoPlayError,
    onVideoFrame,
    crossOrigin,
    delayRenderRetries,
    delayRenderTimeoutInMilliseconds,
    allowAmplificationDuringRender,
    useWebAudioApi,
    audioStreamIndex,
    ...nativeProps
  } = props;
  const _propsValid = true;
  if (!_propsValid) {
    throw new Error("typecheck error");
  }
  const { fps, durationInFrames } = useVideoConfig();
  const parentSequence = useContext52(SequenceContext);
  const logLevel = useLogLevel();
  const mountTime = useMountTime();
  if (typeof acceptableTimeShift !== "undefined") {
    throw new Error("acceptableTimeShift has been removed. Use acceptableTimeShiftInSeconds instead.");
  }
  warnAboutTooHighVolume(userPreferredVolume);
  useMediaPlayback({
    mediaRef: videoRef,
    src,
    mediaType: "video",
    playbackRate: props.playbackRate ?? 1,
    preservePitch,
    onlyWarnForMediaSeekingError,
    acceptableTimeshift: acceptableTimeShiftInSeconds ?? null,
    isPremounting: Boolean(parentSequence?.premounting),
    isPostmounting: Boolean(parentSequence?.postmounting),
    pauseWhenBuffering,
    onAutoPlayError: onAutoPlayError ?? null
  });
  useMediaTag({
    id: timelineId,
    isPostmounting: Boolean(parentSequence?.postmounting),
    isPremounting: Boolean(parentSequence?.premounting),
    mediaRef: videoRef,
    mediaType: "video",
    onAutoPlayError: onAutoPlayError ?? null
  });
  useVolume({
    logLevel,
    mediaRef: videoRef,
    volume: userPreferredVolume,
    source: sharedSource,
    shouldUseWebAudioApi: useWebAudioApi ?? false
  });
  const actualFrom = parentSequence ? parentSequence.relativeFrom : 0;
  const duration = parentSequence ? Math.min(parentSequence.durationInFrames, durationInFrames) : durationInFrames;
  const preloadedSrc = usePreload(src);
  const actualSrc = useAppendVideoFragment({
    actualSrc: preloadedSrc,
    actualFrom,
    duration,
    fps
  });
  useImperativeHandle10(ref, () => {
    return videoRef.current;
  }, []);
  useState28(() => playbackLogging({
    logLevel,
    message: `Mounting video with source = ${actualSrc}, v=${VERSION}, user agent=${typeof navigator === "undefined" ? "server" : navigator.userAgent}`,
    tag: "video",
    mountTime
  }));
  useEffect23(() => {
    const { current } = videoRef;
    if (!current) {
      return;
    }
    const errorHandler = () => {
      if (current.error) {
        console.error("Error occurred in video", current?.error);
        if (onError) {
          const err = new MediaPlaybackError({
            message: `Code ${current.error.code}: ${current.error.message}`,
            src
          });
          onError(err);
          return;
        }
        throw new MediaPlaybackError({
          message: `The browser threw an error while playing the video ${src}: Code ${current.error.code} - ${current?.error?.message}. See https://remotion.dev/docs/media-playback-error for help. Pass an onError() prop to handle the error.`,
          src
        });
      } else {
        if (onError) {
          const err = new MediaPlaybackError({
            message: `The browser threw an error while playing the video ${src}`,
            src
          });
          onError(err);
          return;
        }
        throw new MediaPlaybackError({
          message: "The browser threw an error while playing the video",
          src
        });
      }
    };
    current.addEventListener("error", errorHandler, { once: true });
    return () => {
      current.removeEventListener("error", errorHandler);
    };
  }, [onError, src]);
  useEmitVideoFrame({ ref: videoRef, onVideoFrame });
  useMediaDuration(videoRef, onDuration, src, false);
  useEffect23(() => {
    const { current } = videoRef;
    if (!current) {
      return;
    }
    if (isIosSafari()) {
      current.preload = "metadata";
    } else {
      current.preload = "auto";
    }
  }, []);
  const actualStyle = useMemo49(() => {
    return {
      ...style
    };
  }, [style]);
  const crossOriginValue = getCrossOriginValue({
    crossOrigin,
    requestsVideoFrame: Boolean(onVideoFrame),
    isClientSideRendering: false
  });
  const video = /* @__PURE__ */ jsx43("video", {
    ...nativeProps,
    ref: videoRef,
    muted: isMutedForPlayback,
    playsInline: true,
    src: actualSrc,
    loop: _remotionInternalNativeLoopPassed,
    style: actualStyle,
    disableRemotePlayback: true,
    crossOrigin: crossOriginValue,
    controls: false
  });
  return video;
};
var VideoForPreviewContent = forwardRef14(VideoForDevelopmentRefForwardingFunction);
var VideoForPreviewRefForwardingFunction = (props, ref) => {
  const {
    volume,
    muted,
    playbackRate,
    src,
    name,
    _remotionInternalStack,
    showInTimeline,
    loopVolumeCurveBehavior,
    onlyWarnForMediaSeekingError
  } = props;
  const [timelineId] = useState28(() => String(Math.random()));
  const parentSequence = useContext52(SequenceContext);
  const { isStudio } = useRemotionEnvironment();
  const [mediaVolume] = useMediaVolumeState();
  const volumePropFrame = useFrameForVolumeProp(loopVolumeCurveBehavior ?? "repeat");
  const userPreferredVolume = evaluateVolume({
    frame: volumePropFrame,
    volume,
    mediaVolume
  });
  const { isMutedForTimeline, isMutedForPlayback } = useMediaAudioState({
    muted: muted ?? false,
    volume: userPreferredVolume,
    audioEnabled: true
  });
  const getStack = useCallback24(() => {
    return _remotionInternalStack ?? null;
  }, [_remotionInternalStack]);
  const { automaticOutlineRef, registration } = useMediaInTimelineRegistration({
    mediaType: "video",
    src,
    playbackRate: playbackRate ?? 1,
    displayName: name ?? null,
    id: timelineId,
    getStack,
    showInTimeline,
    premountDisplay: parentSequence?.premountDisplay ?? null,
    postmountDisplay: parentSequence?.postmountDisplay ?? null,
    loopDisplay: undefined,
    documentationLink: onlyWarnForMediaSeekingError ? "https://www.remotion.dev/docs/offthreadvideo" : "https://www.remotion.dev/docs/html5-video",
    muted: isMutedForTimeline
  });
  const metadata = useMemo49(() => isStudio || automaticOutlineRef || registration !== null ? {
    type: "sequence",
    id: timelineId,
    value: registration,
    outlineChildrenRef: automaticOutlineRef
  } : null, [automaticOutlineRef, isStudio, registration, timelineId]);
  return /* @__PURE__ */ jsx43(CommittedMetadataProvider, {
    value: null,
    _remotionCommitMetadata: metadata,
    children: /* @__PURE__ */ jsx43(SequenceContent, {
      children: /* @__PURE__ */ jsx43(VideoForPreviewContent, {
        ...props,
        ref,
        timelineId,
        userPreferredVolume,
        isMutedForPlayback
      })
    })
  });
};
var VideoForPreview = forwardRef14(VideoForPreviewRefForwardingFunction);

// src/video/OffthreadVideo.tsx
import { jsx as jsx44 } from "react/jsx-runtime";
var InnerOffthreadVideo = (props) => {
  const {
    startFrom,
    endAt,
    trimBefore,
    trimAfter,
    durationInFrames,
    name,
    pauseWhenBuffering,
    _remotionInternalStack,
    showInTimeline,
    ...otherProps
  } = props;
  const environment = useRemotionEnvironment();
  const shouldPauseWhenBuffering = resolveV5Default(pauseWhenBuffering);
  if (environment.isClientSideRendering) {
    throw new Error("<OffthreadVideo> is not supported in @remotion/web-renderer. Use <Video> from @remotion/media instead. See https://remotion.dev/docs/client-side-rendering/limitations");
  }
  const onDuration = useCallback25(() => {
    return;
  }, []);
  if (typeof props.src !== "string") {
    throw new TypeError(`The \`<OffthreadVideo>\` tag requires a string for \`src\`, but got ${JSON.stringify(props.src)} instead.`);
  }
  validateMediaTrimProps({ startFrom, endAt, trimBefore, trimAfter });
  if (durationInFrames !== undefined) {
    validateDurationInFrames(durationInFrames, {
      component: "of the <OffthreadVideo /> component",
      allowFloats: true
    });
  }
  const { trimBeforeValue, trimAfterValue } = resolveTrimProps({
    startFrom,
    endAt,
    trimBefore,
    trimAfter
  });
  const effectiveTrimAfter = getMediaTrimAfter({
    durationInFrames,
    trimAfter: trimAfterValue,
    trimBefore: trimBeforeValue
  });
  if (typeof trimBeforeValue !== "undefined" || typeof effectiveTrimAfter !== "undefined") {
    return /* @__PURE__ */ jsx44(Html5MediaTrimContext.Provider, {
      value: trimBeforeValue ?? 0,
      children: /* @__PURE__ */ jsx44(Sequence, {
        layout: "none",
        from: 0 - (trimBeforeValue ?? 0),
        showInTimeline: false,
        durationInFrames: effectiveTrimAfter === undefined ? undefined : (trimBeforeValue ?? 0) + (effectiveTrimAfter - (trimBeforeValue ?? 0)) / (props.playbackRate ?? 1),
        name,
        children: /* @__PURE__ */ jsx44(InnerOffthreadVideo, {
          pauseWhenBuffering: shouldPauseWhenBuffering,
          ...otherProps,
          trimAfter: undefined,
          durationInFrames: undefined,
          name: undefined,
          showInTimeline,
          trimBefore: undefined,
          _remotionInternalStack: undefined,
          startFrom: undefined,
          endAt: undefined
        })
      })
    });
  }
  validateMediaProps(props, "Video");
  if (environment.isRendering) {
    return /* @__PURE__ */ jsx44(OffthreadVideoForRendering, {
      pauseWhenBuffering: shouldPauseWhenBuffering,
      ...otherProps,
      trimAfter: undefined,
      durationInFrames: undefined,
      name: undefined,
      showInTimeline,
      trimBefore: undefined,
      _remotionInternalStack: undefined,
      startFrom: undefined,
      endAt: undefined
    });
  }
  const {
    transparent,
    toneMapped,
    onAutoPlayError,
    onVideoFrame,
    crossOrigin,
    delayRenderRetries,
    delayRenderTimeoutInMilliseconds,
    ...propsForPreview
  } = otherProps;
  return /* @__PURE__ */ jsx44(VideoForPreview, {
    _remotionInternalStack: _remotionInternalStack ?? null,
    onDuration,
    onlyWarnForMediaSeekingError: true,
    pauseWhenBuffering: shouldPauseWhenBuffering,
    showInTimeline: showInTimeline ?? true,
    onAutoPlayError: onAutoPlayError ?? undefined,
    onVideoFrame: onVideoFrame ?? null,
    crossOrigin,
    ...propsForPreview,
    _remotionInternalNativeLoopPassed: false
  });
};
var OffthreadVideo = ({
  src,
  acceptableTimeShiftInSeconds,
  allowAmplificationDuringRender,
  audioStreamIndex,
  crossOrigin,
  delayRenderRetries,
  delayRenderTimeoutInMilliseconds,
  loopVolumeCurveBehavior,
  muted,
  name,
  onAutoPlayError,
  onError,
  onVideoFrame,
  pauseWhenBuffering,
  playbackRate,
  preservePitch,
  showInTimeline,
  style,
  toneFrequency,
  toneMapped,
  transparent,
  trimAfter,
  durationInFrames,
  trimBefore,
  useWebAudioApi,
  volume,
  _remotionInternalNativeLoopPassed,
  endAt,
  _remotionInternalStack,
  startFrom,
  imageFormat,
  ...props
}) => {
  if (imageFormat) {
    throw new TypeError(`The \`<OffthreadVideo>\` tag does no longer accept \`imageFormat\`. Use the \`transparent\` prop if you want to render a transparent video.`);
  }
  return /* @__PURE__ */ jsx44(InnerOffthreadVideo, {
    acceptableTimeShiftInSeconds,
    allowAmplificationDuringRender: allowAmplificationDuringRender ?? true,
    audioStreamIndex: audioStreamIndex ?? 0,
    crossOrigin,
    delayRenderRetries,
    delayRenderTimeoutInMilliseconds,
    loopVolumeCurveBehavior: loopVolumeCurveBehavior ?? "repeat",
    muted: muted ?? false,
    name,
    onAutoPlayError: onAutoPlayError ?? null,
    onError,
    onVideoFrame,
    pauseWhenBuffering: resolveV5Default(pauseWhenBuffering),
    playbackRate: playbackRate ?? 1,
    preservePitch,
    toneFrequency: toneFrequency ?? 1,
    showInTimeline: showInTimeline ?? true,
    src,
    _remotionInternalStack,
    startFrom,
    _remotionInternalNativeLoopPassed: _remotionInternalNativeLoopPassed ?? false,
    endAt,
    style,
    toneMapped: toneMapped ?? true,
    transparent: transparent ?? false,
    trimAfter,
    durationInFrames,
    trimBefore,
    useWebAudioApi: useWebAudioApi ?? false,
    volume,
    ...props
  });
};
addSequenceStackTraces(OffthreadVideo);

// src/watch-static-file.ts
var WATCH_REMOTION_STATIC_FILES = "remotion_staticFilesChanged";
var watchStaticFile = (fileName, callback) => {
  if (ENABLE_V5_BREAKING_CHANGES) {
    throw new Error("watchStaticFile() has moved into the `@remotion/studio` package. Update your imports.");
  }
  if (!getRemotionEnvironment().isStudio) {
    console.warn("The watchStaticFile() API is only available while using the Remotion Studio.");
    return { cancel: () => {
      return;
    } };
  }
  const withoutStaticBase = fileName.startsWith(window.remotion_staticBase) ? fileName.replace(window.remotion_staticBase, "") : fileName;
  const withoutLeadingSlash = withoutStaticBase.startsWith("/") ? withoutStaticBase.slice(1) : withoutStaticBase;
  let prevFileData = window.remotion_staticFiles.find((file) => file.name === withoutLeadingSlash);
  const checkFile = (event) => {
    const staticFiles = event.detail.files;
    const newFileData = staticFiles.find((file) => file.name === withoutLeadingSlash);
    if (!newFileData) {
      if (prevFileData !== undefined) {
        callback(null);
      }
      prevFileData = undefined;
      return;
    }
    if (prevFileData === undefined || prevFileData.lastModified !== newFileData.lastModified) {
      callback(newFileData);
      prevFileData = newFileData;
    }
  };
  window.addEventListener(WATCH_REMOTION_STATIC_FILES, checkFile);
  const cancel = () => {
    return window.removeEventListener(WATCH_REMOTION_STATIC_FILES, checkFile);
  };
  return { cancel };
};

// src/wrap-remotion-context.tsx
import React54, { useCallback as useCallback26, useMemo as useMemo50, useRef as useRef32, useState as useState29 } from "react";
import { jsx as jsx45 } from "react/jsx-runtime";
function useRemotionContexts() {
  const compositionManagerCtx = React54.useContext(CompositionManager);
  const videoContext = React54.useContext(VideoContext);
  const timelineContext = React54.useContext(TimelineContext);
  const setTimelineContext = React54.useContext(SetTimelineContext);
  const sequenceContext = React54.useContext(SequenceContext);
  const defaultPremountInSeconds = React54.useContext(DefaultPremountContext);
  const timelineTrackContext = React54.useContext(TimelineTrackContext);
  const canUseRemotionHooksContext = React54.useContext(CanUseRemotionHooks);
  const preloadContext = React54.useContext(PreloadContext);
  const resolveCompositionContext = React54.useContext(ResolveCompositionContext);
  const renderAssetManagerContext = React54.useContext(RenderAssetManager);
  const sequenceManagerActionsContext = React54.useContext(SequenceManagerActionsContext);
  const sequenceManagerRefContext = React54.useContext(SequenceManagerRefContext);
  const sequenceRegistryContext = React54.useContext(SequenceRegistryContext);
  const sequenceRegistryScopeContext = React54.useContext(SequenceRegistryScopeContext);
  const sequenceRegistrationContext = React54.useContext(SequenceRegistrationContext);
  const disableSequenceRegistrationContext = React54.useContext(DisableSequenceRegistrationContext);
  const remotionEnvironmentContext = React54.useContext(RemotionEnvironmentContext);
  const visualModePropStatusesRefContext = React54.useContext(VisualModePropStatusesRefContext);
  const bufferManagerContext = React54.useContext(BufferingContextReact);
  const logLevelContext = React54.useContext(LogLevelContext);
  return useMemo50(() => ({
    compositionManagerCtx,
    videoContext,
    timelineContext,
    setTimelineContext,
    sequenceContext,
    defaultPremountInSeconds,
    timelineTrackContext,
    canUseRemotionHooksContext,
    preloadContext,
    resolveCompositionContext,
    renderAssetManagerContext,
    sequenceManagerActionsContext,
    sequenceManagerRefContext,
    sequenceRegistryContext,
    sequenceRegistryScopeContext,
    sequenceRegistrationContext,
    disableSequenceRegistrationContext,
    remotionEnvironmentContext,
    visualModePropStatusesRefContext,
    bufferManagerContext,
    logLevelContext
  }), [
    compositionManagerCtx,
    videoContext,
    sequenceContext,
    defaultPremountInSeconds,
    timelineTrackContext,
    setTimelineContext,
    timelineContext,
    canUseRemotionHooksContext,
    preloadContext,
    resolveCompositionContext,
    renderAssetManagerContext,
    sequenceManagerActionsContext,
    sequenceManagerRefContext,
    sequenceRegistryContext,
    sequenceRegistryScopeContext,
    sequenceRegistrationContext,
    disableSequenceRegistrationContext,
    remotionEnvironmentContext,
    visualModePropStatusesRefContext,
    bufferManagerContext,
    logLevelContext
  ]);
}
var SequenceRegistryScopeProvider = withCommittedMetadata(SequenceRegistryScopeContext.Provider);
var ForwardedSequenceRegistry = ({
  contexts,
  children
}) => {
  const [scopeId] = useState29(() => String(Math.random()));
  const [observerAvailable, setObserverAvailable] = useState29(isCommitRegistrationObserverInstalled);
  const observedCommitRef = useRef32(false);
  const observerFailedRef = useRef32(false);
  const unmountedRef = useRef32(false);
  const lifetimeRef = useRef32(0);
  const registry = contexts.sequenceRegistryContext;
  const scope = contexts.sequenceRegistryScopeContext;
  const activeRegistryRef = useRef32(registry);
  const commitRegistrationEnabled = scope?.commitRegistrationRequested === true && registry !== null && observerAvailable;
  const onCommitSequences = useCallback26((sequences, sequenceIds) => {
    if (observerFailedRef.current && sequenceIds.length > 0) {
      return;
    }
    observedCommitRef.current = true;
    scope?.onCommitSequences(scopeId, sequences, sequenceIds);
  }, [scope, scopeId]);
  const useIsomorphicLayoutEffect = typeof window === "undefined" ? React54.useEffect : React54.useLayoutEffect;
  useIsomorphicLayoutEffect(() => {
    if (scope === null || typeof window === "undefined") {
      return;
    }
    const lifetime = ++lifetimeRef.current;
    unmountedRef.current = false;
    activeRegistryRef.current = registry;
    const onFailure = () => {
      if (observerFailedRef.current) {
        return;
      }
      observerFailedRef.current = true;
      queueMicrotask(() => {
        scope.onCommitSequences(scopeId, [], []);
        queueMicrotask(() => {
          if (!unmountedRef.current)
            setObserverAvailable(false);
        });
      });
    };
    window.addEventListener(COMMIT_REGISTRATION_ERROR_EVENT, onFailure);
    if (commitRegistrationEnabled) {
      queueMicrotask(() => {
        if (lifetimeRef.current === lifetime && !unmountedRef.current && !observedCommitRef.current) {
          onFailure();
        }
      });
    }
    return () => {
      unmountedRef.current = true;
      window.removeEventListener(COMMIT_REGISTRATION_ERROR_EVENT, onFailure);
      queueMicrotask(() => {
        if (activeRegistryRef.current !== registry || lifetimeRef.current === lifetime && unmountedRef.current) {
          scope.onCommitSequences(scopeId, [], []);
        }
      });
    };
  }, [scope, scopeId, registry, commitRegistrationEnabled]);
  const metadata = useMemo50(() => ({
    type: "sequence-manager",
    id: scopeId,
    onCommit: commitRegistrationEnabled ? onCommitSequences : null
  }), [commitRegistrationEnabled, onCommitSequences, scopeId]);
  return /* @__PURE__ */ jsx45(SequenceRegistryScopeProvider, {
    value: scope,
    _remotionCommitMetadata: metadata,
    children: /* @__PURE__ */ jsx45(SequenceManagerActionsContext.Provider, {
      value: contexts.sequenceManagerActionsContext,
      children: /* @__PURE__ */ jsx45(SequenceRegistryContext.Provider, {
        value: registry,
        children: /* @__PURE__ */ jsx45(SequenceCommitRegistrationContext.Provider, {
          value: commitRegistrationEnabled,
          children
        })
      })
    })
  });
};
var RemotionContextProvider = (props) => {
  const { children, contexts } = props;
  return /* @__PURE__ */ jsx45(LogLevelContext.Provider, {
    value: contexts.logLevelContext,
    children: /* @__PURE__ */ jsx45(CanUseRemotionHooks.Provider, {
      value: contexts.canUseRemotionHooksContext,
      children: /* @__PURE__ */ jsx45(PreloadContext.Provider, {
        value: contexts.preloadContext,
        children: /* @__PURE__ */ jsx45(CompositionManager.Provider, {
          value: contexts.compositionManagerCtx,
          children: /* @__PURE__ */ jsx45(SequenceManagerRefContext.Provider, {
            value: contexts.sequenceManagerRefContext,
            children: /* @__PURE__ */ jsx45(RemotionEnvironmentContext.Provider, {
              value: contexts.remotionEnvironmentContext,
              children: /* @__PURE__ */ jsx45(SequenceRegistrationContext.Provider, {
                value: contexts.sequenceRegistrationContext,
                children: /* @__PURE__ */ jsx45(DisableSequenceRegistrationContext.Provider, {
                  value: contexts.disableSequenceRegistrationContext,
                  children: /* @__PURE__ */ jsx45(ForwardedSequenceRegistry, {
                    contexts,
                    children: /* @__PURE__ */ jsx45(VisualModePropStatusesRefContext.Provider, {
                      value: contexts.visualModePropStatusesRefContext,
                      children: /* @__PURE__ */ jsx45(RenderAssetManager.Provider, {
                        value: contexts.renderAssetManagerContext,
                        children: /* @__PURE__ */ jsx45(ResolveCompositionContext.Provider, {
                          value: contexts.resolveCompositionContext,
                          children: /* @__PURE__ */ jsx45(TimelineContext.Provider, {
                            value: contexts.timelineContext,
                            children: /* @__PURE__ */ jsx45(SetTimelineContext.Provider, {
                              value: contexts.setTimelineContext,
                              children: /* @__PURE__ */ jsx45(SequenceContext.Provider, {
                                value: contexts.sequenceContext,
                                children: /* @__PURE__ */ jsx45(BufferingContextReact.Provider, {
                                  value: contexts.bufferManagerContext,
                                  children: /* @__PURE__ */ jsx45(TimelineTrackContext.Provider, {
                                    value: contexts.timelineTrackContext,
                                    children: /* @__PURE__ */ jsx45(DefaultPremountContext.Provider, {
                                      value: contexts.defaultPremountInSeconds,
                                      children: /* @__PURE__ */ jsx45(VideoContext.Provider, {
                                        value: contexts.videoContext,
                                        children
                                      })
                                    })
                                  })
                                })
                              })
                            })
                          })
                        })
                      })
                    })
                  })
                })
              })
            })
          })
        })
      })
    })
  });
};

// src/internals.ts
var compositionSelectorRef = createRef3();
var Internals = {
  HtmlInCanvasFallback,
  useHtmlInCanvasUnsupportedMessage,
  OptimisticEffectDeletion,
  useOptimisticEffectDeletion,
  OptimisticSequenceDeletion,
  usePendingSequenceDeletions,
  createElementSourceProxy,
  CommittedMetadataProvider,
  withCommittedMetadata,
  DefaultPremountContext,
  evaluateSourceNumericValue,
  evaluateSourcePropStatuses,
  AbsoluteFillElement,
  MaxMediaCacheSizeContext,
  getMediabunnyInputResourceKey,
  globalMediaResourceManager,
  makeMediaResourceManager,
  MEDIABUNNY_DURATION_VALUE_KEY,
  makeRenderResourceManager,
  RenderResourceManagerContext,
  createRuntimeValueStore,
  useUnsafeVideoConfig,
  useFrameForVolumeProp,
  useTimelinePosition,
  useAbsoluteTimelinePosition,
  useIsInsideFreeze,
  useIsInsideNonPremountFreeze,
  useMediaAudioState,
  evaluateVolume,
  getAbsoluteSrc,
  getAnimatedImageDurationInSeconds,
  getAssetDisplayName,
  Timeline: exports_timeline_position_state,
  validateMediaTrimProps,
  validateMediaProps,
  resolveTrimProps,
  VideoForPreview,
  CompositionManager,
  CompositionManagerRefContext,
  CompositionSetters,
  VisualModePropStatusesContext,
  VisualModePropStatusesRefContext,
  VisualModePropStatusesSubscriptionContext,
  VisualModeBatchSettersContext,
  VisualModeDragOverridesContext,
  VisualModeDragOverridesRefContext,
  VisualModeSettersContext,
  SequenceManagerProvider,
  SequenceManagerRefContext,
  SequenceRegistryContext,
  useActiveFromDragOverrideKeys,
  useDragOverridesForNodePath,
  useSequenceManagerSequences,
  SequenceRegistrationContext,
  DisableSequenceRegistrationProvider,
  CommittedMetadataInternals,
  SequenceOutlineInternals,
  SequenceOutlineContext,
  SequenceStackTracesUpdateContext,
  baseSchema,
  sequenceSchema,
  sequenceTimingSchema,
  SequenceContent,
  DEFAULT_SEQUENCE_ACTIVITY_LIMIT,
  SequenceActivitySettingsContext,
  SequenceWithoutSchema,
  sequenceStyleSchema,
  sequenceVisualStyleSchema,
  sequencePremountSchema,
  sequenceCropSchema,
  textSchema,
  transformSchema,
  premountSchema,
  flattenActiveSchema,
  getFlatSchemaWithAllKeys,
  RemotionRootContexts,
  CompositionManagerProvider,
  CompositionRegistryProvider,
  useVideo,
  VideoProvider,
  getRoot,
  useMediaVolumeState,
  usePlayerMutedState,
  useMediaInTimeline: useMediaInTimelineRegistration,
  useLazyComponent,
  truthy,
  SequenceContext,
  TimelineTrackContext,
  TrackWithoutSchema,
  PremountContext,
  usePremounting,
  resolveSequenceDuration,
  useRemotionContexts,
  RemotionContextProvider,
  CSSUtils: exports_default_css,
  setupEnvVariables,
  MediaVolumeContext,
  SetMediaVolumeContext,
  getRemotionEnvironment,
  SharedAudioContext,
  SharedAudioContextProvider,
  SharedAudioTagsContext,
  SharedAudioTagsContextProvider,
  getAudioSyncAnchorTolerance,
  invalidCompositionErrorMessage,
  invalidFolderNameErrorMessage,
  calculateMediaDuration,
  isCompositionIdValid,
  isFolderNameValid,
  getPreviewDomElement,
  compositionsRef,
  portalNode,
  setPortalNodeCurrentScale,
  waitForRoot,
  SetTimelineContext,
  CanUseRemotionHooksProvider,
  CanUseRemotionHooks,
  DisableInteractivityProvider,
  EnableInteractivityProvider,
  PrefetchProvider,
  DurationsContextProvider,
  IsPlayerContextProvider,
  useIsPlayer,
  EditorPropsProvider,
  EditorPropsContext,
  usePreload,
  resolveVideoConfig,
  resolveVideoConfigOrCatch,
  resolveVideoConfigWithMetadataOrCatch,
  ResolveCompositionContext,
  useResolvedVideoConfig,
  resolveCompositionsRef,
  REMOTION_STUDIO_CONTAINER_ELEMENT,
  RenderAssetManager,
  persistCurrentFrame,
  usePlaybackRate,
  useTimelineContext,
  useTimelineSetFrameWithoutSeek,
  isIosSafari,
  WATCH_REMOTION_STATIC_FILES,
  REACT_REFRESH_STARTED_EVENT,
  REACT_REFRESH_FINISHED_EVENT,
  addSequenceStackTraces,
  useMediaStartsAt,
  BufferingProvider,
  BufferingContextReact,
  getComponentsToAddStacksTo,
  getSingleChildComponent,
  getStackForControls,
  makeOriginalSourceStack,
  parseOriginalSourceStack,
  REMOTION_INTERNAL_STACK_PROP,
  setComponentIdentityResolver,
  CurrentScaleContext,
  PixelDensityContext,
  PreviewSizeContext,
  calculateScale,
  validateRenderAsset,
  Log,
  LogLevelContext,
  useLogLevel,
  playbackLogging,
  timeValueRef,
  compositionSelectorRef,
  RemotionEnvironmentContext,
  warnAboutTooHighVolume,
  AudioForPreview,
  OBJECTFIT_CONTAIN_CLASS_NAME,
  InnerOffthreadVideo,
  useBasicMediaInTimeline,
  getInputPropsOverride,
  setInputPropsOverride,
  useVideoEnabled,
  useAudioEnabled,
  useBuffering,
  TimelinePosition: exports_timeline_position_state,
  useTimelineSeek,
  DelayRenderContextType,
  TimelineContext,
  usePlaying,
  PlaybackPitchContext,
  PlaybackRateContext,
  AbsoluteTimeContext,
  RenderAssetManagerProvider,
  getEffectiveVisualModeValue,
  CompositionRenderErrorContext,
  useEffectChainState,
  createEffectChainState,
  cleanupEffectChainState,
  runEffectChain,
  useMemoizedEffects,
  subscribeToEffectSource,
  useMemoizedEffectDefinitions,
  PreferredEffectBackendContext,
  validatePreferredEffectBackend,
  createEffect,
  createEffectImplementation,
  createCurveSampler,
  createWebGLContextError,
  createWebGL2ContextError,
  computeEffectiveSchemaValuesDotNotation,
  interpolateKeyframedStatus,
  prepareNumericKeyframedStatus,
  setInterpolatePaths,
  makeStaticDragOverride,
  makeKeyframedDragOverride,
  resolveDragOverrideValue,
  getStaticDragOverrideValue,
  OverrideIdsToNodePathsGettersContext,
  OverrideIdsToNodePathsSettersContext,
  findPropsToDelete,
  makeSequencePropsSubscriptionKey,
  getPropStatusesCtx,
  getEffectPropStatusesCtx,
  hiddenField,
  durationInFramesField,
  freezeField,
  fromField,
  trimAfterField,
  resolveSequenceCrop,
  useCropStyle
};
Object.assign(Internals, { useSyncExternalStore: useSyncExternalStore2 });
// src/font-face-registry.ts
var fontDataByUrl = new Map;
// src/series/index.tsx
import React56, {
  forwardRef as forwardRef15,
  useMemo as useMemo51
} from "react";

// src/series/flatten-children.tsx
import React55 from "react";
var flattenChildren = (children) => {
  const childrenArray = React55.Children.toArray(children);
  return childrenArray.reduce((flatChildren, child) => {
    if (child.type === React55.Fragment) {
      return flatChildren.concat(flattenChildren(child.props.children));
    }
    flatChildren.push(child);
    return flatChildren;
  }, []);
};

// src/series/index.tsx
import { jsx as jsx46, jsxs as jsxs6, Fragment } from "react/jsx-runtime";
var seriesSequenceSchema = {
  durationInFrames: Interactive.baseSchema.durationInFrames,
  name: Interactive.sequenceSchema.name,
  hidden: Interactive.sequenceSchema.hidden,
  showInTimeline: Interactive.sequenceSchema.showInTimeline,
  freeze: Interactive.baseSchema.freeze,
  trimBefore: Interactive.sequenceSchema.trimBefore,
  playbackRate: Interactive.sequenceSchema.playbackRate,
  layout: Interactive.sequenceSchema.layout
};
var SeriesSequenceInner = forwardRef15(({ offset = 0, className = "", _remotionInternalRender = null, ...props }, ref) => {
  useRequireToBeInsideSeries();
  if (_remotionInternalRender) {
    return _remotionInternalRender({ ...props, offset, className: className || undefined }, ref);
  }
  return /* @__PURE__ */ jsx46(IsNotInsideSeriesProvider, {
    children: props.children
  });
});
var SeriesSequence = Interactive.withSchema({
  Component: SeriesSequenceInner,
  componentName: "<Series.Sequence>",
  componentIdentity: "dev.remotion.remotion.Series.Sequence",
  schema: seriesSequenceSchema,
  supportsEffects: false
});
var SequenceWithoutSchemaWithRef = SequenceWithoutSchema;
var validateSeriesSequenceProps = ({
  durationInFrames,
  offset: offsetProp,
  index,
  childrenLength
}) => {
  const debugInfo = `index = ${index}, duration = ${durationInFrames}`;
  if (index !== childrenLength - 1 || durationInFrames !== Infinity) {
    validateDurationInFrames(durationInFrames, {
      component: `of a <Series.Sequence /> component`,
      allowFloats: true
    });
  }
  const offset = offsetProp ?? 0;
  if (Number.isNaN(offset)) {
    throw new TypeError(`The "offset" property of a <Series.Sequence /> must not be NaN, but got NaN (${debugInfo}).`);
  }
  if (!Number.isFinite(offset)) {
    throw new TypeError(`The "offset" property of a <Series.Sequence /> must be finite, but got ${offset} (${debugInfo}).`);
  }
  if (offset % 1 !== 0) {
    throw new TypeError(`The "offset" property of a <Series.Sequence /> must be finite, but got ${offset} (${debugInfo}).`);
  }
  return offset;
};
var SeriesInner = (props) => {
  const pendingDeletions = usePendingSequenceDeletions();
  const childrenValue = useMemo51(() => {
    const flattenedChildren = flattenChildren(props.children).filter((child) => !OptimisticSequenceDeletion.isElementDeleted(child, pendingDeletions));
    const renderChildren = (i, startFrame) => {
      if (i === flattenedChildren.length) {
        return null;
      }
      const child = flattenedChildren[i];
      const castedChild = child;
      if (typeof castedChild === "string") {
        if (castedChild.trim() === "") {
          return renderChildren(i + 1, startFrame);
        }
        throw new TypeError(`The <Series /> component only accepts a list of <Series.Sequence /> components as its children, but you passed a string "${castedChild}"`);
      }
      if (castedChild.type !== SeriesSequence) {
        throw new TypeError(`The <Series /> component only accepts a list of <Series.Sequence /> components as its children, but got ${castedChild} instead`);
      }
      const castedElement = castedChild;
      validateSeriesSequenceProps({
        durationInFrames: castedElement.props.durationInFrames,
        offset: castedElement.props.offset,
        index: i,
        childrenLength: flattenedChildren.length
      });
      return React56.cloneElement(castedElement, {
        _remotionInternalRender: (resolvedProps, ref) => {
          const durationInFramesProp = resolvedProps.durationInFrames;
          const timelineDurationInFrames = durationInFramesProp / (resolvedProps.playbackRate ?? 1);
          if (resolvedProps.loop) {
            throw new Error("<Series.Sequence> does not accept `loop`. Put a looping <Sequence> inside the <Series.Sequence> instead.");
          }
          const {
            durationInFrames: _durationInFrames,
            children: sequenceChildren,
            offset: offsetProp,
            controls,
            from: _from,
            name,
            ...passedProps
          } = resolvedProps;
          const offset = validateSeriesSequenceProps({
            durationInFrames: durationInFramesProp,
            offset: offsetProp,
            index: i,
            childrenLength: flattenedChildren.length
          });
          const currentStartFrame = startFrame + offset;
          const nextStartFrame = startFrame + timelineDurationInFrames + offset;
          return /* @__PURE__ */ jsxs6(Fragment, {
            children: [
              /* @__PURE__ */ jsx46(SequenceWithoutSchemaWithRef, {
                ref,
                name: name || "<Series.Sequence>",
                _remotionInternalDocumentationLink: "https://www.remotion.dev/docs/series",
                controls: controls ?? undefined,
                from: currentStartFrame,
                durationInFrames: durationInFramesProp,
                ...passedProps,
                _remotionInternalTimelineTrack: {
                  role: "clip",
                  seriesOffset: offset
                },
                children: /* @__PURE__ */ jsx46(IsNotInsideSeriesProvider, {
                  children: sequenceChildren
                })
              }),
              renderChildren(i + 1, nextStartFrame)
            ]
          });
        }
      });
    };
    return renderChildren(0, 0);
  }, [props.children, pendingDeletions]);
  return /* @__PURE__ */ jsx46(TrackWithoutSchema, {
    layout: "none",
    _remotionInternalDocumentationLink: "https://www.remotion.dev/docs/series",
    ...props,
    name: props.name ?? "<Series>",
    children: /* @__PURE__ */ jsx46(IsInsideSeriesContainer, {
      children: childrenValue
    })
  });
};
var Series = Object.assign(withInteractivitySchema({
  Component: SeriesInner,
  componentName: "<Series>",
  componentIdentity: "dev.remotion.remotion.Series",
  schema: {
    ...sequenceSchemaDefaultLayoutNone,
    ...sequenceTimingSchema
  },
  supportsEffects: false
}), {
  Sequence: SeriesSequence
});
addSequenceStackTraces(Series);
// src/static-file.ts
var problematicCharacters = {
  "%3A": ":",
  "%2F": "/",
  "%3F": "?",
  "%23": "#",
  "%5B": "[",
  "%5D": "]",
  "%40": "@",
  "%21": "!",
  "%24": "$",
  "%26": "&",
  "%27": "'",
  "%28": "(",
  "%29": ")",
  "%2A": "*",
  "%2B": "+",
  "%2C": ",",
  "%3B": ";"
};
var didWarn = {};
var warnOnce2 = (message) => {
  if (didWarn[message]) {
    return;
  }
  console.warn(message);
  didWarn[message] = true;
};
var includesHexOfUnsafeChar = (path) => {
  for (const key of Object.keys(problematicCharacters)) {
    if (path.includes(key)) {
      return { containsHex: true, hexCode: key };
    }
  }
  return { containsHex: false };
};
var trimLeadingSlash = (path) => {
  if (path.startsWith("/")) {
    return trimLeadingSlash(path.substring(1));
  }
  return path;
};
var inner = (path) => {
  if (typeof window !== "undefined" && window.remotion_staticBase) {
    if (path.startsWith(window.remotion_staticBase)) {
      throw new Error(`The value "${path}" is already prefixed with the static base ${window.remotion_staticBase}. You don't need to call staticFile() on it.`);
    }
    return `${window.remotion_staticBase}/${trimLeadingSlash(path)}`;
  }
  return `/${trimLeadingSlash(path)}`;
};
var encodeBySplitting = (path) => {
  const splitBySlash = path.split("/");
  const encodedArray = splitBySlash.map((element) => {
    return encodeURIComponent(element);
  });
  const merged = encodedArray.join("/");
  return merged;
};
var staticFile = (path) => {
  if (path === null) {
    throw new TypeError("null was passed to staticFile()");
  }
  if (typeof path === "undefined") {
    throw new TypeError("undefined was passed to staticFile()");
  }
  if (path.startsWith("http://") || path.startsWith("https://")) {
    throw new TypeError(`staticFile() does not support remote URLs - got "${path}". Instead, pass the URL without wrapping it in staticFile(). See: https://remotion.dev/docs/staticfile-remote-urls`);
  }
  if (path.startsWith("..") || path.startsWith("./")) {
    throw new TypeError(`staticFile() does not support relative paths - got "${path}". Instead, pass the name of a file that is inside the public/ folder. See: https://remotion.dev/docs/staticfile-relative-paths`);
  }
  if (path.startsWith("/Users") || path.startsWith("/home") || path.startsWith("/tmp") || path.startsWith("/etc") || path.startsWith("/opt") || path.startsWith("/var") || path.startsWith("C:") || path.startsWith("D:") || path.startsWith("E:")) {
    throw new TypeError(`staticFile() does not support absolute paths - got "${path}". Instead, pass the name of a file that is inside the public/ folder. See: https://remotion.dev/docs/staticfile-relative-paths`);
  }
  if (path.startsWith("public/")) {
    throw new TypeError(`Do not include the public/ prefix when using staticFile() - got "${path}". See: https://remotion.dev/docs/staticfile-relative-paths`);
  }
  const includesHex = includesHexOfUnsafeChar(path);
  if (includesHex.containsHex) {
    warnOnce2(`WARNING: You seem to pass an already encoded path (path contains ${includesHex.hexCode}). Since Remotion 4.0, the encoding is done by staticFile() itself. You may want to remove a encodeURIComponent() wrapping.`);
  }
  if (typeof window !== "undefined") {
    const matchingStaticFile = window.remotion_staticFiles?.find((file) => file.name === trimLeadingSlash(path));
    if (matchingStaticFile) {
      return matchingStaticFile.src;
    }
  }
  const preprocessed = encodeBySplitting(path);
  const preparsed = inner(preprocessed);
  if (!preparsed.startsWith("/")) {
    return `/${preparsed}`;
  }
  return preparsed;
};
// src/Still.tsx
import React57 from "react";
var Still = (props) => {
  const newProps = {
    ...props,
    durationInFrames: 1,
    fps: 1
  };
  return React57.createElement(Composition, newProps);
};
addSequenceStackTraces(Still);
// src/video/html5-video.tsx
import { forwardRef as forwardRef17, useContext as useContext54, useMemo as useMemo53 } from "react";

// src/video/VideoForRendering.tsx
import {
  forwardRef as forwardRef16,
  useContext as useContext53,
  useEffect as useEffect24,
  useImperativeHandle as useImperativeHandle11,
  useLayoutEffect as useLayoutEffect24,
  useMemo as useMemo52,
  useRef as useRef33
} from "react";

// src/video/seek-until-right.ts
var roundTo6Commas = (num) => {
  return Math.round(num * 1e5) / 1e5;
};
var seekToTime = ({
  element,
  desiredTime,
  logLevel,
  mountTime
}) => {
  if (isApproximatelyTheSame(element.currentTime, desiredTime)) {
    return {
      wait: Promise.resolve(desiredTime),
      cancel: () => {}
    };
  }
  let cancel;
  let cancelSeeked = null;
  const prom = new Promise((resolve) => {
    cancel = element.requestVideoFrameCallback((now, metadata) => {
      const displayIn = metadata.expectedDisplayTime - now;
      if (displayIn <= 0) {
        resolve(metadata.mediaTime);
        return;
      }
      setTimeout(() => {
        resolve(metadata.mediaTime);
      }, displayIn + 150);
    });
  });
  const waitForSeekedEvent = new Promise((resolve) => {
    const onDone = () => {
      resolve();
    };
    element.addEventListener("seeked", onDone, {
      once: true
    });
    cancelSeeked = () => {
      element.removeEventListener("seeked", onDone);
    };
  });
  seek({
    logLevel,
    mediaRef: element,
    time: desiredTime,
    why: "Seeking during rendering",
    mountTime
  });
  return {
    wait: Promise.all([prom, waitForSeekedEvent]).then(([time]) => time),
    cancel: () => {
      cancelSeeked?.();
      element.cancelVideoFrameCallback(cancel);
    }
  };
};
var seekToTimeMultipleUntilRight = ({
  element,
  desiredTime,
  fps,
  logLevel,
  mountTime
}) => {
  const threshold = 1 / fps / 2;
  let currentCancel = () => {
    return;
  };
  if (Number.isFinite(element.duration) && element.currentTime >= element.duration && desiredTime >= element.duration) {
    return {
      prom: Promise.resolve(),
      cancel: () => {}
    };
  }
  const prom = new Promise((resolve, reject) => {
    const firstSeek = seekToTime({
      element,
      desiredTime: desiredTime + threshold,
      logLevel,
      mountTime
    });
    firstSeek.wait.then((seekedTo) => {
      const difference = Math.abs(desiredTime - seekedTo);
      if (difference <= threshold) {
        return resolve();
      }
      const sign = desiredTime > seekedTo ? 1 : -1;
      const newSeek = seekToTime({
        element,
        desiredTime: seekedTo + threshold * sign,
        logLevel,
        mountTime
      });
      currentCancel = newSeek.cancel;
      newSeek.wait.then((newTime) => {
        const newDifference = Math.abs(desiredTime - newTime);
        if (roundTo6Commas(newDifference) <= roundTo6Commas(threshold)) {
          return resolve();
        }
        const thirdSeek = seekToTime({
          element,
          desiredTime: desiredTime + threshold,
          logLevel,
          mountTime
        });
        currentCancel = thirdSeek.cancel;
        return thirdSeek.wait.then(() => {
          resolve();
        }).catch((err) => {
          reject(err);
        });
      }).catch((err) => {
        reject(err);
      });
    });
    currentCancel = firstSeek.cancel;
  });
  return {
    prom,
    cancel: () => {
      currentCancel();
    }
  };
};

// src/video/VideoForRendering.tsx
import { jsx as jsx47 } from "react/jsx-runtime";
var VideoForRenderingForwardFunction = ({
  onError,
  volume: volumeProp,
  allowAmplificationDuringRender,
  playbackRate,
  onDuration,
  toneFrequency,
  name,
  acceptableTimeShiftInSeconds,
  delayRenderRetries,
  delayRenderTimeoutInMilliseconds,
  loopVolumeCurveBehavior,
  audioStreamIndex,
  onVideoFrame,
  preservePitch,
  ...props
}, ref) => {
  const absoluteFrame = useTimelinePosition();
  const frame = useCurrentFrame();
  const volumePropsFrame = useFrameForVolumeProp(loopVolumeCurveBehavior ?? "repeat");
  const videoConfig = useUnsafeVideoConfig();
  const videoRef = useRef33(null);
  const sequenceContext = useContext53(SequenceContext);
  const sequencePlaybackRate = sequenceContext?.playbackRate ?? 1;
  const audioStartFrame = useContext53(Html5MediaTrimContext);
  const environment = useRemotionEnvironment();
  const logLevel = useLogLevel();
  const mountTime = useMountTime();
  const { delayRender, continueRender } = useDelayRender();
  const { registerRenderAsset, unregisterRenderAsset } = useContext53(RenderAssetManager);
  const id = useMemo52(() => `video-${random(props.src ?? "")}-${sequenceContext?.cumulatedFrom}-${sequenceContext?.relativeFrom}-${sequenceContext?.durationInFrames}`, [
    props.src,
    sequenceContext?.cumulatedFrom,
    sequenceContext?.relativeFrom,
    sequenceContext?.durationInFrames
  ]);
  const volume = evaluateVolume({
    volume: volumeProp,
    frame: volumePropsFrame,
    mediaVolume: 1
  });
  warnAboutTooHighVolume(volume);
  const audioEnabled = useAudioEnabled();
  const { shouldUseAudio } = useMediaAudioState({
    muted: props.muted ?? false,
    volume,
    audioEnabled
  });
  if (!videoConfig) {
    throw new Error("No video config found");
  }
  useEffect24(() => {
    if (!props.src) {
      throw new Error("No src passed");
    }
    if (!shouldUseAudio) {
      return;
    }
    registerRenderAsset({
      type: "video",
      src: getAbsoluteSrc(props.src),
      id,
      frame: absoluteFrame,
      volume,
      mediaFrame: audioStartFrame + (frame - audioStartFrame) / sequencePlaybackRate,
      playbackRate: (playbackRate ?? 1) * sequencePlaybackRate,
      toneFrequency: toneFrequency ?? 1,
      audioStartFrame,
      audioStreamIndex: audioStreamIndex ?? 0,
      preservePitch: preservePitch ?? true
    });
    return () => unregisterRenderAsset(id);
  }, [
    shouldUseAudio,
    props.src,
    registerRenderAsset,
    id,
    unregisterRenderAsset,
    volume,
    frame,
    absoluteFrame,
    playbackRate,
    toneFrequency,
    audioStartFrame,
    sequencePlaybackRate,
    audioStreamIndex,
    preservePitch
  ]);
  useImperativeHandle11(ref, () => {
    return videoRef.current;
  }, []);
  useEmitVideoFrame({ ref: videoRef, onVideoFrame });
  useEffect24(() => {
    if (!window.remotion_videoEnabled) {
      return;
    }
    const { current } = videoRef;
    if (!current) {
      return;
    }
    const currentTime = getMediaTime({
      frame,
      playbackRate: playbackRate || 1,
      startFrom: audioStartFrame,
      fps: videoConfig.fps
    });
    const handle = delayRender(`Rendering <Html5Video /> with src="${props.src}" at time ${currentTime}`, {
      retries: delayRenderRetries ?? undefined,
      timeoutInMilliseconds: delayRenderTimeoutInMilliseconds ?? undefined
    });
    if (window.process?.env?.NODE_ENV === "test") {
      continueRender(handle);
      return;
    }
    if (isApproximatelyTheSame(current.currentTime, currentTime)) {
      if (current.readyState >= 2) {
        continueRender(handle);
        return;
      }
      const loadedDataHandler = () => {
        continueRender(handle);
      };
      current.addEventListener("loadeddata", loadedDataHandler, { once: true });
      return () => {
        current.removeEventListener("loadeddata", loadedDataHandler);
      };
    }
    const endedHandler = () => {
      continueRender(handle);
    };
    const seek = seekToTimeMultipleUntilRight({
      element: current,
      desiredTime: currentTime,
      fps: videoConfig.fps,
      logLevel,
      mountTime
    });
    seek.prom.then(() => {
      continueRender(handle);
    });
    current.addEventListener("ended", endedHandler, { once: true });
    const errorHandler = () => {
      if (current?.error) {
        console.error("Error occurred in video", current?.error);
        if (onError) {
          return;
        }
        throw new MediaPlaybackError({
          message: `The browser threw an error while playing the video ${props.src}: Code ${current.error.code} - ${current?.error?.message}. See https://remotion.dev/docs/media-playback-error for help. Pass an onError() prop to handle the error.`,
          src: props.src
        });
      } else {
        throw new MediaPlaybackError({
          message: "The browser threw an error",
          src: props.src
        });
      }
    };
    current.addEventListener("error", errorHandler, { once: true });
    return () => {
      seek.cancel();
      current.removeEventListener("ended", endedHandler);
      current.removeEventListener("error", errorHandler);
      continueRender(handle);
    };
  }, [
    volumePropsFrame,
    props.src,
    playbackRate,
    videoConfig.fps,
    frame,
    audioStartFrame,
    onError,
    delayRenderRetries,
    delayRenderTimeoutInMilliseconds,
    logLevel,
    mountTime,
    continueRender,
    delayRender
  ]);
  const { src } = props;
  if (environment.isRendering) {
    useLayoutEffect24(() => {
      if (window.process?.env?.NODE_ENV === "test") {
        return;
      }
      const newHandle = delayRender("Loading <Html5Video> duration with src=" + src, {
        retries: delayRenderRetries ?? undefined,
        timeoutInMilliseconds: delayRenderTimeoutInMilliseconds ?? undefined
      });
      const { current } = videoRef;
      const didLoad = () => {
        if (current?.duration) {
          onDuration(src, current.duration);
        }
        continueRender(newHandle);
      };
      if (current?.duration) {
        onDuration(src, current.duration);
        continueRender(newHandle);
      } else {
        current?.addEventListener("loadedmetadata", didLoad, { once: true });
      }
      return () => {
        current?.removeEventListener("loadedmetadata", didLoad);
        continueRender(newHandle);
      };
    }, [
      src,
      onDuration,
      delayRenderRetries,
      delayRenderTimeoutInMilliseconds,
      continueRender,
      delayRender
    ]);
  }
  return /* @__PURE__ */ jsx47("video", {
    ref: videoRef,
    disableRemotePlayback: true,
    ...props
  });
};
var VideoForRendering = forwardRef16(VideoForRenderingForwardFunction);

// src/video/html5-video.tsx
import { jsx as jsx48 } from "react/jsx-runtime";
var VideoForwardingFunction = (props, ref) => {
  const {
    startFrom,
    endAt,
    trimBefore,
    trimAfter,
    durationInFrames,
    name,
    pauseWhenBuffering,
    _remotionInternalStack,
    _remotionInternalNativeLoopPassed,
    showInTimeline,
    onAutoPlayError,
    onVideoFrame,
    ...otherProps
  } = props;
  const { loop, ...propsOtherThanLoop } = props;
  const { fps } = useVideoConfig();
  const environment = useRemotionEnvironment();
  const shouldPauseWhenBuffering = resolveV5Default(pauseWhenBuffering);
  if (environment.isClientSideRendering) {
    throw new Error("<Html5Video> is not supported in @remotion/web-renderer. Use <Video> from @remotion/media instead. See https://remotion.dev/docs/client-side-rendering/limitations");
  }
  const { durations, setDurations } = useContext54(DurationsContext);
  if (typeof ref === "string") {
    throw new Error("string refs are not supported");
  }
  if (typeof props.src !== "string") {
    throw new TypeError(`The \`<Html5Video>\` tag requires a string for \`src\`, but got ${JSON.stringify(props.src)} instead.`);
  }
  const preloadedSrc = usePreload(props.src);
  const onDuration = useMemo53(() => onMediaDuration.bind(null, setDurations), [setDurations]);
  const durationFetched = durations[getAbsoluteSrc(preloadedSrc)] ?? durations[getAbsoluteSrc(props.src)];
  validateMediaTrimProps({ startFrom, endAt, trimBefore, trimAfter });
  if (durationInFrames !== undefined) {
    validateDurationInFrames(durationInFrames, {
      component: "of the <Html5Video /> component",
      allowFloats: true
    });
  }
  const { trimBeforeValue, trimAfterValue } = resolveTrimProps({
    startFrom,
    endAt,
    trimBefore,
    trimAfter
  });
  const effectiveTrimAfter = getMediaTrimAfter({
    durationInFrames,
    trimAfter: trimAfterValue,
    trimBefore: trimBeforeValue
  });
  const loopDuration = effectiveTrimAfter ?? (durationFetched === undefined ? undefined : durationFetched * fps);
  if (loop && loopDuration !== undefined) {
    if (!Number.isFinite(loopDuration)) {
      return /* @__PURE__ */ jsx48(Html5Video, {
        ...propsOtherThanLoop,
        ref,
        _remotionInternalStack,
        _remotionInternalNativeLoopPassed: true
      });
    }
    return /* @__PURE__ */ jsx48(Loop, {
      durationInFrames: calculateMediaDuration({
        trimAfter: effectiveTrimAfter,
        mediaDurationInFrames: loopDuration,
        playbackRate: props.playbackRate ?? 1,
        trimBefore: trimBeforeValue
      }),
      layout: "none",
      name,
      showInTimeline: false,
      children: /* @__PURE__ */ jsx48(Html5Video, {
        ...propsOtherThanLoop,
        ref,
        _remotionInternalStack,
        _remotionInternalNativeLoopPassed: true
      })
    });
  }
  if (typeof trimBeforeValue !== "undefined" || typeof effectiveTrimAfter !== "undefined") {
    return /* @__PURE__ */ jsx48(Html5MediaTrimContext.Provider, {
      value: trimBeforeValue ?? 0,
      children: /* @__PURE__ */ jsx48(Sequence, {
        layout: "none",
        from: 0 - (trimBeforeValue ?? 0),
        showInTimeline: false,
        durationInFrames: effectiveTrimAfter === undefined ? undefined : (trimBeforeValue ?? 0) + (effectiveTrimAfter - (trimBeforeValue ?? 0)) / (props.playbackRate ?? 1),
        name,
        children: /* @__PURE__ */ jsx48(Html5Video, {
          pauseWhenBuffering: shouldPauseWhenBuffering,
          onVideoFrame,
          ...otherProps,
          ref,
          showInTimeline,
          _remotionInternalStack
        })
      })
    });
  }
  validateMediaProps({
    playbackRate: props.playbackRate,
    preservePitch: props.preservePitch,
    volume: props.volume
  }, "Html5Video");
  if (environment.isRendering) {
    return /* @__PURE__ */ jsx48(VideoForRendering, {
      onDuration,
      onVideoFrame: onVideoFrame ?? null,
      ...otherProps,
      ref
    });
  }
  return /* @__PURE__ */ jsx48(VideoForPreview, {
    onlyWarnForMediaSeekingError: false,
    ...otherProps,
    ref,
    onVideoFrame: onVideoFrame ?? null,
    pauseWhenBuffering: shouldPauseWhenBuffering,
    onDuration,
    _remotionInternalStack: _remotionInternalStack ?? null,
    _remotionInternalNativeLoopPassed: _remotionInternalNativeLoopPassed ?? false,
    showInTimeline: showInTimeline ?? true,
    onAutoPlayError: onAutoPlayError ?? undefined
  });
};
var Html5Video = forwardRef17(VideoForwardingFunction);
addSequenceStackTraces(Html5Video);
var Video = Html5Video;
// src/index.ts
checkMultipleRemotionVersions();
var Experimental = {
  Clipper,
  Null,
  useIsPlayer
};
var proxyObj = {};
var Config = new Proxy(proxyObj, {
  get(_, prop) {
    if (prop === "Bundling" || prop === "Rendering" || prop === "Log" || prop === "Puppeteer" || prop === "Output") {
      return Config;
    }
    return () => {
      console.warn("⚠️  The CLI configuration has been extracted from Remotion Core.");
      console.warn("Update the import from the config file:");
      console.warn();
      console.warn("- Delete:");
      console.warn('import {Config} from "remotion";');
      console.warn("+ Replace:");
      console.warn('import {Config} from "@remotion/cli/config";');
      console.warn();
      console.warn("For more information, see https://www.remotion.dev/docs/4-0-migration.");
      process.exit(1);
    };
  }
});
Sequence.displayName = "Sequence";
addSequenceStackTraces(Sequence);
setSequenceComponent(Sequence);
addSequenceStackTraces(Composition);
addSequenceStackTraces(Folder);
export {
  AbsoluteFill,
  AnimatedImage,
  Artifact,
  Audio,
  CanvasImage,
  Composition,
  Config,
  Easing,
  Experimental,
  Folder,
  FolderContext,
  Freeze,
  HTML_IN_CANVAS_UNSUPPORTED_MESSAGE,
  Html5Audio,
  Html5Video,
  HtmlInCanvas,
  IFrame,
  Img,
  Interactive,
  Internals,
  Loop,
  MediaPlaybackError,
  OffthreadVideo,
  Sequence,
  Series,
  Solid,
  Still,
  Track,
  VERSION,
  Video,
  absoluteFillSchema,
  assertValidInterpolateEasingOption,
  assertValidInterpolatePosterizeOption,
  cancelRender,
  continueRender,
  createEffect,
  createEffectImplementation,
  delayRender,
  getHtmlInCanvasUnsupportedMessage,
  getInputProps,
  getRemotionEnvironment,
  getStaticFiles,
  interpolate,
  interpolateColors,
  isHtmlInCanvasSupported,
  measureSpring,
  prefetch,
  random,
  registerRoot,
  spring,
  staticFile,
  useBufferState,
  useCurrentFrame,
  useCurrentScale,
  useDelayRender,
  useIsInsideNonPremountFreeze,
  usePixelDensity,
  useRemotionEnvironment,
  useVideoConfig,
  watchStaticFile
};
